export default {
"villagersdata":[
  {
    "name": "Judy",
    "url": "https://nookipedia.com/wiki/Judy",
    "alt_name": "",
    "skin_color": "ffebff",
    "text_color": "725661",
    "id": "cbr19",
    "image_url": "https://dodo.ac/np/images/d/d4/Judy_NH.png",
    "species": "Bear cub",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 10,
    "sign": "Pisces",
    "quote": "I'm dancing my dreams away.",
    "phrase": "myohmy",
    "clothing": "Fairy-Tale Dress",
    "islander": "FALSE",
    "debut": "NH",
    "prev_phrases": [],
    "appearances": "['NH', 'PC']",
    "Amiibo": "NO",
    "hobby": "Music",
    "interior_decor": "Cute",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 1,
    "Average_Popularity_Score": 4.25,
    "Nookazon_Bells_Price_Ranking": 5,
    "Nookazon_average_price_Bells": 723959,
    "Nookazon_NMT_Price_Ranking": 2,
    "Nookazon_average_price_NMT": 200,
    "Poll_Ranking_2020": 5,
    "Poll_Ranking_2020_21": 5,
    "Total_Poll_Votes_2020": 10393,
    "Total_Poll_Votes_2020_21": 12377,
    "Poll_votes_May_2020": 577,
    "Poll_votes_June_2020": 2696,
    "Poll_votes_July_2020": 2642,
    "Poll_votes_August_2020": 1445,
    "Poll_votes_September_2020": 1191,
    "Poll_votes_October_2020": 824,
    "Poll_votes_November_2020": 546,
    "Poll_votes_December_2020": 472,
    "Poll_votes_January_2021": 524,
    "Poll_votes_February_2021": 479,
    "Poll_votes_March_2021": 560,
    "Poll_votes_April_2021": 421
  },
  {
    "name": "Audie",
    "url": "https://nookipedia.com/wiki/Audie",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "wol12",
    "image_url": "https://dodo.ac/np/images/1/1b/Audie_NH.png",
    "species": "Wolf",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "August",
    "birthday_day": 31,
    "sign": "Virgo",
    "quote": "Be the kind of person your future self won't regret having been.",
    "phrase": "foxtrot",
    "clothing": "Tropical Muumuu",
    "islander": "FALSE",
    "debut": "NH",
    "prev_phrases": [],
    "appearances": "['NH', 'PC']",
    "Amiibo": "NO",
    "hobby": "Fitness",
    "interior_decor": "Beach",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 2,
    "Average_Popularity_Score": 8,
    "Nookazon_Bells_Price_Ranking": 10,
    "Nookazon_average_price_Bells": 500000,
    "Nookazon_NMT_Price_Ranking": 6,
    "Nookazon_average_price_NMT": 50,
    "Poll_Ranking_2020": 8,
    "Poll_Ranking_2020_21": 8,
    "Total_Poll_Votes_2020": 8343,
    "Total_Poll_Votes_2020_21": 9953,
    "Poll_votes_May_2020": 447,
    "Poll_votes_June_2020": 2381,
    "Poll_votes_July_2020": 2038,
    "Poll_votes_August_2020": 1151,
    "Poll_votes_September_2020": 810,
    "Poll_votes_October_2020": 744,
    "Poll_votes_November_2020": 402,
    "Poll_votes_December_2020": 370,
    "Poll_votes_January_2021": 407,
    "Poll_votes_February_2021": 404,
    "Poll_votes_March_2021": 450,
    "Poll_votes_April_2021": 349
  },
  {
    "name": "Stitches",
    "url": "https://nookipedia.com/wiki/Stitches",
    "alt_name": "",
    "skin_color": "ffaa3b",
    "text_color": "874c25",
    "id": "cbr05",
    "image_url": "https://dodo.ac/np/images/5/56/Stitches_NH.png",
    "species": "Bear cub",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "February",
    "birthday_day": 10,
    "sign": "Aquarius",
    "quote": "A stitch in time saves nine.",
    "phrase": "stuffin'",
    "clothing": "Starry Tank",
    "islander": "FALSE",
    "debut": "WW",
    "prev_phrases": [],
    "appearances": "['WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Toys",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 3,
    "Average_Popularity_Score": 10.25,
    "Nookazon_Bells_Price_Ranking": 7,
    "Nookazon_average_price_Bells": 581250,
    "Nookazon_NMT_Price_Ranking": 20,
    "Nookazon_average_price_NMT": 40,
    "Poll_Ranking_2020": 7,
    "Poll_Ranking_2020_21": 7,
    "Total_Poll_Votes_2020": 8349,
    "Total_Poll_Votes_2020_21": 10152,
    "Poll_votes_May_2020": 479,
    "Poll_votes_June_2020": 2072,
    "Poll_votes_July_2020": 2153,
    "Poll_votes_August_2020": 1172,
    "Poll_votes_September_2020": 915,
    "Poll_votes_October_2020": 722,
    "Poll_votes_November_2020": 429,
    "Poll_votes_December_2020": 407,
    "Poll_votes_January_2021": 452,
    "Poll_votes_February_2021": 473,
    "Poll_votes_March_2021": 498,
    "Poll_votes_April_2021": 380
  },
  {
    "name": "Raymond",
    "url": "https://nookipedia.com/wiki/Raymond",
    "alt_name": "",
    "skin_color": "acc8cf",
    "text_color": 498992,
    "id": "cat23",
    "image_url": "https://dodo.ac/np/images/2/2a/Raymond_NH.png",
    "species": "Cat",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 1,
    "sign": "Libra",
    "quote": "Stay on brand!",
    "phrase": "crisp",
    "clothing": "Waistcoat",
    "islander": "FALSE",
    "debut": "NH",
    "prev_phrases": [],
    "appearances": "['NH', 'PC']",
    "Amiibo": "NO",
    "hobby": "Nature",
    "interior_decor": "Office",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 4,
    "Average_Popularity_Score": 10.5,
    "Nookazon_Bells_Price_Ranking": 37,
    "Nookazon_average_price_Bells": 333334,
    "Nookazon_NMT_Price_Ranking": 1,
    "Nookazon_average_price_NMT": 260,
    "Poll_Ranking_2020": 2,
    "Poll_Ranking_2020_21": 2,
    "Total_Poll_Votes_2020": 20373,
    "Total_Poll_Votes_2020_21": 23693,
    "Poll_votes_May_2020": 1183,
    "Poll_votes_June_2020": 5656,
    "Poll_votes_July_2020": 5129,
    "Poll_votes_August_2020": 2640,
    "Poll_votes_September_2020": 2273,
    "Poll_votes_October_2020": 1609,
    "Poll_votes_November_2020": 1011,
    "Poll_votes_December_2020": 872,
    "Poll_votes_January_2021": 934,
    "Poll_votes_February_2021": 817,
    "Poll_votes_March_2021": 913,
    "Poll_votes_April_2021": 656
  },
  {
    "name": "Poppy",
    "url": "https://nookipedia.com/wiki/Poppy",
    "alt_name": "",
    "skin_color": "db6161",
    "text_color": "fffce9",
    "id": "squ15",
    "image_url": "https://dodo.ac/np/images/c/c4/Poppy_NH.png",
    "species": "Squirrel",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "August",
    "birthday_day": 5,
    "sign": "Leo",
    "quote": "It's all about positive thinking!",
    "phrase": "nutty",
    "clothing": "Alpinist Dress",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": [],
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 5,
    "Average_Popularity_Score": 14.75,
    "Nookazon_Bells_Price_Ranking": 1,
    "Nookazon_average_price_Bells": 825000,
    "Nookazon_NMT_Price_Ranking": 6,
    "Nookazon_average_price_NMT": 50,
    "Poll_Ranking_2020": 27,
    "Poll_Ranking_2020_21": 26,
    "Total_Poll_Votes_2020": 3834,
    "Total_Poll_Votes_2020_21": 4770,
    "Poll_votes_May_2020": 142,
    "Poll_votes_June_2020": 650,
    "Poll_votes_July_2020": 915,
    "Poll_votes_August_2020": 618,
    "Poll_votes_September_2020": 587,
    "Poll_votes_October_2020": 415,
    "Poll_votes_November_2020": 275,
    "Poll_votes_December_2020": 232,
    "Poll_votes_January_2021": 236,
    "Poll_votes_February_2021": 242,
    "Poll_votes_March_2021": 259,
    "Poll_votes_April_2021": 199
  },
  {
    "name": "Molly",
    "url": "https://nookipedia.com/wiki/Molly",
    "alt_name": "",
    "skin_color": "e8b010",
    "text_color": "fffce9",
    "id": "duk16",
    "image_url": "https://dodo.ac/np/images/2/29/Molly_NH.png",
    "species": "Duck",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 7,
    "sign": "Pisces",
    "quote": "Like water off a duck's back.",
    "phrase": "quackidee",
    "clothing": "Pintuck-Pleated Dress",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.058823529,
    "Rarity": "0.17%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 6,
    "Average_Popularity_Score": 15.25,
    "Nookazon_Bells_Price_Ranking": 6,
    "Nookazon_average_price_Bells": 681250,
    "Nookazon_NMT_Price_Ranking": 13,
    "Nookazon_average_price_NMT": 48,
    "Poll_Ranking_2020": 21,
    "Poll_Ranking_2020_21": 21,
    "Total_Poll_Votes_2020": 5644,
    "Total_Poll_Votes_2020_21": 7209,
    "Poll_votes_May_2020": 358,
    "Poll_votes_June_2020": 1295,
    "Poll_votes_July_2020": 1432,
    "Poll_votes_August_2020": 833,
    "Poll_votes_September_2020": 605,
    "Poll_votes_October_2020": 502,
    "Poll_votes_November_2020": 338,
    "Poll_votes_December_2020": 281,
    "Poll_votes_January_2021": 333,
    "Poll_votes_February_2021": 416,
    "Poll_votes_March_2021": 482,
    "Poll_votes_April_2021": 334
  },
  {
    "name": "Dom",
    "url": "https://nookipedia.com/wiki/Dom",
    "alt_name": "",
    "skin_color": "feeae7",
    "text_color": "97858e",
    "id": "shp15",
    "image_url": "https://dodo.ac/np/images/7/75/Dom_NH.png",
    "species": "Sheep",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "March",
    "birthday_day": 18,
    "sign": "Pisces",
    "quote": "Be true to your most shiny self.",
    "phrase": "indeedaroo",
    "clothing": "Tie-Dye Shirt",
    "islander": "FALSE",
    "debut": "NH",
    "prev_phrases": [],
    "appearances": "['NH', 'PC']",
    "Amiibo": "NO",
    "hobby": "Play",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 7,
    "Average_Popularity_Score": 16,
    "Nookazon_Bells_Price_Ranking": 37,
    "Nookazon_average_price_Bells": 333334,
    "Nookazon_NMT_Price_Ranking": 3,
    "Nookazon_average_price_NMT": 80,
    "Poll_Ranking_2020": 13,
    "Poll_Ranking_2020_21": 12,
    "Total_Poll_Votes_2020": 7851,
    "Total_Poll_Votes_2020_21": 9411,
    "Poll_votes_May_2020": 375,
    "Poll_votes_June_2020": 1937,
    "Poll_votes_July_2020": 2143,
    "Poll_votes_August_2020": 1111,
    "Poll_votes_September_2020": 864,
    "Poll_votes_October_2020": 661,
    "Poll_votes_November_2020": 394,
    "Poll_votes_December_2020": 366,
    "Poll_votes_January_2021": 405,
    "Poll_votes_February_2021": 365,
    "Poll_votes_March_2021": 441,
    "Poll_votes_April_2021": 349
  },
  {
    "name": "Maple",
    "url": "https://nookipedia.com/wiki/Maple",
    "alt_name": "",
    "skin_color": "a87850",
    "text_color": "fffce9",
    "id": "cbr01",
    "image_url": "https://dodo.ac/np/images/a/a2/Maple_NH.png",
    "species": "Bear cub",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "June",
    "birthday_day": 15,
    "sign": "Gemini",
    "quote": "Waste not, want not.",
    "phrase": "honey",
    "clothing": "Tree Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Normal",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 8,
    "Average_Popularity_Score": 17,
    "Nookazon_Bells_Price_Ranking": 2,
    "Nookazon_average_price_Bells": 750000,
    "Nookazon_NMT_Price_Ranking": 20,
    "Nookazon_average_price_NMT": 40,
    "Poll_Ranking_2020": 23,
    "Poll_Ranking_2020_21": 23,
    "Total_Poll_Votes_2020": 5047,
    "Total_Poll_Votes_2020_21": 6628,
    "Poll_votes_May_2020": 206,
    "Poll_votes_June_2020": 957,
    "Poll_votes_July_2020": 1116,
    "Poll_votes_August_2020": 740,
    "Poll_votes_September_2020": 720,
    "Poll_votes_October_2020": 570,
    "Poll_votes_November_2020": 389,
    "Poll_votes_December_2020": 349,
    "Poll_votes_January_2021": 412,
    "Poll_votes_February_2021": 384,
    "Poll_votes_March_2021": 466,
    "Poll_votes_April_2021": 319
  },
  {
    "name": "Coco",
    "url": "https://nookipedia.com/wiki/Coco",
    "alt_name": "",
    "skin_color": "e4b887",
    "text_color": "fffce9",
    "id": "rbt02",
    "image_url": "https://dodo.ac/np/images/8/83/Coco_NH.png",
    "species": "Rabbit",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 1,
    "sign": "Pisces",
    "quote": "Don't put off till tomorrow what you can do today.",
    "phrase": "doyoing",
    "clothing": "Layered Tank Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 9,
    "Average_Popularity_Score": 17.25,
    "Nookazon_Bells_Price_Ranking": 13,
    "Nookazon_average_price_Bells": 484375,
    "Nookazon_NMT_Price_Ranking": 20,
    "Nookazon_average_price_NMT": 40,
    "Poll_Ranking_2020": 18,
    "Poll_Ranking_2020_21": 18,
    "Total_Poll_Votes_2020": 6949,
    "Total_Poll_Votes_2020_21": 8325,
    "Poll_votes_May_2020": 447,
    "Poll_votes_June_2020": 1680,
    "Poll_votes_July_2020": 1762,
    "Poll_votes_August_2020": 1015,
    "Poll_votes_September_2020": 740,
    "Poll_votes_October_2020": 601,
    "Poll_votes_November_2020": 391,
    "Poll_votes_December_2020": 313,
    "Poll_votes_January_2021": 326,
    "Poll_votes_February_2021": 352,
    "Poll_votes_March_2021": 387,
    "Poll_votes_April_2021": 311
  },
  {
    "name": "Beau",
    "url": "https://nookipedia.com/wiki/Beau",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "der07",
    "image_url": "https://dodo.ac/np/images/d/d4/Beau_NH.png",
    "species": "Deer",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "April",
    "birthday_day": 5,
    "sign": "Aries",
    "quote": "You snooze, you lose.",
    "phrase": "saltlick",
    "clothing": "Reindeer Sweater",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 10,
    "Average_Popularity_Score": 21.25,
    "Nookazon_Bells_Price_Ranking": 12,
    "Nookazon_average_price_Bells": 487500,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 12,
    "Poll_Ranking_2020_21": 11,
    "Total_Poll_Votes_2020": 7918,
    "Total_Poll_Votes_2020_21": 9503,
    "Poll_votes_May_2020": 504,
    "Poll_votes_June_2020": 2095,
    "Poll_votes_July_2020": 1867,
    "Poll_votes_August_2020": 1072,
    "Poll_votes_September_2020": 892,
    "Poll_votes_October_2020": 673,
    "Poll_votes_November_2020": 443,
    "Poll_votes_December_2020": 372,
    "Poll_votes_January_2021": 389,
    "Poll_votes_February_2021": 394,
    "Poll_votes_March_2021": 430,
    "Poll_votes_April_2021": 372
  },
  {
    "name": "Lucky",
    "url": "https://nookipedia.com/wiki/Lucky",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "dog02",
    "image_url": "https://dodo.ac/np/images/5/59/Lucky_NH.png",
    "species": "Dog",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "November",
    "birthday_day": 4,
    "sign": "Scorpio",
    "quote": "Don't bite the hand that feeds you.",
    "phrase": "rrr-owch",
    "clothing": "Open-Collar Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Graveyard",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 11,
    "Average_Popularity_Score": 21.5,
    "Nookazon_Bells_Price_Ranking": 31,
    "Nookazon_average_price_Bells": 370834,
    "Nookazon_NMT_Price_Ranking": 17,
    "Nookazon_average_price_NMT": 43,
    "Poll_Ranking_2020": 19,
    "Poll_Ranking_2020_21": 19,
    "Total_Poll_Votes_2020": 6772,
    "Total_Poll_Votes_2020_21": 7763,
    "Poll_votes_May_2020": 402,
    "Poll_votes_June_2020": 1663,
    "Poll_votes_July_2020": 1533,
    "Poll_votes_August_2020": 885,
    "Poll_votes_September_2020": 664,
    "Poll_votes_October_2020": 1009,
    "Poll_votes_November_2020": 357,
    "Poll_votes_December_2020": 259,
    "Poll_votes_January_2021": 229,
    "Poll_votes_February_2021": 261,
    "Poll_votes_March_2021": 264,
    "Poll_votes_April_2021": 237
  },
  {
    "name": "Roald",
    "url": "https://nookipedia.com/wiki/Roald",
    "alt_name": "",
    "skin_color": "194c89",
    "text_color": "fffad4",
    "id": "pgn01",
    "image_url": "https://dodo.ac/np/images/6/63/Roald_NH.png",
    "species": "Penguin",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "January",
    "birthday_day": 5,
    "sign": "Capricorn",
    "quote": "You must learn to waddle before you can swim.",
    "phrase": "b-b-buddy",
    "clothing": "Flannel Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Ice",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 12,
    "Average_Popularity_Score": 22.75,
    "Nookazon_Bells_Price_Ranking": 8,
    "Nookazon_average_price_Bells": 562500,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 11,
    "Poll_Ranking_2020_21": 16,
    "Total_Poll_Votes_2020": 8127,
    "Total_Poll_Votes_2020_21": 9078,
    "Poll_votes_May_2020": 450,
    "Poll_votes_June_2020": 2478,
    "Poll_votes_July_2020": 2104,
    "Poll_votes_August_2020": 1217,
    "Poll_votes_September_2020": 758,
    "Poll_votes_October_2020": 530,
    "Poll_votes_November_2020": 335,
    "Poll_votes_December_2020": 255,
    "Poll_votes_January_2021": 238,
    "Poll_votes_February_2021": 263,
    "Poll_votes_March_2021": 255,
    "Poll_votes_April_2021": 195
  },
  {
    "name": "Sherb",
    "url": "https://nookipedia.com/wiki/Sherb",
    "alt_name": "",
    "skin_color": "bff2ff",
    "text_color": "85a2af",
    "id": "goa09",
    "image_url": "https://dodo.ac/np/images/1/18/Sherb_NH.png",
    "species": "Goat",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "January",
    "birthday_day": 18,
    "sign": "Capricorn",
    "quote": "Forty winks is never enough.",
    "phrase": "bawwww",
    "clothing": "Snowy Sweater",
    "islander": "FALSE",
    "debut": "NH",
    "prev_phrases": [],
    "appearances": "['NH', 'PC']",
    "Amiibo": "NO",
    "hobby": "Nature",
    "interior_decor": "Cute",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 13,
    "Average_Popularity_Score": 23.25,
    "Nookazon_Bells_Price_Ranking": 83,
    "Nookazon_average_price_Bells": 233334,
    "Nookazon_NMT_Price_Ranking": 4,
    "Nookazon_average_price_NMT": 70,
    "Poll_Ranking_2020": 3,
    "Poll_Ranking_2020_21": 3,
    "Total_Poll_Votes_2020": 14170,
    "Total_Poll_Votes_2020_21": 16851,
    "Poll_votes_May_2020": 953,
    "Poll_votes_June_2020": 3374,
    "Poll_votes_July_2020": 3597,
    "Poll_votes_August_2020": 1988,
    "Poll_votes_September_2020": 1685,
    "Poll_votes_October_2020": 1173,
    "Poll_votes_November_2020": 749,
    "Poll_votes_December_2020": 651,
    "Poll_votes_January_2021": 696,
    "Poll_votes_February_2021": 663,
    "Poll_votes_March_2021": 743,
    "Poll_votes_April_2021": 579
  },
  {
    "name": "Ankha",
    "url": "https://nookipedia.com/wiki/Ankha",
    "alt_name": "",
    "skin_color": "fff80d",
    "text_color": "9b8986",
    "id": "cat19",
    "image_url": "https://dodo.ac/np/images/5/56/Ankha_NH.png",
    "species": "Cat",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "September",
    "birthday_day": 22,
    "sign": "Virgo",
    "quote": "All that glitters is not gold.",
    "phrase": "me meow",
    "clothing": "Palatial Tank Dress",
    "islander": "TRUE",
    "debut": "AC",
    "prev_phrases": [],
    "appearances": "['AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Egyptian",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 14,
    "Average_Popularity_Score": 23.5,
    "Nookazon_Bells_Price_Ranking": 70,
    "Nookazon_average_price_Bells": 250000,
    "Nookazon_NMT_Price_Ranking": 6,
    "Nookazon_average_price_NMT": 50,
    "Poll_Ranking_2020": 9,
    "Poll_Ranking_2020_21": 9,
    "Total_Poll_Votes_2020": 8286,
    "Total_Poll_Votes_2020_21": 9903,
    "Poll_votes_May_2020": 454,
    "Poll_votes_June_2020": 2311,
    "Poll_votes_July_2020": 2038,
    "Poll_votes_August_2020": 1174,
    "Poll_votes_September_2020": 868,
    "Poll_votes_October_2020": 641,
    "Poll_votes_November_2020": 414,
    "Poll_votes_December_2020": 386,
    "Poll_votes_January_2021": 385,
    "Poll_votes_February_2021": 437,
    "Poll_votes_March_2021": 446,
    "Poll_votes_April_2021": 349
  },
  {
    "name": "Bob",
    "url": "https://nookipedia.com/wiki/Bob",
    "alt_name": "",
    "skin_color": "a06fce",
    "text_color": "fffce9",
    "id": "cat00",
    "image_url": "https://dodo.ac/np/images/e/ea/Bob_NH.png",
    "species": "Cat",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "January",
    "birthday_day": 1,
    "sign": "Capricorn",
    "quote": "You only live once...or nine times.",
    "phrase": "pthhpth",
    "clothing": "Blossom Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Toys",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 15,
    "Average_Popularity_Score": 25.25,
    "Nookazon_Bells_Price_Ranking": 55,
    "Nookazon_average_price_Bells": 287500,
    "Nookazon_NMT_Price_Ranking": 12,
    "Nookazon_average_price_NMT": 49,
    "Poll_Ranking_2020": 16,
    "Poll_Ranking_2020_21": 17,
    "Total_Poll_Votes_2020": 7515,
    "Total_Poll_Votes_2020_21": 8794,
    "Poll_votes_May_2020": 457,
    "Poll_votes_June_2020": 1841,
    "Poll_votes_July_2020": 1932,
    "Poll_votes_August_2020": 1046,
    "Poll_votes_September_2020": 918,
    "Poll_votes_October_2020": 592,
    "Poll_votes_November_2020": 409,
    "Poll_votes_December_2020": 320,
    "Poll_votes_January_2021": 349,
    "Poll_votes_February_2021": 329,
    "Poll_votes_March_2021": 345,
    "Poll_votes_April_2021": 256
  },
  {
    "name": "Julian",
    "url": "https://nookipedia.com/wiki/Julian",
    "alt_name": "",
    "skin_color": "3fd8e0",
    "text_color": "fffce9",
    "id": "hrs13",
    "image_url": "https://dodo.ac/np/images/f/f2/Julian_NH.png",
    "species": "Horse",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "March",
    "birthday_day": 15,
    "sign": "Pisces",
    "quote": "Never trot when you can prance.",
    "phrase": "glitter",
    "clothing": "Space Parka",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Outer space",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 16,
    "Average_Popularity_Score": 27.75,
    "Nookazon_Bells_Price_Ranking": 2,
    "Nookazon_average_price_Bells": 750000,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 28,
    "Poll_Ranking_2020_21": 29,
    "Total_Poll_Votes_2020": 3821,
    "Total_Poll_Votes_2020_21": 4641,
    "Poll_votes_May_2020": 283,
    "Poll_votes_June_2020": 983,
    "Poll_votes_July_2020": 943,
    "Poll_votes_August_2020": 552,
    "Poll_votes_September_2020": 378,
    "Poll_votes_October_2020": 310,
    "Poll_votes_November_2020": 202,
    "Poll_votes_December_2020": 170,
    "Poll_votes_January_2021": 184,
    "Poll_votes_February_2021": 213,
    "Poll_votes_March_2021": 231,
    "Poll_votes_April_2021": 192
  },
  {
    "name": "Apollo",
    "url": "https://nookipedia.com/wiki/Apollo",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "pbr00",
    "image_url": "https://dodo.ac/np/images/0/0e/Apollo_NH_Transparent.png",
    "species": "Eagle",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 4,
    "sign": "Cancer",
    "quote": "What goes up must come down.",
    "phrase": "pah",
    "clothing": "Flight Jacket",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Bachelor pad",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 3,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 17,
    "Average_Popularity_Score": 31,
    "Nookazon_Bells_Price_Ranking": 13,
    "Nookazon_average_price_Bells": 484375,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 30,
    "Poll_Ranking_2020_21": 30,
    "Total_Poll_Votes_2020": 3747,
    "Total_Poll_Votes_2020_21": 4517,
    "Poll_votes_May_2020": 219,
    "Poll_votes_June_2020": 948,
    "Poll_votes_July_2020": 959,
    "Poll_votes_August_2020": 516,
    "Poll_votes_September_2020": 401,
    "Poll_votes_October_2020": 319,
    "Poll_votes_November_2020": 208,
    "Poll_votes_December_2020": 177,
    "Poll_votes_January_2021": 174,
    "Poll_votes_February_2021": 216,
    "Poll_votes_March_2021": 211,
    "Poll_votes_April_2021": 169
  },
  {
    "name": "Merry",
    "url": "https://nookipedia.com/wiki/Merry",
    "alt_name": "",
    "skin_color": "fff98f",
    "text_color": "879b96",
    "id": "cat16",
    "image_url": "https://dodo.ac/np/images/4/4f/Merry_NH.png",
    "species": "Cat",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "June",
    "birthday_day": 29,
    "sign": "Cancer",
    "quote": "A smile increases your face value.",
    "phrase": "mweee",
    "clothing": "Dreamy Sweater",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Colorful",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 18,
    "Average_Popularity_Score": 32,
    "Nookazon_Bells_Price_Ranking": 87,
    "Nookazon_average_price_Bells": 226875,
    "Nookazon_NMT_Price_Ranking": 13,
    "Nookazon_average_price_NMT": 48,
    "Poll_Ranking_2020": 10,
    "Poll_Ranking_2020_21": 14,
    "Total_Poll_Votes_2020": 8192,
    "Total_Poll_Votes_2020_21": 9156,
    "Poll_votes_May_2020": 101,
    "Poll_votes_June_2020": 445,
    "Poll_votes_July_2020": 1598,
    "Poll_votes_August_2020": 3540,
    "Poll_votes_September_2020": 1293,
    "Poll_votes_October_2020": 526,
    "Poll_votes_November_2020": 275,
    "Poll_votes_December_2020": 414,
    "Poll_votes_January_2021": 281,
    "Poll_votes_February_2021": 239,
    "Poll_votes_March_2021": 244,
    "Poll_votes_April_2021": 200
  },
  {
    "name": "Kabuki",
    "url": "https://nookipedia.com/wiki/Kabuki",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "cat09",
    "image_url": "https://dodo.ac/np/images/2/2a/Kabuki_NH.png",
    "species": "Cat",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "November",
    "birthday_day": 29,
    "sign": "Sagittarius",
    "quote": "If you make your opponent flinch, you have already won.",
    "phrase": "meooo-OH",
    "clothing": "Kabuki-Actor Yukata",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Asian",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 19,
    "Average_Popularity_Score": 32.5,
    "Nookazon_Bells_Price_Ranking": 2,
    "Nookazon_average_price_Bells": 750000,
    "Nookazon_NMT_Price_Ranking": 20,
    "Nookazon_average_price_NMT": 40,
    "Poll_Ranking_2020": 57,
    "Poll_Ranking_2020_21": 54,
    "Total_Poll_Votes_2020": 2014,
    "Total_Poll_Votes_2020_21": 2440,
    "Poll_votes_May_2020": 142,
    "Poll_votes_June_2020": 494,
    "Poll_votes_July_2020": 496,
    "Poll_votes_August_2020": 284,
    "Poll_votes_September_2020": 232,
    "Poll_votes_October_2020": 173,
    "Poll_votes_November_2020": 113,
    "Poll_votes_December_2020": 80,
    "Poll_votes_January_2021": 96,
    "Poll_votes_February_2021": 94,
    "Poll_votes_March_2021": 130,
    "Poll_votes_April_2021": 106
  },
  {
    "name": "Dobie",
    "url": "https://nookipedia.com/wiki/Dobie",
    "alt_name": "",
    "skin_color": 798040,
    "text_color": "fffad4",
    "id": "wol04",
    "image_url": "https://dodo.ac/np/images/7/76/Dobie_NH.png",
    "species": "Wolf",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "February",
    "birthday_day": 17,
    "sign": "Aquarius",
    "quote": "Old longings never truly fade.",
    "phrase": "ohmmm",
    "clothing": "Fuzzy Vest",
    "islander": "TRUE",
    "debut": "AC",
    "prev_phrases": [],
    "appearances": "['AC', 'E_PLUS', 'WA', 'NH']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Office",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 20,
    "Average_Popularity_Score": 33.75,
    "Nookazon_Bells_Price_Ranking": 23,
    "Nookazon_average_price_Bells": 387500,
    "Nookazon_NMT_Price_Ranking": 6,
    "Nookazon_average_price_NMT": 50,
    "Poll_Ranking_2020": 56,
    "Poll_Ranking_2020_21": 53,
    "Total_Poll_Votes_2020": 2022,
    "Total_Poll_Votes_2020_21": 2554,
    "Poll_votes_May_2020": 73,
    "Poll_votes_June_2020": 350,
    "Poll_votes_July_2020": 474,
    "Poll_votes_August_2020": 330,
    "Poll_votes_September_2020": 298,
    "Poll_votes_October_2020": 236,
    "Poll_votes_November_2020": 159,
    "Poll_votes_December_2020": 102,
    "Poll_votes_January_2021": 134,
    "Poll_votes_February_2021": 130,
    "Poll_votes_March_2021": 141,
    "Poll_votes_April_2021": 127
  },
  {
    "name": "Pekoe",
    "url": "https://nookipedia.com/wiki/Pekoe",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "cbr14",
    "image_url": "https://dodo.ac/np/images/d/df/Pekoe_NH.png",
    "species": "Bear cub",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "May",
    "birthday_day": 18,
    "sign": "Taurus",
    "quote": "Let bygones be bygones.",
    "phrase": "bud",
    "clothing": "Sleeveless Silk Dress",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": [],
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Asian",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 21,
    "Average_Popularity_Score": 34.25,
    "Nookazon_Bells_Price_Ranking": 13,
    "Nookazon_average_price_Bells": 484375,
    "Nookazon_NMT_Price_Ranking": 20,
    "Nookazon_average_price_NMT": 40,
    "Poll_Ranking_2020": 51,
    "Poll_Ranking_2020_21": 52,
    "Total_Poll_Votes_2020": 2129,
    "Total_Poll_Votes_2020_21": 2590,
    "Poll_votes_May_2020": 113,
    "Poll_votes_June_2020": 482,
    "Poll_votes_July_2020": 518,
    "Poll_votes_August_2020": 313,
    "Poll_votes_September_2020": 251,
    "Poll_votes_October_2020": 213,
    "Poll_votes_November_2020": 127,
    "Poll_votes_December_2020": 112,
    "Poll_votes_January_2021": 114,
    "Poll_votes_February_2021": 113,
    "Poll_votes_March_2021": 122,
    "Poll_votes_April_2021": 112
  },
  {
    "name": "Tangy",
    "url": "https://nookipedia.com/wiki/Tangy",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "cat05",
    "image_url": "https://dodo.ac/np/images/6/6f/Tangy_NH.png",
    "species": "Cat",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "June",
    "birthday_day": 17,
    "sign": "Gemini",
    "quote": "When life gives you lemons, make lemonade!",
    "phrase": "reeeeOWR",
    "clothing": "Retro Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Fruit",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 22,
    "Average_Popularity_Score": 39.75,
    "Nookazon_Bells_Price_Ranking": 83,
    "Nookazon_average_price_Bells": 233334,
    "Nookazon_NMT_Price_Ranking": 20,
    "Nookazon_average_price_NMT": 40,
    "Poll_Ranking_2020": 29,
    "Poll_Ranking_2020_21": 28,
    "Total_Poll_Votes_2020": 3819,
    "Total_Poll_Votes_2020_21": 4677,
    "Poll_votes_May_2020": 267,
    "Poll_votes_June_2020": 905,
    "Poll_votes_July_2020": 887,
    "Poll_votes_August_2020": 561,
    "Poll_votes_September_2020": 471,
    "Poll_votes_October_2020": 332,
    "Poll_votes_November_2020": 216,
    "Poll_votes_December_2020": 180,
    "Poll_votes_January_2021": 205,
    "Poll_votes_February_2021": 220,
    "Poll_votes_March_2021": 234,
    "Poll_votes_April_2021": 199
  },
  {
    "name": "Whitney",
    "url": "https://nookipedia.com/wiki/Whitney",
    "alt_name": "",
    "skin_color": "bff2ff",
    "text_color": "85a2af",
    "id": "wol03",
    "image_url": "https://dodo.ac/np/images/3/36/Whitney_NH.png",
    "species": "Wolf",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "September",
    "birthday_day": 17,
    "sign": "Virgo",
    "quote": "Don't cry wolf unless you mean it.",
    "phrase": "snappy",
    "clothing": "Sleeveless Shirtdress",
    "islander": "FALSE",
    "debut": "WW",
    "prev_phrases": [],
    "appearances": "['WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 23,
    "Average_Popularity_Score": 40.75,
    "Nookazon_Bells_Price_Ranking": 36,
    "Nookazon_average_price_Bells": 335417,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 38,
    "Poll_Ranking_2020_21": 38,
    "Total_Poll_Votes_2020": 2928,
    "Total_Poll_Votes_2020_21": 3602,
    "Poll_votes_May_2020": 162,
    "Poll_votes_June_2020": 720,
    "Poll_votes_July_2020": 689,
    "Poll_votes_August_2020": 417,
    "Poll_votes_September_2020": 311,
    "Poll_votes_October_2020": 265,
    "Poll_votes_November_2020": 194,
    "Poll_votes_December_2020": 170,
    "Poll_votes_January_2021": 166,
    "Poll_votes_February_2021": 176,
    "Poll_votes_March_2021": 184,
    "Poll_votes_April_2021": 148
  },
  {
    "name": "Cookie",
    "url": "https://nookipedia.com/wiki/Cookie",
    "alt_name": "",
    "skin_color": "f993ce",
    "text_color": "fffce9",
    "id": "dog08",
    "image_url": "https://dodo.ac/np/images/d/d9/Cookie_NH.png",
    "species": "Dog",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "June",
    "birthday_day": 18,
    "sign": "Gemini",
    "quote": "Don't lose sight of what you're really after.",
    "phrase": "arfer",
    "clothing": "Retro Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Cute",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 23,
    "Average_Popularity_Score": 40.75,
    "Nookazon_Bells_Price_Ranking": 32,
    "Nookazon_average_price_Bells": 368750,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 43,
    "Poll_Ranking_2020_21": 40,
    "Total_Poll_Votes_2020": 2680,
    "Total_Poll_Votes_2020_21": 3325,
    "Poll_votes_May_2020": 147,
    "Poll_votes_June_2020": 631,
    "Poll_votes_July_2020": 743,
    "Poll_votes_August_2020": 369,
    "Poll_votes_September_2020": 240,
    "Poll_votes_October_2020": 228,
    "Poll_votes_November_2020": 167,
    "Poll_votes_December_2020": 155,
    "Poll_votes_January_2021": 171,
    "Poll_votes_February_2021": 162,
    "Poll_votes_March_2021": 168,
    "Poll_votes_April_2021": 144
  },
  {
    "name": "Marshal",
    "url": "https://nookipedia.com/wiki/Marshal",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "squ17",
    "image_url": "https://dodo.ac/np/images/d/da/Marshal_NH.png",
    "species": "Squirrel",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "September",
    "birthday_day": 29,
    "sign": "Libra",
    "quote": "Seize the day.",
    "phrase": "sulky",
    "clothing": "Puffy Vest",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 25,
    "Average_Popularity_Score": 43,
    "Nookazon_Bells_Price_Ranking": 164,
    "Nookazon_average_price_Bells": 166667,
    "Nookazon_NMT_Price_Ranking": 6,
    "Nookazon_average_price_NMT": 50,
    "Poll_Ranking_2020": 1,
    "Poll_Ranking_2020_21": 1,
    "Total_Poll_Votes_2020": 21900,
    "Total_Poll_Votes_2020_21": 25603,
    "Poll_votes_May_2020": 1165,
    "Poll_votes_June_2020": 6044,
    "Poll_votes_July_2020": 5426,
    "Poll_votes_August_2020": 2820,
    "Poll_votes_September_2020": 2760,
    "Poll_votes_October_2020": 1641,
    "Poll_votes_November_2020": 1108,
    "Poll_votes_December_2020": 936,
    "Poll_votes_January_2021": 1000,
    "Poll_votes_February_2021": 913,
    "Poll_votes_March_2021": 1065,
    "Poll_votes_April_2021": 725
  },
  {
    "name": "Genji",
    "url": "https://nookipedia.com/wiki/Genji",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "rbt08",
    "image_url": "https://dodo.ac/np/images/6/67/Genji_NH.png",
    "species": "Rabbit",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "January",
    "birthday_day": 21,
    "sign": "Aquarius",
    "quote": "Fall down seven times, get up eight.",
    "phrase": "mochi",
    "clothing": "Misty Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": "['otaku']",
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Asian",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 26,
    "Average_Popularity_Score": 44.75,
    "Nookazon_Bells_Price_Ranking": 61,
    "Nookazon_average_price_Bells": 270834,
    "Nookazon_NMT_Price_Ranking": 16,
    "Nookazon_average_price_NMT": 45,
    "Poll_Ranking_2020": 50,
    "Poll_Ranking_2020_21": 51,
    "Total_Poll_Votes_2020": 2175,
    "Total_Poll_Votes_2020_21": 2605,
    "Poll_votes_May_2020": 131,
    "Poll_votes_June_2020": 469,
    "Poll_votes_July_2020": 495,
    "Poll_votes_August_2020": 298,
    "Poll_votes_September_2020": 314,
    "Poll_votes_October_2020": 221,
    "Poll_votes_November_2020": 126,
    "Poll_votes_December_2020": 121,
    "Poll_votes_January_2021": 118,
    "Poll_votes_February_2021": 113,
    "Poll_votes_March_2021": 98,
    "Poll_votes_April_2021": 101
  },
  {
    "name": "Reneigh",
    "url": "https://nookipedia.com/wiki/Reneigh",
    "alt_name": "",
    "skin_color": "76494e",
    "text_color": "fffce9",
    "id": "hrs16",
    "image_url": "https://dodo.ac/np/images/9/92/Reneigh_NH.png",
    "species": "Horse",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "June",
    "birthday_day": 4,
    "sign": "Gemini",
    "quote": "You can only be you, so be the best you that you can be.",
    "phrase": "ayup yup",
    "clothing": "Zigzag-Print Dress",
    "islander": "FALSE",
    "debut": "NH",
    "prev_phrases": [],
    "appearances": "['NH', 'PC']",
    "Amiibo": "NO",
    "hobby": "Play",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 28,
    "Average_Popularity_Score": 48.75,
    "Nookazon_Bells_Price_Ranking": 18,
    "Nookazon_average_price_Bells": 445834,
    "Nookazon_NMT_Price_Ranking": 27,
    "Nookazon_average_price_NMT": 35,
    "Poll_Ranking_2020": 75,
    "Poll_Ranking_2020_21": 75,
    "Total_Poll_Votes_2020": 1291,
    "Total_Poll_Votes_2020_21": 1677,
    "Poll_votes_May_2020": 62,
    "Poll_votes_June_2020": 273,
    "Poll_votes_July_2020": 309,
    "Poll_votes_August_2020": 200,
    "Poll_votes_September_2020": 165,
    "Poll_votes_October_2020": 128,
    "Poll_votes_November_2020": 82,
    "Poll_votes_December_2020": 72,
    "Poll_votes_January_2021": 98,
    "Poll_votes_February_2021": 99,
    "Poll_votes_March_2021": 106,
    "Poll_votes_April_2021": 83
  },
  {
    "name": "Diana",
    "url": "https://nookipedia.com/wiki/Diana",
    "alt_name": "",
    "skin_color": "ffebff",
    "text_color": 725661,
    "id": "der08",
    "image_url": "https://dodo.ac/np/images/1/1f/Diana_NH.png",
    "species": "Deer",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 4,
    "sign": "Capricorn",
    "quote": "Sometimes you have to lose to win.",
    "phrase": "no doy",
    "clothing": "Mysterious Dress",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 27,
    "Average_Popularity_Score": 48,
    "Nookazon_Bells_Price_Ranking": 97,
    "Nookazon_average_price_Bells": 200000,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 22,
    "Poll_Ranking_2020_21": 22,
    "Total_Poll_Votes_2020": 5448,
    "Total_Poll_Votes_2020_21": 6633,
    "Poll_votes_May_2020": 279,
    "Poll_votes_June_2020": 1411,
    "Poll_votes_July_2020": 1374,
    "Poll_votes_August_2020": 781,
    "Poll_votes_September_2020": 575,
    "Poll_votes_October_2020": 432,
    "Poll_votes_November_2020": 307,
    "Poll_votes_December_2020": 289,
    "Poll_votes_January_2021": 260,
    "Poll_votes_February_2021": 319,
    "Poll_votes_March_2021": 353,
    "Poll_votes_April_2021": 253
  },
  {
    "name": "Fauna",
    "url": "https://nookipedia.com/wiki/Fauna",
    "alt_name": "",
    "skin_color": "7a2500",
    "text_color": "fffce9",
    "id": "der00",
    "image_url": "https://dodo.ac/np/images/9/91/Fauna_NH.png",
    "species": "Deer",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 26,
    "sign": "Aries",
    "quote": "The first step is always the hardest.",
    "phrase": "dearie",
    "clothing": "Bohemian Tunic Dress",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Normal",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 3,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 29,
    "Average_Popularity_Score": 49,
    "Nookazon_Bells_Price_Ranking": 97,
    "Nookazon_average_price_Bells": 200000,
    "Nookazon_NMT_Price_Ranking": 79,
    "Nookazon_average_price_NMT": 26,
    "Poll_Ranking_2020": 15,
    "Poll_Ranking_2020_21": 10,
    "Total_Poll_Votes_2020": 7746,
    "Total_Poll_Votes_2020_21": 9601,
    "Poll_votes_May_2020": 423,
    "Poll_votes_June_2020": 1942,
    "Poll_votes_July_2020": 1801,
    "Poll_votes_August_2020": 1145,
    "Poll_votes_September_2020": 890,
    "Poll_votes_October_2020": 684,
    "Poll_votes_November_2020": 449,
    "Poll_votes_December_2020": 412,
    "Poll_votes_January_2021": 447,
    "Poll_votes_February_2021": 487,
    "Poll_votes_March_2021": 514,
    "Poll_votes_April_2021": 407
  },
  {
    "name": "Ketchup",
    "url": "https://nookipedia.com/wiki/Ketchup",
    "alt_name": "",
    "skin_color": "ff4040",
    "text_color": "fffad4",
    "id": "duk13",
    "image_url": "https://dodo.ac/np/images/4/42/Ketchup_NH.png",
    "species": "Duck",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "July",
    "birthday_day": 27,
    "sign": "Leo",
    "quote": "When in doubt, eat a tomato!",
    "phrase": "bitty",
    "clothing": "Lacy Dress",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.058823529,
    "Rarity": "0.17%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 29,
    "Average_Popularity_Score": 49,
    "Nookazon_Bells_Price_Ranking": 97,
    "Nookazon_average_price_Bells": 200000,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 24,
    "Poll_Ranking_2020_21": 24,
    "Total_Poll_Votes_2020": 4953,
    "Total_Poll_Votes_2020_21": 6019,
    "Poll_votes_May_2020": 284,
    "Poll_votes_June_2020": 1110,
    "Poll_votes_July_2020": 1259,
    "Poll_votes_August_2020": 709,
    "Poll_votes_September_2020": 687,
    "Poll_votes_October_2020": 403,
    "Poll_votes_November_2020": 262,
    "Poll_votes_December_2020": 239,
    "Poll_votes_January_2021": 255,
    "Poll_votes_February_2021": 249,
    "Poll_votes_March_2021": 326,
    "Poll_votes_April_2021": 236
  },
  {
    "name": "Sylvana",
    "url": "https://nookipedia.com/wiki/Sylvana",
    "alt_name": "",
    "skin_color": "c0ab72",
    "text_color": "fffce9",
    "id": "squ14",
    "image_url": "https://dodo.ac/np/images/f/fc/Sylvana_NH.png",
    "species": "Squirrel",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "October",
    "birthday_day": 22,
    "sign": "Libra",
    "quote": "Remember to see the forest between the trees.",
    "phrase": "hubbub",
    "clothing": "Kiwi Dress",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 31,
    "Average_Popularity_Score": 50.5,
    "Nookazon_Bells_Price_Ranking": 37,
    "Nookazon_average_price_Bells": 333334,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 54,
    "Poll_Ranking_2020_21": 57,
    "Total_Poll_Votes_2020": 2057,
    "Total_Poll_Votes_2020_21": 2385,
    "Poll_votes_May_2020": 42,
    "Poll_votes_June_2020": 195,
    "Poll_votes_July_2020": 226,
    "Poll_votes_August_2020": 1163,
    "Poll_votes_September_2020": 153,
    "Poll_votes_October_2020": 132,
    "Poll_votes_November_2020": 80,
    "Poll_votes_December_2020": 66,
    "Poll_votes_January_2021": 87,
    "Poll_votes_February_2021": 80,
    "Poll_votes_March_2021": 85,
    "Poll_votes_April_2021": 76
  },
  {
    "name": "Erik",
    "url": "https://nookipedia.com/wiki/Erik",
    "alt_name": "",
    "skin_color": "e8b010",
    "text_color": "fffce9",
    "id": "der09",
    "image_url": "https://dodo.ac/np/images/8/88/Erik_NH.png",
    "species": "Deer",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 27,
    "sign": "Leo",
    "quote": "If you're afraid of wolves, don't go to the woods.",
    "phrase": "chow down",
    "clothing": "Yodel Sweater",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Ice",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 32,
    "Average_Popularity_Score": 51.75,
    "Nookazon_Bells_Price_Ranking": 130,
    "Nookazon_average_price_Bells": 187500,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 14,
    "Poll_Ranking_2020_21": 13,
    "Total_Poll_Votes_2020": 7787,
    "Total_Poll_Votes_2020_21": 9309,
    "Poll_votes_May_2020": 281,
    "Poll_votes_June_2020": 1139,
    "Poll_votes_July_2020": 1197,
    "Poll_votes_August_2020": 690,
    "Poll_votes_September_2020": 2488,
    "Poll_votes_October_2020": 993,
    "Poll_votes_November_2020": 572,
    "Poll_votes_December_2020": 427,
    "Poll_votes_January_2021": 413,
    "Poll_votes_February_2021": 400,
    "Poll_votes_March_2021": 412,
    "Poll_votes_April_2021": 297
  },
  {
    "name": "Fang",
    "url": "https://nookipedia.com/wiki/Fang",
    "alt_name": "",
    "skin_color": "ddcdca",
    "text_color": "4b4496",
    "id": "wol06",
    "image_url": "https://dodo.ac/np/images/9/9e/Fang_NH_Transparent.png",
    "species": "Wolf",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 18,
    "sign": "Sagittarius",
    "quote": "You mess with the wolf, you get the fangs.",
    "phrase": "cha-chomp",
    "clothing": "Snowy Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 35,
    "Average_Popularity_Score": 54.75,
    "Nookazon_Bells_Price_Ranking": 70,
    "Nookazon_average_price_Bells": 250000,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 53,
    "Poll_Ranking_2020_21": 49,
    "Total_Poll_Votes_2020": 2086,
    "Total_Poll_Votes_2020_21": 2711,
    "Poll_votes_May_2020": 154,
    "Poll_votes_June_2020": 642,
    "Poll_votes_July_2020": 62,
    "Poll_votes_August_2020": 374,
    "Poll_votes_September_2020": 284,
    "Poll_votes_October_2020": 227,
    "Poll_votes_November_2020": 163,
    "Poll_votes_December_2020": 180,
    "Poll_votes_January_2021": 172,
    "Poll_votes_February_2021": 141,
    "Poll_votes_March_2021": 183,
    "Poll_votes_April_2021": 129
  },
  {
    "name": "Lolly",
    "url": "https://nookipedia.com/wiki/Lolly",
    "alt_name": "",
    "skin_color": "bff2ff",
    "text_color": "85a2af",
    "id": "cat18",
    "image_url": "https://dodo.ac/np/images/1/16/Lolly_NH.png",
    "species": "Cat",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 27,
    "sign": "Aries",
    "quote": "Laughter is the best medicine.",
    "phrase": "bonbon",
    "clothing": "Snowy Sweater",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Normal",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 33,
    "Average_Popularity_Score": 54.25,
    "Nookazon_Bells_Price_Ranking": 164,
    "Nookazon_average_price_Bells": 166667,
    "Nookazon_NMT_Price_Ranking": 13,
    "Nookazon_average_price_NMT": 48,
    "Poll_Ranking_2020": 20,
    "Poll_Ranking_2020_21": 20,
    "Total_Poll_Votes_2020": 5740,
    "Total_Poll_Votes_2020_21": 7356,
    "Poll_votes_May_2020": 335,
    "Poll_votes_June_2020": 1239,
    "Poll_votes_July_2020": 1329,
    "Poll_votes_August_2020": 794,
    "Poll_votes_September_2020": 738,
    "Poll_votes_October_2020": 563,
    "Poll_votes_November_2020": 370,
    "Poll_votes_December_2020": 372,
    "Poll_votes_January_2021": 420,
    "Poll_votes_February_2021": 410,
    "Poll_votes_March_2021": 443,
    "Poll_votes_April_2021": 343
  },
  {
    "name": "Filbert",
    "url": "https://nookipedia.com/wiki/Filbert",
    "alt_name": "",
    "skin_color": "55cfff",
    "text_color": "fffce9",
    "id": "squ02",
    "image_url": "https://dodo.ac/np/images/8/81/Filbert_NH.png",
    "species": "Squirrel",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 3,
    "sign": "Gemini",
    "quote": "Don't go nuts or anything.",
    "phrase": "bucko",
    "clothing": "Tree Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Outer space",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 34,
    "Average_Popularity_Score": 54.5,
    "Nookazon_Bells_Price_Ranking": 97,
    "Nookazon_average_price_Bells": 200000,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 34,
    "Poll_Ranking_2020_21": 35,
    "Total_Poll_Votes_2020": 3240,
    "Total_Poll_Votes_2020_21": 3846,
    "Poll_votes_May_2020": 220,
    "Poll_votes_June_2020": 745,
    "Poll_votes_July_2020": 744,
    "Poll_votes_August_2020": 465,
    "Poll_votes_September_2020": 394,
    "Poll_votes_October_2020": 296,
    "Poll_votes_November_2020": 208,
    "Poll_votes_December_2020": 168,
    "Poll_votes_January_2021": 170,
    "Poll_votes_February_2021": 142,
    "Poll_votes_March_2021": 164,
    "Poll_votes_April_2021": 130
  },
  {
    "name": "Bluebear",
    "url": "https://nookipedia.com/wiki/Bluebear",
    "alt_name": "",
    "skin_color": "3fd8e0",
    "text_color": "fffce9",
    "id": "cbr00",
    "image_url": "https://dodo.ac/np/images/4/49/Bluebear_NH.png",
    "species": "Bear cub",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "June",
    "birthday_day": 24,
    "sign": "Cancer",
    "quote": "Candy makes the world go 'round.",
    "phrase": "peach",
    "clothing": "Aran-Knit Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Cute",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 36,
    "Average_Popularity_Score": 56.75,
    "Nookazon_Bells_Price_Ranking": 58,
    "Nookazon_average_price_Bells": 284375,
    "Nookazon_NMT_Price_Ranking": 91,
    "Nookazon_average_price_NMT": 23,
    "Poll_Ranking_2020": 39,
    "Poll_Ranking_2020_21": 39,
    "Total_Poll_Votes_2020": 2820,
    "Total_Poll_Votes_2020_21": 3505,
    "Poll_votes_May_2020": 154,
    "Poll_votes_June_2020": 648,
    "Poll_votes_July_2020": 692,
    "Poll_votes_August_2020": 443,
    "Poll_votes_September_2020": 324,
    "Poll_votes_October_2020": 239,
    "Poll_votes_November_2020": 184,
    "Poll_votes_December_2020": 136,
    "Poll_votes_January_2021": 183,
    "Poll_votes_February_2021": 158,
    "Poll_votes_March_2021": 198,
    "Poll_votes_April_2021": 146
  },
  {
    "name": "Daisy",
    "url": "https://nookipedia.com/wiki/Daisy",
    "alt_name": "",
    "skin_color": "fff98f",
    "text_color": "879b96",
    "id": "dog07",
    "image_url": "https://dodo.ac/np/images/9/96/Daisy_NH.png",
    "species": "Dog",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "November",
    "birthday_day": 16,
    "sign": "Scorpio",
    "quote": "It's not always a dog-eat-dog world.",
    "phrase": "bow-WOW",
    "clothing": "Colorful Striped Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Normal",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 38,
    "Average_Popularity_Score": 58,
    "Nookazon_Bells_Price_Ranking": 47,
    "Nookazon_average_price_Bells": 325000,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 69,
    "Poll_Ranking_2020_21": 67,
    "Total_Poll_Votes_2020": 1496,
    "Total_Poll_Votes_2020_21": 1893,
    "Poll_votes_May_2020": 103,
    "Poll_votes_June_2020": 347,
    "Poll_votes_July_2020": 334,
    "Poll_votes_August_2020": 221,
    "Poll_votes_September_2020": 196,
    "Poll_votes_October_2020": 137,
    "Poll_votes_November_2020": 81,
    "Poll_votes_December_2020": 77,
    "Poll_votes_January_2021": 91,
    "Poll_votes_February_2021": 84,
    "Poll_votes_March_2021": 123,
    "Poll_votes_April_2021": 99
  },
  {
    "name": "Kiki",
    "url": "https://nookipedia.com/wiki/Kiki",
    "alt_name": "",
    "skin_color": "4F4F74",
    "text_color": "fffce9",
    "id": "cat04",
    "image_url": "https://dodo.ac/np/images/c/c5/Kiki_NH.png",
    "species": "Cat",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "October",
    "birthday_day": 8,
    "sign": "Libra",
    "quote": "Nothing ventured, nothing gained.",
    "phrase": "kitty cat",
    "clothing": "Argyle Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Normal",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 36,
    "Average_Popularity_Score": 56.75,
    "Nookazon_Bells_Price_Ranking": 130,
    "Nookazon_average_price_Bells": 187500,
    "Nookazon_NMT_Price_Ranking": 5,
    "Nookazon_average_price_NMT": 52,
    "Poll_Ranking_2020": 49,
    "Poll_Ranking_2020_21": 46,
    "Total_Poll_Votes_2020": 2249,
    "Total_Poll_Votes_2020_21": 2839,
    "Poll_votes_May_2020": 138,
    "Poll_votes_June_2020": 429,
    "Poll_votes_July_2020": 409,
    "Poll_votes_August_2020": 291,
    "Poll_votes_September_2020": 300,
    "Poll_votes_October_2020": 379,
    "Poll_votes_November_2020": 176,
    "Poll_votes_December_2020": 127,
    "Poll_votes_January_2021": 114,
    "Poll_votes_February_2021": 149,
    "Poll_votes_March_2021": 187,
    "Poll_votes_April_2021": 140
  },
  {
    "name": "Marina",
    "url": "https://nookipedia.com/wiki/Marina",
    "alt_name": "",
    "skin_color": "f993ce",
    "text_color": "fffce9",
    "id": "ocp01",
    "image_url": "https://dodo.ac/np/images/2/25/Marina_NH.png",
    "species": "Octopus",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "June",
    "birthday_day": 26,
    "sign": "Cancer",
    "quote": "If you can't say something nice, don't say anything at all.",
    "phrase": "blurp",
    "clothing": "Dreamy Sweater",
    "islander": "TRUE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Cute",
    "P (individual within species)": 0.333333333,
    "Rarity": "0.95%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 39,
    "Average_Popularity_Score": 58.25,
    "Nookazon_Bells_Price_Ranking": 37,
    "Nookazon_average_price_Bells": 333334,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 6,
    "Poll_Ranking_2020_21": 6,
    "Total_Poll_Votes_2020": 9293,
    "Total_Poll_Votes_2020_21": 11121,
    "Poll_votes_May_2020": 520,
    "Poll_votes_June_2020": 2521,
    "Poll_votes_July_2020": 2440,
    "Poll_votes_August_2020": 1240,
    "Poll_votes_September_2020": 911,
    "Poll_votes_October_2020": 725,
    "Poll_votes_November_2020": 489,
    "Poll_votes_December_2020": 447,
    "Poll_votes_January_2021": 460,
    "Poll_votes_February_2021": 460,
    "Poll_votes_March_2021": 516,
    "Poll_votes_April_2021": 392
  },
  {
    "name": "Wolfgang",
    "url": "https://nookipedia.com/wiki/Wolfgang",
    "alt_name": "",
    "skin_color": "194c89",
    "text_color": "fffad4",
    "id": "wol02",
    "image_url": "https://dodo.ac/np/images/a/aa/Wolfgang_NH.png",
    "species": "Wolf",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "November",
    "birthday_day": 25,
    "sign": "Sagittarius",
    "quote": "Don't be afraid to show your fangs.",
    "phrase": "snarrrl",
    "clothing": "Flight Jacket",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 41,
    "Average_Popularity_Score": 62.75,
    "Nookazon_Bells_Price_Ranking": 76,
    "Nookazon_average_price_Bells": 243750,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 63,
    "Poll_Ranking_2020_21": 62,
    "Total_Poll_Votes_2020": 1679,
    "Total_Poll_Votes_2020_21": 2172,
    "Poll_votes_May_2020": 123,
    "Poll_votes_June_2020": 420,
    "Poll_votes_July_2020": 385,
    "Poll_votes_August_2020": 212,
    "Poll_votes_September_2020": 175,
    "Poll_votes_October_2020": 157,
    "Poll_votes_November_2020": 108,
    "Poll_votes_December_2020": 99,
    "Poll_votes_January_2021": 106,
    "Poll_votes_February_2021": 124,
    "Poll_votes_March_2021": 135,
    "Poll_votes_April_2021": 128
  },
  {
    "name": "Teddy",
    "url": "https://nookipedia.com/wiki/Teddy",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "bea00",
    "image_url": "https://dodo.ac/np/images/b/b9/Teddy_NH.png",
    "species": "Bear",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "September",
    "birthday_day": 26,
    "sign": "Libra",
    "quote": "No pain, no gain!",
    "phrase": "grooof",
    "clothing": "Energetic Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Cabin",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 42,
    "Average_Popularity_Score": 63.25,
    "Nookazon_Bells_Price_Ranking": 37,
    "Nookazon_average_price_Bells": 333334,
    "Nookazon_NMT_Price_Ranking": 32,
    "Nookazon_average_price_NMT": 32,
    "Poll_Ranking_2020": 93,
    "Poll_Ranking_2020_21": 92,
    "Total_Poll_Votes_2020": 1019,
    "Total_Poll_Votes_2020_21": 1250,
    "Poll_votes_May_2020": 36,
    "Poll_votes_June_2020": 267,
    "Poll_votes_July_2020": 247,
    "Poll_votes_August_2020": 137,
    "Poll_votes_September_2020": 129,
    "Poll_votes_October_2020": 99,
    "Poll_votes_November_2020": 56,
    "Poll_votes_December_2020": 48,
    "Poll_votes_January_2021": 59,
    "Poll_votes_February_2021": 60,
    "Poll_votes_March_2021": 62,
    "Poll_votes_April_2021": 50
  },
  {
    "name": "Rudy",
    "url": "https://nookipedia.com/wiki/Rudy",
    "alt_name": "",
    "skin_color": "7a2500",
    "text_color": "fffce9",
    "id": "cat20",
    "image_url": "https://dodo.ac/np/images/7/7e/Rudy_NH.png",
    "species": "Cat",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 20,
    "sign": "Sagittarius",
    "quote": "Always land on your feet!",
    "phrase": "mush",
    "clothing": "Simple Parka",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Toys",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 43,
    "Average_Popularity_Score": 67.5,
    "Nookazon_Bells_Price_Ranking": 45,
    "Nookazon_average_price_Bells": 331511,
    "Nookazon_NMT_Price_Ranking": 25,
    "Nookazon_average_price_NMT": 39,
    "Poll_Ranking_2020": 100,
    "Poll_Ranking_2020_21": 100,
    "Total_Poll_Votes_2020": 951,
    "Total_Poll_Votes_2020_21": 1205,
    "Poll_votes_May_2020": 39,
    "Poll_votes_June_2020": 186,
    "Poll_votes_July_2020": 233,
    "Poll_votes_August_2020": 150,
    "Poll_votes_September_2020": 114,
    "Poll_votes_October_2020": 105,
    "Poll_votes_November_2020": 69,
    "Poll_votes_December_2020": 55,
    "Poll_votes_January_2021": 66,
    "Poll_votes_February_2021": 62,
    "Poll_votes_March_2021": 73,
    "Poll_votes_April_2021": 53
  },
  {
    "name": "Cherry",
    "url": "https://nookipedia.com/wiki/Cherry",
    "alt_name": "",
    "skin_color": "ff6183",
    "text_color": "fffce9",
    "id": "dog17",
    "image_url": "https://dodo.ac/np/images/3/3e/Cherry_NH.png",
    "species": "Dog",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "May",
    "birthday_day": 11,
    "sign": "Taurus",
    "quote": "One dog barks at something, the rest bark at him.",
    "phrase": "what what",
    "clothing": "Spider-Web Tee",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Modern",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 44,
    "Average_Popularity_Score": 68.25,
    "Nookazon_Bells_Price_Ranking": 172,
    "Nookazon_average_price_Bells": 165365,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 26,
    "Poll_Ranking_2020_21": 25,
    "Total_Poll_Votes_2020": 3976,
    "Total_Poll_Votes_2020_21": 4892,
    "Poll_votes_May_2020": 251,
    "Poll_votes_June_2020": 1002,
    "Poll_votes_July_2020": 975,
    "Poll_votes_August_2020": 556,
    "Poll_votes_September_2020": 394,
    "Poll_votes_October_2020": 352,
    "Poll_votes_November_2020": 244,
    "Poll_votes_December_2020": 202,
    "Poll_votes_January_2021": 211,
    "Poll_votes_February_2021": 218,
    "Poll_votes_March_2021": 251,
    "Poll_votes_April_2021": 236
  },
  {
    "name": "June",
    "url": "https://nookipedia.com/wiki/June_(villager)",
    "alt_name": "",
    "skin_color": "c0ab72",
    "text_color": "fffce9",
    "id": "cbr13",
    "image_url": "https://dodo.ac/np/images/8/85/June_NH.png",
    "species": "Bear cub",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "May",
    "birthday_day": 21,
    "sign": "Gemini",
    "quote": "Dream big, expect little.",
    "phrase": "rainbow",
    "clothing": "Hibiscus Muumuu",
    "islander": "TRUE",
    "debut": "AC",
    "prev_phrases": [],
    "appearances": "['AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Beach",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 45,
    "Average_Popularity_Score": 70.25,
    "Nookazon_Bells_Price_Ranking": 70,
    "Nookazon_average_price_Bells": 250000,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 77,
    "Poll_Ranking_2020_21": 80,
    "Total_Poll_Votes_2020": 1205,
    "Total_Poll_Votes_2020_21": 1455,
    "Poll_votes_May_2020": 53,
    "Poll_votes_June_2020": 354,
    "Poll_votes_July_2020": 300,
    "Poll_votes_August_2020": 148,
    "Poll_votes_September_2020": 131,
    "Poll_votes_October_2020": 108,
    "Poll_votes_November_2020": 52,
    "Poll_votes_December_2020": 59,
    "Poll_votes_January_2021": 64,
    "Poll_votes_February_2021": 60,
    "Poll_votes_March_2021": 71,
    "Poll_votes_April_2021": 55
  },
  {
    "name": "Zucker",
    "url": "https://nookipedia.com/wiki/Zucker",
    "alt_name": "",
    "skin_color": "e4b887",
    "text_color": "fffce9",
    "id": "ocp02",
    "image_url": "https://dodo.ac/np/images/7/7f/Zucker_NH.png",
    "species": "Octopus",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "March",
    "birthday_day": 8,
    "sign": "Pisces",
    "quote": "There's no such thing as luck.",
    "phrase": "bloop",
    "clothing": "Happi Tee",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.333333333,
    "Rarity": "0.95%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 40,
    "Average_Popularity_Score": 60.5,
    "Nookazon_Bells_Price_Ranking": 130,
    "Nookazon_average_price_Bells": 187500,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 4,
    "Poll_Ranking_2020_21": 4,
    "Total_Poll_Votes_2020": 11610,
    "Total_Poll_Votes_2020_21": 14260,
    "Poll_votes_May_2020": 654,
    "Poll_votes_June_2020": 3079,
    "Poll_votes_July_2020": 2881,
    "Poll_votes_August_2020": 1573,
    "Poll_votes_September_2020": 1131,
    "Poll_votes_October_2020": 1036,
    "Poll_votes_November_2020": 654,
    "Poll_votes_December_2020": 602,
    "Poll_votes_January_2021": 684,
    "Poll_votes_February_2021": 674,
    "Poll_votes_March_2021": 734,
    "Poll_votes_April_2021": 558
  },
  {
    "name": "Rosie",
    "url": "https://nookipedia.com/wiki/Rosie",
    "alt_name": "",
    "skin_color": "7fa9ff",
    "text_color": "fffce9",
    "id": "cat02",
    "image_url": "https://dodo.ac/np/images/6/67/Rosie_NH.png",
    "species": "Cat",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "February",
    "birthday_day": 27,
    "sign": "Pisces",
    "quote": "One good purr deserves another.",
    "phrase": "silly",
    "clothing": "Dazed Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Cute",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 46,
    "Average_Popularity_Score": 70.75,
    "Nookazon_Bells_Price_Ranking": 149,
    "Nookazon_average_price_Bells": 181771,
    "Nookazon_NMT_Price_Ranking": 72,
    "Nookazon_average_price_NMT": 28,
    "Poll_Ranking_2020": 31,
    "Poll_Ranking_2020_21": 31,
    "Total_Poll_Votes_2020": 3427,
    "Total_Poll_Votes_2020_21": 4247,
    "Poll_votes_May_2020": 235,
    "Poll_votes_June_2020": 796,
    "Poll_votes_July_2020": 818,
    "Poll_votes_August_2020": 489,
    "Poll_votes_September_2020": 411,
    "Poll_votes_October_2020": 298,
    "Poll_votes_November_2020": 204,
    "Poll_votes_December_2020": 176,
    "Poll_votes_January_2021": 202,
    "Poll_votes_February_2021": 210,
    "Poll_votes_March_2021": 239,
    "Poll_votes_April_2021": 169
  },
  {
    "name": "Chrissy",
    "url": "https://nookipedia.com/wiki/Chrissy",
    "alt_name": "",
    "skin_color": "f993ce",
    "text_color": "fffce9",
    "id": "rbt13",
    "image_url": "https://dodo.ac/np/images/6/6a/Chrissy_NH.png",
    "species": "Rabbit",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "August",
    "birthday_day": 28,
    "sign": "Virgo",
    "quote": "A fool and their Bells are soon parted.",
    "phrase": "sparkles",
    "clothing": "Marble-Dots Dress",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Cute",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 49,
    "Average_Popularity_Score": 74,
    "Nookazon_Bells_Price_Ranking": 127,
    "Nookazon_average_price_Bells": 190000,
    "Nookazon_NMT_Price_Ranking": 27,
    "Nookazon_average_price_NMT": 35,
    "Poll_Ranking_2020": 70,
    "Poll_Ranking_2020_21": 71,
    "Total_Poll_Votes_2020": 1489,
    "Total_Poll_Votes_2020_21": 1839,
    "Poll_votes_May_2020": 85,
    "Poll_votes_June_2020": 359,
    "Poll_votes_July_2020": 362,
    "Poll_votes_August_2020": 218,
    "Poll_votes_September_2020": 178,
    "Poll_votes_October_2020": 132,
    "Poll_votes_November_2020": 84,
    "Poll_votes_December_2020": 71,
    "Poll_votes_January_2021": 85,
    "Poll_votes_February_2021": 82,
    "Poll_votes_March_2021": 98,
    "Poll_votes_April_2021": 85
  },
  {
    "name": "Punchy",
    "url": "https://nookipedia.com/wiki/Punchy",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "cat06",
    "image_url": "https://dodo.ac/np/images/6/6d/Punchy_NH.png",
    "species": "Cat",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "April",
    "birthday_day": 11,
    "sign": "Aries",
    "quote": "There's always more fish in the sea!",
    "phrase": "mrmpht",
    "clothing": "Madras Plaid Shirt",
    "islander": "FALSE",
    "debut": "AC",
    "prev_phrases": [],
    "appearances": "['AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Normal",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 47,
    "Average_Popularity_Score": 72.25,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 17,
    "Nookazon_average_price_NMT": 43,
    "Poll_Ranking_2020": 40,
    "Poll_Ranking_2020_21": 41,
    "Total_Poll_Votes_2020": 2782,
    "Total_Poll_Votes_2020_21": 3283,
    "Poll_votes_May_2020": 254,
    "Poll_votes_June_2020": 694,
    "Poll_votes_July_2020": 652,
    "Poll_votes_August_2020": 353,
    "Poll_votes_September_2020": 327,
    "Poll_votes_October_2020": 226,
    "Poll_votes_November_2020": 148,
    "Poll_votes_December_2020": 128,
    "Poll_votes_January_2021": 131,
    "Poll_votes_February_2021": 123,
    "Poll_votes_March_2021": 133,
    "Poll_votes_April_2021": 114
  },
  {
    "name": "Mitzi",
    "url": "https://nookipedia.com/wiki/Mitzi",
    "alt_name": "",
    "skin_color": "7fa9ff",
    "text_color": "fffce9",
    "id": "cat01",
    "image_url": "https://dodo.ac/np/images/6/63/Mitzi_NH.png",
    "species": "Cat",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "September",
    "birthday_day": 25,
    "sign": "Libra",
    "quote": "Practice makes purrrfect!",
    "phrase": "mew",
    "clothing": "Gumdrop Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Normal",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 50,
    "Average_Popularity_Score": 75.25,
    "Nookazon_Bells_Price_Ranking": 70,
    "Nookazon_average_price_Bells": 252000,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 92,
    "Poll_Ranking_2020_21": 90,
    "Total_Poll_Votes_2020": 1041,
    "Total_Poll_Votes_2020_21": 1297,
    "Poll_votes_May_2020": 87,
    "Poll_votes_June_2020": 286,
    "Poll_votes_July_2020": 235,
    "Poll_votes_August_2020": 122,
    "Poll_votes_September_2020": 104,
    "Poll_votes_October_2020": 95,
    "Poll_votes_November_2020": 60,
    "Poll_votes_December_2020": 52,
    "Poll_votes_January_2021": 58,
    "Poll_votes_February_2021": 49,
    "Poll_votes_March_2021": 86,
    "Poll_votes_April_2021": 63
  },
  {
    "name": "Static",
    "url": "https://nookipedia.com/wiki/Static",
    "alt_name": "",
    "skin_color": "a06fce",
    "text_color": "fffce9",
    "id": "squ08",
    "image_url": "https://dodo.ac/np/images/6/68/Static_NH.png",
    "species": "Squirrel",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 9,
    "sign": "Cancer",
    "quote": "Lightning never strikes twice.",
    "phrase": "krzzt",
    "clothing": "Dragon Jacket",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Metal",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 51,
    "Average_Popularity_Score": 76.5,
    "Nookazon_Bells_Price_Ranking": 93,
    "Nookazon_average_price_Bells": 216667,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 78,
    "Poll_Ranking_2020_21": 81,
    "Total_Poll_Votes_2020": 1183,
    "Total_Poll_Votes_2020_21": 1427,
    "Poll_votes_May_2020": 75,
    "Poll_votes_June_2020": 247,
    "Poll_votes_July_2020": 250,
    "Poll_votes_August_2020": 213,
    "Poll_votes_September_2020": 159,
    "Poll_votes_October_2020": 117,
    "Poll_votes_November_2020": 74,
    "Poll_votes_December_2020": 48,
    "Poll_votes_January_2021": 62,
    "Poll_votes_February_2021": 50,
    "Poll_votes_March_2021": 67,
    "Poll_votes_April_2021": 65
  },
  {
    "name": "Agnes",
    "url": "https://nookipedia.com/wiki/Agnes",
    "alt_name": "",
    "skin_color": 515151,
    "text_color": "fffce9",
    "id": "pig17",
    "image_url": "https://dodo.ac/np/images/4/4e/Agnes_NH_Transparent.png",
    "species": "Pig",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 21,
    "sign": "Taurus",
    "quote": "You reap what you sow.",
    "phrase": "snuffle",
    "clothing": "Striped Halter Dress",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 52,
    "Average_Popularity_Score": 76.75,
    "Nookazon_Bells_Price_Ranking": 97,
    "Nookazon_average_price_Bells": 200000,
    "Nookazon_NMT_Price_Ranking": 80,
    "Nookazon_average_price_NMT": 25,
    "Poll_Ranking_2020": 66,
    "Poll_Ranking_2020_21": 65,
    "Total_Poll_Votes_2020": 1564,
    "Total_Poll_Votes_2020_21": 1988,
    "Poll_votes_May_2020": 65,
    "Poll_votes_June_2020": 376,
    "Poll_votes_July_2020": 400,
    "Poll_votes_August_2020": 228,
    "Poll_votes_September_2020": 169,
    "Poll_votes_October_2020": 146,
    "Poll_votes_November_2020": 95,
    "Poll_votes_December_2020": 85,
    "Poll_votes_January_2021": 96,
    "Poll_votes_February_2021": 116,
    "Poll_votes_March_2021": 120,
    "Poll_votes_April_2021": 92
  },
  {
    "name": "Bam",
    "url": "https://nookipedia.com/wiki/Bam",
    "alt_name": "",
    "skin_color": "0961f6",
    "text_color": "fffce9",
    "id": "der01",
    "image_url": "https://dodo.ac/np/images/2/2b/Bam_NH.png",
    "species": "Deer",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "November",
    "birthday_day": 7,
    "sign": "Scorpio",
    "quote": "Get while the getting's good.",
    "phrase": "kablang",
    "clothing": "Athletic Jacket",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": "['boosh', 'prang']",
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Gym",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 48,
    "Average_Popularity_Score": 72.5,
    "Nookazon_Bells_Price_Ranking": 64,
    "Nookazon_average_price_Bells": 262500,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 61,
    "Poll_Ranking_2020_21": 61,
    "Total_Poll_Votes_2020": 1790,
    "Total_Poll_Votes_2020_21": 2214,
    "Poll_votes_May_2020": 125,
    "Poll_votes_June_2020": 445,
    "Poll_votes_July_2020": 398,
    "Poll_votes_August_2020": 268,
    "Poll_votes_September_2020": 211,
    "Poll_votes_October_2020": 143,
    "Poll_votes_November_2020": 113,
    "Poll_votes_December_2020": 87,
    "Poll_votes_January_2021": 94,
    "Poll_votes_February_2021": 94,
    "Poll_votes_March_2021": 127,
    "Poll_votes_April_2021": 109
  },
  {
    "name": "Olivia",
    "url": "https://nookipedia.com/wiki/Olivia",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "cat03",
    "image_url": "https://dodo.ac/np/images/3/36/Olivia_NH.png",
    "species": "Cat",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "February",
    "birthday_day": 3,
    "sign": "Aquarius",
    "quote": "There's an exception to every rule.",
    "phrase": "purrr",
    "clothing": "Sweetheart Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 55,
    "Average_Popularity_Score": 82.5,
    "Nookazon_Bells_Price_Ranking": 63,
    "Nookazon_average_price_Bells": 266667,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 114,
    "Poll_Ranking_2020_21": 108,
    "Total_Poll_Votes_2020": 876,
    "Total_Poll_Votes_2020_21": 1115,
    "Poll_votes_May_2020": 57,
    "Poll_votes_June_2020": 199,
    "Poll_votes_July_2020": 211,
    "Poll_votes_August_2020": 102,
    "Poll_votes_September_2020": 117,
    "Poll_votes_October_2020": 92,
    "Poll_votes_November_2020": 49,
    "Poll_votes_December_2020": 49,
    "Poll_votes_January_2021": 60,
    "Poll_votes_February_2021": 54,
    "Poll_votes_March_2021": 69,
    "Poll_votes_April_2021": 56
  },
  {
    "name": "Ruby",
    "url": "https://nookipedia.com/wiki/Ruby",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "rbt09",
    "image_url": "https://dodo.ac/np/images/4/41/Ruby_NH.png",
    "species": "Rabbit",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "December",
    "birthday_day": 25,
    "sign": "Capricorn",
    "quote": "You can always take the red-eye.",
    "phrase": "li'l ears",
    "clothing": "Rabbit Tee",
    "islander": "FALSE",
    "debut": "WW",
    "prev_phrases": [],
    "appearances": "['WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Outer space",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 54,
    "Average_Popularity_Score": 81.25,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 25,
    "Nookazon_average_price_NMT": 39,
    "Poll_Ranking_2020": 52,
    "Poll_Ranking_2020_21": 55,
    "Total_Poll_Votes_2020": 2098,
    "Total_Poll_Votes_2020_21": 2403,
    "Poll_votes_May_2020": 73,
    "Poll_votes_June_2020": 477,
    "Poll_votes_July_2020": 479,
    "Poll_votes_August_2020": 387,
    "Poll_votes_September_2020": 254,
    "Poll_votes_October_2020": 198,
    "Poll_votes_November_2020": 123,
    "Poll_votes_December_2020": 107,
    "Poll_votes_January_2021": 80,
    "Poll_votes_February_2021": 84,
    "Poll_votes_March_2021": 73,
    "Poll_votes_April_2021": 68
  },
  {
    "name": "Pietro",
    "url": "https://nookipedia.com/wiki/Pietro",
    "alt_name": "",
    "skin_color": "ff4040",
    "text_color": "fffad4",
    "id": "shp13",
    "image_url": "https://dodo.ac/np/images/f/fb/Pietro_NH.png",
    "species": "Sheep",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "April",
    "birthday_day": 19,
    "sign": "Aries",
    "quote": "Be the class clown.",
    "phrase": "honk honk",
    "clothing": "Jester Costume",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Colorful",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 56,
    "Average_Popularity_Score": 85,
    "Nookazon_Bells_Price_Ranking": 235,
    "Nookazon_average_price_Bells": 133334,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 25,
    "Poll_Ranking_2020_21": 27,
    "Total_Poll_Votes_2020": 4068,
    "Total_Poll_Votes_2020_21": 4709,
    "Poll_votes_May_2020": 331,
    "Poll_votes_June_2020": 1101,
    "Poll_votes_July_2020": 1088,
    "Poll_votes_August_2020": 524,
    "Poll_votes_September_2020": 371,
    "Poll_votes_October_2020": 296,
    "Poll_votes_November_2020": 190,
    "Poll_votes_December_2020": 167,
    "Poll_votes_January_2021": 157,
    "Poll_votes_February_2021": 182,
    "Poll_votes_March_2021": 172,
    "Poll_votes_April_2021": 130
  },
  {
    "name": "Kid Cat",
    "url": "https://nookipedia.com/wiki/Kid_Cat",
    "alt_name": "",
    "skin_color": "ff4040",
    "text_color": "fffad4",
    "id": "cat10",
    "image_url": "https://dodo.ac/np/images/c/c3/Kid_Cat_NH.png",
    "species": "Cat",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 1,
    "sign": "Leo",
    "quote": "Crime doesn't pay!",
    "phrase": "psst",
    "clothing": "No. 1 Shirt",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 57,
    "Average_Popularity_Score": 85.25,
    "Nookazon_Bells_Price_Ranking": 164,
    "Nookazon_average_price_Bells": 166667,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 62,
    "Poll_Ranking_2020_21": 63,
    "Total_Poll_Votes_2020": 1736,
    "Total_Poll_Votes_2020_21": 2143,
    "Poll_votes_May_2020": 100,
    "Poll_votes_June_2020": 381,
    "Poll_votes_July_2020": 355,
    "Poll_votes_August_2020": 250,
    "Poll_votes_September_2020": 252,
    "Poll_votes_October_2020": 189,
    "Poll_votes_November_2020": 113,
    "Poll_votes_December_2020": 96,
    "Poll_votes_January_2021": 100,
    "Poll_votes_February_2021": 85,
    "Poll_votes_March_2021": 118,
    "Poll_votes_April_2021": 104
  },
  {
    "name": "Felicity",
    "url": "https://nookipedia.com/wiki/Felicity",
    "alt_name": "",
    "skin_color": "fff98f",
    "text_color": "879b96",
    "id": "cat17",
    "image_url": "https://dodo.ac/np/images/c/c7/Felicity_NH.png",
    "species": "Cat",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 30,
    "sign": "Aries",
    "quote": "Love has no bounds.",
    "phrase": "mimimi",
    "clothing": "Tweed Dress",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 3,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 60,
    "Average_Popularity_Score": 86.5,
    "Nookazon_Bells_Price_Ranking": 49,
    "Nookazon_average_price_Bells": 306250,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 128,
    "Poll_Ranking_2020_21": 123,
    "Total_Poll_Votes_2020": 738,
    "Total_Poll_Votes_2020_21": 952,
    "Poll_votes_May_2020": 50,
    "Poll_votes_June_2020": 167,
    "Poll_votes_July_2020": 146,
    "Poll_votes_August_2020": 81,
    "Poll_votes_September_2020": 90,
    "Poll_votes_October_2020": 86,
    "Poll_votes_November_2020": 64,
    "Poll_votes_December_2020": 54,
    "Poll_votes_January_2021": 39,
    "Poll_votes_February_2021": 54,
    "Poll_votes_March_2021": 67,
    "Poll_votes_April_2021": 54
  },
  {
    "name": "Biskit",
    "url": "https://nookipedia.com/wiki/Biskit",
    "alt_name": "",
    "skin_color": "ffaa3b",
    "text_color": "874c25",
    "id": "dog03",
    "image_url": "https://dodo.ac/np/images/7/78/Biskit_NH.png",
    "species": "Dog",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "May",
    "birthday_day": 13,
    "sign": "Taurus",
    "quote": "Let sleeping dogs lie.",
    "phrase": "dawg",
    "clothing": "Meme Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 57,
    "Average_Popularity_Score": 85.25,
    "Nookazon_Bells_Price_Ranking": 97,
    "Nookazon_average_price_Bells": 200000,
    "Nookazon_NMT_Price_Ranking": 72,
    "Nookazon_average_price_NMT": 28,
    "Poll_Ranking_2020": 84,
    "Poll_Ranking_2020_21": 86,
    "Total_Poll_Votes_2020": 1114,
    "Total_Poll_Votes_2020_21": 1332,
    "Poll_votes_May_2020": 69,
    "Poll_votes_June_2020": 237,
    "Poll_votes_July_2020": 307,
    "Poll_votes_August_2020": 172,
    "Poll_votes_September_2020": 134,
    "Poll_votes_October_2020": 92,
    "Poll_votes_November_2020": 60,
    "Poll_votes_December_2020": 43,
    "Poll_votes_January_2021": 56,
    "Poll_votes_February_2021": 42,
    "Poll_votes_March_2021": 71,
    "Poll_votes_April_2021": 49
  },
  {
    "name": "Barold",
    "url": "https://nookipedia.com/wiki/Barold",
    "alt_name": "",
    "skin_color": "bfbfbf",
    "text_color": "5e5e5e",
    "id": "cbr16",
    "image_url": "https://dodo.ac/np/images/9/9d/Barold_NH.png",
    "species": "Bear cub",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "March",
    "birthday_day": 2,
    "sign": "Pisces",
    "quote": "Please DO feed the bears!",
    "phrase": "cubby",
    "clothing": "Animal-Stripes Tee",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "High-Tech",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 53,
    "Average_Popularity_Score": 79.5,
    "Nookazon_Bells_Price_Ranking": 20,
    "Nookazon_average_price_Bells": 422657,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 87,
    "Poll_Ranking_2020_21": 97,
    "Total_Poll_Votes_2020": 1070,
    "Total_Poll_Votes_2020_21": 1226,
    "Poll_votes_May_2020": 34,
    "Poll_votes_June_2020": 201,
    "Poll_votes_July_2020": 287,
    "Poll_votes_August_2020": 163,
    "Poll_votes_September_2020": 181,
    "Poll_votes_October_2020": 109,
    "Poll_votes_November_2020": 58,
    "Poll_votes_December_2020": 37,
    "Poll_votes_January_2021": 26,
    "Poll_votes_February_2021": 47,
    "Poll_votes_March_2021": 51,
    "Poll_votes_April_2021": 32
  },
  {
    "name": "Octavian",
    "url": "https://nookipedia.com/wiki/Octavian",
    "alt_name": "",
    "skin_color": "ff4040",
    "text_color": "fffad4",
    "id": "ocp00",
    "image_url": "https://dodo.ac/np/images/5/54/Octavian_NH_Transparent.png",
    "species": "Octopus",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "September",
    "birthday_day": 20,
    "sign": "Virgo",
    "quote": "Don't be a sucker!",
    "phrase": "sucker",
    "clothing": "Gold-Print Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Outer space",
    "P (individual within species)": 0.333333333,
    "Rarity": "0.95%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 59,
    "Average_Popularity_Score": 85.5,
    "Nookazon_Bells_Price_Ranking": 86,
    "Nookazon_average_price_Bells": 231250,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 37,
    "Poll_Ranking_2020_21": 36,
    "Total_Poll_Votes_2020": 2987,
    "Total_Poll_Votes_2020_21": 3650,
    "Poll_votes_May_2020": 109,
    "Poll_votes_June_2020": 711,
    "Poll_votes_July_2020": 765,
    "Poll_votes_August_2020": 439,
    "Poll_votes_September_2020": 308,
    "Poll_votes_October_2020": 301,
    "Poll_votes_November_2020": 192,
    "Poll_votes_December_2020": 162,
    "Poll_votes_January_2021": 156,
    "Poll_votes_February_2021": 176,
    "Poll_votes_March_2021": 183,
    "Poll_votes_April_2021": 148
  },
  {
    "name": "Tabby",
    "url": "https://nookipedia.com/wiki/Tabby",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "cat12",
    "image_url": "https://dodo.ac/np/images/2/2f/Tabby_NH.png",
    "species": "Cat",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "August",
    "birthday_day": 13,
    "sign": "Leo",
    "quote": "You can never have too much of a good thing!",
    "phrase": "me-WOW",
    "clothing": "Tee Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Library",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 61,
    "Average_Popularity_Score": 88.25,
    "Nookazon_Bells_Price_Ranking": 150,
    "Nookazon_average_price_Bells": 180209,
    "Nookazon_NMT_Price_Ranking": 91,
    "Nookazon_average_price_NMT": 23,
    "Poll_Ranking_2020": 47,
    "Poll_Ranking_2020_21": 56,
    "Total_Poll_Votes_2020": 2284,
    "Total_Poll_Votes_2020_21": 2390,
    "Poll_votes_May_2020": 21,
    "Poll_votes_June_2020": 61,
    "Poll_votes_July_2020": 90,
    "Poll_votes_August_2020": 68,
    "Poll_votes_September_2020": 1755,
    "Poll_votes_October_2020": 220,
    "Poll_votes_November_2020": 39,
    "Poll_votes_December_2020": 30,
    "Poll_votes_January_2021": 27,
    "Poll_votes_February_2021": 24,
    "Poll_votes_March_2021": 27,
    "Poll_votes_April_2021": 28
  },
  {
    "name": "Tia",
    "url": "https://nookipedia.com/wiki/Tia",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "elp10",
    "image_url": "https://dodo.ac/np/images/0/0d/Tia_NH.png",
    "species": "Elephant",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "November",
    "birthday_day": 18,
    "sign": "Scorpio",
    "quote": "Tea is a cup of life.",
    "phrase": "teacup",
    "clothing": "Maid Dress",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Cafe",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 65,
    "Average_Popularity_Score": 94,
    "Nookazon_Bells_Price_Ranking": 257,
    "Nookazon_average_price_Bells": 120000,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 35,
    "Poll_Ranking_2020_21": 34,
    "Total_Poll_Votes_2020": 3174,
    "Total_Poll_Votes_2020_21": 3913,
    "Poll_votes_May_2020": 191,
    "Poll_votes_June_2020": 799,
    "Poll_votes_July_2020": 801,
    "Poll_votes_August_2020": 431,
    "Poll_votes_September_2020": 341,
    "Poll_votes_October_2020": 253,
    "Poll_votes_November_2020": 191,
    "Poll_votes_December_2020": 167,
    "Poll_votes_January_2021": 179,
    "Poll_votes_February_2021": 191,
    "Poll_votes_March_2021": 207,
    "Poll_votes_April_2021": 162
  },
  {
    "name": "Muffy",
    "url": "https://nookipedia.com/wiki/Muffy",
    "alt_name": "",
    "skin_color": 515151,
    "text_color": "fffce9",
    "id": "shp12",
    "image_url": "https://dodo.ac/np/images/1/16/Muffy_NH.png",
    "species": "Sheep",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "February",
    "birthday_day": 14,
    "sign": "Aquarius",
    "quote": "There's a black sheep in every family.",
    "phrase": "nightshade",
    "clothing": "Ruffled Dress",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 68,
    "Average_Popularity_Score": 96,
    "Nookazon_Bells_Price_Ranking": 154,
    "Nookazon_average_price_Bells": 177084,
    "Nookazon_NMT_Price_Ranking": 90,
    "Nookazon_average_price_NMT": 24,
    "Poll_Ranking_2020": 68,
    "Poll_Ranking_2020_21": 70,
    "Total_Poll_Votes_2020": 1516,
    "Total_Poll_Votes_2020_21": 1844,
    "Poll_votes_May_2020": 121,
    "Poll_votes_June_2020": 348,
    "Poll_votes_July_2020": 399,
    "Poll_votes_August_2020": 207,
    "Poll_votes_September_2020": 162,
    "Poll_votes_October_2020": 140,
    "Poll_votes_November_2020": 72,
    "Poll_votes_December_2020": 67,
    "Poll_votes_January_2021": 91,
    "Poll_votes_February_2021": 85,
    "Poll_votes_March_2021": 89,
    "Poll_votes_April_2021": 63
  },
  {
    "name": "Deirdre",
    "url": "https://nookipedia.com/wiki/Deirdre",
    "alt_name": "",
    "skin_color": "ddcdca",
    "text_color": "4b4496",
    "id": "der04",
    "image_url": "https://dodo.ac/np/images/3/3c/Deirdre_NH.png",
    "species": "Deer",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "May",
    "birthday_day": 4,
    "sign": "Taurus",
    "quote": "Legs of an antelope, heart of an eagle.",
    "phrase": "whatevs",
    "clothing": "Flower Sweater",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 68,
    "Average_Popularity_Score": 96,
    "Nookazon_Bells_Price_Ranking": 117,
    "Nookazon_average_price_Bells": 195834,
    "Nookazon_NMT_Price_Ranking": 91,
    "Nookazon_average_price_NMT": 23,
    "Poll_Ranking_2020": 94,
    "Poll_Ranking_2020_21": 88,
    "Total_Poll_Votes_2020": 1013,
    "Total_Poll_Votes_2020_21": 1313,
    "Poll_votes_May_2020": 52,
    "Poll_votes_June_2020": 192,
    "Poll_votes_July_2020": 237,
    "Poll_votes_August_2020": 145,
    "Poll_votes_September_2020": 142,
    "Poll_votes_October_2020": 100,
    "Poll_votes_November_2020": 84,
    "Poll_votes_December_2020": 61,
    "Poll_votes_January_2021": 71,
    "Poll_votes_February_2021": 70,
    "Poll_votes_March_2021": 94,
    "Poll_votes_April_2021": 65
  },
  {
    "name": "Bea",
    "url": "https://nookipedia.com/wiki/Bea",
    "alt_name": "",
    "skin_color": "a87850",
    "text_color": "fffce9",
    "id": "dog10",
    "image_url": "https://dodo.ac/np/images/c/c2/Bea_NH.png",
    "species": "Dog",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "October",
    "birthday_day": 15,
    "sign": "Libra",
    "quote": "The perfect pair complements each other.",
    "phrase": "bingo",
    "clothing": "Striped Maxi Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Cafe",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 70,
    "Average_Popularity_Score": 99,
    "Nookazon_Bells_Price_Ranking": 110,
    "Nookazon_average_price_Bells": 198438,
    "Nookazon_NMT_Price_Ranking": 72,
    "Nookazon_average_price_NMT": 28,
    "Poll_Ranking_2020": 113,
    "Poll_Ranking_2020_21": 107,
    "Total_Poll_Votes_2020": 885,
    "Total_Poll_Votes_2020_21": 1126,
    "Poll_votes_May_2020": 35,
    "Poll_votes_June_2020": 172,
    "Poll_votes_July_2020": 280,
    "Poll_votes_August_2020": 107,
    "Poll_votes_September_2020": 112,
    "Poll_votes_October_2020": 87,
    "Poll_votes_November_2020": 51,
    "Poll_votes_December_2020": 41,
    "Poll_votes_January_2021": 50,
    "Poll_votes_February_2021": 63,
    "Poll_votes_March_2021": 60,
    "Poll_votes_April_2021": 68
  },
  {
    "name": "Aurora",
    "url": "https://nookipedia.com/wiki/Aurora",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "pgn00",
    "image_url": "https://dodo.ac/np/images/c/c6/Aurora_NH_Transparent.png",
    "species": "Penguin",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 27,
    "sign": "Aquarius",
    "quote": "Always keep your cool.",
    "phrase": "b-b-baby",
    "clothing": "Plover Cardigan",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Ice",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 63,
    "Average_Popularity_Score": 91,
    "Nookazon_Bells_Price_Ranking": 164,
    "Nookazon_average_price_Bells": 166667,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 48,
    "Poll_Ranking_2020_21": 48,
    "Total_Poll_Votes_2020": 2261,
    "Total_Poll_Votes_2020_21": 2724,
    "Poll_votes_May_2020": 100,
    "Poll_votes_June_2020": 678,
    "Poll_votes_July_2020": 565,
    "Poll_votes_August_2020": 317,
    "Poll_votes_September_2020": 221,
    "Poll_votes_October_2020": 159,
    "Poll_votes_November_2020": 111,
    "Poll_votes_December_2020": 110,
    "Poll_votes_January_2021": 124,
    "Poll_votes_February_2021": 125,
    "Poll_votes_March_2021": 122,
    "Poll_votes_April_2021": 92
  },
  {
    "name": "Bill",
    "url": "https://nookipedia.com/wiki/Bill",
    "alt_name": "",
    "skin_color": "7a2500",
    "text_color": "fffce9",
    "id": "duk00",
    "image_url": "https://dodo.ac/np/images/c/c1/Bill_NH.png",
    "species": "Duck",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "February",
    "birthday_day": 1,
    "sign": "Aquarius",
    "quote": "Even though there's no 'I' in team, there is a 'me'!",
    "phrase": "quacko",
    "clothing": "Basketball Tank",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Asian",
    "P (individual within species)": 0.058823529,
    "Rarity": "0.17%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 62,
    "Average_Popularity_Score": 90.5,
    "Nookazon_Bells_Price_Ranking": 130,
    "Nookazon_average_price_Bells": 187500,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 103,
    "Poll_Ranking_2020_21": 64,
    "Total_Poll_Votes_2020": 929,
    "Total_Poll_Votes_2020_21": 2081,
    "Poll_votes_May_2020": 81,
    "Poll_votes_June_2020": 228,
    "Poll_votes_July_2020": 217,
    "Poll_votes_August_2020": 123,
    "Poll_votes_September_2020": 85,
    "Poll_votes_October_2020": 85,
    "Poll_votes_November_2020": 54,
    "Poll_votes_December_2020": 56,
    "Poll_votes_January_2021": 68,
    "Poll_votes_February_2021": 60,
    "Poll_votes_March_2021": 869,
    "Poll_votes_April_2021": 155
  },
  {
    "name": "Merengue",
    "url": "https://nookipedia.com/wiki/Merengue",
    "alt_name": "",
    "skin_color": "f2bdc7",
    "text_color": "634b4b",
    "id": "rhn07",
    "image_url": "https://dodo.ac/np/images/0/0c/Merengue_NH.png",
    "species": "Rhinoceros",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 19,
    "sign": "Pisces",
    "quote": "Life is a piece of cake.",
    "phrase": "shortcake",
    "clothing": "Chef's Outfit",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Cafe",
    "P (individual within species)": 0.166666667,
    "Rarity": "0.48%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 64,
    "Average_Popularity_Score": 92.25,
    "Nookazon_Bells_Price_Ranking": 235,
    "Nookazon_average_price_Bells": 133334,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 17,
    "Poll_Ranking_2020_21": 15,
    "Total_Poll_Votes_2020": 7434,
    "Total_Poll_Votes_2020_21": 9095,
    "Poll_votes_May_2020": 403,
    "Poll_votes_June_2020": 1935,
    "Poll_votes_July_2020": 1752,
    "Poll_votes_August_2020": 1211,
    "Poll_votes_September_2020": 726,
    "Poll_votes_October_2020": 637,
    "Poll_votes_November_2020": 404,
    "Poll_votes_December_2020": 366,
    "Poll_votes_January_2021": 436,
    "Poll_votes_February_2021": 429,
    "Poll_votes_March_2021": 452,
    "Poll_votes_April_2021": 344
  },
  {
    "name": "Skye",
    "url": "https://nookipedia.com/wiki/Skye",
    "alt_name": "",
    "skin_color": "3fd8e0",
    "text_color": "fffce9",
    "id": "wol09",
    "image_url": "https://dodo.ac/np/images/d/d1/Skye_NH.png",
    "species": "Wolf",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 24,
    "sign": "Aries",
    "quote": "Love makes the world go 'round.",
    "phrase": "airmail",
    "clothing": "Peasant Blouse",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Cute",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 67,
    "Average_Popularity_Score": 95.75,
    "Nookazon_Bells_Price_Ranking": 74,
    "Nookazon_average_price_Bells": 247657,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 42,
    "Poll_Ranking_2020_21": 42,
    "Total_Poll_Votes_2020": 2732,
    "Total_Poll_Votes_2020_21": 3203,
    "Poll_votes_May_2020": 208,
    "Poll_votes_June_2020": 706,
    "Poll_votes_July_2020": 707,
    "Poll_votes_August_2020": 351,
    "Poll_votes_September_2020": 277,
    "Poll_votes_October_2020": 205,
    "Poll_votes_November_2020": 160,
    "Poll_votes_December_2020": 118,
    "Poll_votes_January_2021": 118,
    "Poll_votes_February_2021": 137,
    "Poll_votes_March_2021": 123,
    "Poll_votes_April_2021": 93
  },
  {
    "name": "Megan",
    "url": "https://nookipedia.com/wiki/Megan",
    "alt_name": "",
    "skin_color": "ec7efc",
    "text_color": "fffce9",
    "id": "bea15",
    "image_url": "https://dodo.ac/np/images/7/72/Megan_NH_1.png",
    "species": "Bear",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 13,
    "sign": "Pisces",
    "quote": "Take a page out of someone else's book, if it's a good book.",
    "phrase": "sundae",
    "clothing": "Dollhouse Dress",
    "islander": "FALSE",
    "debut": "NH",
    "prev_phrases": [],
    "appearances": "['NH', 'PC']",
    "Amiibo": "NO",
    "hobby": "Nature",
    "interior_decor": "Colorful",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 71,
    "Average_Popularity_Score": 101,
    "Nookazon_Bells_Price_Ranking": 97,
    "Nookazon_average_price_Bells": 200000,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 130,
    "Poll_Ranking_2020_21": 128,
    "Total_Poll_Votes_2020": 727,
    "Total_Poll_Votes_2020_21": 905,
    "Poll_votes_May_2020": 33,
    "Poll_votes_June_2020": 176,
    "Poll_votes_July_2020": 175,
    "Poll_votes_August_2020": 105,
    "Poll_votes_September_2020": 83,
    "Poll_votes_October_2020": 65,
    "Poll_votes_November_2020": 53,
    "Poll_votes_December_2020": 37,
    "Poll_votes_January_2021": 43,
    "Poll_votes_February_2021": 44,
    "Poll_votes_March_2021": 49,
    "Poll_votes_April_2021": 42
  },
  {
    "name": "Wade",
    "url": "https://nookipedia.com/wiki/Wade",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "pgn09",
    "image_url": "https://dodo.ac/np/images/5/52/Wade_NH.png",
    "species": "Penguin",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 30,
    "sign": "Scorpio",
    "quote": "Which came first, the seeds or the sunflower?",
    "phrase": "so it goes",
    "clothing": "Frog Tee",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Fish",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 1,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 66,
    "Average_Popularity_Score": 95,
    "Nookazon_Bells_Price_Ranking": 90,
    "Nookazon_average_price_Bells": 224480,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 91,
    "Poll_Ranking_2020_21": 93,
    "Total_Poll_Votes_2020": 1044,
    "Total_Poll_Votes_2020_21": 1237,
    "Poll_votes_May_2020": 79,
    "Poll_votes_June_2020": 242,
    "Poll_votes_July_2020": 249,
    "Poll_votes_August_2020": 149,
    "Poll_votes_September_2020": 108,
    "Poll_votes_October_2020": 83,
    "Poll_votes_November_2020": 74,
    "Poll_votes_December_2020": 60,
    "Poll_votes_January_2021": 49,
    "Poll_votes_February_2021": 53,
    "Poll_votes_March_2021": 59,
    "Poll_votes_April_2021": 32
  },
  {
    "name": "Goldie",
    "url": "https://nookipedia.com/wiki/Goldie",
    "alt_name": "",
    "skin_color": "fff98f",
    "text_color": "879b96",
    "id": "dog00",
    "image_url": "https://dodo.ac/np/images/8/83/Goldie_NH.png",
    "species": "Dog",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "December",
    "birthday_day": 27,
    "sign": "Capricorn",
    "quote": "A little bit of happiness is better than a lot of anguish.",
    "phrase": "woof",
    "clothing": "Tweed Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Normal",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 75,
    "Average_Popularity_Score": 103.25,
    "Nookazon_Bells_Price_Ranking": 275,
    "Nookazon_average_price_Bells": 106250,
    "Nookazon_NMT_Price_Ranking": 72,
    "Nookazon_average_price_NMT": 28,
    "Poll_Ranking_2020": 33,
    "Poll_Ranking_2020_21": 33,
    "Total_Poll_Votes_2020": 3264,
    "Total_Poll_Votes_2020_21": 3969,
    "Poll_votes_May_2020": 217,
    "Poll_votes_June_2020": 798,
    "Poll_votes_July_2020": 828,
    "Poll_votes_August_2020": 425,
    "Poll_votes_September_2020": 370,
    "Poll_votes_October_2020": 266,
    "Poll_votes_November_2020": 187,
    "Poll_votes_December_2020": 173,
    "Poll_votes_January_2021": 184,
    "Poll_votes_February_2021": 180,
    "Poll_votes_March_2021": 187,
    "Poll_votes_April_2021": 154
  },
  {
    "name": "Dotty",
    "url": "https://nookipedia.com/wiki/Dotty",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "rbt01",
    "image_url": "https://dodo.ac/np/images/c/cc/Dotty_NH.png",
    "species": "Rabbit",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 14,
    "sign": "Pisces",
    "quote": "It's always a good hare day.",
    "phrase": "wee one",
    "clothing": "Sleeveless Tunic",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Normal",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 3,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 74,
    "Average_Popularity_Score": 102.5,
    "Nookazon_Bells_Price_Ranking": 130,
    "Nookazon_average_price_Bells": 187500,
    "Nookazon_NMT_Price_Ranking": 72,
    "Nookazon_average_price_NMT": 28,
    "Poll_Ranking_2020": 107,
    "Poll_Ranking_2020_21": 104,
    "Total_Poll_Votes_2020": 904,
    "Total_Poll_Votes_2020_21": 1138,
    "Poll_votes_May_2020": 57,
    "Poll_votes_June_2020": 252,
    "Poll_votes_July_2020": 218,
    "Poll_votes_August_2020": 100,
    "Poll_votes_September_2020": 95,
    "Poll_votes_October_2020": 71,
    "Poll_votes_November_2020": 61,
    "Poll_votes_December_2020": 50,
    "Poll_votes_January_2021": 52,
    "Poll_votes_February_2021": 71,
    "Poll_votes_March_2021": 64,
    "Poll_votes_April_2021": 47
  },
  {
    "name": "Stella",
    "url": "https://nookipedia.com/wiki/Stella",
    "alt_name": "",
    "skin_color": "951d43",
    "text_color": "fffad4",
    "id": "shp03",
    "image_url": "https://dodo.ac/np/images/9/95/Stella_NH.png",
    "species": "Sheep",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 9,
    "sign": "Aries",
    "quote": "100% Natural Fiber.",
    "phrase": "baa-dabing",
    "clothing": "Flower Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Normal",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 76,
    "Average_Popularity_Score": 106,
    "Nookazon_Bells_Price_Ranking": 64,
    "Nookazon_average_price_Bells": 262500,
    "Nookazon_NMT_Price_Ranking": 72,
    "Nookazon_average_price_NMT": 28,
    "Poll_Ranking_2020": 142,
    "Poll_Ranking_2020_21": 144,
    "Total_Poll_Votes_2020": 654,
    "Total_Poll_Votes_2020_21": 807,
    "Poll_votes_May_2020": 46,
    "Poll_votes_June_2020": 179,
    "Poll_votes_July_2020": 165,
    "Poll_votes_August_2020": 84,
    "Poll_votes_September_2020": 65,
    "Poll_votes_October_2020": 47,
    "Poll_votes_November_2020": 37,
    "Poll_votes_December_2020": 31,
    "Poll_votes_January_2021": 39,
    "Poll_votes_February_2021": 32,
    "Poll_votes_March_2021": 40,
    "Poll_votes_April_2021": 42
  },
  {
    "name": "Agent S",
    "url": "https://nookipedia.com/wiki/Agent_S",
    "alt_name": "",
    "skin_color": "0961f6",
    "text_color": "fffce9",
    "id": "squ05",
    "image_url": "https://dodo.ac/np/images/a/a7/Agent_S_NH.png",
    "species": "Squirrel",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "July",
    "birthday_day": 2,
    "sign": "Cancer",
    "quote": "You gotta put the pedal to the metal!",
    "phrase": "sidekick",
    "clothing": "No. 2 Shirt",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Gym",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 72,
    "Average_Popularity_Score": 101.25,
    "Nookazon_Bells_Price_Ranking": 67,
    "Nookazon_average_price_Bells": 258334,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 116,
    "Poll_Ranking_2020_21": 117,
    "Total_Poll_Votes_2020": 832,
    "Total_Poll_Votes_2020_21": 998,
    "Poll_votes_May_2020": 22,
    "Poll_votes_June_2020": 226,
    "Poll_votes_July_2020": 235,
    "Poll_votes_August_2020": 96,
    "Poll_votes_September_2020": 111,
    "Poll_votes_October_2020": 65,
    "Poll_votes_November_2020": 41,
    "Poll_votes_December_2020": 36,
    "Poll_votes_January_2021": 44,
    "Poll_votes_February_2021": 36,
    "Poll_votes_March_2021": 50,
    "Poll_votes_April_2021": 36
  },
  {
    "name": "Snake",
    "url": "https://nookipedia.com/wiki/Snake",
    "alt_name": "",
    "skin_color": "f993ce",
    "text_color": "fffce9",
    "id": "rbt03",
    "image_url": "https://dodo.ac/np/images/e/ec/Snake_NH.png",
    "species": "Rabbit",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "November",
    "birthday_day": 3,
    "sign": "Scorpio",
    "quote": "A good ninja is neither seen nor heard.",
    "phrase": "bunyip",
    "clothing": "Ninja Costume",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Asian",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 72,
    "Average_Popularity_Score": 101.25,
    "Nookazon_Bells_Price_Ranking": 113,
    "Nookazon_average_price_Bells": 196875,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 88,
    "Poll_Ranking_2020_21": 94,
    "Total_Poll_Votes_2020": 1059,
    "Total_Poll_Votes_2020_21": 1236,
    "Poll_votes_May_2020": 105,
    "Poll_votes_June_2020": 281,
    "Poll_votes_July_2020": 247,
    "Poll_votes_August_2020": 140,
    "Poll_votes_September_2020": 110,
    "Poll_votes_October_2020": 78,
    "Poll_votes_November_2020": 48,
    "Poll_votes_December_2020": 50,
    "Poll_votes_January_2021": 46,
    "Poll_votes_February_2021": 44,
    "Poll_votes_March_2021": 52,
    "Poll_votes_April_2021": 35
  },
  {
    "name": "Flurry",
    "url": "https://nookipedia.com/wiki/Flurry",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "ham06",
    "image_url": "https://dodo.ac/np/images/0/03/Flurry_NH.png",
    "species": "Hamster",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 30,
    "sign": "Aquarius",
    "quote": "Squeak your mind, even if your voice shakes.",
    "phrase": "powderpuff",
    "clothing": "Flower Sweater",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Normal",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 79,
    "Average_Popularity_Score": 108,
    "Nookazon_Bells_Price_Ranking": 154,
    "Nookazon_average_price_Bells": 177084,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 46,
    "Poll_Ranking_2020_21": 47,
    "Total_Poll_Votes_2020": 2316,
    "Total_Poll_Votes_2020_21": 2812,
    "Poll_votes_May_2020": 168,
    "Poll_votes_June_2020": 606,
    "Poll_votes_July_2020": 581,
    "Poll_votes_August_2020": 295,
    "Poll_votes_September_2020": 202,
    "Poll_votes_October_2020": 201,
    "Poll_votes_November_2020": 138,
    "Poll_votes_December_2020": 125,
    "Poll_votes_January_2021": 136,
    "Poll_votes_February_2021": 134,
    "Poll_votes_March_2021": 137,
    "Poll_votes_April_2021": 89
  },
  {
    "name": "Bones",
    "url": "https://nookipedia.com/wiki/Bones",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "dog04",
    "image_url": "https://dodo.ac/np/images/2/2b/Bones_NH.png",
    "species": "Dog",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 4,
    "sign": "Leo",
    "quote": "A snack a day keeps the vacuum away.",
    "phrase": "yip yip",
    "clothing": "Printed Fleece Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Library",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 82,
    "Average_Popularity_Score": 111.75,
    "Nookazon_Bells_Price_Ranking": 274,
    "Nookazon_average_price_Bells": 108334,
    "Nookazon_NMT_Price_Ranking": 27,
    "Nookazon_average_price_NMT": 35,
    "Poll_Ranking_2020": 72,
    "Poll_Ranking_2020_21": 73,
    "Total_Poll_Votes_2020": 1365,
    "Total_Poll_Votes_2020_21": 1707,
    "Poll_votes_May_2020": 76,
    "Poll_votes_June_2020": 291,
    "Poll_votes_July_2020": 306,
    "Poll_votes_August_2020": 209,
    "Poll_votes_September_2020": 171,
    "Poll_votes_October_2020": 125,
    "Poll_votes_November_2020": 105,
    "Poll_votes_December_2020": 82,
    "Poll_votes_January_2021": 77,
    "Poll_votes_February_2021": 78,
    "Poll_votes_March_2021": 108,
    "Poll_votes_April_2021": 79
  },
  {
    "name": "Ellie",
    "url": "https://nookipedia.com/wiki/Ellie",
    "alt_name": "",
    "skin_color": "c0ab72",
    "text_color": "fffce9",
    "id": "elp07",
    "image_url": "https://dodo.ac/np/images/3/38/Ellie_NH.png",
    "species": "Elephant",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "May",
    "birthday_day": 12,
    "sign": "Taurus",
    "quote": "You need the sour to highlight the sweet.",
    "phrase": "li'l one",
    "clothing": "Aran-Knit Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": "['wee one']",
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 83,
    "Average_Popularity_Score": 113.75,
    "Nookazon_Bells_Price_Ranking": 174,
    "Nookazon_average_price_Bells": 162344,
    "Nookazon_NMT_Price_Ranking": 91,
    "Nookazon_average_price_NMT": 23,
    "Poll_Ranking_2020": 96,
    "Poll_Ranking_2020_21": 95,
    "Total_Poll_Votes_2020": 998,
    "Total_Poll_Votes_2020_21": 1235,
    "Poll_votes_May_2020": 53,
    "Poll_votes_June_2020": 265,
    "Poll_votes_July_2020": 239,
    "Poll_votes_August_2020": 143,
    "Poll_votes_September_2020": 106,
    "Poll_votes_October_2020": 87,
    "Poll_votes_November_2020": 59,
    "Poll_votes_December_2020": 46,
    "Poll_votes_January_2021": 60,
    "Poll_votes_February_2021": 61,
    "Poll_votes_March_2021": 73,
    "Poll_votes_April_2021": 43
  },
  {
    "name": "Dizzy",
    "url": "https://nookipedia.com/wiki/Dizzy",
    "alt_name": "",
    "skin_color": "7fa9ff",
    "text_color": "fffce9",
    "id": "elp01",
    "image_url": "https://dodo.ac/np/images/6/63/Dizzy_NH.png",
    "species": "Elephant",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 14,
    "sign": "Cancer",
    "quote": "Keep it mellow.",
    "phrase": "woo-oo",
    "clothing": "Bone Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Toys",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 77,
    "Average_Popularity_Score": 106.5,
    "Nookazon_Bells_Price_Ranking": 92,
    "Nookazon_average_price_Bells": 217969,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 117,
    "Poll_Ranking_2020_21": 115,
    "Total_Poll_Votes_2020": 824,
    "Total_Poll_Votes_2020_21": 1042,
    "Poll_votes_May_2020": 41,
    "Poll_votes_June_2020": 191,
    "Poll_votes_July_2020": 218,
    "Poll_votes_August_2020": 122,
    "Poll_votes_September_2020": 100,
    "Poll_votes_October_2020": 69,
    "Poll_votes_November_2020": 47,
    "Poll_votes_December_2020": 36,
    "Poll_votes_January_2021": 61,
    "Poll_votes_February_2021": 53,
    "Poll_votes_March_2021": 61,
    "Poll_votes_April_2021": 43
  },
  {
    "name": "Frita",
    "url": "https://nookipedia.com/wiki/Frita",
    "alt_name": "",
    "skin_color": "ffaa3b",
    "text_color": "874c25",
    "id": "shp11",
    "image_url": "https://dodo.ac/np/images/d/d5/Frita_NH.png",
    "species": "Sheep",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "July",
    "birthday_day": 16,
    "sign": "Cancer",
    "quote": "Don't sweat the small potatoes.",
    "phrase": "oh ewe",
    "clothing": "Hot-Dog Costume",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Cafe",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 1,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 78,
    "Average_Popularity_Score": 107.25,
    "Nookazon_Bells_Price_Ranking": 21,
    "Nookazon_average_price_Bells": 408855,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 147,
    "Poll_Ranking_2020_21": 152,
    "Total_Poll_Votes_2020": 635,
    "Total_Poll_Votes_2020_21": 751,
    "Poll_votes_May_2020": 30,
    "Poll_votes_June_2020": 172,
    "Poll_votes_July_2020": 163,
    "Poll_votes_August_2020": 92,
    "Poll_votes_September_2020": 73,
    "Poll_votes_October_2020": 45,
    "Poll_votes_November_2020": 31,
    "Poll_votes_December_2020": 29,
    "Poll_votes_January_2021": 27,
    "Poll_votes_February_2021": 32,
    "Poll_votes_March_2021": 32,
    "Poll_votes_April_2021": 25
  },
  {
    "name": "Roscoe",
    "url": "https://nookipedia.com/wiki/Roscoe",
    "alt_name": "",
    "skin_color": 515151,
    "text_color": "fffce9",
    "id": "hrs04",
    "image_url": "https://dodo.ac/np/images/8/8e/Roscoe_NH.png",
    "species": "Horse",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 16,
    "sign": "Gemini",
    "quote": "Trouble rides a fast horse.",
    "phrase": "nay",
    "clothing": "Biker Jacket",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Grunge",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 88,
    "Average_Popularity_Score": 116,
    "Nookazon_Bells_Price_Ranking": 164,
    "Nookazon_average_price_Bells": 166667,
    "Nookazon_NMT_Price_Ranking": 80,
    "Nookazon_average_price_NMT": 25,
    "Poll_Ranking_2020": 109,
    "Poll_Ranking_2020_21": 110,
    "Total_Poll_Votes_2020": 903,
    "Total_Poll_Votes_2020_21": 1106,
    "Poll_votes_May_2020": 72,
    "Poll_votes_June_2020": 191,
    "Poll_votes_July_2020": 195,
    "Poll_votes_August_2020": 129,
    "Poll_votes_September_2020": 103,
    "Poll_votes_October_2020": 90,
    "Poll_votes_November_2020": 76,
    "Poll_votes_December_2020": 47,
    "Poll_votes_January_2021": 45,
    "Poll_votes_February_2021": 49,
    "Poll_votes_March_2021": 71,
    "Poll_votes_April_2021": 38
  },
  {
    "name": "Melba",
    "url": "https://nookipedia.com/wiki/Melba",
    "alt_name": "",
    "skin_color": "e4b887",
    "text_color": "fffce9",
    "id": "kal02",
    "image_url": "https://dodo.ac/np/images/4/43/Melba_NH.png",
    "species": "Koala",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 12,
    "sign": "Aries",
    "quote": "A friend who shares is a friend who cares.",
    "phrase": "toasty",
    "clothing": "Plaid-Print Dress",
    "islander": "FALSE",
    "debut": "WW",
    "prev_phrases": [],
    "appearances": "['WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Normal",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 86,
    "Average_Popularity_Score": 115.5,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 45,
    "Poll_Ranking_2020_21": 44,
    "Total_Poll_Votes_2020": 2355,
    "Total_Poll_Votes_2020_21": 2982,
    "Poll_votes_May_2020": 190,
    "Poll_votes_June_2020": 575,
    "Poll_votes_July_2020": 583,
    "Poll_votes_August_2020": 304,
    "Poll_votes_September_2020": 256,
    "Poll_votes_October_2020": 199,
    "Poll_votes_November_2020": 133,
    "Poll_votes_December_2020": 115,
    "Poll_votes_January_2021": 144,
    "Poll_votes_February_2021": 164,
    "Poll_votes_March_2021": 192,
    "Poll_votes_April_2021": 127
  },
  {
    "name": "Bella",
    "url": "https://nookipedia.com/wiki/Bella",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "mus02",
    "image_url": "https://dodo.ac/np/images/c/c0/Bella_NH.png",
    "species": "Mouse",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "December",
    "birthday_day": 28,
    "sign": "Capricorn",
    "quote": "A glamour shot is worth a thousand words.",
    "phrase": "eeks",
    "clothing": "Tee Dress",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Grunge",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 93,
    "Average_Popularity_Score": 121.25,
    "Nookazon_Bells_Price_Ranking": 54,
    "Nookazon_average_price_Bells": 290625,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 192,
    "Poll_Ranking_2020_21": 190,
    "Total_Poll_Votes_2020": 449,
    "Total_Poll_Votes_2020_21": 567,
    "Poll_votes_May_2020": 31,
    "Poll_votes_June_2020": 116,
    "Poll_votes_July_2020": 114,
    "Poll_votes_August_2020": 42,
    "Poll_votes_September_2020": 52,
    "Poll_votes_October_2020": 44,
    "Poll_votes_November_2020": 21,
    "Poll_votes_December_2020": 29,
    "Poll_votes_January_2021": 25,
    "Poll_votes_February_2021": 31,
    "Poll_votes_March_2021": 33,
    "Poll_votes_April_2021": 29
  },
  {
    "name": "Lily",
    "url": "https://nookipedia.com/wiki/Lily",
    "alt_name": "",
    "skin_color": "00d1bd",
    "text_color": "fffce9",
    "id": "flg00",
    "image_url": "https://dodo.ac/np/images/4/42/Lily_NH.png",
    "species": "Frog",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "February",
    "birthday_day": 4,
    "sign": "Aquarius",
    "quote": "Don't jump to conclusions!",
    "phrase": "toady",
    "clothing": "Tropical Muumuu",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": "['zzrrbbit']",
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Flowery",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 80,
    "Average_Popularity_Score": 108.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 55,
    "Poll_Ranking_2020_21": 50,
    "Total_Poll_Votes_2020": 2051,
    "Total_Poll_Votes_2020_21": 2680,
    "Poll_votes_May_2020": 135,
    "Poll_votes_June_2020": 507,
    "Poll_votes_July_2020": 527,
    "Poll_votes_August_2020": 273,
    "Poll_votes_September_2020": 219,
    "Poll_votes_October_2020": 164,
    "Poll_votes_November_2020": 118,
    "Poll_votes_December_2020": 108,
    "Poll_votes_January_2021": 122,
    "Poll_votes_February_2021": 167,
    "Poll_votes_March_2021": 185,
    "Poll_votes_April_2021": 155
  },
  {
    "name": "Gala",
    "url": "https://nookipedia.com/wiki/Gala",
    "alt_name": "",
    "skin_color": "feeae7",
    "text_color": "97858e",
    "id": "pig13",
    "image_url": "https://dodo.ac/np/images/e/e6/Gala_NH.png",
    "species": "Pig",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 5,
    "sign": "Pisces",
    "quote": "Still waters run deep.",
    "phrase": "snortie",
    "clothing": "Flower-Print Dress",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": [],
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Bank",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 94,
    "Average_Popularity_Score": 121.75,
    "Nookazon_Bells_Price_Ranking": 50,
    "Nookazon_average_price_Bells": 300000,
    "Nookazon_NMT_Price_Ranking": 177,
    "Nookazon_average_price_NMT": 19,
    "Poll_Ranking_2020": 135,
    "Poll_Ranking_2020_21": 130,
    "Total_Poll_Votes_2020": 706,
    "Total_Poll_Votes_2020_21": 892,
    "Poll_votes_May_2020": 33,
    "Poll_votes_June_2020": 131,
    "Poll_votes_July_2020": 178,
    "Poll_votes_August_2020": 114,
    "Poll_votes_September_2020": 84,
    "Poll_votes_October_2020": 64,
    "Poll_votes_November_2020": 65,
    "Poll_votes_December_2020": 37,
    "Poll_votes_January_2021": 51,
    "Poll_votes_February_2021": 49,
    "Poll_votes_March_2021": 51,
    "Poll_votes_April_2021": 35
  },
  {
    "name": "Bunnie",
    "url": "https://nookipedia.com/wiki/Bunnie",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "rbt00",
    "image_url": "https://dodo.ac/np/images/0/00/Bunnie_NH_Transparent.png",
    "species": "Rabbit",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "May",
    "birthday_day": 9,
    "sign": "Taurus",
    "quote": "Hare today, gone tomorrow.",
    "phrase": "tee-hee",
    "clothing": "Lively Plaid Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Cute",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 81,
    "Average_Popularity_Score": 111.5,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 74,
    "Poll_Ranking_2020_21": 76,
    "Total_Poll_Votes_2020": 1312,
    "Total_Poll_Votes_2020_21": 1581,
    "Poll_votes_May_2020": 114,
    "Poll_votes_June_2020": 280,
    "Poll_votes_July_2020": 309,
    "Poll_votes_August_2020": 183,
    "Poll_votes_September_2020": 158,
    "Poll_votes_October_2020": 125,
    "Poll_votes_November_2020": 78,
    "Poll_votes_December_2020": 65,
    "Poll_votes_January_2021": 50,
    "Poll_votes_February_2021": 60,
    "Poll_votes_March_2021": 79,
    "Poll_votes_April_2021": 80
  },
  {
    "name": "Francine",
    "url": "https://nookipedia.com/wiki/Francine",
    "alt_name": "",
    "skin_color": "3fd8e0",
    "text_color": "fffce9",
    "id": "rbt12",
    "image_url": "https://dodo.ac/np/images/3/34/Francine_NH.png",
    "species": "Rabbit",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 22,
    "sign": "Aquarius",
    "quote": "You can't have wise folks if you don't have fools too.",
    "phrase": "karat",
    "clothing": "Marble-Dots Dress",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Colorful",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 96,
    "Average_Popularity_Score": 122.5,
    "Nookazon_Bells_Price_Ranking": 235,
    "Nookazon_average_price_Bells": 133334,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 106,
    "Poll_Ranking_2020_21": 102,
    "Total_Poll_Votes_2020": 905,
    "Total_Poll_Votes_2020_21": 1166,
    "Poll_votes_May_2020": 42,
    "Poll_votes_June_2020": 201,
    "Poll_votes_July_2020": 225,
    "Poll_votes_August_2020": 141,
    "Poll_votes_September_2020": 112,
    "Poll_votes_October_2020": 80,
    "Poll_votes_November_2020": 57,
    "Poll_votes_December_2020": 47,
    "Poll_votes_January_2021": 60,
    "Poll_votes_February_2021": 57,
    "Poll_votes_March_2021": 74,
    "Poll_votes_April_2021": 70
  },
  {
    "name": "Fuchsia",
    "url": "https://nookipedia.com/wiki/Fuchsia",
    "alt_name": "",
    "skin_color": "f993ce",
    "text_color": "fffce9",
    "id": "der06",
    "image_url": "https://dodo.ac/np/images/6/67/Fuchsia_NH.png",
    "species": "Deer",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "September",
    "birthday_day": 19,
    "sign": "Virgo",
    "quote": "It takes one to know one.",
    "phrase": "precious",
    "clothing": "Zigzag-Print Dress",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": "['girlfriend']",
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Colorful",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 85,
    "Average_Popularity_Score": 115.25,
    "Nookazon_Bells_Price_Ranking": 189,
    "Nookazon_average_price_Bells": 150542,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 80,
    "Poll_Ranking_2020_21": 84,
    "Total_Poll_Votes_2020": 1166,
    "Total_Poll_Votes_2020_21": 1401,
    "Poll_votes_May_2020": 75,
    "Poll_votes_June_2020": 233,
    "Poll_votes_July_2020": 281,
    "Poll_votes_August_2020": 186,
    "Poll_votes_September_2020": 139,
    "Poll_votes_October_2020": 115,
    "Poll_votes_November_2020": 74,
    "Poll_votes_December_2020": 63,
    "Poll_votes_January_2021": 65,
    "Poll_votes_February_2021": 57,
    "Poll_votes_March_2021": 66,
    "Poll_votes_April_2021": 47
  },
  {
    "name": "Drago",
    "url": "https://nookipedia.com/wiki/Drago",
    "alt_name": "",
    "skin_color": "78dd62",
    "text_color": "28665a",
    "id": "crd08",
    "image_url": "https://dodo.ac/np/images/f/f9/Drago_NH.png",
    "species": "Alligator",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "February",
    "birthday_day": 12,
    "sign": "Aquarius",
    "quote": "There is no room for two dragons in one pond.",
    "phrase": "burrrn",
    "clothing": "Dragon Suit",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Asian",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 95,
    "Average_Popularity_Score": 122,
    "Nookazon_Bells_Price_Ranking": 216,
    "Nookazon_average_price_Bells": 143750,
    "Nookazon_NMT_Price_Ranking": 80,
    "Nookazon_average_price_NMT": 25,
    "Poll_Ranking_2020": 95,
    "Poll_Ranking_2020_21": 96,
    "Total_Poll_Votes_2020": 1010,
    "Total_Poll_Votes_2020_21": 1229,
    "Poll_votes_May_2020": 76,
    "Poll_votes_June_2020": 283,
    "Poll_votes_July_2020": 239,
    "Poll_votes_August_2020": 139,
    "Poll_votes_September_2020": 95,
    "Poll_votes_October_2020": 91,
    "Poll_votes_November_2020": 45,
    "Poll_votes_December_2020": 42,
    "Poll_votes_January_2021": 59,
    "Poll_votes_February_2021": 52,
    "Poll_votes_March_2021": 58,
    "Poll_votes_April_2021": 50
  },
  {
    "name": "Katt",
    "url": "https://nookipedia.com/wiki/Katt",
    "alt_name": "",
    "skin_color": "a87850",
    "text_color": "fffce9",
    "id": "cat21",
    "image_url": "https://dodo.ac/np/images/c/c9/Katt_NH.png",
    "species": "Cat",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 27,
    "sign": "Taurus",
    "quote": "MeowMEOWmeow!",
    "phrase": "purrty",
    "clothing": "Old-School Jacket",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Music room",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 84,
    "Average_Popularity_Score": 114.5,
    "Nookazon_Bells_Price_Ranking": 216,
    "Nookazon_average_price_Bells": 143750,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 65,
    "Poll_Ranking_2020_21": 69,
    "Total_Poll_Votes_2020": 1569,
    "Total_Poll_Votes_2020_21": 1858,
    "Poll_votes_May_2020": 123,
    "Poll_votes_June_2020": 437,
    "Poll_votes_July_2020": 311,
    "Poll_votes_August_2020": 217,
    "Poll_votes_September_2020": 185,
    "Poll_votes_October_2020": 134,
    "Poll_votes_November_2020": 91,
    "Poll_votes_December_2020": 71,
    "Poll_votes_January_2021": 73,
    "Poll_votes_February_2021": 71,
    "Poll_votes_March_2021": 82,
    "Poll_votes_April_2021": 63
  },
  {
    "name": "Sprinkle",
    "url": "https://nookipedia.com/wiki/Sprinkle",
    "alt_name": "",
    "skin_color": "00d1bd",
    "text_color": "fffce9",
    "id": "pgn14",
    "image_url": "https://dodo.ac/np/images/4/44/Sprinkle_NH.png",
    "species": "Penguin",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "February",
    "birthday_day": 20,
    "sign": "Pisces",
    "quote": "Frosting is just the icing on the cake.",
    "phrase": "frappe",
    "clothing": "Snowy Sweater",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Ice",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 98,
    "Average_Popularity_Score": 124.75,
    "Nookazon_Bells_Price_Ranking": 188,
    "Nookazon_average_price_Bells": 151563,
    "Nookazon_NMT_Price_Ranking": 221,
    "Nookazon_average_price_NMT": 16,
    "Poll_Ranking_2020": 44,
    "Poll_Ranking_2020_21": 45,
    "Total_Poll_Votes_2020": 2387,
    "Total_Poll_Votes_2020_21": 2946,
    "Poll_votes_May_2020": 146,
    "Poll_votes_June_2020": 574,
    "Poll_votes_July_2020": 581,
    "Poll_votes_August_2020": 335,
    "Poll_votes_September_2020": 219,
    "Poll_votes_October_2020": 207,
    "Poll_votes_November_2020": 158,
    "Poll_votes_December_2020": 167,
    "Poll_votes_January_2021": 154,
    "Poll_votes_February_2021": 149,
    "Poll_votes_March_2021": 141,
    "Poll_votes_April_2021": 115
  },
  {
    "name": "Freya",
    "url": "https://nookipedia.com/wiki/Freya",
    "alt_name": "",
    "skin_color": "ff6183",
    "text_color": "fffce9",
    "id": "wol05",
    "image_url": "https://dodo.ac/np/images/e/ee/Freya_NH.png",
    "species": "Wolf",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "December",
    "birthday_day": 14,
    "sign": "Sagittarius",
    "quote": "Don't stray too far from the pack.",
    "phrase": "uff da",
    "clothing": "Reindeer Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 99,
    "Average_Popularity_Score": 125.75,
    "Nookazon_Bells_Price_Ranking": 64,
    "Nookazon_average_price_Bells": 262500,
    "Nookazon_NMT_Price_Ranking": 221,
    "Nookazon_average_price_NMT": 16,
    "Poll_Ranking_2020": 105,
    "Poll_Ranking_2020_21": 109,
    "Total_Poll_Votes_2020": 908,
    "Total_Poll_Votes_2020_21": 1109,
    "Poll_votes_May_2020": 65,
    "Poll_votes_June_2020": 265,
    "Poll_votes_July_2020": 212,
    "Poll_votes_August_2020": 106,
    "Poll_votes_September_2020": 84,
    "Poll_votes_October_2020": 73,
    "Poll_votes_November_2020": 57,
    "Poll_votes_December_2020": 46,
    "Poll_votes_January_2021": 45,
    "Poll_votes_February_2021": 60,
    "Poll_votes_March_2021": 51,
    "Poll_votes_April_2021": 45
  },
  {
    "name": "Vivian",
    "url": "https://nookipedia.com/wiki/Vivian",
    "alt_name": "",
    "skin_color": "e4b887",
    "text_color": "fffce9",
    "id": "wol08",
    "image_url": "https://dodo.ac/np/images/2/24/Vivian_NH.png",
    "species": "Wolf",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 26,
    "sign": "Aquarius",
    "quote": "Onwards and upwards!",
    "phrase": "piffle",
    "clothing": "Peacoat-and-Skirt Combo",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WA', 'NH']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 89,
    "Average_Popularity_Score": 118.75,
    "Nookazon_Bells_Price_Ranking": 91,
    "Nookazon_average_price_Bells": 219167,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 143,
    "Poll_Ranking_2020_21": 140,
    "Total_Poll_Votes_2020": 654,
    "Total_Poll_Votes_2020_21": 833,
    "Poll_votes_May_2020": 22,
    "Poll_votes_June_2020": 143,
    "Poll_votes_July_2020": 165,
    "Poll_votes_August_2020": 93,
    "Poll_votes_September_2020": 74,
    "Poll_votes_October_2020": 73,
    "Poll_votes_November_2020": 47,
    "Poll_votes_December_2020": 37,
    "Poll_votes_January_2021": 48,
    "Poll_votes_February_2021": 45,
    "Poll_votes_March_2021": 55,
    "Poll_votes_April_2021": 31
  },
  {
    "name": "Peanut",
    "url": "https://nookipedia.com/wiki/Peanut",
    "alt_name": "",
    "skin_color": "ec7efc",
    "text_color": "fffce9",
    "id": "squ00",
    "image_url": "https://dodo.ac/np/images/0/06/Peanut_NH_Transparent.png",
    "species": "Squirrel",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "June",
    "birthday_day": 8,
    "sign": "Gemini",
    "quote": "Never take a nibble when you can take a bite.",
    "phrase": "slacker",
    "clothing": "Striped Maxi Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Cute",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 102,
    "Average_Popularity_Score": 126.75,
    "Nookazon_Bells_Price_Ranking": 269,
    "Nookazon_average_price_Bells": 112500,
    "Nookazon_NMT_Price_Ranking": 80,
    "Nookazon_average_price_NMT": 25,
    "Poll_Ranking_2020": 76,
    "Poll_Ranking_2020_21": 79,
    "Total_Poll_Votes_2020": 1207,
    "Total_Poll_Votes_2020_21": 1457,
    "Poll_votes_May_2020": 71,
    "Poll_votes_June_2020": 289,
    "Poll_votes_July_2020": 315,
    "Poll_votes_August_2020": 179,
    "Poll_votes_September_2020": 134,
    "Poll_votes_October_2020": 91,
    "Poll_votes_November_2020": 59,
    "Poll_votes_December_2020": 69,
    "Poll_votes_January_2021": 66,
    "Poll_votes_February_2021": 60,
    "Poll_votes_March_2021": 75,
    "Poll_votes_April_2021": 49
  },
  {
    "name": "Gladys",
    "url": "https://nookipedia.com/wiki/Gladys",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "ost01",
    "image_url": "https://dodo.ac/np/images/a/a5/Gladys_NH_Transparent.png",
    "species": "Ostrich",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 15,
    "sign": "Capricorn",
    "quote": "Smiles are free.",
    "phrase": "stretch",
    "clothing": "Misty Tee",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Asian",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 90,
    "Average_Popularity_Score": 120.5,
    "Nookazon_Bells_Price_Ranking": 48,
    "Nookazon_average_price_Bells": 308594,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 167,
    "Poll_Ranking_2020_21": 165,
    "Total_Poll_Votes_2020": 534,
    "Total_Poll_Votes_2020_21": 670,
    "Poll_votes_May_2020": 37,
    "Poll_votes_June_2020": 140,
    "Poll_votes_July_2020": 130,
    "Poll_votes_August_2020": 67,
    "Poll_votes_September_2020": 60,
    "Poll_votes_October_2020": 38,
    "Poll_votes_November_2020": 34,
    "Poll_votes_December_2020": 28,
    "Poll_votes_January_2021": 46,
    "Poll_votes_February_2021": 29,
    "Poll_votes_March_2021": 40,
    "Poll_votes_April_2021": 21
  },
  {
    "name": "Chevre",
    "url": "https://nookipedia.com/wiki/Chevre",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "goa00",
    "image_url": "https://dodo.ac/np/images/c/c9/Chevre_NH.png",
    "species": "Goat",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 6,
    "sign": "Pisces",
    "quote": "If you're gonna dream, dream big.",
    "phrase": "la baa",
    "clothing": "Poncho Coat",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 91,
    "Average_Popularity_Score": 120.75,
    "Nookazon_Bells_Price_Ranking": 259,
    "Nookazon_average_price_Bells": 116667,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 59,
    "Poll_Ranking_2020_21": 60,
    "Total_Poll_Votes_2020": 1875,
    "Total_Poll_Votes_2020_21": 2296,
    "Poll_votes_May_2020": 120,
    "Poll_votes_June_2020": 469,
    "Poll_votes_July_2020": 446,
    "Poll_votes_August_2020": 236,
    "Poll_votes_September_2020": 201,
    "Poll_votes_October_2020": 177,
    "Poll_votes_November_2020": 132,
    "Poll_votes_December_2020": 94,
    "Poll_votes_January_2021": 97,
    "Poll_votes_February_2021": 109,
    "Poll_votes_March_2021": 118,
    "Poll_votes_April_2021": 97
  },
  {
    "name": "Moe",
    "url": "https://nookipedia.com/wiki/Moe",
    "alt_name": "",
    "skin_color": "0961f6",
    "text_color": "fffce9",
    "id": "cat08",
    "image_url": "https://dodo.ac/np/images/a/a4/Moe_NH.png",
    "species": "Cat",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "January",
    "birthday_day": 12,
    "sign": "Capricorn",
    "quote": "Ignorance is bliss.",
    "phrase": "myawn",
    "clothing": "Simple Parka",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Toys",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 91,
    "Average_Popularity_Score": 120.75,
    "Nookazon_Bells_Price_Ranking": 37,
    "Nookazon_average_price_Bells": 333334,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 168,
    "Poll_Ranking_2020_21": 171,
    "Total_Poll_Votes_2020": 527,
    "Total_Poll_Votes_2020_21": 634,
    "Poll_votes_May_2020": 46,
    "Poll_votes_June_2020": 141,
    "Poll_votes_July_2020": 119,
    "Poll_votes_August_2020": 78,
    "Poll_votes_September_2020": 60,
    "Poll_votes_October_2020": 32,
    "Poll_votes_November_2020": 25,
    "Poll_votes_December_2020": 26,
    "Poll_votes_January_2021": 28,
    "Poll_votes_February_2021": 22,
    "Poll_votes_March_2021": 34,
    "Poll_votes_April_2021": 23
  },
  {
    "name": "Joey",
    "url": "https://nookipedia.com/wiki/Joey",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "duk01",
    "image_url": "https://dodo.ac/np/images/6/66/Joey_NH.png",
    "species": "Duck",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "January",
    "birthday_day": 3,
    "sign": "Capricorn",
    "quote": "Don't get your feathers all ruffled. Just chill.",
    "phrase": "bleeeeeck",
    "clothing": "Bear Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Beach",
    "P (individual within species)": 0.058823529,
    "Rarity": "0.17%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 105,
    "Average_Popularity_Score": 130,
    "Nookazon_Bells_Price_Ranking": 180,
    "Nookazon_average_price_Bells": 156250,
    "Nookazon_NMT_Price_Ranking": 72,
    "Nookazon_average_price_NMT": 28,
    "Poll_Ranking_2020": 136,
    "Poll_Ranking_2020_21": 134,
    "Total_Poll_Votes_2020": 702,
    "Total_Poll_Votes_2020_21": 866,
    "Poll_votes_May_2020": 33,
    "Poll_votes_June_2020": 193,
    "Poll_votes_July_2020": 162,
    "Poll_votes_August_2020": 102,
    "Poll_votes_September_2020": 81,
    "Poll_votes_October_2020": 66,
    "Poll_votes_November_2020": 34,
    "Poll_votes_December_2020": 31,
    "Poll_votes_January_2021": 35,
    "Poll_votes_February_2021": 31,
    "Poll_votes_March_2021": 45,
    "Poll_votes_April_2021": 53
  },
  {
    "name": "Blaire",
    "url": "https://nookipedia.com/wiki/Blaire",
    "alt_name": "",
    "skin_color": 515151,
    "text_color": "fffce9",
    "id": "squ01",
    "image_url": "https://dodo.ac/np/images/7/73/Blaire_NH.png",
    "species": "Squirrel",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "July",
    "birthday_day": 3,
    "sign": "Cancer",
    "quote": "Practice makes perfect.",
    "phrase": "nutlet",
    "clothing": "Layered Tank Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Flowery",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 103,
    "Average_Popularity_Score": 128.75,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 150,
    "Poll_Ranking_2020_21": 137,
    "Total_Poll_Votes_2020": 629,
    "Total_Poll_Votes_2020_21": 851,
    "Poll_votes_May_2020": 26,
    "Poll_votes_June_2020": 129,
    "Poll_votes_July_2020": 141,
    "Poll_votes_August_2020": 81,
    "Poll_votes_September_2020": 77,
    "Poll_votes_October_2020": 72,
    "Poll_votes_November_2020": 56,
    "Poll_votes_December_2020": 47,
    "Poll_votes_January_2021": 46,
    "Poll_votes_February_2021": 55,
    "Poll_votes_March_2021": 69,
    "Poll_votes_April_2021": 52
  },
  {
    "name": "Zell",
    "url": "https://nookipedia.com/wiki/Zell",
    "alt_name": "",
    "skin_color": "4c3317",
    "text_color": "fffce9",
    "id": "der02",
    "image_url": "https://dodo.ac/np/images/c/c0/Zell_NH.png",
    "species": "Deer",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 7,
    "sign": "Gemini",
    "quote": "Clothes totally make the mammal.",
    "phrase": "pronk",
    "clothing": "Gilet and Shirt",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Modern",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 97,
    "Average_Popularity_Score": 123.75,
    "Nookazon_Bells_Price_Ranking": 273,
    "Nookazon_average_price_Bells": 110000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 60,
    "Poll_Ranking_2020_21": 59,
    "Total_Poll_Votes_2020": 1874,
    "Total_Poll_Votes_2020_21": 2308,
    "Poll_votes_May_2020": 100,
    "Poll_votes_June_2020": 424,
    "Poll_votes_July_2020": 441,
    "Poll_votes_August_2020": 274,
    "Poll_votes_September_2020": 194,
    "Poll_votes_October_2020": 192,
    "Poll_votes_November_2020": 142,
    "Poll_votes_December_2020": 107,
    "Poll_votes_January_2021": 112,
    "Poll_votes_February_2021": 100,
    "Poll_votes_March_2021": 119,
    "Poll_votes_April_2021": 103
  },
  {
    "name": "Savannah",
    "url": "https://nookipedia.com/wiki/Savannah",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "hrs02",
    "image_url": "https://dodo.ac/np/images/4/46/Savannah_NH.png",
    "species": "Horse",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 25,
    "sign": "Aquarius",
    "quote": "Keep your chin up!",
    "phrase": "y'all",
    "clothing": "Top Coat",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 99,
    "Average_Popularity_Score": 125.75,
    "Nookazon_Bells_Price_Ranking": 79,
    "Nookazon_average_price_Bells": 237500,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 161,
    "Poll_Ranking_2020_21": 160,
    "Total_Poll_Votes_2020": 551,
    "Total_Poll_Votes_2020_21": 702,
    "Poll_votes_May_2020": 41,
    "Poll_votes_June_2020": 123,
    "Poll_votes_July_2020": 120,
    "Poll_votes_August_2020": 79,
    "Poll_votes_September_2020": 66,
    "Poll_votes_October_2020": 52,
    "Poll_votes_November_2020": 36,
    "Poll_votes_December_2020": 34,
    "Poll_votes_January_2021": 35,
    "Poll_votes_February_2021": 40,
    "Poll_votes_March_2021": 39,
    "Poll_votes_April_2021": 37
  },
  {
    "name": "Flora",
    "url": "https://nookipedia.com/wiki/Flora",
    "alt_name": "",
    "skin_color": "ff6183",
    "text_color": "fffce9",
    "id": "ost09",
    "image_url": "https://dodo.ac/np/images/8/8e/Flora_NH.png",
    "species": "Ostrich",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "February",
    "birthday_day": 9,
    "sign": "Aquarius",
    "quote": "Pink is the new black.",
    "phrase": "pinky",
    "clothing": "Gumdrop Dress",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 86,
    "Average_Popularity_Score": 115.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 36,
    "Poll_Ranking_2020_21": 37,
    "Total_Poll_Votes_2020": 3021,
    "Total_Poll_Votes_2020_21": 3627,
    "Poll_votes_May_2020": 176,
    "Poll_votes_June_2020": 741,
    "Poll_votes_July_2020": 738,
    "Poll_votes_August_2020": 435,
    "Poll_votes_September_2020": 348,
    "Poll_votes_October_2020": 266,
    "Poll_votes_November_2020": 180,
    "Poll_votes_December_2020": 137,
    "Poll_votes_January_2021": 158,
    "Poll_votes_February_2021": 153,
    "Poll_votes_March_2021": 165,
    "Poll_votes_April_2021": 130
  },
  {
    "name": "Marcel",
    "url": "https://nookipedia.com/wiki/Marcel",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "dog15",
    "image_url": "https://dodo.ac/np/images/3/3e/Marcel_NH.png",
    "species": "Dog",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 31,
    "sign": "Capricorn",
    "quote": "There's not a dog so bad that he won't wag his tail.",
    "phrase": "non",
    "clothing": "Sea Hanten Shirt",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": [],
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Asian",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 109,
    "Average_Popularity_Score": 135.25,
    "Nookazon_Bells_Price_Ranking": 130,
    "Nookazon_average_price_Bells": 187500,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 174,
    "Poll_Ranking_2020_21": 180,
    "Total_Poll_Votes_2020": 502,
    "Total_Poll_Votes_2020_21": 597,
    "Poll_votes_May_2020": 32,
    "Poll_votes_June_2020": 103,
    "Poll_votes_July_2020": 124,
    "Poll_votes_August_2020": 62,
    "Poll_votes_September_2020": 75,
    "Poll_votes_October_2020": 42,
    "Poll_votes_November_2020": 30,
    "Poll_votes_December_2020": 34,
    "Poll_votes_January_2021": 23,
    "Poll_votes_February_2021": 27,
    "Poll_votes_March_2021": 29,
    "Poll_votes_April_2021": 16
  },
  {
    "name": "Carmen",
    "url": "https://nookipedia.com/wiki/Carmen",
    "alt_name": "",
    "skin_color": "7a2500",
    "text_color": "fffce9",
    "id": "rbt16",
    "image_url": "https://dodo.ac/np/images/e/eb/Carmen_NH.png",
    "species": "Rabbit",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 6,
    "sign": "Capricorn",
    "quote": "Absence makes the heart grow fonder.",
    "phrase": "nougat",
    "clothing": "Plaid-Print Dress",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": [],
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 103,
    "Average_Popularity_Score": 128.75,
    "Nookazon_Bells_Price_Ranking": 121,
    "Nookazon_average_price_Bells": 193750,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 140,
    "Poll_Ranking_2020_21": 145,
    "Total_Poll_Votes_2020": 668,
    "Total_Poll_Votes_2020_21": 805,
    "Poll_votes_May_2020": 51,
    "Poll_votes_June_2020": 153,
    "Poll_votes_July_2020": 160,
    "Poll_votes_August_2020": 83,
    "Poll_votes_September_2020": 98,
    "Poll_votes_October_2020": 54,
    "Poll_votes_November_2020": 45,
    "Poll_votes_December_2020": 24,
    "Poll_votes_January_2021": 37,
    "Poll_votes_February_2021": 33,
    "Poll_votes_March_2021": 41,
    "Poll_votes_April_2021": 26
  },
  {
    "name": "Ribbot",
    "url": "https://nookipedia.com/wiki/Ribbot",
    "alt_name": "",
    "skin_color": "bfbfbf",
    "text_color": "5e5e5e",
    "id": "flg01",
    "image_url": "https://dodo.ac/np/images/9/94/Ribbot_NH.png",
    "species": "Frog",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "February",
    "birthday_day": 13,
    "sign": "Aquarius",
    "quote": "Never rest, never rust.",
    "phrase": "zzrrbbit",
    "clothing": "Simple Parka",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": "['toady']",
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "High-Tech",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 110,
    "Average_Popularity_Score": 137.75,
    "Nookazon_Bells_Price_Ranking": 175,
    "Nookazon_average_price_Bells": 160938,
    "Nookazon_NMT_Price_Ranking": 80,
    "Nookazon_average_price_NMT": 25,
    "Poll_Ranking_2020": 145,
    "Poll_Ranking_2020_21": 148,
    "Total_Poll_Votes_2020": 641,
    "Total_Poll_Votes_2020_21": 788,
    "Poll_votes_May_2020": 45,
    "Poll_votes_June_2020": 182,
    "Poll_votes_July_2020": 142,
    "Poll_votes_August_2020": 82,
    "Poll_votes_September_2020": 61,
    "Poll_votes_October_2020": 55,
    "Poll_votes_November_2020": 46,
    "Poll_votes_December_2020": 28,
    "Poll_votes_January_2021": 31,
    "Poll_votes_February_2021": 34,
    "Poll_votes_March_2021": 43,
    "Poll_votes_April_2021": 39
  },
  {
    "name": "Purrl",
    "url": "https://nookipedia.com/wiki/Purrl",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "cat07",
    "image_url": "https://dodo.ac/np/images/a/a2/Purrl_NH.png",
    "species": "Cat",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "May",
    "birthday_day": 29,
    "sign": "Gemini",
    "quote": "Let them drink cream.",
    "phrase": "kitten",
    "clothing": "Kung-Fu Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 3,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 114,
    "Average_Popularity_Score": 140,
    "Nookazon_Bells_Price_Ranking": 163,
    "Nookazon_average_price_Bells": 166928,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 175,
    "Poll_Ranking_2020_21": 173,
    "Total_Poll_Votes_2020": 496,
    "Total_Poll_Votes_2020_21": 625,
    "Poll_votes_May_2020": 20,
    "Poll_votes_June_2020": 94,
    "Poll_votes_July_2020": 113,
    "Poll_votes_August_2020": 82,
    "Poll_votes_September_2020": 63,
    "Poll_votes_October_2020": 45,
    "Poll_votes_November_2020": 41,
    "Poll_votes_December_2020": 38,
    "Poll_votes_January_2021": 26,
    "Poll_votes_February_2021": 35,
    "Poll_votes_March_2021": 41,
    "Poll_votes_April_2021": 27
  },
  {
    "name": "Cheri",
    "url": "https://nookipedia.com/wiki/Cheri",
    "alt_name": "",
    "skin_color": "db6161",
    "text_color": "fffce9",
    "id": "cbr10",
    "image_url": "https://dodo.ac/np/images/d/d5/Cheri_NH.png",
    "species": "Bear cub",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 17,
    "sign": "Pisces",
    "quote": "Good things come in small packages.",
    "phrase": "tralala",
    "clothing": "Zigzag-Print Dress",
    "islander": "FALSE",
    "debut": "AC",
    "prev_phrases": [],
    "appearances": "['AC', 'E_PLUS', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Cute",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 107,
    "Average_Popularity_Score": 132,
    "Nookazon_Bells_Price_Ranking": 246,
    "Nookazon_average_price_Bells": 132000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 86,
    "Poll_Ranking_2020_21": 89,
    "Total_Poll_Votes_2020": 1071,
    "Total_Poll_Votes_2020_21": 1311,
    "Poll_votes_May_2020": 48,
    "Poll_votes_June_2020": 288,
    "Poll_votes_July_2020": 256,
    "Poll_votes_August_2020": 156,
    "Poll_votes_September_2020": 113,
    "Poll_votes_October_2020": 92,
    "Poll_votes_November_2020": 62,
    "Poll_votes_December_2020": 56,
    "Poll_votes_January_2021": 61,
    "Poll_votes_February_2021": 62,
    "Poll_votes_March_2021": 60,
    "Poll_votes_April_2021": 57
  },
  {
    "name": "Tutu",
    "url": "https://nookipedia.com/wiki/Tutu",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "bea07",
    "image_url": "https://dodo.ac/np/images/9/93/Tutu_NH.png",
    "species": "Bear",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "September",
    "birthday_day": 15,
    "sign": "Virgo",
    "quote": "Even the best of friends start out as strangers.",
    "phrase": "twinkles",
    "clothing": "Heart Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Cute",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 108,
    "Average_Popularity_Score": 132.75,
    "Nookazon_Bells_Price_Ranking": 173,
    "Nookazon_average_price_Bells": 163282,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 126,
    "Poll_Ranking_2020_21": 127,
    "Total_Poll_Votes_2020": 749,
    "Total_Poll_Votes_2020_21": 917,
    "Poll_votes_May_2020": 53,
    "Poll_votes_June_2020": 171,
    "Poll_votes_July_2020": 168,
    "Poll_votes_August_2020": 101,
    "Poll_votes_September_2020": 93,
    "Poll_votes_October_2020": 80,
    "Poll_votes_November_2020": 47,
    "Poll_votes_December_2020": 36,
    "Poll_votes_January_2021": 41,
    "Poll_votes_February_2021": 45,
    "Poll_votes_March_2021": 46,
    "Poll_votes_April_2021": 36
  },
  {
    "name": "Shep",
    "url": "https://nookipedia.com/wiki/Shep",
    "alt_name": "",
    "skin_color": "c0ab72",
    "text_color": "fffce9",
    "id": "dog18",
    "image_url": "https://dodo.ac/np/images/c/c1/Shep_NH.png",
    "species": "Dog",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "November",
    "birthday_day": 24,
    "sign": "Sagittarius",
    "quote": "Even dogs won't get in the middle of true love.",
    "phrase": "baa baa baa",
    "clothing": "Denim Vest",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": "['baaa man']",
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Cabin",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 115,
    "Average_Popularity_Score": 141,
    "Nookazon_Bells_Price_Ranking": 231,
    "Nookazon_average_price_Bells": 136875,
    "Nookazon_NMT_Price_Ranking": 177,
    "Nookazon_average_price_NMT": 19,
    "Poll_Ranking_2020": 81,
    "Poll_Ranking_2020_21": 78,
    "Total_Poll_Votes_2020": 1162,
    "Total_Poll_Votes_2020_21": 1466,
    "Poll_votes_May_2020": 61,
    "Poll_votes_June_2020": 227,
    "Poll_votes_July_2020": 271,
    "Poll_votes_August_2020": 175,
    "Poll_votes_September_2020": 163,
    "Poll_votes_October_2020": 116,
    "Poll_votes_November_2020": 76,
    "Poll_votes_December_2020": 73,
    "Poll_votes_January_2021": 82,
    "Poll_votes_February_2021": 68,
    "Poll_votes_March_2021": 84,
    "Poll_votes_April_2021": 70
  },
  {
    "name": "Chief",
    "url": "https://nookipedia.com/wiki/Chief",
    "alt_name": "",
    "skin_color": "ffaa3b",
    "text_color": "874c25",
    "id": "wol00",
    "image_url": "https://dodo.ac/np/images/1/13/Chief_NH.png",
    "species": "Wolf",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 19,
    "sign": "Sagittarius",
    "quote": "Don't wish it were easier; wish you were better.",
    "phrase": "harrumph",
    "clothing": "Sweater On Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Alley",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 113,
    "Average_Popularity_Score": 139,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 89,
    "Poll_Ranking_2020_21": 91,
    "Total_Poll_Votes_2020": 1056,
    "Total_Poll_Votes_2020_21": 1262,
    "Poll_votes_May_2020": 82,
    "Poll_votes_June_2020": 274,
    "Poll_votes_July_2020": 262,
    "Poll_votes_August_2020": 125,
    "Poll_votes_September_2020": 120,
    "Poll_votes_October_2020": 92,
    "Poll_votes_November_2020": 50,
    "Poll_votes_December_2020": 51,
    "Poll_votes_January_2021": 47,
    "Poll_votes_February_2021": 48,
    "Poll_votes_March_2021": 71,
    "Poll_votes_April_2021": 40
  },
  {
    "name": "Tasha",
    "url": "https://nookipedia.com/wiki/Tasha",
    "alt_name": "",
    "skin_color": "194c89",
    "text_color": "fffad4",
    "id": "squ13",
    "image_url": "https://dodo.ac/np/images/3/35/Tasha_NH.png",
    "species": "Squirrel",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "November",
    "birthday_day": 30,
    "sign": "Sagittarius",
    "quote": "There's no such thing as a safe secret.",
    "phrase": "nice nice",
    "clothing": "Collarless Coat",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Grunge",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 1,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 119,
    "Average_Popularity_Score": 143,
    "Nookazon_Bells_Price_Ranking": 235,
    "Nookazon_average_price_Bells": 133334,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 139,
    "Poll_Ranking_2020_21": 143,
    "Total_Poll_Votes_2020": 677,
    "Total_Poll_Votes_2020_21": 816,
    "Poll_votes_May_2020": 46,
    "Poll_votes_June_2020": 138,
    "Poll_votes_July_2020": 146,
    "Poll_votes_August_2020": 95,
    "Poll_votes_September_2020": 92,
    "Poll_votes_October_2020": 64,
    "Poll_votes_November_2020": 50,
    "Poll_votes_December_2020": 46,
    "Poll_votes_January_2021": 37,
    "Poll_votes_February_2021": 31,
    "Poll_votes_March_2021": 40,
    "Poll_votes_April_2021": 31
  },
  {
    "name": "Phoebe",
    "url": "https://nookipedia.com/wiki/Phoebe",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "ost10",
    "image_url": "https://dodo.ac/np/images/5/50/Phoebe_NH.png",
    "species": "Ostrich",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 22,
    "sign": "Taurus",
    "quote": "You can't keep a good bird down.",
    "phrase": "sparky",
    "clothing": "Front-Tie Tee",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 117,
    "Average_Popularity_Score": 142.25,
    "Nookazon_Bells_Price_Ranking": 216,
    "Nookazon_average_price_Bells": 143750,
    "Nookazon_NMT_Price_Ranking": 209,
    "Nookazon_average_price_NMT": 17,
    "Poll_Ranking_2020": 71,
    "Poll_Ranking_2020_21": 72,
    "Total_Poll_Votes_2020": 1383,
    "Total_Poll_Votes_2020_21": 1743,
    "Poll_votes_May_2020": 105,
    "Poll_votes_June_2020": 303,
    "Poll_votes_July_2020": 340,
    "Poll_votes_August_2020": 204,
    "Poll_votes_September_2020": 150,
    "Poll_votes_October_2020": 134,
    "Poll_votes_November_2020": 82,
    "Poll_votes_December_2020": 65,
    "Poll_votes_January_2021": 94,
    "Poll_votes_February_2021": 94,
    "Poll_votes_March_2021": 92,
    "Poll_votes_April_2021": 80
  },
  {
    "name": "Lyman",
    "url": "https://nookipedia.com/wiki/Lyman",
    "alt_name": "",
    "skin_color": "a8e989",
    "text_color": 8.78e+88,
    "id": "kal09",
    "image_url": "https://dodo.ac/np/images/a/a5/Lyman_NH.png",
    "species": "Koala",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 12,
    "sign": "Libra",
    "quote": "Eucalyptus is the spice of life.",
    "phrase": "chips",
    "clothing": "Vertical-Stripes Shirt",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 111,
    "Average_Popularity_Score": 138.25,
    "Nookazon_Bells_Price_Ranking": 130,
    "Nookazon_average_price_Bells": 187500,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 97,
    "Poll_Ranking_2020_21": 99,
    "Total_Poll_Votes_2020": 993,
    "Total_Poll_Votes_2020_21": 1207,
    "Poll_votes_May_2020": 73,
    "Poll_votes_June_2020": 196,
    "Poll_votes_July_2020": 198,
    "Poll_votes_August_2020": 144,
    "Poll_votes_September_2020": 185,
    "Poll_votes_October_2020": 100,
    "Poll_votes_November_2020": 47,
    "Poll_votes_December_2020": 50,
    "Poll_votes_January_2021": 55,
    "Poll_votes_February_2021": 53,
    "Poll_votes_March_2021": 63,
    "Poll_votes_April_2021": 43
  },
  {
    "name": "Pashmina",
    "url": "https://nookipedia.com/wiki/Pashmina",
    "alt_name": "",
    "skin_color": "e2856b",
    "text_color": "fffce9",
    "id": "goa08",
    "image_url": "https://dodo.ac/np/images/3/3e/Pashmina_NH.png",
    "species": "Goat",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "December",
    "birthday_day": 26,
    "sign": "Capricorn",
    "quote": "Before you judge someone, walk a mile in their hooves.",
    "phrase": "kidders",
    "clothing": "Rainbow Sweater",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Cafe",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 101,
    "Average_Popularity_Score": 126,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 58,
    "Poll_Ranking_2020_21": 58,
    "Total_Poll_Votes_2020": 1907,
    "Total_Poll_Votes_2020_21": 2368,
    "Poll_votes_May_2020": 106,
    "Poll_votes_June_2020": 441,
    "Poll_votes_July_2020": 461,
    "Poll_votes_August_2020": 256,
    "Poll_votes_September_2020": 230,
    "Poll_votes_October_2020": 183,
    "Poll_votes_November_2020": 113,
    "Poll_votes_December_2020": 117,
    "Poll_votes_January_2021": 127,
    "Poll_votes_February_2021": 125,
    "Poll_votes_March_2021": 126,
    "Poll_votes_April_2021": 83
  },
  {
    "name": "Gayle",
    "url": "https://nookipedia.com/wiki/Gayle",
    "alt_name": "",
    "skin_color": "f993ce",
    "text_color": "fffce9",
    "id": "crd07",
    "image_url": "https://dodo.ac/np/images/5/5e/Gayle_NH.png",
    "species": "Alligator",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "May",
    "birthday_day": 17,
    "sign": "Taurus",
    "quote": "An ounce of prevention is worth a pound of cure.",
    "phrase": "snacky",
    "clothing": "Lace-Up Dress",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Cute",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 1,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 117,
    "Average_Popularity_Score": 142.25,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 79,
    "Poll_Ranking_2020_21": 77,
    "Total_Poll_Votes_2020": 1182,
    "Total_Poll_Votes_2020_21": 1507,
    "Poll_votes_May_2020": 72,
    "Poll_votes_June_2020": 314,
    "Poll_votes_July_2020": 281,
    "Poll_votes_August_2020": 154,
    "Poll_votes_September_2020": 137,
    "Poll_votes_October_2020": 92,
    "Poll_votes_November_2020": 77,
    "Poll_votes_December_2020": 55,
    "Poll_votes_January_2021": 71,
    "Poll_votes_February_2021": 93,
    "Poll_votes_March_2021": 80,
    "Poll_votes_April_2021": 81
  },
  {
    "name": "Kyle",
    "url": "https://nookipedia.com/wiki/Kyle",
    "alt_name": "",
    "skin_color": "e8b010",
    "text_color": "fffce9",
    "id": "wol10",
    "image_url": "https://dodo.ac/np/images/4/46/Kyle_NH.png",
    "species": "Wolf",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 6,
    "sign": "Sagittarius",
    "quote": "Never trust a sheep in wolf's clothing.",
    "phrase": "alpha",
    "clothing": "Gilet and Shirt",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Music room",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 105,
    "Average_Popularity_Score": 130,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 64,
    "Poll_Ranking_2020_21": 66,
    "Total_Poll_Votes_2020": 1588,
    "Total_Poll_Votes_2020_21": 1901,
    "Poll_votes_May_2020": 142,
    "Poll_votes_June_2020": 412,
    "Poll_votes_July_2020": 372,
    "Poll_votes_August_2020": 197,
    "Poll_votes_September_2020": 161,
    "Poll_votes_October_2020": 129,
    "Poll_votes_November_2020": 101,
    "Poll_votes_December_2020": 74,
    "Poll_votes_January_2021": 83,
    "Poll_votes_February_2021": 72,
    "Poll_votes_March_2021": 84,
    "Poll_votes_April_2021": 74
  },
  {
    "name": "Lobo",
    "url": "https://nookipedia.com/wiki/Lobo",
    "alt_name": "",
    "skin_color": 735000000000,
    "text_color": "fffce9",
    "id": "wol01",
    "image_url": "https://dodo.ac/np/images/d/d1/Lobo_NH.png",
    "species": "Wolf",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "November",
    "birthday_day": 5,
    "sign": "Scorpio",
    "quote": "If it's not one thing, it's another.",
    "phrase": "ah-rooooo",
    "clothing": "Bomber-Style Jacket",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Cabin",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 115,
    "Average_Popularity_Score": 141,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 134,
    "Poll_Ranking_2020_21": 135,
    "Total_Poll_Votes_2020": 716,
    "Total_Poll_Votes_2020_21": 865,
    "Poll_votes_May_2020": 60,
    "Poll_votes_June_2020": 180,
    "Poll_votes_July_2020": 164,
    "Poll_votes_August_2020": 91,
    "Poll_votes_September_2020": 68,
    "Poll_votes_October_2020": 69,
    "Poll_votes_November_2020": 37,
    "Poll_votes_December_2020": 47,
    "Poll_votes_January_2021": 33,
    "Poll_votes_February_2021": 34,
    "Poll_votes_March_2021": 46,
    "Poll_votes_April_2021": 36
  },
  {
    "name": "Cube",
    "url": "https://nookipedia.com/wiki/Cube",
    "alt_name": "",
    "skin_color": 515151,
    "text_color": "fffce9",
    "id": "pgn02",
    "image_url": "https://dodo.ac/np/images/1/10/Cube_NH.png",
    "species": "Penguin",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "January",
    "birthday_day": 29,
    "sign": "Aquarius",
    "quote": "Sometimes you gotta learn to chill.",
    "phrase": "brainfreeze",
    "clothing": "Simple-Dots Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": "['d-d-dude']",
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Cute",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 126,
    "Average_Popularity_Score": 152.25,
    "Nookazon_Bells_Price_Ranking": 230,
    "Nookazon_average_price_Bells": 137500,
    "Nookazon_NMT_Price_Ranking": 177,
    "Nookazon_average_price_NMT": 19,
    "Poll_Ranking_2020": 98,
    "Poll_Ranking_2020_21": 101,
    "Total_Poll_Votes_2020": 977,
    "Total_Poll_Votes_2020_21": 1187,
    "Poll_votes_May_2020": 79,
    "Poll_votes_June_2020": 248,
    "Poll_votes_July_2020": 245,
    "Poll_votes_August_2020": 129,
    "Poll_votes_September_2020": 100,
    "Poll_votes_October_2020": 79,
    "Poll_votes_November_2020": 55,
    "Poll_votes_December_2020": 42,
    "Poll_votes_January_2021": 53,
    "Poll_votes_February_2021": 58,
    "Poll_votes_March_2021": 54,
    "Poll_votes_April_2021": 45
  },
  {
    "name": "Caroline",
    "url": "https://nookipedia.com/wiki/Caroline",
    "alt_name": "Bliss",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "squ06",
    "image_url": "https://dodo.ac/np/images/2/26/Caroline_NH.png",
    "species": "Squirrel",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "July",
    "birthday_day": 15,
    "sign": "Cancer",
    "quote": "New brooms sweep clean.",
    "phrase": "hulaaaa",
    "clothing": "Striped Maxi Dress",
    "islander": "TRUE",
    "debut": "AC",
    "prev_phrases": [],
    "appearances": "['AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Office",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 129,
    "Average_Popularity_Score": 154,
    "Nookazon_Bells_Price_Ranking": 158,
    "Nookazon_average_price_Bells": 170834,
    "Nookazon_NMT_Price_Ranking": 102,
    "Nookazon_average_price_NMT": 21,
    "Poll_Ranking_2020": 173,
    "Poll_Ranking_2020_21": 178,
    "Total_Poll_Votes_2020": 509,
    "Total_Poll_Votes_2020_21": 608,
    "Poll_votes_May_2020": 24,
    "Poll_votes_June_2020": 103,
    "Poll_votes_July_2020": 99,
    "Poll_votes_August_2020": 62,
    "Poll_votes_September_2020": 82,
    "Poll_votes_October_2020": 50,
    "Poll_votes_November_2020": 48,
    "Poll_votes_December_2020": 41,
    "Poll_votes_January_2021": 21,
    "Poll_votes_February_2021": 28,
    "Poll_votes_March_2021": 26,
    "Poll_votes_April_2021": 24
  },
  {
    "name": "Alice",
    "url": "https://nookipedia.com/wiki/Alice",
    "alt_name": "",
    "skin_color": "e8b010",
    "text_color": "fffce9",
    "id": "kal01",
    "image_url": "https://dodo.ac/np/images/e/e1/Alice_NH.png",
    "species": "Koala",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "August",
    "birthday_day": 19,
    "sign": "Leo",
    "quote": "Treat others as you would like to be treated.",
    "phrase": "guvnor",
    "clothing": "Striped Maxi Dress",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 127,
    "Average_Popularity_Score": 153,
    "Nookazon_Bells_Price_Ranking": 121,
    "Nookazon_average_price_Bells": 193750,
    "Nookazon_NMT_Price_Ranking": 279,
    "Nookazon_average_price_NMT": 14,
    "Poll_Ranking_2020": 101,
    "Poll_Ranking_2020_21": 106,
    "Total_Poll_Votes_2020": 945,
    "Total_Poll_Votes_2020_21": 1131,
    "Poll_votes_May_2020": 44,
    "Poll_votes_June_2020": 225,
    "Poll_votes_July_2020": 237,
    "Poll_votes_August_2020": 141,
    "Poll_votes_September_2020": 119,
    "Poll_votes_October_2020": 75,
    "Poll_votes_November_2020": 55,
    "Poll_votes_December_2020": 49,
    "Poll_votes_January_2021": 43,
    "Poll_votes_February_2021": 47,
    "Poll_votes_March_2021": 57,
    "Poll_votes_April_2021": 39
  },
  {
    "name": "Alfonso",
    "url": "https://nookipedia.com/wiki/Alfonso",
    "alt_name": "",
    "skin_color": "e8b010",
    "text_color": "fffce9",
    "id": "crd00",
    "image_url": "https://dodo.ac/np/images/e/e4/Alfonso_NH.png",
    "species": "Alligator",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 9,
    "sign": "Gemini",
    "quote": "Slow and steady wins the race.",
    "phrase": "it'sa me",
    "clothing": "Simple Parka",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": "[\\it's a me\\\"]",
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Toys",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 130,
    "Average_Popularity_Score": 154.25,
    "Nookazon_Bells_Price_Ranking": 96,
    "Nookazon_average_price_Bells": 201563,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 118,
    "Poll_Ranking_2020_21": 116,
    "Total_Poll_Votes_2020": 803,
    "Total_Poll_Votes_2020_21": 1028,
    "Poll_votes_May_2020": 43,
    "Poll_votes_June_2020": 241,
    "Poll_votes_July_2020": 214,
    "Poll_votes_August_2020": 108,
    "Poll_votes_September_2020": 89,
    "Poll_votes_October_2020": 53,
    "Poll_votes_November_2020": 29,
    "Poll_votes_December_2020": 26,
    "Poll_votes_January_2021": 40,
    "Poll_votes_February_2021": 55,
    "Poll_votes_March_2021": 80,
    "Poll_votes_April_2021": 50
  },
  {
    "name": "Julia",
    "url": "https://nookipedia.com/wiki/Julia",
    "alt_name": "",
    "skin_color": "0ca54a",
    "text_color": "fffce9",
    "id": "ost05",
    "image_url": "https://dodo.ac/np/images/0/0b/Julia_NH_Transparent.png",
    "species": "Ostrich",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "July",
    "birthday_day": 31,
    "sign": "Leo",
    "quote": "Cut once, measure twice... Waitâ€” reverse that.",
    "phrase": "dahling",
    "clothing": "Zigzag-Print Dress",
    "islander": "TRUE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 120,
    "Average_Popularity_Score": 143.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 80,
    "Nookazon_average_price_NMT": 25,
    "Poll_Ranking_2020": 111,
    "Poll_Ranking_2020_21": 105,
    "Total_Poll_Votes_2020": 893,
    "Total_Poll_Votes_2020_21": 1132,
    "Poll_votes_May_2020": 53,
    "Poll_votes_June_2020": 216,
    "Poll_votes_July_2020": 237,
    "Poll_votes_August_2020": 116,
    "Poll_votes_September_2020": 95,
    "Poll_votes_October_2020": 73,
    "Poll_votes_November_2020": 59,
    "Poll_votes_December_2020": 44,
    "Poll_votes_January_2021": 47,
    "Poll_votes_February_2021": 64,
    "Poll_votes_March_2021": 68,
    "Poll_votes_April_2021": 60
  },
  {
    "name": "Chester",
    "url": "https://nookipedia.com/wiki/Chester",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "cbr15",
    "image_url": "https://dodo.ac/np/images/a/af/Chester_NH.png",
    "species": "Bear cub",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 6,
    "sign": "Leo",
    "quote": "Sleep early. Wake late.",
    "phrase": "rookie",
    "clothing": "Dragon Suit",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": [],
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Bamboo",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 133,
    "Average_Popularity_Score": 157.5,
    "Nookazon_Bells_Price_Ranking": 117,
    "Nookazon_average_price_Bells": 195834,
    "Nookazon_NMT_Price_Ranking": 177,
    "Nookazon_average_price_NMT": 19,
    "Poll_Ranking_2020": 166,
    "Poll_Ranking_2020_21": 168,
    "Total_Poll_Votes_2020": 543,
    "Total_Poll_Votes_2020_21": 640,
    "Poll_votes_May_2020": 36,
    "Poll_votes_June_2020": 95,
    "Poll_votes_July_2020": 145,
    "Poll_votes_August_2020": 115,
    "Poll_votes_September_2020": 50,
    "Poll_votes_October_2020": 53,
    "Poll_votes_November_2020": 27,
    "Poll_votes_December_2020": 22,
    "Poll_votes_January_2021": 29,
    "Poll_votes_February_2021": 20,
    "Poll_votes_March_2021": 29,
    "Poll_votes_April_2021": 19
  },
  {
    "name": "Cyd",
    "url": "https://nookipedia.com/wiki/Cyd",
    "alt_name": "",
    "skin_color": "ff4040",
    "text_color": "fffad4",
    "id": "elp12",
    "image_url": "https://dodo.ac/np/images/5/5d/Cyd_NH.png",
    "species": "Elephant",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 9,
    "sign": "Gemini",
    "quote": "Do what you want, but do it loud!",
    "phrase": "rockin'",
    "clothing": "Dragon Jacket",
    "islander": "FALSE",
    "debut": "NH",
    "prev_phrases": [],
    "appearances": "['NH', 'PC']",
    "Amiibo": "NO",
    "hobby": "Music",
    "interior_decor": "Grunge",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 134,
    "Average_Popularity_Score": 158.5,
    "Nookazon_Bells_Price_Ranking": 269,
    "Nookazon_average_price_Bells": 112500,
    "Nookazon_NMT_Price_Ranking": 33,
    "Nookazon_average_price_NMT": 31,
    "Poll_Ranking_2020": 163,
    "Poll_Ranking_2020_21": 166,
    "Total_Poll_Votes_2020": 550,
    "Total_Poll_Votes_2020_21": 658,
    "Poll_votes_May_2020": 22,
    "Poll_votes_June_2020": 119,
    "Poll_votes_July_2020": 138,
    "Poll_votes_August_2020": 100,
    "Poll_votes_September_2020": 52,
    "Poll_votes_October_2020": 57,
    "Poll_votes_November_2020": 34,
    "Poll_votes_December_2020": 28,
    "Poll_votes_January_2021": 24,
    "Poll_votes_February_2021": 28,
    "Poll_votes_March_2021": 28,
    "Poll_votes_April_2021": 28
  },
  {
    "name": "Cole",
    "url": "https://nookipedia.com/wiki/Cole",
    "alt_name": "",
    "skin_color": 515151,
    "text_color": "fffce9",
    "id": "rbt18",
    "image_url": "https://dodo.ac/np/images/9/95/Cole_NH_Transparent.png",
    "species": "Rabbit",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 10,
    "sign": "Leo",
    "quote": "Little pitchers have big ears.",
    "phrase": "coooooool",
    "clothing": "Orange Dress",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": "['duuude']",
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Beach",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 123,
    "Average_Popularity_Score": 148.25,
    "Nookazon_Bells_Price_Ranking": 97,
    "Nookazon_average_price_Bells": 200000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 196,
    "Poll_Ranking_2020_21": 196,
    "Total_Poll_Votes_2020": 440,
    "Total_Poll_Votes_2020_21": 549,
    "Poll_votes_May_2020": 31,
    "Poll_votes_June_2020": 96,
    "Poll_votes_July_2020": 96,
    "Poll_votes_August_2020": 74,
    "Poll_votes_September_2020": 60,
    "Poll_votes_October_2020": 35,
    "Poll_votes_November_2020": 27,
    "Poll_votes_December_2020": 21,
    "Poll_votes_January_2021": 26,
    "Poll_votes_February_2021": 24,
    "Poll_votes_March_2021": 32,
    "Poll_votes_April_2021": 27
  },
  {
    "name": "Grizzly",
    "url": "https://nookipedia.com/wiki/Grizzly",
    "alt_name": "",
    "skin_color": "7c6559",
    "text_color": "eac113",
    "id": "bea09",
    "image_url": "https://dodo.ac/np/images/4/4b/Grizzly_NH.png",
    "species": "Bear",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 31,
    "sign": "Leo",
    "quote": "Those who live in glass houses shouldn't throw stones.",
    "phrase": "grrr",
    "clothing": "Flannel Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 134,
    "Average_Popularity_Score": 158.5,
    "Nookazon_Bells_Price_Ranking": 57,
    "Nookazon_average_price_Bells": 285938,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 270,
    "Poll_Ranking_2020_21": 263,
    "Total_Poll_Votes_2020": 272,
    "Total_Poll_Votes_2020_21": 372,
    "Poll_votes_May_2020": 11,
    "Poll_votes_June_2020": 47,
    "Poll_votes_July_2020": 55,
    "Poll_votes_August_2020": 48,
    "Poll_votes_September_2020": 37,
    "Poll_votes_October_2020": 37,
    "Poll_votes_November_2020": 17,
    "Poll_votes_December_2020": 20,
    "Poll_votes_January_2021": 21,
    "Poll_votes_February_2021": 25,
    "Poll_votes_March_2021": 27,
    "Poll_votes_April_2021": 27
  },
  {
    "name": "Nan",
    "url": "https://nookipedia.com/wiki/Nan",
    "alt_name": "",
    "skin_color": 515151,
    "text_color": "fffce9",
    "id": "goa01",
    "image_url": "https://dodo.ac/np/images/b/b8/Nan_NH.png",
    "species": "Goat",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "August",
    "birthday_day": 24,
    "sign": "Virgo",
    "quote": "Nanny-nanny boo-boo!",
    "phrase": "kid",
    "clothing": "Tweed Dress",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 122,
    "Average_Popularity_Score": 146.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 127,
    "Poll_Ranking_2020_21": 126,
    "Total_Poll_Votes_2020": 746,
    "Total_Poll_Votes_2020_21": 919,
    "Poll_votes_May_2020": 42,
    "Poll_votes_June_2020": 161,
    "Poll_votes_July_2020": 177,
    "Poll_votes_August_2020": 92,
    "Poll_votes_September_2020": 105,
    "Poll_votes_October_2020": 80,
    "Poll_votes_November_2020": 50,
    "Poll_votes_December_2020": 39,
    "Poll_votes_January_2021": 41,
    "Poll_votes_February_2021": 50,
    "Poll_votes_March_2021": 48,
    "Poll_votes_April_2021": 34
  },
  {
    "name": "Broccolo",
    "url": "https://nookipedia.com/wiki/Broccolo",
    "alt_name": "",
    "skin_color": "55cfff",
    "text_color": "fffce9",
    "id": "mus12",
    "image_url": "https://dodo.ac/np/images/6/69/Broccolo_NH.png",
    "species": "Mouse",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 30,
    "sign": "Cancer",
    "quote": "One nap leads to another.",
    "phrase": "eat it",
    "clothing": "Raglan Shirt",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Toys",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 127,
    "Average_Popularity_Score": 153,
    "Nookazon_Bells_Price_Ranking": 79,
    "Nookazon_average_price_Bells": 237500,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 160,
    "Poll_Ranking_2020_21": 154,
    "Total_Poll_Votes_2020": 555,
    "Total_Poll_Votes_2020_21": 746,
    "Poll_votes_May_2020": 26,
    "Poll_votes_June_2020": 110,
    "Poll_votes_July_2020": 135,
    "Poll_votes_August_2020": 68,
    "Poll_votes_September_2020": 78,
    "Poll_votes_October_2020": 64,
    "Poll_votes_November_2020": 40,
    "Poll_votes_December_2020": 34,
    "Poll_votes_January_2021": 54,
    "Poll_votes_February_2021": 43,
    "Poll_votes_March_2021": 55,
    "Poll_votes_April_2021": 39
  },
  {
    "name": "Ozzie",
    "url": "https://nookipedia.com/wiki/Ozzie",
    "alt_name": "",
    "skin_color": "bfbfbf",
    "text_color": "5e5e5e",
    "id": "kal05",
    "image_url": "https://dodo.ac/np/images/3/3a/Ozzie_NH.png",
    "species": "Koala",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "May",
    "birthday_day": 7,
    "sign": "Taurus",
    "quote": "Half a loaf is better than none.",
    "phrase": "ol' bear",
    "clothing": "Energetic Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "School",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 112,
    "Average_Popularity_Score": 138.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 83,
    "Poll_Ranking_2020_21": 83,
    "Total_Poll_Votes_2020": 1148,
    "Total_Poll_Votes_2020_21": 1413,
    "Poll_votes_May_2020": 88,
    "Poll_votes_June_2020": 294,
    "Poll_votes_July_2020": 282,
    "Poll_votes_August_2020": 151,
    "Poll_votes_September_2020": 116,
    "Poll_votes_October_2020": 101,
    "Poll_votes_November_2020": 66,
    "Poll_votes_December_2020": 50,
    "Poll_votes_January_2021": 63,
    "Poll_votes_February_2021": 58,
    "Poll_votes_March_2021": 84,
    "Poll_votes_April_2021": 60
  },
  {
    "name": "Raddle",
    "url": "https://nookipedia.com/wiki/Raddle",
    "alt_name": "",
    "skin_color": 515151,
    "text_color": "fffce9",
    "id": "flg15",
    "image_url": "https://dodo.ac/np/images/7/7a/Raddle_NH.png",
    "species": "Frog",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 6,
    "sign": "Gemini",
    "quote": "A healthy mind makes for a healthy body.",
    "phrase": "aaachâ€”",
    "clothing": "Doctor's Coat",
    "islander": "TRUE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "School",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 142,
    "Average_Popularity_Score": 163.25,
    "Nookazon_Bells_Price_Ranking": 267,
    "Nookazon_average_price_Bells": 113393,
    "Nookazon_NMT_Price_Ranking": 102,
    "Nookazon_average_price_NMT": 21,
    "Poll_Ranking_2020": 137,
    "Poll_Ranking_2020_21": 142,
    "Total_Poll_Votes_2020": 696,
    "Total_Poll_Votes_2020_21": 820,
    "Poll_votes_May_2020": 64,
    "Poll_votes_June_2020": 159,
    "Poll_votes_July_2020": 174,
    "Poll_votes_August_2020": 82,
    "Poll_votes_September_2020": 79,
    "Poll_votes_October_2020": 65,
    "Poll_votes_November_2020": 42,
    "Poll_votes_December_2020": 31,
    "Poll_votes_January_2021": 28,
    "Poll_votes_February_2021": 39,
    "Poll_votes_March_2021": 37,
    "Poll_votes_April_2021": 20
  },
  {
    "name": "Anchovy",
    "url": "https://nookipedia.com/wiki/Anchovy",
    "alt_name": "",
    "skin_color": "d86808",
    "text_color": "fffce9",
    "id": "brd02",
    "image_url": "https://dodo.ac/np/images/e/ea/Anchovy_NH.png",
    "species": "Bird",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "March",
    "birthday_day": 4,
    "sign": "Pisces",
    "quote": "Why do today what you can put off until tomorrow?",
    "phrase": "chuurp",
    "clothing": "Yodel Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Game room",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 140,
    "Average_Popularity_Score": 162,
    "Nookazon_Bells_Price_Ranking": 9,
    "Nookazon_average_price_Bells": 500050,
    "Nookazon_NMT_Price_Ranking": 279,
    "Nookazon_average_price_NMT": 14,
    "Poll_Ranking_2020": 172,
    "Poll_Ranking_2020_21": 180,
    "Total_Poll_Votes_2020": 512,
    "Total_Poll_Votes_2020_21": 597,
    "Poll_votes_May_2020": 40,
    "Poll_votes_June_2020": 145,
    "Poll_votes_July_2020": 125,
    "Poll_votes_August_2020": 65,
    "Poll_votes_September_2020": 50,
    "Poll_votes_October_2020": 33,
    "Poll_votes_November_2020": 26,
    "Poll_votes_December_2020": 28,
    "Poll_votes_January_2021": 21,
    "Poll_votes_February_2021": 13,
    "Poll_votes_March_2021": 32,
    "Poll_votes_April_2021": 19
  },
  {
    "name": "Pate",
    "url": "https://nookipedia.com/wiki/Pate",
    "alt_name": "",
    "skin_color": "8bcdea",
    "text_color": "fffad4",
    "id": "duk02",
    "image_url": "https://dodo.ac/np/images/6/6b/Pate_NH.png",
    "species": "Duck",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "February",
    "birthday_day": 23,
    "sign": "Pisces",
    "quote": "A duck won't bite you.",
    "phrase": "quackle",
    "clothing": "Sunflower Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.058823529,
    "Rarity": "0.17%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 131,
    "Average_Popularity_Score": 154.75,
    "Nookazon_Bells_Price_Ranking": 113,
    "Nookazon_average_price_Bells": 196875,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 203,
    "Poll_Ranking_2020_21": 201,
    "Total_Poll_Votes_2020": 423,
    "Total_Poll_Votes_2020_21": 535,
    "Poll_votes_May_2020": 33,
    "Poll_votes_June_2020": 100,
    "Poll_votes_July_2020": 87,
    "Poll_votes_August_2020": 51,
    "Poll_votes_September_2020": 54,
    "Poll_votes_October_2020": 38,
    "Poll_votes_November_2020": 31,
    "Poll_votes_December_2020": 29,
    "Poll_votes_January_2021": 24,
    "Poll_votes_February_2021": 29,
    "Poll_votes_March_2021": 33,
    "Poll_votes_April_2021": 26
  },
  {
    "name": "Wendy",
    "url": "https://nookipedia.com/wiki/Wendy",
    "alt_name": "",
    "skin_color": "55cfff",
    "text_color": "fffce9",
    "id": "shp09",
    "image_url": "https://dodo.ac/np/images/2/23/Wendy_NH.png",
    "species": "Sheep",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "August",
    "birthday_day": 15,
    "sign": "Leo",
    "quote": "Every cloud has a silver lining.",
    "phrase": "lambkins",
    "clothing": "Watermelon Dress",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": [],
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Cute",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 139,
    "Average_Popularity_Score": 160.75,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 209,
    "Nookazon_average_price_NMT": 17,
    "Poll_Ranking_2020": 120,
    "Poll_Ranking_2020_21": 122,
    "Total_Poll_Votes_2020": 798,
    "Total_Poll_Votes_2020_21": 953,
    "Poll_votes_May_2020": 66,
    "Poll_votes_June_2020": 238,
    "Poll_votes_July_2020": 200,
    "Poll_votes_August_2020": 87,
    "Poll_votes_September_2020": 61,
    "Poll_votes_October_2020": 72,
    "Poll_votes_November_2020": 37,
    "Poll_votes_December_2020": 37,
    "Poll_votes_January_2021": 40,
    "Poll_votes_February_2021": 28,
    "Poll_votes_March_2021": 40,
    "Poll_votes_April_2021": 47
  },
  {
    "name": "Henry",
    "url": "https://nookipedia.com/wiki/Henry",
    "alt_name": "",
    "skin_color": "78dd62",
    "text_color": "28665a",
    "id": "flg19",
    "image_url": "https://dodo.ac/np/images/2/26/Henry_NH.png",
    "species": "Frog",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "September",
    "birthday_day": 21,
    "sign": "Virgo",
    "quote": "The way to a frog's heart is through his stomach.",
    "phrase": "snoozit",
    "clothing": "Denim Jacket",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 121,
    "Average_Popularity_Score": 146,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 99,
    "Poll_Ranking_2020_21": 98,
    "Total_Poll_Votes_2020": 952,
    "Total_Poll_Votes_2020_21": 1220,
    "Poll_votes_May_2020": 52,
    "Poll_votes_June_2020": 231,
    "Poll_votes_July_2020": 222,
    "Poll_votes_August_2020": 103,
    "Poll_votes_September_2020": 95,
    "Poll_votes_October_2020": 97,
    "Poll_votes_November_2020": 71,
    "Poll_votes_December_2020": 81,
    "Poll_votes_January_2021": 66,
    "Poll_votes_February_2021": 60,
    "Poll_votes_March_2021": 70,
    "Poll_votes_April_2021": 72
  },
  {
    "name": "Clay",
    "url": "https://nookipedia.com/wiki/Clay",
    "alt_name": "",
    "skin_color": "7a2500",
    "text_color": "fffce9",
    "id": "ham05",
    "image_url": "https://dodo.ac/np/images/6/6c/Clay_NH.png",
    "species": "Hamster",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 19,
    "sign": "Libra",
    "quote": "Life is just a bowl of cherries.",
    "phrase": "thump",
    "clothing": "Poncho-Style Sweater",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 125,
    "Average_Popularity_Score": 148.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 41,
    "Poll_Ranking_2020_21": 43,
    "Total_Poll_Votes_2020": 2760,
    "Total_Poll_Votes_2020_21": 3106,
    "Poll_votes_May_2020": 97,
    "Poll_votes_June_2020": 379,
    "Poll_votes_July_2020": 1123,
    "Poll_votes_August_2020": 489,
    "Poll_votes_September_2020": 277,
    "Poll_votes_October_2020": 191,
    "Poll_votes_November_2020": 120,
    "Poll_votes_December_2020": 84,
    "Poll_votes_January_2021": 105,
    "Poll_votes_February_2021": 84,
    "Poll_votes_March_2021": 97,
    "Poll_votes_April_2021": 60
  },
  {
    "name": "Hopper",
    "url": "https://nookipedia.com/wiki/Hopper",
    "alt_name": "",
    "skin_color": 515151,
    "text_color": "fffce9",
    "id": "pgn03",
    "image_url": "https://dodo.ac/np/images/c/cb/Hopper_NH.png",
    "species": "Penguin",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "April",
    "birthday_day": 6,
    "sign": "Aries",
    "quote": "Always have a comeback.",
    "phrase": "slushie",
    "clothing": "Dragon Suit",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Ice",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 137,
    "Average_Popularity_Score": 159.75,
    "Nookazon_Bells_Price_Ranking": 111,
    "Nookazon_average_price_Bells": 197917,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 209,
    "Poll_Ranking_2020_21": 212,
    "Total_Poll_Votes_2020": 415,
    "Total_Poll_Votes_2020_21": 499,
    "Poll_votes_May_2020": 28,
    "Poll_votes_June_2020": 92,
    "Poll_votes_July_2020": 106,
    "Poll_votes_August_2020": 55,
    "Poll_votes_September_2020": 53,
    "Poll_votes_October_2020": 36,
    "Poll_votes_November_2020": 25,
    "Poll_votes_December_2020": 20,
    "Poll_votes_January_2021": 24,
    "Poll_votes_February_2021": 18,
    "Poll_votes_March_2021": 20,
    "Poll_votes_April_2021": 22
  },
  {
    "name": "Bianca",
    "url": "https://nookipedia.com/wiki/Bianca",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "tig06",
    "image_url": "https://dodo.ac/np/images/6/6f/Bianca_NH.png",
    "species": "Tiger",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "December",
    "birthday_day": 13,
    "sign": "Sagittarius",
    "quote": "There is such a thing as love at first sight.",
    "phrase": "glimmer",
    "clothing": "Front-Tie Button-Down Shirt",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 142,
    "Average_Popularity_Score": 163.25,
    "Nookazon_Bells_Price_Ranking": 280,
    "Nookazon_average_price_Bells": 102813,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 73,
    "Poll_Ranking_2020_21": 74,
    "Total_Poll_Votes_2020": 1363,
    "Total_Poll_Votes_2020_21": 1698,
    "Poll_votes_May_2020": 80,
    "Poll_votes_June_2020": 359,
    "Poll_votes_July_2020": 362,
    "Poll_votes_August_2020": 169,
    "Poll_votes_September_2020": 123,
    "Poll_votes_October_2020": 112,
    "Poll_votes_November_2020": 76,
    "Poll_votes_December_2020": 82,
    "Poll_votes_January_2021": 86,
    "Poll_votes_February_2021": 96,
    "Poll_votes_March_2021": 92,
    "Poll_votes_April_2021": 61
  },
  {
    "name": "Tiffany",
    "url": "https://nookipedia.com/wiki/Tiffany",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "rbt07",
    "image_url": "https://dodo.ac/np/images/f/f0/Tiffany_NH.png",
    "species": "Rabbit",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 9,
    "sign": "Capricorn",
    "quote": "What is cheap is most costly.",
    "phrase": "bunbun",
    "clothing": "Chic Tuxedo Dress",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Bachelor pad",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 148,
    "Average_Popularity_Score": 168.25,
    "Nookazon_Bells_Price_Ranking": 259,
    "Nookazon_average_price_Bells": 116667,
    "Nookazon_NMT_Price_Ranking": 80,
    "Nookazon_average_price_NMT": 25,
    "Poll_Ranking_2020": 170,
    "Poll_Ranking_2020_21": 167,
    "Total_Poll_Votes_2020": 519,
    "Total_Poll_Votes_2020_21": 644,
    "Poll_votes_May_2020": 32,
    "Poll_votes_June_2020": 108,
    "Poll_votes_July_2020": 132,
    "Poll_votes_August_2020": 86,
    "Poll_votes_September_2020": 65,
    "Poll_votes_October_2020": 35,
    "Poll_votes_November_2020": 34,
    "Poll_votes_December_2020": 27,
    "Poll_votes_January_2021": 31,
    "Poll_votes_February_2021": 31,
    "Poll_votes_March_2021": 38,
    "Poll_votes_April_2021": 25
  },
  {
    "name": "Hopkins",
    "url": "https://nookipedia.com/wiki/Hopkins",
    "alt_name": "",
    "skin_color": "55cfff",
    "text_color": "fffce9",
    "id": "rbt14",
    "image_url": "https://dodo.ac/np/images/c/c1/Hopkins_NH.png",
    "species": "Rabbit",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "March",
    "birthday_day": 11,
    "sign": "Pisces",
    "quote": "A wise mammal gives danger a wide berth.",
    "phrase": "thumper",
    "clothing": "Striped Shirt",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Arcade",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 138,
    "Average_Popularity_Score": 160.25,
    "Nookazon_Bells_Price_Ranking": 121,
    "Nookazon_average_price_Bells": 193750,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 205,
    "Poll_Ranking_2020_21": 208,
    "Total_Poll_Votes_2020": 419,
    "Total_Poll_Votes_2020_21": 509,
    "Poll_votes_May_2020": 25,
    "Poll_votes_June_2020": 92,
    "Poll_votes_July_2020": 99,
    "Poll_votes_August_2020": 49,
    "Poll_votes_September_2020": 57,
    "Poll_votes_October_2020": 37,
    "Poll_votes_November_2020": 36,
    "Poll_votes_December_2020": 24,
    "Poll_votes_January_2021": 25,
    "Poll_votes_February_2021": 24,
    "Poll_votes_March_2021": 19,
    "Poll_votes_April_2021": 22
  },
  {
    "name": "Scoot",
    "url": "https://nookipedia.com/wiki/Scoot",
    "alt_name": "",
    "skin_color": "78dd62",
    "text_color": "28665a",
    "id": "duk10",
    "image_url": "https://dodo.ac/np/images/e/ec/Scoot_NH.png",
    "species": "Duck",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 13,
    "sign": "Gemini",
    "quote": "Some birds avoid the water, ducks look for it.",
    "phrase": "zip zoom",
    "clothing": "Frog Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.058823529,
    "Rarity": "0.17%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 124,
    "Average_Popularity_Score": 148.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 102,
    "Poll_Ranking_2020_21": 103,
    "Total_Poll_Votes_2020": 944,
    "Total_Poll_Votes_2020_21": 1147,
    "Poll_votes_May_2020": 92,
    "Poll_votes_June_2020": 256,
    "Poll_votes_July_2020": 229,
    "Poll_votes_August_2020": 125,
    "Poll_votes_September_2020": 75,
    "Poll_votes_October_2020": 74,
    "Poll_votes_November_2020": 46,
    "Poll_votes_December_2020": 47,
    "Poll_votes_January_2021": 51,
    "Poll_votes_February_2021": 51,
    "Poll_votes_March_2021": 55,
    "Poll_votes_April_2021": 46
  },
  {
    "name": "Margie",
    "url": "https://nookipedia.com/wiki/Margie",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "elp04",
    "image_url": "https://dodo.ac/np/images/5/54/Margie_NH.png",
    "species": "Elephant",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 28,
    "sign": "Aquarius",
    "quote": "Keep your feet on the ground.",
    "phrase": "tootie",
    "clothing": "Silk Floral-Print Shirt",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 145,
    "Average_Popularity_Score": 165.25,
    "Nookazon_Bells_Price_Ranking": 233,
    "Nookazon_average_price_Bells": 135000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 159,
    "Poll_Ranking_2020_21": 162,
    "Total_Poll_Votes_2020": 558,
    "Total_Poll_Votes_2020_21": 695,
    "Poll_votes_May_2020": 31,
    "Poll_votes_June_2020": 128,
    "Poll_votes_July_2020": 142,
    "Poll_votes_August_2020": 79,
    "Poll_votes_September_2020": 64,
    "Poll_votes_October_2020": 44,
    "Poll_votes_November_2020": 35,
    "Poll_votes_December_2020": 35,
    "Poll_votes_January_2021": 33,
    "Poll_votes_February_2021": 38,
    "Poll_votes_March_2021": 39,
    "Poll_votes_April_2021": 27
  },
  {
    "name": "Apple",
    "url": "https://nookipedia.com/wiki/Apple",
    "alt_name": "",
    "skin_color": "ff6183",
    "text_color": "fffce9",
    "id": "ham01",
    "image_url": "https://dodo.ac/np/images/5/57/Apple_NH.png",
    "species": "Hamster",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "September",
    "birthday_day": 24,
    "sign": "Libra",
    "quote": "One rotten apple spoils the barrel.",
    "phrase": "cheekers",
    "clothing": "Marble-Dots Tee",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Fruit",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 136,
    "Average_Popularity_Score": 159.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 32,
    "Poll_Ranking_2020_21": 32,
    "Total_Poll_Votes_2020": 3379,
    "Total_Poll_Votes_2020_21": 4188,
    "Poll_votes_May_2020": 182,
    "Poll_votes_June_2020": 769,
    "Poll_votes_July_2020": 892,
    "Poll_votes_August_2020": 496,
    "Poll_votes_September_2020": 391,
    "Poll_votes_October_2020": 284,
    "Poll_votes_November_2020": 196,
    "Poll_votes_December_2020": 169,
    "Poll_votes_January_2021": 217,
    "Poll_votes_February_2021": 214,
    "Poll_votes_March_2021": 206,
    "Poll_votes_April_2021": 172
  },
  {
    "name": "Mira",
    "url": "https://nookipedia.com/wiki/Mira",
    "alt_name": "",
    "skin_color": "fff80d",
    "text_color": "9b8986",
    "id": "rbt19",
    "image_url": "https://dodo.ac/np/images/d/d1/Mira_NH.png",
    "species": "Rabbit",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "July",
    "birthday_day": 6,
    "sign": "Cancer",
    "quote": "Always help a friend in need.",
    "phrase": "cottontail",
    "clothing": "Noble Zap Suit",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Theater",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 155,
    "Average_Popularity_Score": 174,
    "Nookazon_Bells_Price_Ranking": 159,
    "Nookazon_average_price_Bells": 168750,
    "Nookazon_NMT_Price_Ranking": 279,
    "Nookazon_average_price_NMT": 14,
    "Poll_Ranking_2020": 132,
    "Poll_Ranking_2020_21": 129,
    "Total_Poll_Votes_2020": 723,
    "Total_Poll_Votes_2020_21": 896,
    "Poll_votes_May_2020": 62,
    "Poll_votes_June_2020": 183,
    "Poll_votes_July_2020": 173,
    "Poll_votes_August_2020": 100,
    "Poll_votes_September_2020": 72,
    "Poll_votes_October_2020": 70,
    "Poll_votes_November_2020": 29,
    "Poll_votes_December_2020": 34,
    "Poll_votes_January_2021": 57,
    "Poll_votes_February_2021": 44,
    "Poll_votes_March_2021": 49,
    "Poll_votes_April_2021": 23
  },
  {
    "name": "Pompom",
    "url": "https://nookipedia.com/wiki/Pompom",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "duk05",
    "image_url": "https://dodo.ac/np/images/3/32/Pompom_NH.png",
    "species": "Duck",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "February",
    "birthday_day": 11,
    "sign": "Aquarius",
    "quote": "Happiness is a rainy day!",
    "phrase": "rah rah",
    "clothing": "Parka Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Normal",
    "P (individual within species)": 0.058823529,
    "Rarity": "0.17%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 146,
    "Average_Popularity_Score": 165.5,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 191,
    "Poll_Ranking_2020_21": 184,
    "Total_Poll_Votes_2020": 450,
    "Total_Poll_Votes_2020_21": 588,
    "Poll_votes_May_2020": 35,
    "Poll_votes_June_2020": 72,
    "Poll_votes_July_2020": 91,
    "Poll_votes_August_2020": 76,
    "Poll_votes_September_2020": 65,
    "Poll_votes_October_2020": 51,
    "Poll_votes_November_2020": 28,
    "Poll_votes_December_2020": 32,
    "Poll_votes_January_2021": 41,
    "Poll_votes_February_2021": 27,
    "Poll_votes_March_2021": 40,
    "Poll_votes_April_2021": 30
  },
  {
    "name": "Walt",
    "url": "https://nookipedia.com/wiki/Walt",
    "alt_name": "",
    "skin_color": "acc8cf",
    "text_color": 498992,
    "id": "kgr08",
    "image_url": "https://dodo.ac/np/images/b/bf/Walt_NH.png",
    "species": "Kangaroo",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "April",
    "birthday_day": 24,
    "sign": "Taurus",
    "quote": "Take the good with the bad.",
    "phrase": "pockets",
    "clothing": "Casual Kimono",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Bamboo",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 147,
    "Average_Popularity_Score": 168,
    "Nookazon_Bells_Price_Ranking": 164,
    "Nookazon_average_price_Bells": 166667,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 200,
    "Poll_Ranking_2020_21": 202,
    "Total_Poll_Votes_2020": 438,
    "Total_Poll_Votes_2020_21": 534,
    "Poll_votes_May_2020": 29,
    "Poll_votes_June_2020": 93,
    "Poll_votes_July_2020": 112,
    "Poll_votes_August_2020": 64,
    "Poll_votes_September_2020": 37,
    "Poll_votes_October_2020": 50,
    "Poll_votes_November_2020": 31,
    "Poll_votes_December_2020": 22,
    "Poll_votes_January_2021": 21,
    "Poll_votes_February_2021": 19,
    "Poll_votes_March_2021": 27,
    "Poll_votes_April_2021": 29
  },
  {
    "name": "Bonbon",
    "url": "https://nookipedia.com/wiki/Bonbon",
    "alt_name": "",
    "skin_color": "7c6559",
    "text_color": "eac113",
    "id": "rbt17",
    "image_url": "https://dodo.ac/np/images/c/cc/Bonbon_NH.png",
    "species": "Rabbit",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 3,
    "sign": "Pisces",
    "quote": "Hindsight is always 20/20.",
    "phrase": "deelish",
    "clothing": "Sleeveless Tunic",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Cute",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 150,
    "Average_Popularity_Score": 169.75,
    "Nookazon_Bells_Price_Ranking": 77,
    "Nookazon_average_price_Bells": 241667,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 259,
    "Poll_Ranking_2020_21": 249,
    "Total_Poll_Votes_2020": 296,
    "Total_Poll_Votes_2020_21": 395,
    "Poll_votes_May_2020": 20,
    "Poll_votes_June_2020": 51,
    "Poll_votes_July_2020": 77,
    "Poll_votes_August_2020": 51,
    "Poll_votes_September_2020": 37,
    "Poll_votes_October_2020": 31,
    "Poll_votes_November_2020": 15,
    "Poll_votes_December_2020": 14,
    "Poll_votes_January_2021": 28,
    "Poll_votes_February_2021": 21,
    "Poll_votes_March_2021": 25,
    "Poll_votes_April_2021": 25
  },
  {
    "name": "Papi",
    "url": "https://nookipedia.com/wiki/Papi",
    "alt_name": "",
    "skin_color": "d86808",
    "text_color": "fffce9",
    "id": "hrs12",
    "image_url": "https://dodo.ac/np/images/a/a7/Papi_NH.png",
    "species": "Horse",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "January",
    "birthday_day": 10,
    "sign": "Capricorn",
    "quote": "Never say neigh.",
    "phrase": "haaay",
    "clothing": "Colorful Striped Sweater",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Toys",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 132,
    "Average_Popularity_Score": 157,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 122,
    "Poll_Ranking_2020_21": 120,
    "Total_Poll_Votes_2020": 764,
    "Total_Poll_Votes_2020_21": 971,
    "Poll_votes_May_2020": 53,
    "Poll_votes_June_2020": 167,
    "Poll_votes_July_2020": 152,
    "Poll_votes_August_2020": 124,
    "Poll_votes_September_2020": 88,
    "Poll_votes_October_2020": 79,
    "Poll_votes_November_2020": 52,
    "Poll_votes_December_2020": 49,
    "Poll_votes_January_2021": 44,
    "Poll_votes_February_2021": 51,
    "Poll_votes_March_2021": 63,
    "Poll_votes_April_2021": 49
  },
  {
    "name": "Canberra",
    "url": "https://nookipedia.com/wiki/Canberra",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "kal08",
    "image_url": "https://dodo.ac/np/images/e/e6/Canberra_NH.png",
    "species": "Koala",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "May",
    "birthday_day": 14,
    "sign": "Taurus",
    "quote": "It's never too late to start over.",
    "phrase": "nuh uh",
    "clothing": "Striped Tank",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Beach",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 159,
    "Average_Popularity_Score": 176.75,
    "Nookazon_Bells_Price_Ranking": 216,
    "Nookazon_average_price_Bells": 143750,
    "Nookazon_NMT_Price_Ranking": 209,
    "Nookazon_average_price_NMT": 17,
    "Poll_Ranking_2020": 151,
    "Poll_Ranking_2020_21": 141,
    "Total_Poll_Votes_2020": 627,
    "Total_Poll_Votes_2020_21": 822,
    "Poll_votes_May_2020": 39,
    "Poll_votes_June_2020": 173,
    "Poll_votes_July_2020": 160,
    "Poll_votes_August_2020": 76,
    "Poll_votes_September_2020": 75,
    "Poll_votes_October_2020": 48,
    "Poll_votes_November_2020": 26,
    "Poll_votes_December_2020": 30,
    "Poll_votes_January_2021": 50,
    "Poll_votes_February_2021": 46,
    "Poll_votes_March_2021": 61,
    "Poll_votes_April_2021": 38
  },
  {
    "name": "Nibbles",
    "url": "https://nookipedia.com/wiki/Nibbles",
    "alt_name": "",
    "skin_color": "00d1bd",
    "text_color": "fffce9",
    "id": "squ04",
    "image_url": "https://dodo.ac/np/images/9/97/Nibbles_NH.png",
    "species": "Squirrel",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "July",
    "birthday_day": 19,
    "sign": "Cancer",
    "quote": "Appearances are, like, totally deceiving.",
    "phrase": "niblet",
    "clothing": "Watermelon Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Fruit",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 156,
    "Average_Popularity_Score": 174.75,
    "Nookazon_Bells_Price_Ranking": 97,
    "Nookazon_average_price_Bells": 200000,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 210,
    "Poll_Ranking_2020_21": 209,
    "Total_Poll_Votes_2020": 410,
    "Total_Poll_Votes_2020_21": 506,
    "Poll_votes_May_2020": 25,
    "Poll_votes_June_2020": 114,
    "Poll_votes_July_2020": 95,
    "Poll_votes_August_2020": 51,
    "Poll_votes_September_2020": 41,
    "Poll_votes_October_2020": 38,
    "Poll_votes_November_2020": 27,
    "Poll_votes_December_2020": 19,
    "Poll_votes_January_2021": 19,
    "Poll_votes_February_2021": 24,
    "Poll_votes_March_2021": 31,
    "Poll_votes_April_2021": 22
  },
  {
    "name": "Rolf",
    "url": "https://nookipedia.com/wiki/Rolf",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "tig00",
    "image_url": "https://dodo.ac/np/images/9/93/Rolf_NH.png",
    "species": "Tiger",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 22,
    "sign": "Leo",
    "quote": "Don't skip lunch. Ever.",
    "phrase": "grrrolf",
    "clothing": "Down Jacket",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 152,
    "Average_Popularity_Score": 172,
    "Nookazon_Bells_Price_Ranking": 97,
    "Nookazon_average_price_Bells": 200000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 180,
    "Poll_Ranking_2020_21": 183,
    "Total_Poll_Votes_2020": 484,
    "Total_Poll_Votes_2020_21": 591,
    "Poll_votes_May_2020": 40,
    "Poll_votes_June_2020": 132,
    "Poll_votes_July_2020": 112,
    "Poll_votes_August_2020": 59,
    "Poll_votes_September_2020": 57,
    "Poll_votes_October_2020": 36,
    "Poll_votes_November_2020": 22,
    "Poll_votes_December_2020": 26,
    "Poll_votes_January_2021": 27,
    "Poll_votes_February_2021": 29,
    "Poll_votes_March_2021": 33,
    "Poll_votes_April_2021": 18
  },
  {
    "name": "Sterling",
    "url": "https://nookipedia.com/wiki/Sterling",
    "alt_name": "",
    "skin_color": "bfbfbf",
    "text_color": "5e5e5e",
    "id": "pbr07",
    "image_url": "https://dodo.ac/np/images/4/4f/Sterling_NH.png",
    "species": "Eagle",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 11,
    "sign": "Sagittarius",
    "quote": "Discretion is the better part of valor.",
    "phrase": "skraaaaw",
    "clothing": "Cavalier Shirt",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": [],
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Jail",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 149,
    "Average_Popularity_Score": 169,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 179,
    "Poll_Ranking_2020_21": 191,
    "Total_Poll_Votes_2020": 489,
    "Total_Poll_Votes_2020_21": 565,
    "Poll_votes_May_2020": 51,
    "Poll_votes_June_2020": 113,
    "Poll_votes_July_2020": 127,
    "Poll_votes_August_2020": 59,
    "Poll_votes_September_2020": 55,
    "Poll_votes_October_2020": 39,
    "Poll_votes_November_2020": 20,
    "Poll_votes_December_2020": 25,
    "Poll_votes_January_2021": 16,
    "Poll_votes_February_2021": 22,
    "Poll_votes_March_2021": 22,
    "Poll_votes_April_2021": 16
  },
  {
    "name": "Bruce",
    "url": "https://nookipedia.com/wiki/Bruce",
    "alt_name": "",
    "skin_color": "459aba",
    "text_color": "fffce9",
    "id": "der03",
    "image_url": "https://dodo.ac/np/images/0/08/Bruce_NH.png",
    "species": "Deer",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "May",
    "birthday_day": 26,
    "sign": "Gemini",
    "quote": "Nobody's perfect.",
    "phrase": "gruff",
    "clothing": "After-School Jacket",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Alley",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 141,
    "Average_Popularity_Score": 162.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 124,
    "Poll_Ranking_2020_21": 131,
    "Total_Poll_Votes_2020": 760,
    "Total_Poll_Votes_2020_21": 890,
    "Poll_votes_May_2020": 43,
    "Poll_votes_June_2020": 215,
    "Poll_votes_July_2020": 163,
    "Poll_votes_August_2020": 104,
    "Poll_votes_September_2020": 96,
    "Poll_votes_October_2020": 56,
    "Poll_votes_November_2020": 52,
    "Poll_votes_December_2020": 31,
    "Poll_votes_January_2021": 35,
    "Poll_votes_February_2021": 38,
    "Poll_votes_March_2021": 27,
    "Poll_votes_April_2021": 30
  },
  {
    "name": "Poncho",
    "url": "https://nookipedia.com/wiki/Poncho",
    "alt_name": "",
    "skin_color": "194c89",
    "text_color": "fffad4",
    "id": "cbr02",
    "image_url": "https://dodo.ac/np/images/f/f0/Poncho_NH.png",
    "species": "Bear cub",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "January",
    "birthday_day": 2,
    "sign": "Capricorn",
    "quote": "Fortune favors the brave!",
    "phrase": "li'l bear",
    "clothing": "Energetic Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Dorm",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 144,
    "Average_Popularity_Score": 163.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 144,
    "Poll_Ranking_2020_21": 133,
    "Total_Poll_Votes_2020": 648,
    "Total_Poll_Votes_2020_21": 869,
    "Poll_votes_May_2020": 45,
    "Poll_votes_June_2020": 142,
    "Poll_votes_July_2020": 130,
    "Poll_votes_August_2020": 116,
    "Poll_votes_September_2020": 71,
    "Poll_votes_October_2020": 57,
    "Poll_votes_November_2020": 40,
    "Poll_votes_December_2020": 47,
    "Poll_votes_January_2021": 39,
    "Poll_votes_February_2021": 68,
    "Poll_votes_March_2021": 62,
    "Poll_votes_April_2021": 52
  },
  {
    "name": "Rod",
    "url": "https://nookipedia.com/wiki/Rod",
    "alt_name": "",
    "skin_color": "ec7efc",
    "text_color": "fffce9",
    "id": "mus05",
    "image_url": "https://dodo.ac/np/images/e/ea/Rod_NH.png",
    "species": "Mouse",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 14,
    "sign": "Leo",
    "quote": "If you can't beat 'em, work harder.",
    "phrase": "ace",
    "clothing": "Striped Tank",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Beach",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 159,
    "Average_Popularity_Score": 176.75,
    "Nookazon_Bells_Price_Ranking": 157,
    "Nookazon_average_price_Bells": 176081,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 229,
    "Poll_Ranking_2020_21": 223,
    "Total_Poll_Votes_2020": 369,
    "Total_Poll_Votes_2020_21": 469,
    "Poll_votes_May_2020": 12,
    "Poll_votes_June_2020": 75,
    "Poll_votes_July_2020": 90,
    "Poll_votes_August_2020": 59,
    "Poll_votes_September_2020": 48,
    "Poll_votes_October_2020": 31,
    "Poll_votes_November_2020": 27,
    "Poll_votes_December_2020": 27,
    "Poll_votes_January_2021": 19,
    "Poll_votes_February_2021": 28,
    "Poll_votes_March_2021": 35,
    "Poll_votes_April_2021": 18
  },
  {
    "name": "Lopez",
    "url": "https://nookipedia.com/wiki/Lopez",
    "alt_name": "",
    "skin_color": "e8b010",
    "text_color": "fffce9",
    "id": "der05",
    "image_url": "https://dodo.ac/np/images/5/53/Lopez_NH.png",
    "species": "Deer",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 20,
    "sign": "Leo",
    "quote": "Always look both ways before crossing the street.",
    "phrase": "badoom",
    "clothing": "Chimayo Vest",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": "['buckaroo']",
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 165,
    "Average_Popularity_Score": 182.25,
    "Nookazon_Bells_Price_Ranking": 216,
    "Nookazon_average_price_Bells": 143750,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 112,
    "Poll_Ranking_2020_21": 112,
    "Total_Poll_Votes_2020": 888,
    "Total_Poll_Votes_2020_21": 1084,
    "Poll_votes_May_2020": 45,
    "Poll_votes_June_2020": 204,
    "Poll_votes_July_2020": 210,
    "Poll_votes_August_2020": 139,
    "Poll_votes_September_2020": 105,
    "Poll_votes_October_2020": 90,
    "Poll_votes_November_2020": 49,
    "Poll_votes_December_2020": 46,
    "Poll_votes_January_2021": 44,
    "Poll_votes_February_2021": 58,
    "Poll_votes_March_2021": 58,
    "Poll_votes_April_2021": 36
  },
  {
    "name": "Maddie",
    "url": "https://nookipedia.com/wiki/Maddie",
    "alt_name": "",
    "skin_color": "e8b010",
    "text_color": "fffce9",
    "id": "dog09",
    "image_url": "https://dodo.ac/np/images/0/06/Maddie_NH.png",
    "species": "Dog",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 11,
    "sign": "Capricorn",
    "quote": "The IT revolution is under way.",
    "phrase": "yippee",
    "clothing": "Layered Sleeveless Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 168,
    "Average_Popularity_Score": 183.5,
    "Nookazon_Bells_Price_Ranking": 272,
    "Nookazon_average_price_Bells": 111250,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 131,
    "Poll_Ranking_2020_21": 139,
    "Total_Poll_Votes_2020": 723,
    "Total_Poll_Votes_2020_21": 842,
    "Poll_votes_May_2020": 34,
    "Poll_votes_June_2020": 159,
    "Poll_votes_July_2020": 173,
    "Poll_votes_August_2020": 121,
    "Poll_votes_September_2020": 104,
    "Poll_votes_October_2020": 64,
    "Poll_votes_November_2020": 33,
    "Poll_votes_December_2020": 35,
    "Poll_votes_January_2021": 32,
    "Poll_votes_February_2021": 24,
    "Poll_votes_March_2021": 40,
    "Poll_votes_April_2021": 23
  },
  {
    "name": "Puddles",
    "url": "https://nookipedia.com/wiki/Puddles",
    "alt_name": "",
    "skin_color": "ff6183",
    "text_color": "fffce9",
    "id": "flg06",
    "image_url": "https://dodo.ac/np/images/f/f9/Puddles_NH.png",
    "species": "Frog",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 13,
    "sign": "Capricorn",
    "quote": "Look before you leap.",
    "phrase": "splish",
    "clothing": "Retro Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Club",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 169,
    "Average_Popularity_Score": 183.75,
    "Nookazon_Bells_Price_Ranking": 154,
    "Nookazon_average_price_Bells": 177084,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 141,
    "Poll_Ranking_2020_21": 146,
    "Total_Poll_Votes_2020": 663,
    "Total_Poll_Votes_2020_21": 804,
    "Poll_votes_May_2020": 56,
    "Poll_votes_June_2020": 174,
    "Poll_votes_July_2020": 173,
    "Poll_votes_August_2020": 86,
    "Poll_votes_September_2020": 48,
    "Poll_votes_October_2020": 64,
    "Poll_votes_November_2020": 31,
    "Poll_votes_December_2020": 31,
    "Poll_votes_January_2021": 43,
    "Poll_votes_February_2021": 31,
    "Poll_votes_March_2021": 35,
    "Poll_votes_April_2021": 32
  },
  {
    "name": "Olive",
    "url": "https://nookipedia.com/wiki/Olive",
    "alt_name": "",
    "skin_color": "bfbfbf",
    "text_color": "5e5e5e",
    "id": "cbr09",
    "image_url": "https://dodo.ac/np/images/5/5c/Olive_NH.png",
    "species": "Bear cub",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "July",
    "birthday_day": 12,
    "sign": "Cancer",
    "quote": "Sticky fingers attract bees.",
    "phrase": "sweet pea",
    "clothing": "Plover Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Normal",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 161,
    "Average_Popularity_Score": 177.25,
    "Nookazon_Bells_Price_Ranking": 235,
    "Nookazon_average_price_Bells": 133334,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 186,
    "Poll_Ranking_2020_21": 185,
    "Total_Poll_Votes_2020": 463,
    "Total_Poll_Votes_2020_21": 580,
    "Poll_votes_May_2020": 32,
    "Poll_votes_June_2020": 93,
    "Poll_votes_July_2020": 124,
    "Poll_votes_August_2020": 63,
    "Poll_votes_September_2020": 52,
    "Poll_votes_October_2020": 44,
    "Poll_votes_November_2020": 26,
    "Poll_votes_December_2020": 29,
    "Poll_votes_January_2021": 25,
    "Poll_votes_February_2021": 21,
    "Poll_votes_March_2021": 42,
    "Poll_votes_April_2021": 29
  },
  {
    "name": "Tom",
    "url": "https://nookipedia.com/wiki/Tom",
    "alt_name": "",
    "skin_color": "0961f6",
    "text_color": "fffce9",
    "id": "cat15",
    "image_url": "https://dodo.ac/np/images/d/d1/Tom_NH.png",
    "species": "Cat",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 10,
    "sign": "Sagittarius",
    "quote": "There's no use crying over spilled milk.",
    "phrase": "me-YOWZA",
    "clothing": "Bulldog Jacket",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Road",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 173,
    "Average_Popularity_Score": 186.75,
    "Nookazon_Bells_Price_Ranking": 94,
    "Nookazon_average_price_Bells": 207032,
    "Nookazon_NMT_Price_Ranking": 209,
    "Nookazon_average_price_NMT": 17,
    "Poll_Ranking_2020": 224,
    "Poll_Ranking_2020_21": 222,
    "Total_Poll_Votes_2020": 378,
    "Total_Poll_Votes_2020_21": 471,
    "Poll_votes_May_2020": 22,
    "Poll_votes_June_2020": 87,
    "Poll_votes_July_2020": 74,
    "Poll_votes_August_2020": 51,
    "Poll_votes_September_2020": 53,
    "Poll_votes_October_2020": 40,
    "Poll_votes_November_2020": 18,
    "Poll_votes_December_2020": 33,
    "Poll_votes_January_2021": 20,
    "Poll_votes_February_2021": 29,
    "Poll_votes_March_2021": 24,
    "Poll_votes_April_2021": 20
  },
  {
    "name": "Nana",
    "url": "https://nookipedia.com/wiki/Nana",
    "alt_name": "",
    "skin_color": "ec7efc",
    "text_color": "fffce9",
    "id": "mnk01",
    "image_url": "https://dodo.ac/np/images/b/b1/Nana_NH.png",
    "species": "Monkey",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "August",
    "birthday_day": 23,
    "sign": "Virgo",
    "quote": "Bread always falls peanut-butter side down.",
    "phrase": "po po",
    "clothing": "Pom-Pom Sweater",
    "islander": "FALSE",
    "debut": "WW",
    "prev_phrases": [],
    "appearances": "['WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Normal",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 171,
    "Average_Popularity_Score": 185.5,
    "Nookazon_Bells_Price_Ranking": 232,
    "Nookazon_average_price_Bells": 135417,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 171,
    "Poll_Ranking_2020_21": 163,
    "Total_Poll_Votes_2020": 513,
    "Total_Poll_Votes_2020_21": 675,
    "Poll_votes_May_2020": 31,
    "Poll_votes_June_2020": 132,
    "Poll_votes_July_2020": 103,
    "Poll_votes_August_2020": 77,
    "Poll_votes_September_2020": 78,
    "Poll_votes_October_2020": 42,
    "Poll_votes_November_2020": 25,
    "Poll_votes_December_2020": 25,
    "Poll_votes_January_2021": 42,
    "Poll_votes_February_2021": 38,
    "Poll_votes_March_2021": 49,
    "Poll_votes_April_2021": 33
  },
  {
    "name": "Hornsby",
    "url": "https://nookipedia.com/wiki/Hornsby",
    "alt_name": "",
    "skin_color": "0961f6",
    "text_color": "fffce9",
    "id": "rhn04",
    "image_url": "https://dodo.ac/np/images/9/95/Hornsby_NH.png",
    "species": "Rhinoceros",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "March",
    "birthday_day": 20,
    "sign": "Pisces",
    "quote": "You can't hit a mosquito with a horseshoe.",
    "phrase": "schnozzle",
    "clothing": "Argyle Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Messy",
    "P (individual within species)": 0.166666667,
    "Rarity": "0.48%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 156,
    "Average_Popularity_Score": 174.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 279,
    "Nookazon_average_price_NMT": 14,
    "Poll_Ranking_2020": 67,
    "Poll_Ranking_2020_21": 68,
    "Total_Poll_Votes_2020": 1528,
    "Total_Poll_Votes_2020_21": 1867,
    "Poll_votes_May_2020": 108,
    "Poll_votes_June_2020": 404,
    "Poll_votes_July_2020": 384,
    "Poll_votes_August_2020": 214,
    "Poll_votes_September_2020": 139,
    "Poll_votes_October_2020": 131,
    "Poll_votes_November_2020": 77,
    "Poll_votes_December_2020": 71,
    "Poll_votes_January_2021": 81,
    "Poll_votes_February_2021": 92,
    "Poll_votes_March_2021": 93,
    "Poll_votes_April_2021": 73
  },
  {
    "name": "Hamlet",
    "url": "https://nookipedia.com/wiki/Hamlet",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "ham00",
    "image_url": "https://dodo.ac/np/images/4/46/Hamlet_NH.png",
    "species": "Hamster",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "May",
    "birthday_day": 30,
    "sign": "Gemini",
    "quote": "The ear's the thing.",
    "phrase": "hammie",
    "clothing": "Big-Star Tee",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Toys",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 164,
    "Average_Popularity_Score": 180.75,
    "Nookazon_Bells_Price_Ranking": 235,
    "Nookazon_average_price_Bells": 133334,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 82,
    "Poll_Ranking_2020_21": 82,
    "Total_Poll_Votes_2020": 1153,
    "Total_Poll_Votes_2020_21": 1414,
    "Poll_votes_May_2020": 69,
    "Poll_votes_June_2020": 274,
    "Poll_votes_July_2020": 296,
    "Poll_votes_August_2020": 158,
    "Poll_votes_September_2020": 113,
    "Poll_votes_October_2020": 100,
    "Poll_votes_November_2020": 82,
    "Poll_votes_December_2020": 61,
    "Poll_votes_January_2021": 73,
    "Poll_votes_February_2021": 64,
    "Poll_votes_March_2021": 70,
    "Poll_votes_April_2021": 54
  },
  {
    "name": "Stinky",
    "url": "https://nookipedia.com/wiki/Stinky",
    "alt_name": "",
    "skin_color": "d8cc39",
    "text_color": "8b5f57",
    "id": "cat13",
    "image_url": "https://dodo.ac/np/images/9/9c/Stinky_NH.png",
    "species": "Cat",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 17,
    "sign": "Leo",
    "quote": "If the mask fits, wear it!",
    "phrase": "GAAHHH",
    "clothing": "Athletic Jacket",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Gym",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 163,
    "Average_Popularity_Score": 180.5,
    "Nookazon_Bells_Price_Ranking": 214,
    "Nookazon_average_price_Bells": 144792,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 197,
    "Poll_Ranking_2020_21": 202,
    "Total_Poll_Votes_2020": 439,
    "Total_Poll_Votes_2020_21": 534,
    "Poll_votes_May_2020": 32,
    "Poll_votes_June_2020": 106,
    "Poll_votes_July_2020": 106,
    "Poll_votes_August_2020": 58,
    "Poll_votes_September_2020": 45,
    "Poll_votes_October_2020": 37,
    "Poll_votes_November_2020": 29,
    "Poll_votes_December_2020": 26,
    "Poll_votes_January_2021": 21,
    "Poll_votes_February_2021": 25,
    "Poll_votes_March_2021": 28,
    "Poll_votes_April_2021": 21
  },
  {
    "name": "Hazel",
    "url": "https://nookipedia.com/wiki/Hazel",
    "alt_name": "",
    "skin_color": "ffaa3b",
    "text_color": "874c25",
    "id": "squ18",
    "image_url": "https://dodo.ac/np/images/1/17/Hazel_NH.png",
    "species": "Squirrel",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "August",
    "birthday_day": 30,
    "sign": "Virgo",
    "quote": "Never say never!",
    "phrase": "uni-wow",
    "clothing": "Athletic Jacket",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Gym",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 151,
    "Average_Popularity_Score": 170.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 90,
    "Poll_Ranking_2020_21": 87,
    "Total_Poll_Votes_2020": 1049,
    "Total_Poll_Votes_2020_21": 1322,
    "Poll_votes_May_2020": 79,
    "Poll_votes_June_2020": 250,
    "Poll_votes_July_2020": 262,
    "Poll_votes_August_2020": 113,
    "Poll_votes_September_2020": 142,
    "Poll_votes_October_2020": 95,
    "Poll_votes_November_2020": 60,
    "Poll_votes_December_2020": 48,
    "Poll_votes_January_2021": 52,
    "Poll_votes_February_2021": 90,
    "Poll_votes_March_2021": 85,
    "Poll_votes_April_2021": 46
  },
  {
    "name": "Pecan",
    "url": "https://nookipedia.com/wiki/Pecan",
    "alt_name": "",
    "skin_color": "7a2500",
    "text_color": "fffce9",
    "id": "squ03",
    "image_url": "https://dodo.ac/np/images/6/60/Pecan_NH.png",
    "species": "Squirrel",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "September",
    "birthday_day": 10,
    "sign": "Virgo",
    "quote": "Promises are like pie crustsâ€” they're made to be broken.",
    "phrase": "chipmunk",
    "clothing": "Milkmaid Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 174,
    "Average_Popularity_Score": 187.5,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 201,
    "Poll_Ranking_2020_21": 188,
    "Total_Poll_Votes_2020": 434,
    "Total_Poll_Votes_2020_21": 568,
    "Poll_votes_May_2020": 27,
    "Poll_votes_June_2020": 86,
    "Poll_votes_July_2020": 78,
    "Poll_votes_August_2020": 51,
    "Poll_votes_September_2020": 67,
    "Poll_votes_October_2020": 54,
    "Poll_votes_November_2020": 38,
    "Poll_votes_December_2020": 33,
    "Poll_votes_January_2021": 31,
    "Poll_votes_February_2021": 32,
    "Poll_votes_March_2021": 40,
    "Poll_votes_April_2021": 31
  },
  {
    "name": "Ken",
    "url": "https://nookipedia.com/wiki/Ken",
    "alt_name": "",
    "skin_color": "6b75ce",
    "text_color": "9ae8df",
    "id": "chn13",
    "image_url": "https://dodo.ac/np/images/e/e0/Ken_NH.png",
    "species": "Chicken",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 23,
    "sign": "Capricorn",
    "quote": "C'est la vie!",
    "phrase": "no doubt",
    "clothing": "Ninja Costume",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Asian",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 166,
    "Average_Popularity_Score": 182.5,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 212,
    "Poll_Ranking_2020_21": 218,
    "Total_Poll_Votes_2020": 404,
    "Total_Poll_Votes_2020_21": 488,
    "Poll_votes_May_2020": 30,
    "Poll_votes_June_2020": 122,
    "Poll_votes_July_2020": 80,
    "Poll_votes_August_2020": 57,
    "Poll_votes_September_2020": 39,
    "Poll_votes_October_2020": 26,
    "Poll_votes_November_2020": 34,
    "Poll_votes_December_2020": 16,
    "Poll_votes_January_2021": 27,
    "Poll_votes_February_2021": 20,
    "Poll_votes_March_2021": 20,
    "Poll_votes_April_2021": 17
  },
  {
    "name": "Walker",
    "url": "https://nookipedia.com/wiki/Walker",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "dog06",
    "image_url": "https://dodo.ac/np/images/0/0f/Walker_NH.png",
    "species": "Dog",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 10,
    "sign": "Gemini",
    "quote": "The dog wags his tail, not for you, but for your bread.",
    "phrase": "wuh",
    "clothing": "Five-Ball Tee",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Colorful",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 3,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 152,
    "Average_Popularity_Score": 172,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 146,
    "Poll_Ranking_2020_21": 150,
    "Total_Poll_Votes_2020": 640,
    "Total_Poll_Votes_2020_21": 777,
    "Poll_votes_May_2020": 56,
    "Poll_votes_June_2020": 150,
    "Poll_votes_July_2020": 133,
    "Poll_votes_August_2020": 99,
    "Poll_votes_September_2020": 74,
    "Poll_votes_October_2020": 59,
    "Poll_votes_November_2020": 34,
    "Poll_votes_December_2020": 35,
    "Poll_votes_January_2021": 31,
    "Poll_votes_February_2021": 36,
    "Poll_votes_March_2021": 49,
    "Poll_votes_April_2021": 21
  },
  {
    "name": "Butch",
    "url": "https://nookipedia.com/wiki/Butch",
    "alt_name": "",
    "skin_color": "ffaa3b",
    "text_color": "874c25",
    "id": "dog01",
    "image_url": "https://dodo.ac/np/images/2/2b/Butch_NH.png",
    "species": "Dog",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "November",
    "birthday_day": 1,
    "sign": "Scorpio",
    "quote": "A house without either a cat or a dog is a sad house indeed.",
    "phrase": "ROOOOOWF",
    "clothing": "Argyle Vest",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Road",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 154,
    "Average_Popularity_Score": 172.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 152,
    "Poll_Ranking_2020_21": 151,
    "Total_Poll_Votes_2020": 624,
    "Total_Poll_Votes_2020_21": 774,
    "Poll_votes_May_2020": 22,
    "Poll_votes_June_2020": 112,
    "Poll_votes_July_2020": 145,
    "Poll_votes_August_2020": 92,
    "Poll_votes_September_2020": 107,
    "Poll_votes_October_2020": 74,
    "Poll_votes_November_2020": 41,
    "Poll_votes_December_2020": 31,
    "Poll_votes_January_2021": 32,
    "Poll_votes_February_2021": 42,
    "Poll_votes_March_2021": 41,
    "Poll_votes_April_2021": 35
  },
  {
    "name": "Benjamin",
    "url": "https://nookipedia.com/wiki/Benjamin",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "dog16",
    "image_url": "https://dodo.ac/np/images/9/97/Benjamin_NH.png",
    "species": "Dog",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 3,
    "sign": "Leo",
    "quote": "A good dog deserves a good treat.",
    "phrase": "alrighty",
    "clothing": "Striped Shirt",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "School",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 177,
    "Average_Popularity_Score": 188.25,
    "Nookazon_Bells_Price_Ranking": 60,
    "Nookazon_average_price_Bells": 271875,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 222,
    "Poll_Ranking_2020_21": 234,
    "Total_Poll_Votes_2020": 379,
    "Total_Poll_Votes_2020_21": 446,
    "Poll_votes_May_2020": 17,
    "Poll_votes_June_2020": 89,
    "Poll_votes_July_2020": 76,
    "Poll_votes_August_2020": 61,
    "Poll_votes_September_2020": 58,
    "Poll_votes_October_2020": 37,
    "Poll_votes_November_2020": 21,
    "Poll_votes_December_2020": 20,
    "Poll_votes_January_2021": 16,
    "Poll_votes_February_2021": 15,
    "Poll_votes_March_2021": 12,
    "Poll_votes_April_2021": 24
  },
  {
    "name": "Murphy",
    "url": "https://nookipedia.com/wiki/Murphy",
    "alt_name": "",
    "skin_color": "78dd62",
    "text_color": "28665a",
    "id": "cbr07",
    "image_url": "https://dodo.ac/np/images/7/7c/Murphy_NH.png",
    "species": "Bear cub",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 29,
    "sign": "Capricorn",
    "quote": "More money, more problems.",
    "phrase": "malarkey",
    "clothing": "Puffy Vest",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": "['laddie']",
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 179,
    "Average_Popularity_Score": 194,
    "Nookazon_Bells_Price_Ranking": 235,
    "Nookazon_average_price_Bells": 133334,
    "Nookazon_NMT_Price_Ranking": 101,
    "Nookazon_average_price_NMT": 22,
    "Poll_Ranking_2020": 221,
    "Poll_Ranking_2020_21": 220,
    "Total_Poll_Votes_2020": 381,
    "Total_Poll_Votes_2020_21": 476,
    "Poll_votes_May_2020": 16,
    "Poll_votes_June_2020": 75,
    "Poll_votes_July_2020": 96,
    "Poll_votes_August_2020": 57,
    "Poll_votes_September_2020": 53,
    "Poll_votes_October_2020": 43,
    "Poll_votes_November_2020": 25,
    "Poll_votes_December_2020": 16,
    "Poll_votes_January_2021": 22,
    "Poll_votes_February_2021": 21,
    "Poll_votes_March_2021": 29,
    "Poll_votes_April_2021": 23
  },
  {
    "name": "Kody",
    "url": "https://nookipedia.com/wiki/Kody",
    "alt_name": "",
    "skin_color": "55cfff",
    "text_color": "fffce9",
    "id": "cbr04",
    "image_url": "https://dodo.ac/np/images/2/20/Kody_NH.png",
    "species": "Bear cub",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "September",
    "birthday_day": 28,
    "sign": "Libra",
    "quote": "The sky's the limit!",
    "phrase": "grah grah",
    "clothing": "Western Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": "['okey-dokey']",
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Toys",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 172,
    "Average_Popularity_Score": 186.25,
    "Nookazon_Bells_Price_Ranking": 13,
    "Nookazon_average_price_Bells": 484375,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 312,
    "Poll_Ranking_2020_21": 314,
    "Total_Poll_Votes_2020": 204,
    "Total_Poll_Votes_2020_21": 264,
    "Poll_votes_May_2020": 18,
    "Poll_votes_June_2020": 47,
    "Poll_votes_July_2020": 43,
    "Poll_votes_August_2020": 21,
    "Poll_votes_September_2020": 18,
    "Poll_votes_October_2020": 25,
    "Poll_votes_November_2020": 16,
    "Poll_votes_December_2020": 16,
    "Poll_votes_January_2021": 21,
    "Poll_votes_February_2021": 12,
    "Poll_votes_March_2021": 17,
    "Poll_votes_April_2021": 10
  },
  {
    "name": "Boomer",
    "url": "https://nookipedia.com/wiki/Boomer",
    "alt_name": "",
    "skin_color": 798040,
    "text_color": "fffad4",
    "id": "pgn10",
    "image_url": "https://dodo.ac/np/images/7/7d/Boomer_NH.png",
    "species": "Penguin",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "February",
    "birthday_day": 7,
    "sign": "Aquarius",
    "quote": "Flying is believing.",
    "phrase": "human",
    "clothing": "Flight Jacket",
    "islander": "TRUE",
    "debut": "AC",
    "prev_phrases": [],
    "appearances": "['AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Ice",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 178,
    "Average_Popularity_Score": 188.75,
    "Nookazon_Bells_Price_Ranking": 159,
    "Nookazon_average_price_Bells": 168750,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 129,
    "Poll_Ranking_2020_21": 136,
    "Total_Poll_Votes_2020": 733,
    "Total_Poll_Votes_2020_21": 858,
    "Poll_votes_May_2020": 48,
    "Poll_votes_June_2020": 207,
    "Poll_votes_July_2020": 197,
    "Poll_votes_August_2020": 89,
    "Poll_votes_September_2020": 75,
    "Poll_votes_October_2020": 56,
    "Poll_votes_November_2020": 26,
    "Poll_votes_December_2020": 35,
    "Poll_votes_January_2021": 29,
    "Poll_votes_February_2021": 25,
    "Poll_votes_March_2021": 41,
    "Poll_votes_April_2021": 30
  },
  {
    "name": "Portia",
    "url": "https://nookipedia.com/wiki/Portia",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "dog05",
    "image_url": "https://dodo.ac/np/images/c/ce/Portia_NH.png",
    "species": "Dog",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "October",
    "birthday_day": 25,
    "sign": "Scorpio",
    "quote": "Charity begins at home.",
    "phrase": "ruffian",
    "clothing": "Rad Power Skirt Suit",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 175,
    "Average_Popularity_Score": 187.75,
    "Nookazon_Bells_Price_Ranking": 183,
    "Nookazon_average_price_Bells": 155990,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 237,
    "Poll_Ranking_2020_21": 232,
    "Total_Poll_Votes_2020": 355,
    "Total_Poll_Votes_2020_21": 452,
    "Poll_votes_May_2020": 10,
    "Poll_votes_June_2020": 72,
    "Poll_votes_July_2020": 75,
    "Poll_votes_August_2020": 59,
    "Poll_votes_September_2020": 46,
    "Poll_votes_October_2020": 39,
    "Poll_votes_November_2020": 37,
    "Poll_votes_December_2020": 17,
    "Poll_votes_January_2021": 26,
    "Poll_votes_February_2021": 22,
    "Poll_votes_March_2021": 28,
    "Poll_votes_April_2021": 21
  },
  {
    "name": "Blanche",
    "url": "https://nookipedia.com/wiki/Blanche",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "ost08",
    "image_url": "https://dodo.ac/np/images/d/df/Blanche_NH.png",
    "species": "Ostrich",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "December",
    "birthday_day": 21,
    "sign": "Sagittarius",
    "quote": "Nothing beats personal experience.",
    "phrase": "quite so",
    "clothing": "Butterfly Visiting Kimono",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Asian",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 3,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 158,
    "Average_Popularity_Score": 175,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 155,
    "Poll_Ranking_2020_21": 156,
    "Total_Poll_Votes_2020": 581,
    "Total_Poll_Votes_2020_21": 725,
    "Poll_votes_May_2020": 28,
    "Poll_votes_June_2020": 136,
    "Poll_votes_July_2020": 138,
    "Poll_votes_August_2020": 87,
    "Poll_votes_September_2020": 88,
    "Poll_votes_October_2020": 51,
    "Poll_votes_November_2020": 25,
    "Poll_votes_December_2020": 28,
    "Poll_votes_January_2021": 24,
    "Poll_votes_February_2021": 44,
    "Poll_votes_March_2021": 48,
    "Poll_votes_April_2021": 28
  },
  {
    "name": "Egbert",
    "url": "https://nookipedia.com/wiki/Egbert",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "chn02",
    "image_url": "https://dodo.ac/np/images/3/3f/Egbert_NH.png",
    "species": "Chicken",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 14,
    "sign": "Libra",
    "quote": "You gotta break a few eggs to make an omelet.",
    "phrase": "doodle-duh",
    "clothing": "Folk Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Cabin",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 184,
    "Average_Popularity_Score": 195.25,
    "Nookazon_Bells_Price_Ranking": 62,
    "Nookazon_average_price_Bells": 268750,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 216,
    "Poll_Ranking_2020_21": 215,
    "Total_Poll_Votes_2020": 397,
    "Total_Poll_Votes_2020_21": 496,
    "Poll_votes_May_2020": 31,
    "Poll_votes_June_2020": 96,
    "Poll_votes_July_2020": 104,
    "Poll_votes_August_2020": 54,
    "Poll_votes_September_2020": 38,
    "Poll_votes_October_2020": 28,
    "Poll_votes_November_2020": 27,
    "Poll_votes_December_2020": 19,
    "Poll_votes_January_2021": 22,
    "Poll_votes_February_2021": 34,
    "Poll_votes_March_2021": 27,
    "Poll_votes_April_2021": 16
  },
  {
    "name": "Freckles",
    "url": "https://nookipedia.com/wiki/Freckles",
    "alt_name": "",
    "skin_color": "ff6183",
    "text_color": "fffce9",
    "id": "duk07",
    "image_url": "https://dodo.ac/np/images/7/7d/Freckles_NH.png",
    "species": "Duck",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "February",
    "birthday_day": 19,
    "sign": "Pisces",
    "quote": "Act now before you change your mind!",
    "phrase": "ducky",
    "clothing": "Flower-Print Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Fish",
    "P (individual within species)": 0.058823529,
    "Rarity": "0.17%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 162,
    "Average_Popularity_Score": 177.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 157,
    "Poll_Ranking_2020_21": 161,
    "Total_Poll_Votes_2020": 573,
    "Total_Poll_Votes_2020_21": 701,
    "Poll_votes_May_2020": 35,
    "Poll_votes_June_2020": 126,
    "Poll_votes_July_2020": 135,
    "Poll_votes_August_2020": 76,
    "Poll_votes_September_2020": 76,
    "Poll_votes_October_2020": 64,
    "Poll_votes_November_2020": 31,
    "Poll_votes_December_2020": 30,
    "Poll_votes_January_2021": 26,
    "Poll_votes_February_2021": 27,
    "Poll_votes_March_2021": 48,
    "Poll_votes_April_2021": 27
  },
  {
    "name": "Hugh",
    "url": "https://nookipedia.com/wiki/Hugh",
    "alt_name": "",
    "skin_color": "0961f6",
    "text_color": "fffce9",
    "id": "pig03",
    "image_url": "https://dodo.ac/np/images/b/b6/Hugh_NH.png",
    "species": "Pig",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 30,
    "sign": "Capricorn",
    "quote": "Keep it real. Real chill.",
    "phrase": "snortle",
    "clothing": "Camo Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Toys",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 1,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 187,
    "Average_Popularity_Score": 197,
    "Nookazon_Bells_Price_Ranking": 121,
    "Nookazon_average_price_Bells": 193750,
    "Nookazon_NMT_Price_Ranking": 209,
    "Nookazon_average_price_NMT": 17,
    "Poll_Ranking_2020": 228,
    "Poll_Ranking_2020_21": 229,
    "Total_Poll_Votes_2020": 371,
    "Total_Poll_Votes_2020_21": 463,
    "Poll_votes_May_2020": 27,
    "Poll_votes_June_2020": 76,
    "Poll_votes_July_2020": 96,
    "Poll_votes_August_2020": 60,
    "Poll_votes_September_2020": 38,
    "Poll_votes_October_2020": 25,
    "Poll_votes_November_2020": 24,
    "Poll_votes_December_2020": 25,
    "Poll_votes_January_2021": 16,
    "Poll_votes_February_2021": 26,
    "Poll_votes_March_2021": 22,
    "Poll_votes_April_2021": 28
  },
  {
    "name": "Jeremiah",
    "url": "https://nookipedia.com/wiki/Jeremiah",
    "alt_name": "",
    "skin_color": "55cfff",
    "text_color": "fffce9",
    "id": "flg07",
    "image_url": "https://dodo.ac/np/images/9/93/Jeremiah_NH.png",
    "species": "Frog",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 8,
    "sign": "Cancer",
    "quote": "Sleep before you leap.",
    "phrase": "nee-deep",
    "clothing": "Gingham Picnic Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Toyrs",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 170,
    "Average_Popularity_Score": 185.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 209,
    "Nookazon_average_price_NMT": 17,
    "Poll_Ranking_2020": 121,
    "Poll_Ranking_2020_21": 124,
    "Total_Poll_Votes_2020": 774,
    "Total_Poll_Votes_2020_21": 928,
    "Poll_votes_May_2020": 57,
    "Poll_votes_June_2020": 164,
    "Poll_votes_July_2020": 191,
    "Poll_votes_August_2020": 105,
    "Poll_votes_September_2020": 88,
    "Poll_votes_October_2020": 89,
    "Poll_votes_November_2020": 47,
    "Poll_votes_December_2020": 33,
    "Poll_votes_January_2021": 28,
    "Poll_votes_February_2021": 53,
    "Poll_votes_March_2021": 37,
    "Poll_votes_April_2021": 36
  },
  {
    "name": "Gaston",
    "url": "https://nookipedia.com/wiki/Gaston",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "rbt04",
    "image_url": "https://dodo.ac/np/images/5/59/Gaston_NH.png",
    "species": "Rabbit",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 28,
    "sign": "Scorpio",
    "quote": "An ear for an ear makes it hard to hear.",
    "phrase": "mon chou",
    "clothing": "Color-Block Dress Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 190,
    "Average_Popularity_Score": 197.25,
    "Nookazon_Bells_Price_Ranking": 130,
    "Nookazon_average_price_Bells": 187500,
    "Nookazon_NMT_Price_Ranking": 177,
    "Nookazon_average_price_NMT": 19,
    "Poll_Ranking_2020": 230,
    "Poll_Ranking_2020_21": 241,
    "Total_Poll_Votes_2020": 367,
    "Total_Poll_Votes_2020_21": 428,
    "Poll_votes_May_2020": 18,
    "Poll_votes_June_2020": 73,
    "Poll_votes_July_2020": 73,
    "Poll_votes_August_2020": 54,
    "Poll_votes_September_2020": 66,
    "Poll_votes_October_2020": 37,
    "Poll_votes_November_2020": 23,
    "Poll_votes_December_2020": 23,
    "Poll_votes_January_2021": 24,
    "Poll_votes_February_2021": 13,
    "Poll_votes_March_2021": 10,
    "Poll_votes_April_2021": 14
  },
  {
    "name": "Billy",
    "url": "https://nookipedia.com/wiki/Billy",
    "alt_name": "",
    "skin_color": "d86808",
    "text_color": "fffce9",
    "id": "goa02",
    "image_url": "https://dodo.ac/np/images/2/26/Billy_NH.png",
    "species": "Goat",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "March",
    "birthday_day": 25,
    "sign": "Aries",
    "quote": "Old dogs can learn new tricks.",
    "phrase": "dagnaabit",
    "clothing": "Hanten Jacket",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Messy",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 192,
    "Average_Popularity_Score": 198,
    "Nookazon_Bells_Price_Ranking": 264,
    "Nookazon_average_price_Bells": 115834,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 189,
    "Poll_Ranking_2020_21": 172,
    "Total_Poll_Votes_2020": 454,
    "Total_Poll_Votes_2020_21": 629,
    "Poll_votes_May_2020": 37,
    "Poll_votes_June_2020": 114,
    "Poll_votes_July_2020": 117,
    "Poll_votes_August_2020": 67,
    "Poll_votes_September_2020": 46,
    "Poll_votes_October_2020": 34,
    "Poll_votes_November_2020": 25,
    "Poll_votes_December_2020": 14,
    "Poll_votes_January_2021": 55,
    "Poll_votes_February_2021": 27,
    "Poll_votes_March_2021": 55,
    "Poll_votes_April_2021": 38
  },
  {
    "name": "Mac",
    "url": "https://nookipedia.com/wiki/Mac",
    "alt_name": "",
    "skin_color": "e8b010",
    "text_color": "fffce9",
    "id": "dog14",
    "image_url": "https://dodo.ac/np/images/a/ab/Mac_NH.png",
    "species": "Dog",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "November",
    "birthday_day": 11,
    "sign": "Scorpio",
    "quote": "Sometimes life is rough.",
    "phrase": "woo woof",
    "clothing": "Raglan Shirt",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": [],
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 194,
    "Average_Popularity_Score": 198.25,
    "Nookazon_Bells_Price_Ranking": 130,
    "Nookazon_average_price_Bells": 187500,
    "Nookazon_NMT_Price_Ranking": 279,
    "Nookazon_average_price_NMT": 14,
    "Poll_Ranking_2020": 188,
    "Poll_Ranking_2020_21": 192,
    "Total_Poll_Votes_2020": 460,
    "Total_Poll_Votes_2020_21": 559,
    "Poll_votes_May_2020": 24,
    "Poll_votes_June_2020": 128,
    "Poll_votes_July_2020": 105,
    "Poll_votes_August_2020": 54,
    "Poll_votes_September_2020": 52,
    "Poll_votes_October_2020": 44,
    "Poll_votes_November_2020": 35,
    "Poll_votes_December_2020": 18,
    "Poll_votes_January_2021": 23,
    "Poll_votes_February_2021": 28,
    "Poll_votes_March_2021": 30,
    "Poll_votes_April_2021": 18
  },
  {
    "name": "Iggly",
    "url": "https://nookipedia.com/wiki/Iggly",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "pgn11",
    "image_url": "https://dodo.ac/np/images/6/68/Iggly_NH.png",
    "species": "Penguin",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "November",
    "birthday_day": 2,
    "sign": "Scorpio",
    "quote": "Six of one, half dozen of the other.",
    "phrase": "waddler",
    "clothing": "Rugby Uniform",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": [],
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Ice",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 181,
    "Average_Popularity_Score": 194.25,
    "Nookazon_Bells_Price_Ranking": 70,
    "Nookazon_average_price_Bells": 250000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 241,
    "Poll_Ranking_2020_21": 241,
    "Total_Poll_Votes_2020": 340,
    "Total_Poll_Votes_2020_21": 428,
    "Poll_votes_May_2020": 23,
    "Poll_votes_June_2020": 78,
    "Poll_votes_July_2020": 84,
    "Poll_votes_August_2020": 40,
    "Poll_votes_September_2020": 38,
    "Poll_votes_October_2020": 33,
    "Poll_votes_November_2020": 28,
    "Poll_votes_December_2020": 16,
    "Poll_votes_January_2021": 26,
    "Poll_votes_February_2021": 22,
    "Poll_votes_March_2021": 25,
    "Poll_votes_April_2021": 15
  },
  {
    "name": "Kidd",
    "url": "https://nookipedia.com/wiki/Kidd",
    "alt_name": "",
    "skin_color": "d9d9ff",
    "text_color": "4f5d72",
    "id": "goa07",
    "image_url": "https://dodo.ac/np/images/7/7a/Kidd_NH.png",
    "species": "Goat",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 28,
    "sign": "Cancer",
    "quote": "Be yourself, everyone else is already taken.",
    "phrase": "wut",
    "clothing": "Tailored Jacket",
    "islander": "TRUE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 167,
    "Average_Popularity_Score": 182.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 110,
    "Poll_Ranking_2020_21": 111,
    "Total_Poll_Votes_2020": 894,
    "Total_Poll_Votes_2020_21": 1086,
    "Poll_votes_May_2020": 52,
    "Poll_votes_June_2020": 223,
    "Poll_votes_July_2020": 206,
    "Poll_votes_August_2020": 129,
    "Poll_votes_September_2020": 112,
    "Poll_votes_October_2020": 78,
    "Poll_votes_November_2020": 56,
    "Poll_votes_December_2020": 38,
    "Poll_votes_January_2021": 43,
    "Poll_votes_February_2021": 44,
    "Poll_votes_March_2021": 57,
    "Poll_votes_April_2021": 48
  },
  {
    "name": "Wart Jr.",
    "url": "https://nookipedia.com/wiki/Wart_Jr.",
    "alt_name": "",
    "skin_color": "d86808",
    "text_color": "fffce9",
    "id": "flg05",
    "image_url": "https://dodo.ac/np/images/2/21/Wart_Jr._NH.png",
    "species": "Frog",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 21,
    "sign": "Leo",
    "quote": "Age before beauty.",
    "phrase": "grr-ribbit",
    "clothing": "Hanten Jacket",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Asian",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 179,
    "Average_Popularity_Score": 194,
    "Nookazon_Bells_Price_Ranking": 176,
    "Nookazon_average_price_Bells": 158334,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 247,
    "Poll_Ranking_2020_21": 248,
    "Total_Poll_Votes_2020": 327,
    "Total_Poll_Votes_2020_21": 396,
    "Poll_votes_May_2020": 13,
    "Poll_votes_June_2020": 77,
    "Poll_votes_July_2020": 66,
    "Poll_votes_August_2020": 54,
    "Poll_votes_September_2020": 36,
    "Poll_votes_October_2020": 42,
    "Poll_votes_November_2020": 22,
    "Poll_votes_December_2020": 17,
    "Poll_votes_January_2021": 12,
    "Poll_votes_February_2021": 18,
    "Poll_votes_March_2021": 22,
    "Poll_votes_April_2021": 17
  },
  {
    "name": "Admiral",
    "url": "https://nookipedia.com/wiki/Admiral",
    "alt_name": "",
    "skin_color": "0ca54a",
    "text_color": "fffce9",
    "id": "brd06",
    "image_url": "https://dodo.ac/np/images/e/ed/Admiral_NH.png",
    "species": "Bird",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "January",
    "birthday_day": 27,
    "sign": "Aquarius",
    "quote": "Only quitters give up.",
    "phrase": "aye aye",
    "clothing": "Hanten Jacket",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Asian",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 201,
    "Average_Popularity_Score": 202,
    "Nookazon_Bells_Price_Ranking": 185,
    "Nookazon_average_price_Bells": 153125,
    "Nookazon_NMT_Price_Ranking": 209,
    "Nookazon_average_price_NMT": 17,
    "Poll_Ranking_2020": 215,
    "Poll_Ranking_2020_21": 207,
    "Total_Poll_Votes_2020": 401,
    "Total_Poll_Votes_2020_21": 514,
    "Poll_votes_May_2020": 15,
    "Poll_votes_June_2020": 84,
    "Poll_votes_July_2020": 104,
    "Poll_votes_August_2020": 66,
    "Poll_votes_September_2020": 45,
    "Poll_votes_October_2020": 29,
    "Poll_votes_November_2020": 24,
    "Poll_votes_December_2020": 34,
    "Poll_votes_January_2021": 22,
    "Poll_votes_February_2021": 29,
    "Poll_votes_March_2021": 37,
    "Poll_votes_April_2021": 25
  },
  {
    "name": "Tammy",
    "url": "https://nookipedia.com/wiki/Tammy",
    "alt_name": "",
    "skin_color": "fff80d",
    "text_color": "9b8986",
    "id": "cbr17",
    "image_url": "https://dodo.ac/np/images/a/aa/Tammy_NH.png",
    "species": "Bear cub",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "June",
    "birthday_day": 23,
    "sign": "Cancer",
    "quote": "If a job is worth doing, do it right!",
    "phrase": "ya heard",
    "clothing": "Hawk Jacket",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Cute",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 187,
    "Average_Popularity_Score": 197,
    "Nookazon_Bells_Price_Ranking": 211,
    "Nookazon_average_price_Bells": 145313,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 181,
    "Poll_Ranking_2020_21": 176,
    "Total_Poll_Votes_2020": 479,
    "Total_Poll_Votes_2020_21": 611,
    "Poll_votes_May_2020": 32,
    "Poll_votes_June_2020": 126,
    "Poll_votes_July_2020": 104,
    "Poll_votes_August_2020": 71,
    "Poll_votes_September_2020": 44,
    "Poll_votes_October_2020": 46,
    "Poll_votes_November_2020": 29,
    "Poll_votes_December_2020": 27,
    "Poll_votes_January_2021": 39,
    "Poll_votes_February_2021": 34,
    "Poll_votes_March_2021": 34,
    "Poll_votes_April_2021": 25
  },
  {
    "name": "Gonzo",
    "url": "https://nookipedia.com/wiki/Gonzo",
    "alt_name": "",
    "skin_color": "bfbfbf",
    "text_color": "5e5e5e",
    "id": "kal04",
    "image_url": "https://dodo.ac/np/images/0/09/Gonzo_NH.png",
    "species": "Koala",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 13,
    "sign": "Libra",
    "quote": "Brothers are brothers, cheese is cheese.",
    "phrase": "mate",
    "clothing": "Reindeer Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Cabin",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 192,
    "Average_Popularity_Score": 198,
    "Nookazon_Bells_Price_Ranking": 179,
    "Nookazon_average_price_Bells": 157750,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 194,
    "Poll_Ranking_2020_21": 194,
    "Total_Poll_Votes_2020": 446,
    "Total_Poll_Votes_2020_21": 556,
    "Poll_votes_May_2020": 26,
    "Poll_votes_June_2020": 93,
    "Poll_votes_July_2020": 118,
    "Poll_votes_August_2020": 48,
    "Poll_votes_September_2020": 55,
    "Poll_votes_October_2020": 53,
    "Poll_votes_November_2020": 29,
    "Poll_votes_December_2020": 24,
    "Poll_votes_January_2021": 26,
    "Poll_votes_February_2021": 21,
    "Poll_votes_March_2021": 34,
    "Poll_votes_April_2021": 29
  },
  {
    "name": "Tammi",
    "url": "https://nookipedia.com/wiki/Tammi",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "mnk03",
    "image_url": "https://dodo.ac/np/images/a/a8/Tammi_NH.png",
    "species": "Monkey",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 2,
    "sign": "Aries",
    "quote": "Always be down to monkey around!",
    "phrase": "chimpy",
    "clothing": "Silk Floral-Print Shirt",
    "islander": "FALSE",
    "debut": "WW",
    "prev_phrases": [],
    "appearances": "['WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Asian",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 181,
    "Average_Popularity_Score": 194.25,
    "Nookazon_Bells_Price_Ranking": 97,
    "Nookazon_average_price_Bells": 200000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 285,
    "Poll_Ranking_2020_21": 288,
    "Total_Poll_Votes_2020": 244,
    "Total_Poll_Votes_2020_21": 309,
    "Poll_votes_May_2020": 18,
    "Poll_votes_June_2020": 58,
    "Poll_votes_July_2020": 52,
    "Poll_votes_August_2020": 20,
    "Poll_votes_September_2020": 36,
    "Poll_votes_October_2020": 23,
    "Poll_votes_November_2020": 20,
    "Poll_votes_December_2020": 17,
    "Poll_votes_January_2021": 20,
    "Poll_votes_February_2021": 15,
    "Poll_votes_March_2021": 17,
    "Poll_votes_April_2021": 13
  },
  {
    "name": "Biff",
    "url": "https://nookipedia.com/wiki/Biff",
    "alt_name": "",
    "skin_color": "7a2500",
    "text_color": "fffce9",
    "id": "hip04",
    "image_url": "https://dodo.ac/np/images/9/9c/Biff_NH.png",
    "species": "Hippo",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "March",
    "birthday_day": 29,
    "sign": "Aries",
    "quote": "Eighth place is just the seventh loser.",
    "phrase": "squirt",
    "clothing": "Gold-Print Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Alley",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 199,
    "Average_Popularity_Score": 200.75,
    "Nookazon_Bells_Price_Ranking": 216,
    "Nookazon_average_price_Bells": 143750,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 148,
    "Poll_Ranking_2020_21": 149,
    "Total_Poll_Votes_2020": 632,
    "Total_Poll_Votes_2020_21": 784,
    "Poll_votes_May_2020": 46,
    "Poll_votes_June_2020": 153,
    "Poll_votes_July_2020": 159,
    "Poll_votes_August_2020": 97,
    "Poll_votes_September_2020": 68,
    "Poll_votes_October_2020": 44,
    "Poll_votes_November_2020": 35,
    "Poll_votes_December_2020": 30,
    "Poll_votes_January_2021": 47,
    "Poll_votes_February_2021": 31,
    "Poll_votes_March_2021": 50,
    "Poll_votes_April_2021": 24
  },
  {
    "name": "Celia",
    "url": "https://nookipedia.com/wiki/Celia",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "pbr09",
    "image_url": "https://dodo.ac/np/images/0/00/Celia_NH.png",
    "species": "Eagle",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 25,
    "sign": "Aries",
    "quote": "It's the thought that counts.",
    "phrase": "feathers",
    "clothing": "Alpinist Dress",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 190,
    "Average_Popularity_Score": 197.25,
    "Nookazon_Bells_Price_Ranking": 159,
    "Nookazon_average_price_Bells": 168750,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 154,
    "Poll_Ranking_2020_21": 153,
    "Total_Poll_Votes_2020": 591,
    "Total_Poll_Votes_2020_21": 749,
    "Poll_votes_May_2020": 48,
    "Poll_votes_June_2020": 155,
    "Poll_votes_July_2020": 140,
    "Poll_votes_August_2020": 79,
    "Poll_votes_September_2020": 61,
    "Poll_votes_October_2020": 42,
    "Poll_votes_November_2020": 31,
    "Poll_votes_December_2020": 35,
    "Poll_votes_January_2021": 34,
    "Poll_votes_February_2021": 43,
    "Poll_votes_March_2021": 47,
    "Poll_votes_April_2021": 34
  },
  {
    "name": "Klaus",
    "url": "https://nookipedia.com/wiki/Klaus",
    "alt_name": "",
    "skin_color": "acc8cf",
    "text_color": 498992,
    "id": "bea14",
    "image_url": "https://dodo.ac/np/images/5/5c/Klaus_NH.png",
    "species": "Bear",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "March",
    "birthday_day": 31,
    "sign": "Aries",
    "quote": "Pride goes before a fall.",
    "phrase": "strudel",
    "clothing": "Toga",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Bathroom",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 187,
    "Average_Popularity_Score": 197,
    "Nookazon_Bells_Price_Ranking": 97,
    "Nookazon_average_price_Bells": 200000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 226,
    "Poll_Ranking_2020_21": 233,
    "Total_Poll_Votes_2020": 377,
    "Total_Poll_Votes_2020_21": 450,
    "Poll_votes_May_2020": 23,
    "Poll_votes_June_2020": 81,
    "Poll_votes_July_2020": 94,
    "Poll_votes_August_2020": 59,
    "Poll_votes_September_2020": 34,
    "Poll_votes_October_2020": 40,
    "Poll_votes_November_2020": 27,
    "Poll_votes_December_2020": 19,
    "Poll_votes_January_2021": 16,
    "Poll_votes_February_2021": 19,
    "Poll_votes_March_2021": 17,
    "Poll_votes_April_2021": 21
  },
  {
    "name": "Simon",
    "url": "https://nookipedia.com/wiki/Simon",
    "alt_name": "",
    "skin_color": "d8cc39",
    "text_color": "8b5f57",
    "id": "mnk02",
    "image_url": "https://dodo.ac/np/images/6/68/Simon_NH.png",
    "species": "Monkey",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "January",
    "birthday_day": 19,
    "sign": "Capricorn",
    "quote": "Friends go together like peanut butter and bananas.",
    "phrase": "zzzook",
    "clothing": "Striped Tank",
    "islander": "FALSE",
    "debut": "WW",
    "prev_phrases": [],
    "appearances": "['WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 200,
    "Average_Popularity_Score": 201.75,
    "Nookazon_Bells_Price_Ranking": 13,
    "Nookazon_average_price_Bells": 484375,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 306,
    "Poll_Ranking_2020_21": 305,
    "Total_Poll_Votes_2020": 215,
    "Total_Poll_Votes_2020_21": 280,
    "Poll_votes_May_2020": 13,
    "Poll_votes_June_2020": 54,
    "Poll_votes_July_2020": 58,
    "Poll_votes_August_2020": 29,
    "Poll_votes_September_2020": 23,
    "Poll_votes_October_2020": 16,
    "Poll_votes_November_2020": 12,
    "Poll_votes_December_2020": 10,
    "Poll_votes_January_2021": 15,
    "Poll_votes_February_2021": 16,
    "Poll_votes_March_2021": 22,
    "Poll_votes_April_2021": 12
  },
  {
    "name": "Angus",
    "url": "https://nookipedia.com/wiki/Angus",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "bul00",
    "image_url": "https://dodo.ac/np/images/5/5f/Angus_NH.png",
    "species": "Bull",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "April",
    "birthday_day": 30,
    "sign": "Taurus",
    "quote": "Even strong bulls cry.",
    "phrase": "macmoo",
    "clothing": "Flame Tee",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Bachelor pad",
    "P (individual within species)": 0.166666667,
    "Rarity": "0.48%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 204,
    "Average_Popularity_Score": 204,
    "Nookazon_Bells_Price_Ranking": 119,
    "Nookazon_average_price_Bells": 195313,
    "Nookazon_NMT_Price_Ranking": 91,
    "Nookazon_average_price_NMT": 23,
    "Poll_Ranking_2020": 300,
    "Poll_Ranking_2020_21": 303,
    "Total_Poll_Votes_2020": 223,
    "Total_Poll_Votes_2020_21": 284,
    "Poll_votes_May_2020": 5,
    "Poll_votes_June_2020": 52,
    "Poll_votes_July_2020": 67,
    "Poll_votes_August_2020": 27,
    "Poll_votes_September_2020": 33,
    "Poll_votes_October_2020": 18,
    "Poll_votes_November_2020": 14,
    "Poll_votes_December_2020": 7,
    "Poll_votes_January_2021": 14,
    "Poll_votes_February_2021": 13,
    "Poll_votes_March_2021": 17,
    "Poll_votes_April_2021": 17
  },
  {
    "name": "Tex",
    "url": "https://nookipedia.com/wiki/Tex",
    "alt_name": "",
    "skin_color": "194c89",
    "text_color": "fffad4",
    "id": "pgn12",
    "image_url": "https://dodo.ac/np/images/4/44/Tex_NH.png",
    "species": "Penguin",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 6,
    "sign": "Libra",
    "quote": "Rules were made to be broken.",
    "phrase": "picante",
    "clothing": "Letter Jacket",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Music room",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 1,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 197,
    "Average_Popularity_Score": 199.5,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 213,
    "Poll_Ranking_2020_21": 212,
    "Total_Poll_Votes_2020": 403,
    "Total_Poll_Votes_2020_21": 499,
    "Poll_votes_May_2020": 32,
    "Poll_votes_June_2020": 89,
    "Poll_votes_July_2020": 105,
    "Poll_votes_August_2020": 49,
    "Poll_votes_September_2020": 46,
    "Poll_votes_October_2020": 41,
    "Poll_votes_November_2020": 22,
    "Poll_votes_December_2020": 19,
    "Poll_votes_January_2021": 19,
    "Poll_votes_February_2021": 29,
    "Poll_votes_March_2021": 31,
    "Poll_votes_April_2021": 17
  },
  {
    "name": "Tank",
    "url": "https://nookipedia.com/wiki/Tank",
    "alt_name": "",
    "skin_color": "8bcdea",
    "text_color": "fffad4",
    "id": "rhn00",
    "image_url": "https://dodo.ac/np/images/6/69/Tank_NH_Transparent.png",
    "species": "Rhinoceros",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "May",
    "birthday_day": 6,
    "sign": "Taurus",
    "quote": "Remember to keep your core muscles engaged!",
    "phrase": "kerPOW",
    "clothing": "No. 1 Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Bamboo",
    "P (individual within species)": 0.166666667,
    "Rarity": "0.48%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 203,
    "Average_Popularity_Score": 203.75,
    "Nookazon_Bells_Price_Ranking": 216,
    "Nookazon_average_price_Bells": 143750,
    "Nookazon_NMT_Price_Ranking": 177,
    "Nookazon_average_price_NMT": 19,
    "Poll_Ranking_2020": 207,
    "Poll_Ranking_2020_21": 211,
    "Total_Poll_Votes_2020": 417,
    "Total_Poll_Votes_2020_21": 502,
    "Poll_votes_May_2020": 32,
    "Poll_votes_June_2020": 116,
    "Poll_votes_July_2020": 83,
    "Poll_votes_August_2020": 60,
    "Poll_votes_September_2020": 48,
    "Poll_votes_October_2020": 37,
    "Poll_votes_November_2020": 17,
    "Poll_votes_December_2020": 24,
    "Poll_votes_January_2021": 21,
    "Poll_votes_February_2021": 24,
    "Poll_votes_March_2021": 25,
    "Poll_votes_April_2021": 15
  },
  {
    "name": "Colton",
    "url": "https://nookipedia.com/wiki/Colton",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "hrs11",
    "image_url": "https://dodo.ac/np/images/8/83/Colton_NH_3.png",
    "species": "Horse",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "May",
    "birthday_day": 22,
    "sign": "Gemini",
    "quote": "Make hay while the sun shines.",
    "phrase": "check it",
    "clothing": "Prince's Tunic",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 207,
    "Average_Popularity_Score": 205.5,
    "Nookazon_Bells_Price_Ranking": 211,
    "Nookazon_average_price_Bells": 145313,
    "Nookazon_NMT_Price_Ranking": 221,
    "Nookazon_average_price_NMT": 16,
    "Poll_Ranking_2020": 195,
    "Poll_Ranking_2020_21": 195,
    "Total_Poll_Votes_2020": 441,
    "Total_Poll_Votes_2020_21": 553,
    "Poll_votes_May_2020": 29,
    "Poll_votes_June_2020": 115,
    "Poll_votes_July_2020": 96,
    "Poll_votes_August_2020": 57,
    "Poll_votes_September_2020": 53,
    "Poll_votes_October_2020": 39,
    "Poll_votes_November_2020": 24,
    "Poll_votes_December_2020": 28,
    "Poll_votes_January_2021": 29,
    "Poll_votes_February_2021": 24,
    "Poll_votes_March_2021": 31,
    "Poll_votes_April_2021": 28
  },
  {
    "name": "Avery",
    "url": "https://nookipedia.com/wiki/Avery",
    "alt_name": "",
    "skin_color": "c0ab72",
    "text_color": "fffce9",
    "id": "pbr05",
    "image_url": "https://dodo.ac/np/images/d/dd/Avery_NH.png",
    "species": "Eagle",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "February",
    "birthday_day": 22,
    "sign": "Pisces",
    "quote": "What goes around comes around.",
    "phrase": "skree-haw",
    "clothing": "Oversized Shawl Overshirt",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 196,
    "Average_Popularity_Score": 199,
    "Nookazon_Bells_Price_Ranking": 79,
    "Nookazon_average_price_Bells": 237500,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 243,
    "Poll_Ranking_2020_21": 246,
    "Total_Poll_Votes_2020": 332,
    "Total_Poll_Votes_2020_21": 407,
    "Poll_votes_May_2020": 15,
    "Poll_votes_June_2020": 95,
    "Poll_votes_July_2020": 73,
    "Poll_votes_August_2020": 39,
    "Poll_votes_September_2020": 44,
    "Poll_votes_October_2020": 22,
    "Poll_votes_November_2020": 25,
    "Poll_votes_December_2020": 19,
    "Poll_votes_January_2021": 21,
    "Poll_votes_February_2021": 20,
    "Poll_votes_March_2021": 19,
    "Poll_votes_April_2021": 15
  },
  {
    "name": "Mint",
    "url": "https://nookipedia.com/wiki/Mint",
    "alt_name": "",
    "skin_color": "87e0a9",
    "text_color": 219479,
    "id": "squ09",
    "image_url": "https://dodo.ac/np/images/5/5b/Mint_NH.png",
    "species": "Squirrel",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "May",
    "birthday_day": 2,
    "sign": "Taurus",
    "quote": "Always lead by example.",
    "phrase": "ahhhhhh",
    "clothing": "Gumdrop Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 197,
    "Average_Popularity_Score": 199.5,
    "Nookazon_Bells_Price_Ranking": 259,
    "Nookazon_average_price_Bells": 116667,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 164,
    "Poll_Ranking_2020_21": 157,
    "Total_Poll_Votes_2020": 548,
    "Total_Poll_Votes_2020_21": 711,
    "Poll_votes_May_2020": 32,
    "Poll_votes_June_2020": 127,
    "Poll_votes_July_2020": 130,
    "Poll_votes_August_2020": 69,
    "Poll_votes_September_2020": 53,
    "Poll_votes_October_2020": 57,
    "Poll_votes_November_2020": 40,
    "Poll_votes_December_2020": 40,
    "Poll_votes_January_2021": 37,
    "Poll_votes_February_2021": 39,
    "Poll_votes_March_2021": 52,
    "Poll_votes_April_2021": 35
  },
  {
    "name": "Sydney",
    "url": "https://nookipedia.com/wiki/Sydney",
    "alt_name": "",
    "skin_color": 735000000000,
    "text_color": "fffce9",
    "id": "kal03",
    "image_url": "https://dodo.ac/np/images/3/3f/Sydney_NH.png",
    "species": "Koala",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "June",
    "birthday_day": 21,
    "sign": "Gemini",
    "quote": "Sail wherever the wind takes you.",
    "phrase": "sunshine",
    "clothing": "Overall Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Cute",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 175,
    "Average_Popularity_Score": 187.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 119,
    "Poll_Ranking_2020_21": 121,
    "Total_Poll_Votes_2020": 802,
    "Total_Poll_Votes_2020_21": 953,
    "Poll_votes_May_2020": 57,
    "Poll_votes_June_2020": 205,
    "Poll_votes_July_2020": 207,
    "Poll_votes_August_2020": 102,
    "Poll_votes_September_2020": 98,
    "Poll_votes_October_2020": 59,
    "Poll_votes_November_2020": 46,
    "Poll_votes_December_2020": 28,
    "Poll_votes_January_2021": 40,
    "Poll_votes_February_2021": 30,
    "Poll_votes_March_2021": 42,
    "Poll_votes_April_2021": 39
  },
  {
    "name": "Claude",
    "url": "https://nookipedia.com/wiki/Claude",
    "alt_name": "",
    "skin_color": "d86808",
    "text_color": "fffce9",
    "id": "rbt11",
    "image_url": "https://dodo.ac/np/images/1/1f/Claude_NH.png",
    "species": "Rabbit",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 3,
    "sign": "Sagittarius",
    "quote": "Don't judge a rabbit by its ears.",
    "phrase": "hopalong",
    "clothing": "Marble-Dots Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Library",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 195,
    "Average_Popularity_Score": 198.75,
    "Nookazon_Bells_Price_Ranking": 25,
    "Nookazon_average_price_Bells": 378125,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 322,
    "Poll_Ranking_2020_21": 333,
    "Total_Poll_Votes_2020": 187,
    "Total_Poll_Votes_2020_21": 222,
    "Poll_votes_May_2020": 14,
    "Poll_votes_June_2020": 45,
    "Poll_votes_July_2020": 40,
    "Poll_votes_August_2020": 28,
    "Poll_votes_September_2020": 22,
    "Poll_votes_October_2020": 12,
    "Poll_votes_November_2020": 11,
    "Poll_votes_December_2020": 15,
    "Poll_votes_January_2021": 12,
    "Poll_votes_February_2021": 8,
    "Poll_votes_March_2021": 9,
    "Poll_votes_April_2021": 6
  },
  {
    "name": "Snooty",
    "url": "https://nookipedia.com/wiki/Snooty_(villager)",
    "alt_name": "",
    "skin_color": "f2bdc7",
    "text_color": "634b4b",
    "id": "ant06",
    "image_url": "https://dodo.ac/np/images/6/63/Snooty_NH.png",
    "species": "Anteater",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "October",
    "birthday_day": 24,
    "sign": "Scorpio",
    "quote": "Request forgiveness, not permission.",
    "phrase": "sniffff",
    "clothing": "Misty Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Asian",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 1,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 209,
    "Average_Popularity_Score": 206.75,
    "Nookazon_Bells_Price_Ranking": 37,
    "Nookazon_average_price_Bells": 333334,
    "Nookazon_NMT_Price_Ranking": 6,
    "Nookazon_average_price_NMT": 50,
    "Poll_Ranking_2020": 387,
    "Poll_Ranking_2020_21": 392,
    "Total_Poll_Votes_2020": 98,
    "Total_Poll_Votes_2020_21": 128,
    "Poll_votes_May_2020": 4,
    "Poll_votes_June_2020": 22,
    "Poll_votes_July_2020": 21,
    "Poll_votes_August_2020": 10,
    "Poll_votes_September_2020": 17,
    "Poll_votes_October_2020": 9,
    "Poll_votes_November_2020": 5,
    "Poll_votes_December_2020": 10,
    "Poll_votes_January_2021": 9,
    "Poll_votes_February_2021": 3,
    "Poll_votes_March_2021": 10,
    "Poll_votes_April_2021": 8
  },
  {
    "name": "Étoile",
    "url": "https://nookipedia.com/wiki/Étoile",
    "alt_name": "",
    "skin_color": "b99fff",
    "text_color": "ffd7eb",
    "id": "shp14",
    "image_url": "https://dodo.ac/np/images/2/23/%C3%89toile_PC.png",
    "species": "Sheep",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "December",
    "birthday_day": 25,
    "sign": "Capricorn",
    "quote": "Who knows what the stars have in store for us?",
    "phrase": "fuzzy",
    "clothing": "Kiki & Lala Tee",
    "islander": "FALSE",
    "debut": "WA",
    "prev_phrases": [],
    "appearances": "['WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Sanrio",
    "P (individual within species)": 0,
    "Rarity": "0.00%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 211,
    "Average_Popularity_Score": 209,
    "Nookazon_Bells_Price_Ranking": "N/A",
    "Nookazon_average_price_Bells": "N/A",
    "Nookazon_NMT_Price_Ranking": "N/A",
    "Nookazon_average_price_NMT": "N/A",
    "Poll_Ranking_2020": "N/A",
    "Poll_Ranking_2020_21": 209,
    "Total_Poll_Votes_2020": 0,
    "Total_Poll_Votes_2020_21": 506,
    "Poll_votes_May_2020": 0,
    "Poll_votes_June_2020": 0,
    "Poll_votes_July_2020": 0,
    "Poll_votes_August_2020": 0,
    "Poll_votes_September_2020": 0,
    "Poll_votes_October_2020": 0,
    "Poll_votes_November_2020": 0,
    "Poll_votes_December_2020": 0,
    "Poll_votes_January_2021": 0,
    "Poll_votes_February_2021": 0,
    "Poll_votes_March_2021": 270,
    "Poll_votes_April_2021": 236
  },
  {
    "name": "Weber",
    "url": "https://nookipedia.com/wiki/Weber",
    "alt_name": "",
    "skin_color": "a87850",
    "text_color": "fffce9",
    "id": "duk11",
    "image_url": "https://dodo.ac/np/images/6/66/Weber_NH.png",
    "species": "Duck",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 30,
    "sign": "Cancer",
    "quote": "Today's adults are yesterday's children.",
    "phrase": "quaa",
    "clothing": "Striped Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Music room",
    "P (individual within species)": 0.058823529,
    "Rarity": "0.17%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 186,
    "Average_Popularity_Score": 196.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 91,
    "Nookazon_average_price_NMT": 23,
    "Poll_Ranking_2020": 204,
    "Poll_Ranking_2020_21": 206,
    "Total_Poll_Votes_2020": 423,
    "Total_Poll_Votes_2020_21": 517,
    "Poll_votes_May_2020": 42,
    "Poll_votes_June_2020": 82,
    "Poll_votes_July_2020": 98,
    "Poll_votes_August_2020": 67,
    "Poll_votes_September_2020": 61,
    "Poll_votes_October_2020": 39,
    "Poll_votes_November_2020": 15,
    "Poll_votes_December_2020": 19,
    "Poll_votes_January_2021": 25,
    "Poll_votes_February_2021": 15,
    "Poll_votes_March_2021": 28,
    "Poll_votes_April_2021": 26
  },
  {
    "name": "Willow",
    "url": "https://nookipedia.com/wiki/Willow",
    "alt_name": "",
    "skin_color": "fff98f",
    "text_color": "879b96",
    "id": "shp07",
    "image_url": "https://dodo.ac/np/images/6/62/Willow_NH.png",
    "species": "Sheep",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "November",
    "birthday_day": 26,
    "sign": "Sagittarius",
    "quote": "You can't fight your genes.",
    "phrase": "bo peep",
    "clothing": "Pom-Pom Sweater",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 185,
    "Average_Popularity_Score": 195.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 165,
    "Poll_Ranking_2020_21": 157,
    "Total_Poll_Votes_2020": 545,
    "Total_Poll_Votes_2020_21": 711,
    "Poll_votes_May_2020": 22,
    "Poll_votes_June_2020": 95,
    "Poll_votes_July_2020": 123,
    "Poll_votes_August_2020": 91,
    "Poll_votes_September_2020": 77,
    "Poll_votes_October_2020": 50,
    "Poll_votes_November_2020": 49,
    "Poll_votes_December_2020": 38,
    "Poll_votes_January_2021": 39,
    "Poll_votes_February_2021": 47,
    "Poll_votes_March_2021": 45,
    "Poll_votes_April_2021": 35
  },
  {
    "name": "Cally",
    "url": "https://nookipedia.com/wiki/Cally",
    "alt_name": "Sally",
    "skin_color": "c0ab72",
    "text_color": "fffce9",
    "id": "squ11",
    "image_url": "https://dodo.ac/np/images/a/a6/Cally_NH.png",
    "species": "Squirrel",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "September",
    "birthday_day": 4,
    "sign": "Virgo",
    "quote": "It's always teatime somewhere.",
    "phrase": "WHEE",
    "clothing": "Fairy-Tale Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 217,
    "Average_Popularity_Score": 212.5,
    "Nookazon_Bells_Price_Ranking": 235,
    "Nookazon_average_price_Bells": 133334,
    "Nookazon_NMT_Price_Ranking": 27,
    "Nookazon_average_price_NMT": 35,
    "Poll_Ranking_2020": 291,
    "Poll_Ranking_2020_21": 294,
    "Total_Poll_Votes_2020": 235,
    "Total_Poll_Votes_2020_21": 302,
    "Poll_votes_May_2020": 13,
    "Poll_votes_June_2020": 52,
    "Poll_votes_July_2020": 52,
    "Poll_votes_August_2020": 22,
    "Poll_votes_September_2020": 35,
    "Poll_votes_October_2020": 26,
    "Poll_votes_November_2020": 20,
    "Poll_votes_December_2020": 15,
    "Poll_votes_January_2021": 14,
    "Poll_votes_February_2021": 18,
    "Poll_votes_March_2021": 20,
    "Poll_votes_April_2021": 15
  },
  {
    "name": "Antonio",
    "url": "https://nookipedia.com/wiki/Antonio",
    "alt_name": "",
    "skin_color": "fff98f",
    "text_color": "879b96",
    "id": "ant01",
    "image_url": "https://dodo.ac/np/images/d/d4/Antonio_NH.png",
    "species": "Anteater",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 20,
    "sign": "Libra",
    "quote": "Always go for the burn!",
    "phrase": "honk",
    "clothing": "Bone Tee",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Normal",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 183,
    "Average_Popularity_Score": 194.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 85,
    "Poll_Ranking_2020_21": 85,
    "Total_Poll_Votes_2020": 1109,
    "Total_Poll_Votes_2020_21": 1350,
    "Poll_votes_May_2020": 63,
    "Poll_votes_June_2020": 273,
    "Poll_votes_July_2020": 268,
    "Poll_votes_August_2020": 134,
    "Poll_votes_September_2020": 135,
    "Poll_votes_October_2020": 123,
    "Poll_votes_November_2020": 55,
    "Poll_votes_December_2020": 58,
    "Poll_votes_January_2021": 72,
    "Poll_votes_February_2021": 50,
    "Poll_votes_March_2021": 68,
    "Poll_votes_April_2021": 51
  },
  {
    "name": "Tad",
    "url": "https://nookipedia.com/wiki/Tad",
    "alt_name": "",
    "skin_color": "76b788",
    "text_color": "fffce9",
    "id": "flg09",
    "image_url": "https://dodo.ac/np/images/6/67/Tad_NH.png",
    "species": "Frog",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 3,
    "sign": "Leo",
    "quote": "Take a leap!",
    "phrase": "sluuuurp",
    "clothing": "One-Ball Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 219,
    "Average_Popularity_Score": 213.5,
    "Nookazon_Bells_Price_Ranking": 147,
    "Nookazon_average_price_Bells": 184375,
    "Nookazon_NMT_Price_Ranking": 91,
    "Nookazon_average_price_NMT": 23,
    "Poll_Ranking_2020": 314,
    "Poll_Ranking_2020_21": 308,
    "Total_Poll_Votes_2020": 199,
    "Total_Poll_Votes_2020_21": 274,
    "Poll_votes_May_2020": 9,
    "Poll_votes_June_2020": 40,
    "Poll_votes_July_2020": 36,
    "Poll_votes_August_2020": 43,
    "Poll_votes_September_2020": 24,
    "Poll_votes_October_2020": 15,
    "Poll_votes_November_2020": 19,
    "Poll_votes_December_2020": 13,
    "Poll_votes_January_2021": 11,
    "Poll_votes_February_2021": 16,
    "Poll_votes_March_2021": 26,
    "Poll_votes_April_2021": 22
  },
  {
    "name": "Croque",
    "url": "https://nookipedia.com/wiki/Croque",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "flg17",
    "image_url": "https://dodo.ac/np/images/7/70/Croque_NH.png",
    "species": "Frog",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 18,
    "sign": "Cancer",
    "quote": "Where there's smoke, there's fire.",
    "phrase": "as if",
    "clothing": "Silk Shirt",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 225,
    "Average_Popularity_Score": 215,
    "Nookazon_Bells_Price_Ranking": 50,
    "Nookazon_average_price_Bells": 300000,
    "Nookazon_NMT_Price_Ranking": 80,
    "Nookazon_average_price_NMT": 25,
    "Poll_Ranking_2020": 366,
    "Poll_Ranking_2020_21": 365,
    "Total_Poll_Votes_2020": 129,
    "Total_Poll_Votes_2020_21": 168,
    "Poll_votes_May_2020": 8,
    "Poll_votes_June_2020": 24,
    "Poll_votes_July_2020": 38,
    "Poll_votes_August_2020": 18,
    "Poll_votes_September_2020": 13,
    "Poll_votes_October_2020": 12,
    "Poll_votes_November_2020": 4,
    "Poll_votes_December_2020": 12,
    "Poll_votes_January_2021": 9,
    "Poll_votes_February_2021": 9,
    "Poll_votes_March_2021": 12,
    "Poll_votes_April_2021": 9
  },
  {
    "name": "Monique",
    "url": "https://nookipedia.com/wiki/Monique",
    "alt_name": "",
    "skin_color": "fff98f",
    "text_color": "879b96",
    "id": "cat11",
    "image_url": "https://dodo.ac/np/images/c/cc/Monique_NH.png",
    "species": "Cat",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "September",
    "birthday_day": 30,
    "sign": "Libra",
    "quote": "All publicity is good publicity!",
    "phrase": "pffffft",
    "clothing": "Flapper Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 222,
    "Average_Popularity_Score": 214.75,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 31,
    "Nookazon_average_price_NMT": 33,
    "Poll_Ranking_2020": 316,
    "Poll_Ranking_2020_21": 319,
    "Total_Poll_Votes_2020": 195,
    "Total_Poll_Votes_2020_21": 252,
    "Poll_votes_May_2020": 13,
    "Poll_votes_June_2020": 41,
    "Poll_votes_July_2020": 48,
    "Poll_votes_August_2020": 22,
    "Poll_votes_September_2020": 19,
    "Poll_votes_October_2020": 18,
    "Poll_votes_November_2020": 19,
    "Poll_votes_December_2020": 15,
    "Poll_votes_January_2021": 14,
    "Poll_votes_February_2021": 14,
    "Poll_votes_March_2021": 15,
    "Poll_votes_April_2021": 14
  },
  {
    "name": "Sprocket",
    "url": "https://nookipedia.com/wiki/Sprocket",
    "alt_name": "",
    "skin_color": "0ca54a",
    "text_color": "fffce9",
    "id": "ost03",
    "image_url": "https://dodo.ac/np/images/8/8b/Sprocket_NH.png",
    "species": "Ostrich",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 1,
    "sign": "Sagittarius",
    "quote": "Strike while the iron is hot.",
    "phrase": "zort",
    "clothing": "Jumper Work Suit",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "High-Tech",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 1,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 202,
    "Average_Popularity_Score": 202.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 115,
    "Poll_Ranking_2020_21": 118,
    "Total_Poll_Votes_2020": 850,
    "Total_Poll_Votes_2020_21": 981,
    "Poll_votes_May_2020": 79,
    "Poll_votes_June_2020": 218,
    "Poll_votes_July_2020": 197,
    "Poll_votes_August_2020": 119,
    "Poll_votes_September_2020": 85,
    "Poll_votes_October_2020": 66,
    "Poll_votes_November_2020": 52,
    "Poll_votes_December_2020": 34,
    "Poll_votes_January_2021": 33,
    "Poll_votes_February_2021": 32,
    "Poll_votes_March_2021": 43,
    "Poll_votes_April_2021": 23
  },
  {
    "name": "Anabelle",
    "url": "https://nookipedia.com/wiki/Anabelle",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "ant03",
    "image_url": "https://dodo.ac/np/images/d/d8/Anabelle_NH.png",
    "species": "Anteater",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "February",
    "birthday_day": 16,
    "sign": "Aquarius",
    "quote": "Dance like no one's watching!",
    "phrase": "snorty",
    "clothing": "Bold Muumuu",
    "islander": "FALSE",
    "debut": "WW",
    "prev_phrases": [],
    "appearances": "['WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Normal",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 218,
    "Average_Popularity_Score": 212.75,
    "Nookazon_Bells_Price_Ranking": 251,
    "Nookazon_average_price_Bells": 125000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 138,
    "Poll_Ranking_2020_21": 138,
    "Total_Poll_Votes_2020": 691,
    "Total_Poll_Votes_2020_21": 850,
    "Poll_votes_May_2020": 29,
    "Poll_votes_June_2020": 191,
    "Poll_votes_July_2020": 205,
    "Poll_votes_August_2020": 98,
    "Poll_votes_September_2020": 71,
    "Poll_votes_October_2020": 44,
    "Poll_votes_November_2020": 23,
    "Poll_votes_December_2020": 30,
    "Poll_votes_January_2021": 35,
    "Poll_votes_February_2021": 37,
    "Poll_votes_March_2021": 49,
    "Poll_votes_April_2021": 38
  },
  {
    "name": "Jay",
    "url": "https://nookipedia.com/wiki/Jay",
    "alt_name": "",
    "skin_color": "6b75ce",
    "text_color": "9ae8df",
    "id": "brd00",
    "image_url": "https://dodo.ac/np/images/3/3b/Jay_NH_1.png",
    "species": "Bird",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 17,
    "sign": "Cancer",
    "quote": "He who hesitates has lost.",
    "phrase": "heeeeeyy",
    "clothing": "Six-Ball Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 231,
    "Average_Popularity_Score": 218.5,
    "Nookazon_Bells_Price_Ranking": 235,
    "Nookazon_average_price_Bells": 133334,
    "Nookazon_NMT_Price_Ranking": 91,
    "Nookazon_average_price_NMT": 23,
    "Poll_Ranking_2020": 272,
    "Poll_Ranking_2020_21": 274,
    "Total_Poll_Votes_2020": 267,
    "Total_Poll_Votes_2020_21": 345,
    "Poll_votes_May_2020": 21,
    "Poll_votes_June_2020": 52,
    "Poll_votes_July_2020": 72,
    "Poll_votes_August_2020": 45,
    "Poll_votes_September_2020": 30,
    "Poll_votes_October_2020": 26,
    "Poll_votes_November_2020": 9,
    "Poll_votes_December_2020": 12,
    "Poll_votes_January_2021": 16,
    "Poll_votes_February_2021": 22,
    "Poll_votes_March_2021": 18,
    "Poll_votes_April_2021": 22
  },
  {
    "name": "Drake",
    "url": "https://nookipedia.com/wiki/Drake",
    "alt_name": "",
    "skin_color": "459aba",
    "text_color": "fffce9",
    "id": "duk09",
    "image_url": "https://dodo.ac/np/images/e/e0/Drake_NH.png",
    "species": "Duck",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 25,
    "sign": "Cancer",
    "quote": "...Quack.",
    "phrase": "quacko",
    "clothing": "Yodel Sweater",
    "islander": "FALSE",
    "debut": "WW",
    "prev_phrases": [],
    "appearances": "['WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Cabin",
    "P (individual within species)": 0.058823529,
    "Rarity": "0.17%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 220,
    "Average_Popularity_Score": 213.75,
    "Nookazon_Bells_Price_Ranking": 59,
    "Nookazon_average_price_Bells": 275000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 233,
    "Poll_Ranking_2020_21": 236,
    "Total_Poll_Votes_2020": 364,
    "Total_Poll_Votes_2020_21": 438,
    "Poll_votes_May_2020": 32,
    "Poll_votes_June_2020": 79,
    "Poll_votes_July_2020": 81,
    "Poll_votes_August_2020": 59,
    "Poll_votes_September_2020": 47,
    "Poll_votes_October_2020": 29,
    "Poll_votes_November_2020": 18,
    "Poll_votes_December_2020": 19,
    "Poll_votes_January_2021": 27,
    "Poll_votes_February_2021": 14,
    "Poll_votes_March_2021": 21,
    "Poll_votes_April_2021": 12
  },
  {
    "name": "Vesta",
    "url": "https://nookipedia.com/wiki/Vesta",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "shp00",
    "image_url": "https://dodo.ac/np/images/5/59/Vesta_NH_Transparent.png",
    "species": "Sheep",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 16,
    "sign": "Aries",
    "quote": "No sweater off my back.",
    "phrase": "baaaffo",
    "clothing": "Hand-Knit Tank",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Laundromat",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 208,
    "Average_Popularity_Score": 205.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 125,
    "Poll_Ranking_2020_21": 125,
    "Total_Poll_Votes_2020": 758,
    "Total_Poll_Votes_2020_21": 928,
    "Poll_votes_May_2020": 67,
    "Poll_votes_June_2020": 187,
    "Poll_votes_July_2020": 161,
    "Poll_votes_August_2020": 116,
    "Poll_votes_September_2020": 83,
    "Poll_votes_October_2020": 58,
    "Poll_votes_November_2020": 45,
    "Poll_votes_December_2020": 41,
    "Poll_votes_January_2021": 36,
    "Poll_votes_February_2021": 42,
    "Poll_votes_March_2021": 49,
    "Poll_votes_April_2021": 43
  },
  {
    "name": "Benedict",
    "url": "https://nookipedia.com/wiki/Benedict",
    "alt_name": "",
    "skin_color": "ff4040",
    "text_color": "fffad4",
    "id": "chn01",
    "image_url": "https://dodo.ac/np/images/3/3a/Benedict_NH.png",
    "species": "Chicken",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 10,
    "sign": "Libra",
    "quote": "Don't put all your eggs in one basket.",
    "phrase": "uh-hoo",
    "clothing": "Two-Ball Tee",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 234,
    "Average_Popularity_Score": 219.25,
    "Nookazon_Bells_Price_Ranking": 24,
    "Nookazon_average_price_Bells": 380219,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 267,
    "Poll_Ranking_2020_21": 282,
    "Total_Poll_Votes_2020": 278,
    "Total_Poll_Votes_2020_21": 320,
    "Poll_votes_May_2020": 22,
    "Poll_votes_June_2020": 80,
    "Poll_votes_July_2020": 61,
    "Poll_votes_August_2020": 36,
    "Poll_votes_September_2020": 28,
    "Poll_votes_October_2020": 16,
    "Poll_votes_November_2020": 16,
    "Poll_votes_December_2020": 19,
    "Poll_votes_January_2021": 15,
    "Poll_votes_February_2021": 11,
    "Poll_votes_March_2021": 11,
    "Poll_votes_April_2021": 5
  },
  {
    "name": "Cousteau",
    "url": "https://nookipedia.com/wiki/Cousteau",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "flg10",
    "image_url": "https://dodo.ac/np/images/1/1c/Cousteau_NH.png",
    "species": "Frog",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 17,
    "sign": "Sagittarius",
    "quote": "Jump first, ask questions later.",
    "phrase": "oui oui",
    "clothing": "Silk Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Asian",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 215,
    "Average_Popularity_Score": 211,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 273,
    "Poll_Ranking_2020_21": 275,
    "Total_Poll_Votes_2020": 261,
    "Total_Poll_Votes_2020_21": 343,
    "Poll_votes_May_2020": 10,
    "Poll_votes_June_2020": 65,
    "Poll_votes_July_2020": 68,
    "Poll_votes_August_2020": 31,
    "Poll_votes_September_2020": 22,
    "Poll_votes_October_2020": 29,
    "Poll_votes_November_2020": 23,
    "Poll_votes_December_2020": 13,
    "Poll_votes_January_2021": 19,
    "Poll_votes_February_2021": 18,
    "Poll_votes_March_2021": 24,
    "Poll_votes_April_2021": 21
  },
  {
    "name": "Pudge",
    "url": "https://nookipedia.com/wiki/Pudge",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "cbr03",
    "image_url": "https://dodo.ac/np/images/8/87/Pudge_NH.png",
    "species": "Bear cub",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 11,
    "sign": "Gemini",
    "quote": "There's no such thing as a free lunch.",
    "phrase": "golly",
    "clothing": "Letter Jacket",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": "['pudgy']",
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Toys",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 214,
    "Average_Popularity_Score": 210.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 71,
    "Nookazon_average_price_NMT": 29,
    "Poll_Ranking_2020": 239,
    "Poll_Ranking_2020_21": 243,
    "Total_Poll_Votes_2020": 351,
    "Total_Poll_Votes_2020_21": 420,
    "Poll_votes_May_2020": 30,
    "Poll_votes_June_2020": 64,
    "Poll_votes_July_2020": 80,
    "Poll_votes_August_2020": 51,
    "Poll_votes_September_2020": 37,
    "Poll_votes_October_2020": 41,
    "Poll_votes_November_2020": 25,
    "Poll_votes_December_2020": 23,
    "Poll_votes_January_2021": 15,
    "Poll_votes_February_2021": 14,
    "Poll_votes_March_2021": 23,
    "Poll_votes_April_2021": 17
  },
  {
    "name": "Prince",
    "url": "https://nookipedia.com/wiki/Prince",
    "alt_name": "",
    "skin_color": "78dd62",
    "text_color": "28665a",
    "id": "flg12",
    "image_url": "https://dodo.ac/np/images/a/a6/Prince_NH.png",
    "species": "Frog",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 21,
    "sign": "Cancer",
    "quote": "Catch more flies with honey than vinegar.",
    "phrase": "burrup",
    "clothing": "Striped Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 237,
    "Average_Popularity_Score": 220.5,
    "Nookazon_Bells_Price_Ranking": 176,
    "Nookazon_average_price_Bells": 158334,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 257,
    "Poll_Ranking_2020_21": 261,
    "Total_Poll_Votes_2020": 308,
    "Total_Poll_Votes_2020_21": 379,
    "Poll_votes_May_2020": 20,
    "Poll_votes_June_2020": 73,
    "Poll_votes_July_2020": 73,
    "Poll_votes_August_2020": 46,
    "Poll_votes_September_2020": 35,
    "Poll_votes_October_2020": 27,
    "Poll_votes_November_2020": 17,
    "Poll_votes_December_2020": 17,
    "Poll_votes_January_2021": 21,
    "Poll_votes_February_2021": 15,
    "Poll_votes_March_2021": 17,
    "Poll_votes_April_2021": 18
  },
  {
    "name": "Cobb",
    "url": "https://nookipedia.com/wiki/Cobb",
    "alt_name": "",
    "skin_color": "a8e989",
    "text_color": 8.78e+88,
    "id": "pig08",
    "image_url": "https://dodo.ac/np/images/9/9d/Cobb_NH.png",
    "species": "Pig",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 7,
    "sign": "Libra",
    "quote": "Might makes right.",
    "phrase": "hot dog",
    "clothing": "Flannel Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Messy",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 237,
    "Average_Popularity_Score": 220.5,
    "Nookazon_Bells_Price_Ranking": 26,
    "Nookazon_average_price_Bells": 375000,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 337,
    "Poll_Ranking_2020_21": 336,
    "Total_Poll_Votes_2020": 161,
    "Total_Poll_Votes_2020_21": 209,
    "Poll_votes_May_2020": 7,
    "Poll_votes_June_2020": 36,
    "Poll_votes_July_2020": 26,
    "Poll_votes_August_2020": 26,
    "Poll_votes_September_2020": 18,
    "Poll_votes_October_2020": 11,
    "Poll_votes_November_2020": 9,
    "Poll_votes_December_2020": 28,
    "Poll_votes_January_2021": 12,
    "Poll_votes_February_2021": 12,
    "Poll_votes_March_2021": 14,
    "Poll_votes_April_2021": 10
  },
  {
    "name": "Eunice",
    "url": "https://nookipedia.com/wiki/Eunice",
    "alt_name": "",
    "skin_color": "194c89",
    "text_color": "fffad4",
    "id": "shp02",
    "image_url": "https://dodo.ac/np/images/9/97/Eunice_NH.png",
    "species": "Sheep",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 3,
    "sign": "Aries",
    "quote": "There is a point to every encounter.",
    "phrase": "lambchop",
    "clothing": "Aran-Knit Cardigan",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Laundromat",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 228,
    "Average_Popularity_Score": 217.25,
    "Nookazon_Bells_Price_Ranking": 248,
    "Nookazon_average_price_Bells": 128125,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 198,
    "Poll_Ranking_2020_21": 198,
    "Total_Poll_Votes_2020": 438,
    "Total_Poll_Votes_2020_21": 543,
    "Poll_votes_May_2020": 28,
    "Poll_votes_June_2020": 99,
    "Poll_votes_July_2020": 134,
    "Poll_votes_August_2020": 50,
    "Poll_votes_September_2020": 50,
    "Poll_votes_October_2020": 32,
    "Poll_votes_November_2020": 25,
    "Poll_votes_December_2020": 20,
    "Poll_votes_January_2021": 28,
    "Poll_votes_February_2021": 29,
    "Poll_votes_March_2021": 25,
    "Poll_votes_April_2021": 23
  },
  {
    "name": "Ricky",
    "url": "https://nookipedia.com/wiki/Ricky",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "squ10",
    "image_url": "https://dodo.ac/np/images/8/8d/Ricky_NH.png",
    "species": "Squirrel",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "September",
    "birthday_day": 14,
    "sign": "Virgo",
    "quote": "You gotta break a few shells to get to the nut.",
    "phrase": "nutcase",
    "clothing": "Three-Ball Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 221,
    "Average_Popularity_Score": 214.5,
    "Nookazon_Bells_Price_Ranking": 22,
    "Nookazon_average_price_Bells": 400000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 361,
    "Poll_Ranking_2020_21": 366,
    "Total_Poll_Votes_2020": 133,
    "Total_Poll_Votes_2020_21": 166,
    "Poll_votes_May_2020": 11,
    "Poll_votes_June_2020": 27,
    "Poll_votes_July_2020": 28,
    "Poll_votes_August_2020": 18,
    "Poll_votes_September_2020": 19,
    "Poll_votes_October_2020": 7,
    "Poll_votes_November_2020": 17,
    "Poll_votes_December_2020": 6,
    "Poll_votes_January_2021": 6,
    "Poll_votes_February_2021": 10,
    "Poll_votes_March_2021": 11,
    "Poll_votes_April_2021": 6
  },
  {
    "name": "Timbra",
    "url": "https://nookipedia.com/wiki/Timbra",
    "alt_name": "",
    "skin_color": "d86808",
    "text_color": "fffce9",
    "id": "shp10",
    "image_url": "https://dodo.ac/np/images/6/6f/Timbra_NH.png",
    "species": "Sheep",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "October",
    "birthday_day": 21,
    "sign": "Libra",
    "quote": "Don't pine for the past.",
    "phrase": "pine nut",
    "clothing": "Aran-Knit Sweater",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 222,
    "Average_Popularity_Score": 214.75,
    "Nookazon_Bells_Price_Ranking": 79,
    "Nookazon_average_price_Bells": 237500,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 339,
    "Poll_Ranking_2020_21": 338,
    "Total_Poll_Votes_2020": 161,
    "Total_Poll_Votes_2020_21": 206,
    "Poll_votes_May_2020": 7,
    "Poll_votes_June_2020": 22,
    "Poll_votes_July_2020": 26,
    "Poll_votes_August_2020": 29,
    "Poll_votes_September_2020": 45,
    "Poll_votes_October_2020": 12,
    "Poll_votes_November_2020": 14,
    "Poll_votes_December_2020": 6,
    "Poll_votes_January_2021": 18,
    "Poll_votes_February_2021": 8,
    "Poll_votes_March_2021": 13,
    "Poll_votes_April_2021": 6
  },
  {
    "name": "Pinky",
    "url": "https://nookipedia.com/wiki/Pinky",
    "alt_name": "",
    "skin_color": "fff98f",
    "text_color": "879b96",
    "id": "bea01",
    "image_url": "https://dodo.ac/np/images/b/bf/Pinky_NH.png",
    "species": "Bear",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "September",
    "birthday_day": 9,
    "sign": "Virgo",
    "quote": "Time spent with friends is time well spent.",
    "phrase": "wah",
    "clothing": "Silk Floral-Print Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": "['cubbie']",
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Asian",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 206,
    "Average_Popularity_Score": 204.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 158,
    "Poll_Ranking_2020_21": 155,
    "Total_Poll_Votes_2020": 572,
    "Total_Poll_Votes_2020_21": 734,
    "Poll_votes_May_2020": 41,
    "Poll_votes_June_2020": 145,
    "Poll_votes_July_2020": 139,
    "Poll_votes_August_2020": 59,
    "Poll_votes_September_2020": 81,
    "Poll_votes_October_2020": 51,
    "Poll_votes_November_2020": 30,
    "Poll_votes_December_2020": 26,
    "Poll_votes_January_2021": 38,
    "Poll_votes_February_2021": 40,
    "Poll_votes_March_2021": 46,
    "Poll_votes_April_2021": 38
  },
  {
    "name": "Tybalt",
    "url": "https://nookipedia.com/wiki/Tybalt",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "tig02",
    "image_url": "https://dodo.ac/np/images/0/0f/Tybalt_NH.png",
    "species": "Tiger",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 19,
    "sign": "Leo",
    "quote": "There's no excuse for half-baked potatoes.",
    "phrase": "grrrRAH",
    "clothing": "Simple Parka",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Colorful",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 242,
    "Average_Popularity_Score": 223.25,
    "Nookazon_Bells_Price_Ranking": 180,
    "Nookazon_average_price_Bells": 156250,
    "Nookazon_NMT_Price_Ranking": 209,
    "Nookazon_average_price_NMT": 17,
    "Poll_Ranking_2020": 249,
    "Poll_Ranking_2020_21": 252,
    "Total_Poll_Votes_2020": 323,
    "Total_Poll_Votes_2020_21": 389,
    "Poll_votes_May_2020": 25,
    "Poll_votes_June_2020": 76,
    "Poll_votes_July_2020": 64,
    "Poll_votes_August_2020": 47,
    "Poll_votes_September_2020": 43,
    "Poll_votes_October_2020": 27,
    "Poll_votes_November_2020": 19,
    "Poll_votes_December_2020": 22,
    "Poll_votes_January_2021": 19,
    "Poll_votes_February_2021": 17,
    "Poll_votes_March_2021": 24,
    "Poll_votes_April_2021": 6
  },
  {
    "name": "Clyde",
    "url": "https://nookipedia.com/wiki/Clyde",
    "alt_name": "",
    "skin_color": "d8cc39",
    "text_color": "8b5f57",
    "id": "hrs10",
    "image_url": "https://dodo.ac/np/images/b/bb/Clyde_NH.png",
    "species": "Horse",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "May",
    "birthday_day": 1,
    "sign": "Taurus",
    "quote": "The grass is always greener.",
    "phrase": "clip clawp",
    "clothing": "Madras Plaid Shirt",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": [],
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Fruit",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 226,
    "Average_Popularity_Score": 216.25,
    "Nookazon_Bells_Price_Ranking": 29,
    "Nookazon_average_price_Bells": 371094,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 362,
    "Poll_Ranking_2020_21": 366,
    "Total_Poll_Votes_2020": 131,
    "Total_Poll_Votes_2020_21": 166,
    "Poll_votes_May_2020": 13,
    "Poll_votes_June_2020": 34,
    "Poll_votes_July_2020": 28,
    "Poll_votes_August_2020": 15,
    "Poll_votes_September_2020": 16,
    "Poll_votes_October_2020": 10,
    "Poll_votes_November_2020": 8,
    "Poll_votes_December_2020": 7,
    "Poll_votes_January_2021": 6,
    "Poll_votes_February_2021": 6,
    "Poll_votes_March_2021": 12,
    "Poll_votes_April_2021": 11
  },
  {
    "name": "Camofrog",
    "url": "https://nookipedia.com/wiki/Camofrog",
    "alt_name": "",
    "skin_color": "76b788",
    "text_color": "fffce9",
    "id": "flg03",
    "image_url": "https://dodo.ac/np/images/e/e1/Camofrog_NH.png",
    "species": "Frog",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 5,
    "sign": "Gemini",
    "quote": "What you can't see can't hurt you.",
    "phrase": "ten-hut",
    "clothing": "MVP Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 204,
    "Average_Popularity_Score": 204,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 220,
    "Poll_Ranking_2020_21": 214,
    "Total_Poll_Votes_2020": 381,
    "Total_Poll_Votes_2020_21": 498,
    "Poll_votes_May_2020": 23,
    "Poll_votes_June_2020": 83,
    "Poll_votes_July_2020": 86,
    "Poll_votes_August_2020": 54,
    "Poll_votes_September_2020": 57,
    "Poll_votes_October_2020": 35,
    "Poll_votes_November_2020": 26,
    "Poll_votes_December_2020": 17,
    "Poll_votes_January_2021": 26,
    "Poll_votes_February_2021": 22,
    "Poll_votes_March_2021": 42,
    "Poll_votes_April_2021": 27
  },
  {
    "name": "Kitty",
    "url": "https://nookipedia.com/wiki/Kitty",
    "alt_name": "",
    "skin_color": "c0ab72",
    "text_color": "fffce9",
    "id": "cat14",
    "image_url": "https://dodo.ac/np/images/2/21/Kitty_NH.png",
    "species": "Cat",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "February",
    "birthday_day": 15,
    "sign": "Aquarius",
    "quote": "If you want something done well, do it yourself.",
    "phrase": "mrowrr",
    "clothing": "Loose Fall Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.043478261,
    "Rarity": "0.12%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 243,
    "Average_Popularity_Score": 223.5,
    "Nookazon_Bells_Price_Ranking": 164,
    "Nookazon_average_price_Bells": 166667,
    "Nookazon_NMT_Price_Ranking": 80,
    "Nookazon_average_price_NMT": 25,
    "Poll_Ranking_2020": 324,
    "Poll_Ranking_2020_21": 325,
    "Total_Poll_Votes_2020": 186,
    "Total_Poll_Votes_2020_21": 235,
    "Poll_votes_May_2020": 7,
    "Poll_votes_June_2020": 42,
    "Poll_votes_July_2020": 46,
    "Poll_votes_August_2020": 21,
    "Poll_votes_September_2020": 19,
    "Poll_votes_October_2020": 22,
    "Poll_votes_November_2020": 17,
    "Poll_votes_December_2020": 12,
    "Poll_votes_January_2021": 12,
    "Poll_votes_February_2021": 10,
    "Poll_votes_March_2021": 18,
    "Poll_votes_April_2021": 9
  },
  {
    "name": "Quillson",
    "url": "https://nookipedia.com/wiki/Quillson",
    "alt_name": "",
    "skin_color": "76b788",
    "text_color": "fffce9",
    "id": "duk17",
    "image_url": "https://dodo.ac/np/images/e/e4/Quillson_NH.png",
    "species": "Duck",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 22,
    "sign": "Capricorn",
    "quote": "There is beauty in everything.",
    "phrase": "ridukulous",
    "clothing": "Checkered Muffler",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Bachelor pad",
    "P (individual within species)": 0.058823529,
    "Rarity": "0.17%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 234,
    "Average_Popularity_Score": 219.25,
    "Nookazon_Bells_Price_Ranking": 37,
    "Nookazon_average_price_Bells": 333334,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 253,
    "Poll_Ranking_2020_21": 258,
    "Total_Poll_Votes_2020": 315,
    "Total_Poll_Votes_2020_21": 381,
    "Poll_votes_May_2020": 17,
    "Poll_votes_June_2020": 77,
    "Poll_votes_July_2020": 56,
    "Poll_votes_August_2020": 36,
    "Poll_votes_September_2020": 49,
    "Poll_votes_October_2020": 27,
    "Poll_votes_November_2020": 28,
    "Poll_votes_December_2020": 25,
    "Poll_votes_January_2021": 17,
    "Poll_votes_February_2021": 15,
    "Poll_votes_March_2021": 18,
    "Poll_votes_April_2021": 16
  },
  {
    "name": "Chadder",
    "url": "https://nookipedia.com/wiki/Chadder",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "mus18",
    "image_url": "https://dodo.ac/np/images/3/32/Chadder_NH.png",
    "species": "Mouse",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 15,
    "sign": "Sagittarius",
    "quote": "Meeting is just the start of us saying goodbye.",
    "phrase": "fromage",
    "clothing": "Tailcoat",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Bathroom",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 236,
    "Average_Popularity_Score": 220,
    "Nookazon_Bells_Price_Ranking": 216,
    "Nookazon_average_price_Bells": 143750,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 182,
    "Poll_Ranking_2020_21": 170,
    "Total_Poll_Votes_2020": 476,
    "Total_Poll_Votes_2020_21": 636,
    "Poll_votes_May_2020": 32,
    "Poll_votes_June_2020": 123,
    "Poll_votes_July_2020": 116,
    "Poll_votes_August_2020": 57,
    "Poll_votes_September_2020": 65,
    "Poll_votes_October_2020": 37,
    "Poll_votes_November_2020": 31,
    "Poll_votes_December_2020": 15,
    "Poll_votes_January_2021": 25,
    "Poll_votes_February_2021": 57,
    "Poll_votes_March_2021": 38,
    "Poll_votes_April_2021": 40
  },
  {
    "name": "Rodeo",
    "url": "https://nookipedia.com/wiki/Rodeo",
    "alt_name": "",
    "skin_color": 515151,
    "text_color": "fffce9",
    "id": "bul01",
    "image_url": "https://dodo.ac/np/images/6/6c/Rodeo_NH.png",
    "species": "Bull",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 29,
    "sign": "Scorpio",
    "quote": "Zzzzzzzzzzzzzzzzz...",
    "phrase": "chaps",
    "clothing": "Graduation Gown",
    "islander": "FALSE",
    "debut": "WW",
    "prev_phrases": [],
    "appearances": "['WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.166666667,
    "Rarity": "0.48%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 213,
    "Average_Popularity_Score": 209.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 156,
    "Poll_Ranking_2020_21": 164,
    "Total_Poll_Votes_2020": 575,
    "Total_Poll_Votes_2020_21": 673,
    "Poll_votes_May_2020": 35,
    "Poll_votes_June_2020": 114,
    "Poll_votes_July_2020": 156,
    "Poll_votes_August_2020": 78,
    "Poll_votes_September_2020": 65,
    "Poll_votes_October_2020": 75,
    "Poll_votes_November_2020": 27,
    "Poll_votes_December_2020": 25,
    "Poll_votes_January_2021": 29,
    "Poll_votes_February_2021": 29,
    "Poll_votes_March_2021": 23,
    "Poll_votes_April_2021": 17
  },
  {
    "name": "Eugene",
    "url": "https://nookipedia.com/wiki/Eugene",
    "alt_name": "",
    "skin_color": "4c3317",
    "text_color": "fffce9",
    "id": "kal10",
    "image_url": "https://dodo.ac/np/images/a/ab/Eugene_NH.png",
    "species": "Koala",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 26,
    "sign": "Scorpio",
    "quote": "Imitation is the sincerest form of flattery.",
    "phrase": "yeah buddy",
    "clothing": "Biker Jacket",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Office",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 210,
    "Average_Popularity_Score": 208.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 108,
    "Poll_Ranking_2020_21": 113,
    "Total_Poll_Votes_2020": 903,
    "Total_Poll_Votes_2020_21": 1077,
    "Poll_votes_May_2020": 55,
    "Poll_votes_June_2020": 241,
    "Poll_votes_July_2020": 239,
    "Poll_votes_August_2020": 115,
    "Poll_votes_September_2020": 99,
    "Poll_votes_October_2020": 66,
    "Poll_votes_November_2020": 42,
    "Poll_votes_December_2020": 46,
    "Poll_votes_January_2021": 27,
    "Poll_votes_February_2021": 43,
    "Poll_votes_March_2021": 51,
    "Poll_votes_April_2021": 53
  },
  {
    "name": "Cleo",
    "url": "https://nookipedia.com/wiki/Cleo",
    "alt_name": "",
    "skin_color": "a06fce",
    "text_color": "fffce9",
    "id": "hrs07",
    "image_url": "https://dodo.ac/np/images/e/e9/Cleo_NH.png",
    "species": "Horse",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "February",
    "birthday_day": 9,
    "sign": "Aquarius",
    "quote": "There's something lovable in all of us.",
    "phrase": "sugar",
    "clothing": "Floral Lace Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Office",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 231,
    "Average_Popularity_Score": 218.5,
    "Nookazon_Bells_Price_Ranking": 130,
    "Nookazon_average_price_Bells": 187500,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 319,
    "Poll_Ranking_2020_21": 320,
    "Total_Poll_Votes_2020": 190,
    "Total_Poll_Votes_2020_21": 249,
    "Poll_votes_May_2020": 4,
    "Poll_votes_June_2020": 40,
    "Poll_votes_July_2020": 34,
    "Poll_votes_August_2020": 24,
    "Poll_votes_September_2020": 25,
    "Poll_votes_October_2020": 32,
    "Poll_votes_November_2020": 18,
    "Poll_votes_December_2020": 13,
    "Poll_votes_January_2021": 12,
    "Poll_votes_February_2021": 16,
    "Poll_votes_March_2021": 17,
    "Poll_votes_April_2021": 14
  },
  {
    "name": "Cranston",
    "url": "https://nookipedia.com/wiki/Cranston",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "ost06",
    "image_url": "https://dodo.ac/np/images/b/b7/Cranston_NH.png",
    "species": "Ostrich",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "September",
    "birthday_day": 23,
    "sign": "Libra",
    "quote": "Hard work beats talent.",
    "phrase": "sweatband",
    "clothing": "Oversized Shawl Overshirt",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Asian",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 211,
    "Average_Popularity_Score": 209,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 104,
    "Poll_Ranking_2020_21": 114,
    "Total_Poll_Votes_2020": 929,
    "Total_Poll_Votes_2020_21": 1063,
    "Poll_votes_May_2020": 47,
    "Poll_votes_June_2020": 215,
    "Poll_votes_July_2020": 187,
    "Poll_votes_August_2020": 128,
    "Poll_votes_September_2020": 150,
    "Poll_votes_October_2020": 100,
    "Poll_votes_November_2020": 53,
    "Poll_votes_December_2020": 49,
    "Poll_votes_January_2021": 6,
    "Poll_votes_February_2021": 53,
    "Poll_votes_March_2021": 42,
    "Poll_votes_April_2021": 33
  },
  {
    "name": "Miranda",
    "url": "https://nookipedia.com/wiki/Miranda",
    "alt_name": "",
    "skin_color": "ec7efc",
    "text_color": "fffce9",
    "id": "duk12",
    "image_url": "https://dodo.ac/np/images/8/8c/Miranda_NH.png",
    "species": "Duck",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 23,
    "sign": "Taurus",
    "quote": "If the world is flooded, it will be easy for the duck.",
    "phrase": "quackulous",
    "clothing": "Sleeveless Shirtdress",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.058823529,
    "Rarity": "0.17%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 251,
    "Average_Popularity_Score": 229.5,
    "Nookazon_Bells_Price_Ranking": 121,
    "Nookazon_average_price_Bells": 193750,
    "Nookazon_NMT_Price_Ranking": 91,
    "Nookazon_average_price_NMT": 23,
    "Poll_Ranking_2020": 344,
    "Poll_Ranking_2020_21": 353,
    "Total_Poll_Votes_2020": 152,
    "Total_Poll_Votes_2020_21": 186,
    "Poll_votes_May_2020": 5,
    "Poll_votes_June_2020": 30,
    "Poll_votes_July_2020": 25,
    "Poll_votes_August_2020": 9,
    "Poll_votes_September_2020": 57,
    "Poll_votes_October_2020": 11,
    "Poll_votes_November_2020": 7,
    "Poll_votes_December_2020": 8,
    "Poll_votes_January_2021": 13,
    "Poll_votes_February_2021": 8,
    "Poll_votes_March_2021": 7,
    "Poll_votes_April_2021": 6
  },
  {
    "name": "Shari",
    "url": "https://nookipedia.com/wiki/Shari",
    "alt_name": "",
    "skin_color": "bfbfbf",
    "text_color": "5e5e5e",
    "id": "mnk07",
    "image_url": "https://dodo.ac/np/images/7/72/Shari_NH.png",
    "species": "Monkey",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 10,
    "sign": "Aries",
    "quote": "A good start leads to a good end.",
    "phrase": "cheeky",
    "clothing": "Garden Tank",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 216,
    "Average_Popularity_Score": 211.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 123,
    "Poll_Ranking_2020_21": 119,
    "Total_Poll_Votes_2020": 762,
    "Total_Poll_Votes_2020_21": 976,
    "Poll_votes_May_2020": 67,
    "Poll_votes_June_2020": 186,
    "Poll_votes_July_2020": 184,
    "Poll_votes_August_2020": 79,
    "Poll_votes_September_2020": 73,
    "Poll_votes_October_2020": 69,
    "Poll_votes_November_2020": 59,
    "Poll_votes_December_2020": 45,
    "Poll_votes_January_2021": 45,
    "Poll_votes_February_2021": 55,
    "Poll_votes_March_2021": 65,
    "Poll_votes_April_2021": 49
  },
  {
    "name": "Renée",
    "url": "https://nookipedia.com/wiki/Renée",
    "alt_name": "",
    "skin_color": "ec7efc",
    "text_color": "fffce9",
    "id": "rhn08",
    "image_url": "https://dodo.ac/np/images/e/ef/Ren%C3%A9e_NH.png",
    "species": "Rhinoceros",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "May",
    "birthday_day": 28,
    "sign": "Gemini",
    "quote": "Reckless youth makes rueful age.",
    "phrase": "yo yo yo",
    "clothing": "Sailor's Tee",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Club",
    "P (individual within species)": 0.166666667,
    "Rarity": "0.48%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 244,
    "Average_Popularity_Score": 224.5,
    "Nookazon_Bells_Price_Ranking": 164,
    "Nookazon_average_price_Bells": 166667,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 214,
    "Poll_Ranking_2020_21": 205,
    "Total_Poll_Votes_2020": 402,
    "Total_Poll_Votes_2020_21": 521,
    "Poll_votes_May_2020": 16,
    "Poll_votes_June_2020": 113,
    "Poll_votes_July_2020": 96,
    "Poll_votes_August_2020": 54,
    "Poll_votes_September_2020": 48,
    "Poll_votes_October_2020": 44,
    "Poll_votes_November_2020": 16,
    "Poll_votes_December_2020": 15,
    "Poll_votes_January_2021": 31,
    "Poll_votes_February_2021": 32,
    "Poll_votes_March_2021": 28,
    "Poll_votes_April_2021": 28
  },
  {
    "name": "Jacques",
    "url": "https://nookipedia.com/wiki/Jacques",
    "alt_name": "",
    "skin_color": "194c89",
    "text_color": "fffad4",
    "id": "brd16",
    "image_url": "https://dodo.ac/np/images/0/03/Jacques_NH.png",
    "species": "Bird",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 22,
    "sign": "Cancer",
    "quote": "Better to have loved and squawked than to have never loved at all.",
    "phrase": "zut alors",
    "clothing": "Puffy Vest",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Club",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 247,
    "Average_Popularity_Score": 226.5,
    "Nookazon_Bells_Price_Ranking": 283,
    "Nookazon_average_price_Bells": 101042,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 190,
    "Poll_Ranking_2020_21": 199,
    "Total_Poll_Votes_2020": 454,
    "Total_Poll_Votes_2020_21": 540,
    "Poll_votes_May_2020": 31,
    "Poll_votes_June_2020": 98,
    "Poll_votes_July_2020": 117,
    "Poll_votes_August_2020": 65,
    "Poll_votes_September_2020": 49,
    "Poll_votes_October_2020": 34,
    "Poll_votes_November_2020": 30,
    "Poll_votes_December_2020": 30,
    "Poll_votes_January_2021": 21,
    "Poll_votes_February_2021": 26,
    "Poll_votes_March_2021": 22,
    "Poll_votes_April_2021": 17
  },
  {
    "name": "Sly",
    "url": "https://nookipedia.com/wiki/Sly",
    "alt_name": "",
    "skin_color": "e8b010",
    "text_color": "fffce9",
    "id": "crd06",
    "image_url": "https://dodo.ac/np/images/7/70/Sly_NH.png",
    "species": "Alligator",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "November",
    "birthday_day": 15,
    "sign": "Scorpio",
    "quote": "Don't bite off more than you can chew.",
    "phrase": "hoo-rah",
    "clothing": "Camo Tee",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 245,
    "Average_Popularity_Score": 225.5,
    "Nookazon_Bells_Price_Ranking": 88,
    "Nookazon_average_price_Bells": 225000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 246,
    "Poll_Ranking_2020_21": 245,
    "Total_Poll_Votes_2020": 330,
    "Total_Poll_Votes_2020_21": 408,
    "Poll_votes_May_2020": 17,
    "Poll_votes_June_2020": 90,
    "Poll_votes_July_2020": 75,
    "Poll_votes_August_2020": 36,
    "Poll_votes_September_2020": 40,
    "Poll_votes_October_2020": 27,
    "Poll_votes_November_2020": 23,
    "Poll_votes_December_2020": 22,
    "Poll_votes_January_2021": 19,
    "Poll_votes_February_2021": 17,
    "Poll_votes_March_2021": 23,
    "Poll_votes_April_2021": 19
  },
  {
    "name": "Boone",
    "url": "https://nookipedia.com/wiki/Boone",
    "alt_name": "",
    "skin_color": "ffaa3b",
    "text_color": "874c25",
    "id": "gor02",
    "image_url": "https://dodo.ac/np/images/1/19/Boone_NH.png",
    "species": "Gorilla",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "September",
    "birthday_day": 12,
    "sign": "Virgo",
    "quote": "Never settle for second best.",
    "phrase": "baboom",
    "clothing": "Cycling Shirt",
    "islander": "FALSE",
    "debut": "WW",
    "prev_phrases": [],
    "appearances": "['WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Cabin",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 253,
    "Average_Popularity_Score": 230.5,
    "Nookazon_Bells_Price_Ranking": 121,
    "Nookazon_average_price_Bells": 193750,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 256,
    "Poll_Ranking_2020_21": 256,
    "Total_Poll_Votes_2020": 311,
    "Total_Poll_Votes_2020_21": 385,
    "Poll_votes_May_2020": 21,
    "Poll_votes_June_2020": 82,
    "Poll_votes_July_2020": 72,
    "Poll_votes_August_2020": 38,
    "Poll_votes_September_2020": 35,
    "Poll_votes_October_2020": 36,
    "Poll_votes_November_2020": 13,
    "Poll_votes_December_2020": 14,
    "Poll_votes_January_2021": 24,
    "Poll_votes_February_2021": 19,
    "Poll_votes_March_2021": 23,
    "Poll_votes_April_2021": 8
  },
  {
    "name": "Phil",
    "url": "https://nookipedia.com/wiki/Phil",
    "alt_name": "",
    "skin_color": 735000000000,
    "text_color": "fffce9",
    "id": "ost07",
    "image_url": "https://dodo.ac/np/images/f/f2/Phil_NH.png",
    "species": "Ostrich",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "November",
    "birthday_day": 27,
    "sign": "Sagittarius",
    "quote": "Best not to say too much.",
    "phrase": "hurk",
    "clothing": "Fischerhemd",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 261,
    "Average_Popularity_Score": 234.25,
    "Nookazon_Bells_Price_Ranking": 268,
    "Nookazon_average_price_Bells": 112598,
    "Nookazon_NMT_Price_Ranking": 321,
    "Nookazon_average_price_NMT": 11,
    "Poll_Ranking_2020": 169,
    "Poll_Ranking_2020_21": 174,
    "Total_Poll_Votes_2020": 527,
    "Total_Poll_Votes_2020_21": 619,
    "Poll_votes_May_2020": 37,
    "Poll_votes_June_2020": 125,
    "Poll_votes_July_2020": 122,
    "Poll_votes_August_2020": 87,
    "Poll_votes_September_2020": 62,
    "Poll_votes_October_2020": 44,
    "Poll_votes_November_2020": 28,
    "Poll_votes_December_2020": 22,
    "Poll_votes_January_2021": 27,
    "Poll_votes_February_2021": 24,
    "Poll_votes_March_2021": 22,
    "Poll_votes_April_2021": 19
  },
  {
    "name": "O'Hare",
    "url": "https://nookipedia.com/wiki/O'Hare",
    "alt_name": "",
    "skin_color": "7a2500",
    "text_color": "fffce9",
    "id": "rbt15",
    "image_url": "https://dodo.ac/np/images/c/cf/O%27Hare_NH.png",
    "species": "Rabbit",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 24,
    "sign": "Leo",
    "quote": "It's not old; it's vintage.",
    "phrase": "amigo",
    "clothing": "Pineapple Aloha Shirt",
    "islander": "TRUE",
    "debut": "AC",
    "prev_phrases": [],
    "appearances": "['AC', 'E_PLUS', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Beach",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 222,
    "Average_Popularity_Score": 214.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 178,
    "Poll_Ranking_2020_21": 175,
    "Total_Poll_Votes_2020": 490,
    "Total_Poll_Votes_2020_21": 614,
    "Poll_votes_May_2020": 21,
    "Poll_votes_June_2020": 115,
    "Poll_votes_July_2020": 115,
    "Poll_votes_August_2020": 63,
    "Poll_votes_September_2020": 71,
    "Poll_votes_October_2020": 47,
    "Poll_votes_November_2020": 35,
    "Poll_votes_December_2020": 23,
    "Poll_votes_January_2021": 33,
    "Poll_votes_February_2021": 31,
    "Poll_votes_March_2021": 34,
    "Poll_votes_April_2021": 26
  },
  {
    "name": "Tipper",
    "url": "https://nookipedia.com/wiki/Tipper",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "cow01",
    "image_url": "https://dodo.ac/np/images/7/75/Tipper_NH.png",
    "species": "Cow",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "August",
    "birthday_day": 25,
    "sign": "Virgo",
    "quote": "It takes two to tango.",
    "phrase": "pushy",
    "clothing": "Retro Sweater",
    "islander": "FALSE",
    "debut": "WW",
    "prev_phrases": [],
    "appearances": "['WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.25,
    "Rarity": "0.71%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 233,
    "Average_Popularity_Score": 219,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 219,
    "Poll_Ranking_2020_21": 204,
    "Total_Poll_Votes_2020": 392,
    "Total_Poll_Votes_2020_21": 531,
    "Poll_votes_May_2020": 12,
    "Poll_votes_June_2020": 74,
    "Poll_votes_July_2020": 90,
    "Poll_votes_August_2020": 67,
    "Poll_votes_September_2020": 51,
    "Poll_votes_October_2020": 43,
    "Poll_votes_November_2020": 28,
    "Poll_votes_December_2020": 27,
    "Poll_votes_January_2021": 40,
    "Poll_votes_February_2021": 37,
    "Poll_votes_March_2021": 33,
    "Poll_votes_April_2021": 29
  },
  {
    "name": "Opal",
    "url": "https://nookipedia.com/wiki/Opal",
    "alt_name": "",
    "skin_color": "87e0a9",
    "text_color": 219479,
    "id": "elp00",
    "image_url": "https://dodo.ac/np/images/c/ce/Opal_NH.png",
    "species": "Elephant",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 20,
    "sign": "Aquarius",
    "quote": "However little you think of an elephant, you can't say it won't fill a pot.",
    "phrase": "snoot",
    "clothing": "Front-Tie Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Asian",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 249,
    "Average_Popularity_Score": 228.25,
    "Nookazon_Bells_Price_Ranking": 150,
    "Nookazon_average_price_Bells": 180209,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 287,
    "Poll_Ranking_2020_21": 269,
    "Total_Poll_Votes_2020": 241,
    "Total_Poll_Votes_2020_21": 351,
    "Poll_votes_May_2020": 12,
    "Poll_votes_June_2020": 66,
    "Poll_votes_July_2020": 33,
    "Poll_votes_August_2020": 30,
    "Poll_votes_September_2020": 23,
    "Poll_votes_October_2020": 33,
    "Poll_votes_November_2020": 20,
    "Poll_votes_December_2020": 24,
    "Poll_votes_January_2021": 25,
    "Poll_votes_February_2021": 29,
    "Poll_votes_March_2021": 30,
    "Poll_votes_April_2021": 26
  },
  {
    "name": "Ursala",
    "url": "https://nookipedia.com/wiki/Ursala",
    "alt_name": "",
    "skin_color": "f2bdc7",
    "text_color": "634b4b",
    "id": "bea08",
    "image_url": "https://dodo.ac/np/images/6/65/Ursala_NH.png",
    "species": "Bear",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 16,
    "sign": "Capricorn",
    "quote": "Surround yourself with things you love.",
    "phrase": "grooomph",
    "clothing": "Striped Maxi Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 264,
    "Average_Popularity_Score": 235.5,
    "Nookazon_Bells_Price_Ranking": 277,
    "Nookazon_average_price_Bells": 103750,
    "Nookazon_NMT_Price_Ranking": 177,
    "Nookazon_average_price_NMT": 19,
    "Poll_Ranking_2020": 254,
    "Poll_Ranking_2020_21": 244,
    "Total_Poll_Votes_2020": 313,
    "Total_Poll_Votes_2020_21": 412,
    "Poll_votes_May_2020": 9,
    "Poll_votes_June_2020": 75,
    "Poll_votes_July_2020": 74,
    "Poll_votes_August_2020": 59,
    "Poll_votes_September_2020": 31,
    "Poll_votes_October_2020": 22,
    "Poll_votes_November_2020": 21,
    "Poll_votes_December_2020": 22,
    "Poll_votes_January_2021": 23,
    "Poll_votes_February_2021": 29,
    "Poll_votes_March_2021": 26,
    "Poll_votes_April_2021": 21
  },
  {
    "name": "Deli",
    "url": "https://nookipedia.com/wiki/Deli",
    "alt_name": "",
    "skin_color": "c0ab72",
    "text_color": "fffce9",
    "id": "mnk08",
    "image_url": "https://dodo.ac/np/images/3/30/Deli_NH.png",
    "species": "Monkey",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "May",
    "birthday_day": 24,
    "sign": "Gemini",
    "quote": "Righty tighty, lefty loosey.",
    "phrase": "monch",
    "clothing": "Argyle Vest",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Normal",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 227,
    "Average_Popularity_Score": 216.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 185,
    "Poll_Ranking_2020_21": 179,
    "Total_Poll_Votes_2020": 469,
    "Total_Poll_Votes_2020_21": 606,
    "Poll_votes_May_2020": 23,
    "Poll_votes_June_2020": 134,
    "Poll_votes_July_2020": 99,
    "Poll_votes_August_2020": 72,
    "Poll_votes_September_2020": 56,
    "Poll_votes_October_2020": 36,
    "Poll_votes_November_2020": 28,
    "Poll_votes_December_2020": 21,
    "Poll_votes_January_2021": 26,
    "Poll_votes_February_2021": 37,
    "Poll_votes_March_2021": 42,
    "Poll_votes_April_2021": 32
  },
  {
    "name": "Stu",
    "url": "https://nookipedia.com/wiki/Stu",
    "alt_name": "",
    "skin_color": "6b75ce",
    "text_color": "9ae8df",
    "id": "bul03",
    "image_url": "https://dodo.ac/np/images/f/fa/Stu_NH.png",
    "species": "Bull",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "April",
    "birthday_day": 20,
    "sign": "Taurus",
    "quote": "As a cow grows, so do its nostrils.",
    "phrase": "mrooooo",
    "clothing": "Yodel Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": "['moo-dude']",
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Road",
    "P (individual within species)": 0.166666667,
    "Rarity": "0.48%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 250,
    "Average_Popularity_Score": 228.75,
    "Nookazon_Bells_Price_Ranking": 113,
    "Nookazon_average_price_Bells": 196875,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 240,
    "Poll_Ranking_2020_21": 239,
    "Total_Poll_Votes_2020": 347,
    "Total_Poll_Votes_2020_21": 430,
    "Poll_votes_May_2020": 25,
    "Poll_votes_June_2020": 78,
    "Poll_votes_July_2020": 84,
    "Poll_votes_August_2020": 51,
    "Poll_votes_September_2020": 41,
    "Poll_votes_October_2020": 27,
    "Poll_votes_November_2020": 18,
    "Poll_votes_December_2020": 23,
    "Poll_votes_January_2021": 26,
    "Poll_votes_February_2021": 24,
    "Poll_votes_March_2021": 20,
    "Poll_votes_April_2021": 13
  },
  {
    "name": "Hamphrey",
    "url": "https://nookipedia.com/wiki/Hamphrey",
    "alt_name": "",
    "skin_color": 515151,
    "text_color": "fffce9",
    "id": "ham07",
    "image_url": "https://dodo.ac/np/images/a/a9/Hamphrey_NH.png",
    "species": "Hamster",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "February",
    "birthday_day": 25,
    "sign": "Pisces",
    "quote": "Children should be seen and not heard.",
    "phrase": "snort",
    "clothing": "Fuzzy Vest",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Asian",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 266,
    "Average_Popularity_Score": 236,
    "Nookazon_Bells_Price_Ranking": 176,
    "Nookazon_average_price_Bells": 158334,
    "Nookazon_NMT_Price_Ranking": 314,
    "Nookazon_average_price_NMT": 12,
    "Poll_Ranking_2020": 231,
    "Poll_Ranking_2020_21": 227,
    "Total_Poll_Votes_2020": 367,
    "Total_Poll_Votes_2020_21": 464,
    "Poll_votes_May_2020": 25,
    "Poll_votes_June_2020": 83,
    "Poll_votes_July_2020": 89,
    "Poll_votes_August_2020": 57,
    "Poll_votes_September_2020": 46,
    "Poll_votes_October_2020": 25,
    "Poll_votes_November_2020": 24,
    "Poll_votes_December_2020": 18,
    "Poll_votes_January_2021": 21,
    "Poll_votes_February_2021": 23,
    "Poll_votes_March_2021": 32,
    "Poll_votes_April_2021": 21
  },
  {
    "name": "Curlos",
    "url": "https://nookipedia.com/wiki/Curlos",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "shp08",
    "image_url": "https://dodo.ac/np/images/1/1a/Curlos_NH_Transparent.png",
    "species": "Sheep",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "May",
    "birthday_day": 8,
    "sign": "Taurus",
    "quote": "If you want to know yourself better, ask your neighbors.",
    "phrase": "shearly",
    "clothing": "Zigzag Shirt",
    "islander": "TRUE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Bachelor pad",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 257,
    "Average_Popularity_Score": 232,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 264,
    "Poll_Ranking_2020_21": 277,
    "Total_Poll_Votes_2020": 290,
    "Total_Poll_Votes_2020_21": 342,
    "Poll_votes_May_2020": 16,
    "Poll_votes_June_2020": 64,
    "Poll_votes_July_2020": 62,
    "Poll_votes_August_2020": 34,
    "Poll_votes_September_2020": 50,
    "Poll_votes_October_2020": 33,
    "Poll_votes_November_2020": 21,
    "Poll_votes_December_2020": 10,
    "Poll_votes_January_2021": 13,
    "Poll_votes_February_2021": 11,
    "Poll_votes_March_2021": 13,
    "Poll_votes_April_2021": 15
  },
  {
    "name": "Elvis",
    "url": "https://nookipedia.com/wiki/Elvis",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "lon01",
    "image_url": "https://dodo.ac/np/images/c/cc/Elvis_NH.png",
    "species": "Lion",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 23,
    "sign": "Leo",
    "quote": "Better a live coward than a forgotten hero.",
    "phrase": "unh-hunh",
    "clothing": "Royal Shirt",
    "islander": "FALSE",
    "debut": "WW",
    "prev_phrases": [],
    "appearances": "['WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Opulent",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 251,
    "Average_Popularity_Score": 229.5,
    "Nookazon_Bells_Price_Ranking": 235,
    "Nookazon_average_price_Bells": 133334,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 225,
    "Poll_Ranking_2020_21": 229,
    "Total_Poll_Votes_2020": 377,
    "Total_Poll_Votes_2020_21": 463,
    "Poll_votes_May_2020": 19,
    "Poll_votes_June_2020": 88,
    "Poll_votes_July_2020": 90,
    "Poll_votes_August_2020": 53,
    "Poll_votes_September_2020": 41,
    "Poll_votes_October_2020": 42,
    "Poll_votes_November_2020": 23,
    "Poll_votes_December_2020": 21,
    "Poll_votes_January_2021": 15,
    "Poll_votes_February_2021": 20,
    "Poll_votes_March_2021": 31,
    "Poll_votes_April_2021": 20
  },
  {
    "name": "Amelia",
    "url": "https://nookipedia.com/wiki/Amelia",
    "alt_name": "",
    "skin_color": "ff4040",
    "text_color": "fffad4",
    "id": "pbr01",
    "image_url": "https://dodo.ac/np/images/a/ab/Amelia_NH.png",
    "species": "Eagle",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "November",
    "birthday_day": 19,
    "sign": "Scorpio",
    "quote": "Pampering yourself is as important as food, water, and shelter!",
    "phrase": "cuz",
    "clothing": "Aran-Knit Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": "['eaglet']",
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 230,
    "Average_Popularity_Score": 218.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 176,
    "Poll_Ranking_2020_21": 182,
    "Total_Poll_Votes_2020": 493,
    "Total_Poll_Votes_2020_21": 595,
    "Poll_votes_May_2020": 11,
    "Poll_votes_June_2020": 138,
    "Poll_votes_July_2020": 136,
    "Poll_votes_August_2020": 77,
    "Poll_votes_September_2020": 60,
    "Poll_votes_October_2020": 30,
    "Poll_votes_November_2020": 24,
    "Poll_votes_December_2020": 17,
    "Poll_votes_January_2021": 22,
    "Poll_votes_February_2021": 25,
    "Poll_votes_March_2021": 33,
    "Poll_votes_April_2021": 22
  },
  {
    "name": "Bangle",
    "url": "https://nookipedia.com/wiki/Bangle",
    "alt_name": "",
    "skin_color": "7a2500",
    "text_color": "fffce9",
    "id": "tig03",
    "image_url": "https://dodo.ac/np/images/6/68/Bangle_NH.png",
    "species": "Tiger",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "August",
    "birthday_day": 27,
    "sign": "Virgo",
    "quote": "Don't blink or you'll miss it.",
    "phrase": "growf",
    "clothing": "Tropical Muumuu",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Colorful",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 229,
    "Average_Popularity_Score": 218,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 133,
    "Poll_Ranking_2020_21": 132,
    "Total_Poll_Votes_2020": 720,
    "Total_Poll_Votes_2020_21": 885,
    "Poll_votes_May_2020": 46,
    "Poll_votes_June_2020": 175,
    "Poll_votes_July_2020": 178,
    "Poll_votes_August_2020": 95,
    "Poll_votes_September_2020": 72,
    "Poll_votes_October_2020": 67,
    "Poll_votes_November_2020": 44,
    "Poll_votes_December_2020": 43,
    "Poll_votes_January_2021": 40,
    "Poll_votes_February_2021": 43,
    "Poll_votes_March_2021": 47,
    "Poll_votes_April_2021": 35
  },
  {
    "name": "Gabi",
    "url": "https://nookipedia.com/wiki/Gabi",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "rbt05",
    "image_url": "https://dodo.ac/np/images/8/86/Gabi_NH.png",
    "species": "Rabbit",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "December",
    "birthday_day": 16,
    "sign": "Sagittarius",
    "quote": "The more the merrier.",
    "phrase": "honeybun",
    "clothing": "Gingham Picnic Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Colorful",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 271,
    "Average_Popularity_Score": 238.5,
    "Nookazon_Bells_Price_Ranking": 119,
    "Nookazon_average_price_Bells": 195313,
    "Nookazon_NMT_Price_Ranking": 209,
    "Nookazon_average_price_NMT": 17,
    "Poll_Ranking_2020": 310,
    "Poll_Ranking_2020_21": 313,
    "Total_Poll_Votes_2020": 209,
    "Total_Poll_Votes_2020_21": 269,
    "Poll_votes_May_2020": 16,
    "Poll_votes_June_2020": 39,
    "Poll_votes_July_2020": 48,
    "Poll_votes_August_2020": 29,
    "Poll_votes_September_2020": 30,
    "Poll_votes_October_2020": 19,
    "Poll_votes_November_2020": 13,
    "Poll_votes_December_2020": 15,
    "Poll_votes_January_2021": 17,
    "Poll_votes_February_2021": 16,
    "Poll_votes_March_2021": 15,
    "Poll_votes_April_2021": 12
  },
  {
    "name": "Deena",
    "url": "https://nookipedia.com/wiki/Deena",
    "alt_name": "",
    "skin_color": 798040,
    "text_color": "fffad4",
    "id": "duk04",
    "image_url": "https://dodo.ac/np/images/b/b8/Deena_NH.png",
    "species": "Duck",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "June",
    "birthday_day": 27,
    "sign": "Cancer",
    "quote": "Duck...duck...GOOSE!",
    "phrase": "woowoo",
    "clothing": "Overall Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Music room",
    "P (individual within species)": 0.058823529,
    "Rarity": "0.17%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 265,
    "Average_Popularity_Score": 235.75,
    "Nookazon_Bells_Price_Ranking": 130,
    "Nookazon_average_price_Bells": 187500,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 252,
    "Poll_Ranking_2020_21": 262,
    "Total_Poll_Votes_2020": 315,
    "Total_Poll_Votes_2020_21": 373,
    "Poll_votes_May_2020": 25,
    "Poll_votes_June_2020": 73,
    "Poll_votes_July_2020": 74,
    "Poll_votes_August_2020": 43,
    "Poll_votes_September_2020": 44,
    "Poll_votes_October_2020": 26,
    "Poll_votes_November_2020": 14,
    "Poll_votes_December_2020": 16,
    "Poll_votes_January_2021": 12,
    "Poll_votes_February_2021": 11,
    "Poll_votes_March_2021": 17,
    "Poll_votes_April_2021": 18
  },
  {
    "name": "Puck",
    "url": "https://nookipedia.com/wiki/Puck",
    "alt_name": "",
    "skin_color": "0961f6",
    "text_color": "fffce9",
    "id": "pgn06",
    "image_url": "https://dodo.ac/np/images/5/53/Puck_NH.png",
    "species": "Penguin",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "February",
    "birthday_day": 21,
    "sign": "Pisces",
    "quote": "A bad attitude will land you in the penalty box.",
    "phrase": "brrrrrrrrr",
    "clothing": "Ice-Hockey Uniform",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Ice",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 259,
    "Average_Popularity_Score": 233,
    "Nookazon_Bells_Price_Ranking": 50,
    "Nookazon_average_price_Bells": 300000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 271,
    "Poll_Ranking_2020_21": 279,
    "Total_Poll_Votes_2020": 270,
    "Total_Poll_Votes_2020_21": 329,
    "Poll_votes_May_2020": 25,
    "Poll_votes_June_2020": 68,
    "Poll_votes_July_2020": 65,
    "Poll_votes_August_2020": 26,
    "Poll_votes_September_2020": 43,
    "Poll_votes_October_2020": 14,
    "Poll_votes_November_2020": 17,
    "Poll_votes_December_2020": 12,
    "Poll_votes_January_2021": 12,
    "Poll_votes_February_2021": 17,
    "Poll_votes_March_2021": 18,
    "Poll_votes_April_2021": 12
  },
  {
    "name": "Ava",
    "url": "https://nookipedia.com/wiki/Ava",
    "alt_name": "",
    "skin_color": "e8b010",
    "text_color": "fffce9",
    "id": "chn05",
    "image_url": "https://dodo.ac/np/images/c/cc/Ava_NH.png",
    "species": "Chicken",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 28,
    "sign": "Taurus",
    "quote": "Early to bed, early to rise.",
    "phrase": "beaker",
    "clothing": "Checkered Jumper Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Flowery",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 258,
    "Average_Popularity_Score": 232.25,
    "Nookazon_Bells_Price_Ranking": 130,
    "Nookazon_average_price_Bells": 187500,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 279,
    "Poll_Ranking_2020_21": 287,
    "Total_Poll_Votes_2020": 250,
    "Total_Poll_Votes_2020_21": 311,
    "Poll_votes_May_2020": 24,
    "Poll_votes_June_2020": 49,
    "Poll_votes_July_2020": 58,
    "Poll_votes_August_2020": 37,
    "Poll_votes_September_2020": 21,
    "Poll_votes_October_2020": 27,
    "Poll_votes_November_2020": 14,
    "Poll_votes_December_2020": 20,
    "Poll_votes_January_2021": 17,
    "Poll_votes_February_2021": 13,
    "Poll_votes_March_2021": 14,
    "Poll_votes_April_2021": 17
  },
  {
    "name": "Sparro",
    "url": "https://nookipedia.com/wiki/Sparro",
    "alt_name": "",
    "skin_color": "7a2500",
    "text_color": "fffce9",
    "id": "brd18",
    "image_url": "https://dodo.ac/np/images/3/32/Sparro_NH.png",
    "species": "Bird",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "November",
    "birthday_day": 20,
    "sign": "Scorpio",
    "quote": "The proof of the pudding is in the eating.",
    "phrase": "like whoa",
    "clothing": "Earbuds Combo",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 273,
    "Average_Popularity_Score": 240.75,
    "Nookazon_Bells_Price_Ranking": 152,
    "Nookazon_average_price_Bells": 179167,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 376,
    "Poll_Ranking_2020_21": 380,
    "Total_Poll_Votes_2020": 121,
    "Total_Poll_Votes_2020_21": 152,
    "Poll_votes_May_2020": 7,
    "Poll_votes_June_2020": 25,
    "Poll_votes_July_2020": 22,
    "Poll_votes_August_2020": 17,
    "Poll_votes_September_2020": 13,
    "Poll_votes_October_2020": 15,
    "Poll_votes_November_2020": 14,
    "Poll_votes_December_2020": 8,
    "Poll_votes_January_2021": 5,
    "Poll_votes_February_2021": 9,
    "Poll_votes_March_2021": 5,
    "Poll_votes_April_2021": 12
  },
  {
    "name": "Jitters",
    "url": "https://nookipedia.com/wiki/Jitters",
    "alt_name": "",
    "skin_color": "78dd62",
    "text_color": "28665a",
    "id": "brd04",
    "image_url": "https://dodo.ac/np/images/a/a6/Jitters_NH.png",
    "species": "Bird",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "February",
    "birthday_day": 2,
    "sign": "Aquarius",
    "quote": "When you're a team of one, you're always captain!",
    "phrase": "bzzert",
    "clothing": "Soccer-Uniform Top",
    "islander": "FALSE",
    "debut": "WW",
    "prev_phrases": [],
    "appearances": "['WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Gym",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 260,
    "Average_Popularity_Score": 233.5,
    "Nookazon_Bells_Price_Ranking": 259,
    "Nookazon_average_price_Bells": 116667,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 202,
    "Poll_Ranking_2020_21": 225,
    "Total_Poll_Votes_2020": 427,
    "Total_Poll_Votes_2020_21": 467,
    "Poll_votes_May_2020": 14,
    "Poll_votes_June_2020": 36,
    "Poll_votes_July_2020": 55,
    "Poll_votes_August_2020": 80,
    "Poll_votes_September_2020": 180,
    "Poll_votes_October_2020": 34,
    "Poll_votes_November_2020": 13,
    "Poll_votes_December_2020": 15,
    "Poll_votes_January_2021": 10,
    "Poll_votes_February_2021": 9,
    "Poll_votes_March_2021": 15,
    "Poll_votes_April_2021": 6
  },
  {
    "name": "Friga",
    "url": "https://nookipedia.com/wiki/Friga",
    "alt_name": "",
    "skin_color": "f2bdc7",
    "text_color": "634b4b",
    "id": "pgn04",
    "image_url": "https://dodo.ac/np/images/8/8c/Friga_NH.png",
    "species": "Penguin",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "October",
    "birthday_day": 16,
    "sign": "Libra",
    "quote": "You can't learn a life lesson from a fortune cookie.",
    "phrase": "brrrmph",
    "clothing": "Simple Checkered Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 261,
    "Average_Popularity_Score": 234.25,
    "Nookazon_Bells_Price_Ranking": 26,
    "Nookazon_average_price_Bells": 375000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 359,
    "Poll_Ranking_2020_21": 343,
    "Total_Poll_Votes_2020": 135,
    "Total_Poll_Votes_2020_21": 199,
    "Poll_votes_May_2020": 3,
    "Poll_votes_June_2020": 31,
    "Poll_votes_July_2020": 23,
    "Poll_votes_August_2020": 21,
    "Poll_votes_September_2020": 19,
    "Poll_votes_October_2020": 13,
    "Poll_votes_November_2020": 13,
    "Poll_votes_December_2020": 12,
    "Poll_votes_January_2021": 10,
    "Poll_votes_February_2021": 18,
    "Poll_votes_March_2021": 17,
    "Poll_votes_April_2021": 19
  },
  {
    "name": "Flip",
    "url": "https://nookipedia.com/wiki/Flip",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "mnk06",
    "image_url": "https://dodo.ac/np/images/c/c3/Flip_NH.png",
    "species": "Monkey",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "November",
    "birthday_day": 21,
    "sign": "Scorpio",
    "quote": "See no donut, hear no donut, speak no donut.",
    "phrase": "rerack",
    "clothing": "Muscle Tank",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Asian",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 237,
    "Average_Popularity_Score": 220.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 251,
    "Poll_Ranking_2020_21": 247,
    "Total_Poll_Votes_2020": 319,
    "Total_Poll_Votes_2020_21": 405,
    "Poll_votes_May_2020": 20,
    "Poll_votes_June_2020": 91,
    "Poll_votes_July_2020": 60,
    "Poll_votes_August_2020": 44,
    "Poll_votes_September_2020": 35,
    "Poll_votes_October_2020": 23,
    "Poll_votes_November_2020": 24,
    "Poll_votes_December_2020": 22,
    "Poll_votes_January_2021": 17,
    "Poll_votes_February_2021": 23,
    "Poll_votes_March_2021": 26,
    "Poll_votes_April_2021": 20
  },
  {
    "name": "Paolo",
    "url": "https://nookipedia.com/wiki/Paolo",
    "alt_name": "",
    "skin_color": "f993ce",
    "text_color": "fffce9",
    "id": "elp05",
    "image_url": "https://dodo.ac/np/images/5/59/Paolo_NH.png",
    "species": "Elephant",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "May",
    "birthday_day": 5,
    "sign": "Taurus",
    "quote": "When it works, it works.",
    "phrase": "pal",
    "clothing": "Simple Parka",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Bathroom",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 273,
    "Average_Popularity_Score": 240.75,
    "Nookazon_Bells_Price_Ranking": 187,
    "Nookazon_average_price_Bells": 152500,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 288,
    "Poll_Ranking_2020_21": 296,
    "Total_Poll_Votes_2020": 241,
    "Total_Poll_Votes_2020_21": 299,
    "Poll_votes_May_2020": 17,
    "Poll_votes_June_2020": 81,
    "Poll_votes_July_2020": 41,
    "Poll_votes_August_2020": 18,
    "Poll_votes_September_2020": 26,
    "Poll_votes_October_2020": 22,
    "Poll_votes_November_2020": 14,
    "Poll_votes_December_2020": 22,
    "Poll_votes_January_2021": 15,
    "Poll_votes_February_2021": 9,
    "Poll_votes_March_2021": 16,
    "Poll_votes_April_2021": 18
  },
  {
    "name": "Jacob",
    "url": "https://nookipedia.com/wiki/Jacob",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "brd11",
    "image_url": "https://dodo.ac/np/images/3/3e/Jacob_NH.png",
    "species": "Bird",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 24,
    "sign": "Virgo",
    "quote": "Your greatest strength can be your greatest weakness.",
    "phrase": "ya feel",
    "clothing": "Camo Bomber-Style Jacket",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Messy",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 240,
    "Average_Popularity_Score": 222,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 245,
    "Poll_Ranking_2020_21": 250,
    "Total_Poll_Votes_2020": 331,
    "Total_Poll_Votes_2020_21": 393,
    "Poll_votes_May_2020": 23,
    "Poll_votes_June_2020": 89,
    "Poll_votes_July_2020": 79,
    "Poll_votes_August_2020": 43,
    "Poll_votes_September_2020": 35,
    "Poll_votes_October_2020": 32,
    "Poll_votes_November_2020": 15,
    "Poll_votes_December_2020": 15,
    "Poll_votes_January_2021": 20,
    "Poll_votes_February_2021": 15,
    "Poll_votes_March_2021": 18,
    "Poll_votes_April_2021": 9
  },
  {
    "name": "Vladimir",
    "url": "https://nookipedia.com/wiki/Vladimir",
    "alt_name": "",
    "skin_color": "ff6183",
    "text_color": "fffce9",
    "id": "cbr06",
    "image_url": "https://dodo.ac/np/images/7/75/Vladimir_NH.png",
    "species": "Bear cub",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 2,
    "sign": "Leo",
    "quote": "Trouble never comes alone.",
    "phrase": "nyet",
    "clothing": "Striped Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.0625,
    "Rarity": "0.18%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 255,
    "Average_Popularity_Score": 231.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 283,
    "Poll_Ranking_2020_21": 295,
    "Total_Poll_Votes_2020": 248,
    "Total_Poll_Votes_2020_21": 300,
    "Poll_votes_May_2020": 17,
    "Poll_votes_June_2020": 53,
    "Poll_votes_July_2020": 51,
    "Poll_votes_August_2020": 35,
    "Poll_votes_September_2020": 30,
    "Poll_votes_October_2020": 26,
    "Poll_votes_November_2020": 20,
    "Poll_votes_December_2020": 16,
    "Poll_votes_January_2021": 9,
    "Poll_votes_February_2021": 10,
    "Poll_votes_March_2021": 21,
    "Poll_votes_April_2021": 12
  },
  {
    "name": "Sally",
    "url": "https://nookipedia.com/wiki/Sally",
    "alt_name": "Hazel",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "squ07",
    "image_url": "https://dodo.ac/np/images/a/a3/Sally_NH.png",
    "species": "Squirrel",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "June",
    "birthday_day": 19,
    "sign": "Gemini",
    "quote": "Even the smallest acorn may grow into the tallest tree.",
    "phrase": "nutmeg",
    "clothing": "Snowy Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Colorful",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 241,
    "Average_Popularity_Score": 222.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 250,
    "Poll_Ranking_2020_21": 251,
    "Total_Poll_Votes_2020": 322,
    "Total_Poll_Votes_2020_21": 391,
    "Poll_votes_May_2020": 14,
    "Poll_votes_June_2020": 84,
    "Poll_votes_July_2020": 81,
    "Poll_votes_August_2020": 46,
    "Poll_votes_September_2020": 19,
    "Poll_votes_October_2020": 33,
    "Poll_votes_November_2020": 24,
    "Poll_votes_December_2020": 21,
    "Poll_votes_January_2021": 18,
    "Poll_votes_February_2021": 21,
    "Poll_votes_March_2021": 15,
    "Poll_votes_April_2021": 15
  },
  {
    "name": "Nate",
    "url": "https://nookipedia.com/wiki/Nate",
    "alt_name": "",
    "skin_color": "e8b010",
    "text_color": "fffce9",
    "id": "bea05",
    "image_url": "https://dodo.ac/np/images/5/55/Nate_NH.png",
    "species": "Bear",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 16,
    "sign": "Leo",
    "quote": "Be true to yourself.",
    "phrase": "yawwwn",
    "clothing": "Reindeer Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 280,
    "Average_Popularity_Score": 244.75,
    "Nookazon_Bells_Price_Ranking": 186,
    "Nookazon_average_price_Bells": 152605,
    "Nookazon_NMT_Price_Ranking": 321,
    "Nookazon_average_price_NMT": 11,
    "Poll_Ranking_2020": 232,
    "Poll_Ranking_2020_21": 236,
    "Total_Poll_Votes_2020": 366,
    "Total_Poll_Votes_2020_21": 438,
    "Poll_votes_May_2020": 29,
    "Poll_votes_June_2020": 83,
    "Poll_votes_July_2020": 95,
    "Poll_votes_August_2020": 46,
    "Poll_votes_September_2020": 46,
    "Poll_votes_October_2020": 29,
    "Poll_votes_November_2020": 20,
    "Poll_votes_December_2020": 18,
    "Poll_votes_January_2021": 21,
    "Poll_votes_February_2021": 20,
    "Poll_votes_March_2021": 16,
    "Poll_votes_April_2021": 15
  },
  {
    "name": "Peewee",
    "url": "https://nookipedia.com/wiki/Peewee",
    "alt_name": "",
    "skin_color": "7fa9ff",
    "text_color": "fffce9",
    "id": "gor01",
    "image_url": "https://dodo.ac/np/images/2/2a/Peewee_NH.png",
    "species": "Gorilla",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "September",
    "birthday_day": 11,
    "sign": "Virgo",
    "quote": "Look behind you.",
    "phrase": "li'l bitty baby",
    "clothing": "Five-Ball Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": "[\\li'l dude\\\"]",
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Metal",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 277,
    "Average_Popularity_Score": 244,
    "Nookazon_Bells_Price_Ranking": 19,
    "Nookazon_average_price_Bells": 437500,
    "Nookazon_NMT_Price_Ranking": 279,
    "Nookazon_average_price_NMT": 14,
    "Poll_Ranking_2020": 346,
    "Poll_Ranking_2020_21": 339,
    "Total_Poll_Votes_2020": 150,
    "Total_Poll_Votes_2020_21": 203,
    "Poll_votes_May_2020": 9,
    "Poll_votes_June_2020": 50,
    "Poll_votes_July_2020": 32,
    "Poll_votes_August_2020": 12,
    "Poll_votes_September_2020": 17,
    "Poll_votes_October_2020": 13,
    "Poll_votes_November_2020": 9,
    "Poll_votes_December_2020": 8,
    "Poll_votes_January_2021": 12,
    "Poll_votes_February_2021": 10,
    "Poll_votes_March_2021": 17,
    "Poll_votes_April_2021": 14
  },
  {
    "name": "Twiggy",
    "url": "https://nookipedia.com/wiki/Twiggy",
    "alt_name": "",
    "skin_color": "fff80d",
    "text_color": "9b8986",
    "id": "brd03",
    "image_url": "https://dodo.ac/np/images/6/67/Twiggy_NH.png",
    "species": "Bird",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "July",
    "birthday_day": 13,
    "sign": "Cancer",
    "quote": "It's the early bird that catches the worm!",
    "phrase": "cheepers",
    "clothing": "Striped Tank",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 3,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 270,
    "Average_Popularity_Score": 238.25,
    "Nookazon_Bells_Price_Ranking": 159,
    "Nookazon_average_price_Bells": 168750,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 234,
    "Poll_Ranking_2020_21": 235,
    "Total_Poll_Votes_2020": 364,
    "Total_Poll_Votes_2020_21": 442,
    "Poll_votes_May_2020": 33,
    "Poll_votes_June_2020": 86,
    "Poll_votes_July_2020": 92,
    "Poll_votes_August_2020": 56,
    "Poll_votes_September_2020": 33,
    "Poll_votes_October_2020": 25,
    "Poll_votes_November_2020": 18,
    "Poll_votes_December_2020": 21,
    "Poll_votes_January_2021": 14,
    "Poll_votes_February_2021": 16,
    "Poll_votes_March_2021": 25,
    "Poll_votes_April_2021": 23
  },
  {
    "name": "Flo",
    "url": "https://nookipedia.com/wiki/Flo",
    "alt_name": "",
    "skin_color": "6b75ce",
    "text_color": "9ae8df",
    "id": "pgn13",
    "image_url": "https://dodo.ac/np/images/b/bb/Flo_NH.png",
    "species": "Penguin",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "September",
    "birthday_day": 2,
    "sign": "Virgo",
    "quote": "Always keep a straight face.",
    "phrase": "cha",
    "clothing": "Folk Shirt",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Ice",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 245,
    "Average_Popularity_Score": 225.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 149,
    "Poll_Ranking_2020_21": 147,
    "Total_Poll_Votes_2020": 632,
    "Total_Poll_Votes_2020_21": 796,
    "Poll_votes_May_2020": 45,
    "Poll_votes_June_2020": 163,
    "Poll_votes_July_2020": 148,
    "Poll_votes_August_2020": 76,
    "Poll_votes_September_2020": 75,
    "Poll_votes_October_2020": 53,
    "Poll_votes_November_2020": 37,
    "Poll_votes_December_2020": 35,
    "Poll_votes_January_2021": 44,
    "Poll_votes_February_2021": 35,
    "Poll_votes_March_2021": 47,
    "Poll_votes_April_2021": 38
  },
  {
    "name": "Midge",
    "url": "https://nookipedia.com/wiki/Midge",
    "alt_name": "",
    "skin_color": "ec7efc",
    "text_color": "fffce9",
    "id": "brd08",
    "image_url": "https://dodo.ac/np/images/a/af/Midge_NH.png",
    "species": "Bird",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 12,
    "sign": "Pisces",
    "quote": "When the world gets cold, just fly south.",
    "phrase": "tweedledee",
    "clothing": "Silk Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Cute",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 3,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 248,
    "Average_Popularity_Score": 227.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 206,
    "Poll_Ranking_2020_21": 200,
    "Total_Poll_Votes_2020": 419,
    "Total_Poll_Votes_2020_21": 537,
    "Poll_votes_May_2020": 24,
    "Poll_votes_June_2020": 108,
    "Poll_votes_July_2020": 91,
    "Poll_votes_August_2020": 55,
    "Poll_votes_September_2020": 56,
    "Poll_votes_October_2020": 34,
    "Poll_votes_November_2020": 27,
    "Poll_votes_December_2020": 24,
    "Poll_votes_January_2021": 32,
    "Poll_votes_February_2021": 29,
    "Poll_votes_March_2021": 35,
    "Poll_votes_April_2021": 22
  },
  {
    "name": "Sheldon",
    "url": "https://nookipedia.com/wiki/Sheldon",
    "alt_name": "",
    "skin_color": "ffaa3b",
    "text_color": "874c25",
    "id": "squ16",
    "image_url": "https://dodo.ac/np/images/c/ce/Sheldon_NH.png",
    "species": "Squirrel",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "February",
    "birthday_day": 26,
    "sign": "Pisces",
    "quote": "Winners don't quit, and quitters never win.",
    "phrase": "cardio",
    "clothing": "Tiger Jacket",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 263,
    "Average_Popularity_Score": 234.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 221,
    "Nookazon_average_price_NMT": 16,
    "Poll_Ranking_2020": 218,
    "Poll_Ranking_2020_21": 217,
    "Total_Poll_Votes_2020": 396,
    "Total_Poll_Votes_2020_21": 490,
    "Poll_votes_May_2020": 19,
    "Poll_votes_June_2020": 112,
    "Poll_votes_July_2020": 93,
    "Poll_votes_August_2020": 34,
    "Poll_votes_September_2020": 41,
    "Poll_votes_October_2020": 42,
    "Poll_votes_November_2020": 29,
    "Poll_votes_December_2020": 26,
    "Poll_votes_January_2021": 24,
    "Poll_votes_February_2021": 18,
    "Poll_votes_March_2021": 40,
    "Poll_votes_April_2021": 12
  },
  {
    "name": "Robin",
    "url": "https://nookipedia.com/wiki/Robin",
    "alt_name": "",
    "skin_color": "6b75ce",
    "text_color": "9ae8df",
    "id": "brd01",
    "image_url": "https://dodo.ac/np/images/8/85/Robin_NH.png",
    "species": "Bird",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "December",
    "birthday_day": 4,
    "sign": "Sagittarius",
    "quote": "Always keep your wings manicured so you can fly away.",
    "phrase": "la-di-da",
    "clothing": "Front-Tie Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 269,
    "Average_Popularity_Score": 237.5,
    "Nookazon_Bells_Price_Ranking": 130,
    "Nookazon_average_price_Bells": 187500,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 360,
    "Poll_Ranking_2020_21": 358,
    "Total_Poll_Votes_2020": 134,
    "Total_Poll_Votes_2020_21": 178,
    "Poll_votes_May_2020": 6,
    "Poll_votes_June_2020": 25,
    "Poll_votes_July_2020": 38,
    "Poll_votes_August_2020": 22,
    "Poll_votes_September_2020": 14,
    "Poll_votes_October_2020": 11,
    "Poll_votes_November_2020": 9,
    "Poll_votes_December_2020": 9,
    "Poll_votes_January_2021": 11,
    "Poll_votes_February_2021": 13,
    "Poll_votes_March_2021": 8,
    "Poll_votes_April_2021": 12
  },
  {
    "name": "Marcie",
    "url": "https://nookipedia.com/wiki/Marcie",
    "alt_name": "",
    "skin_color": "f993ce",
    "text_color": "fffce9",
    "id": "kgr10",
    "image_url": "https://dodo.ac/np/images/2/2b/Marcie_NH.png",
    "species": "Kangaroo",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "May",
    "birthday_day": 31,
    "sign": "Gemini",
    "quote": "The road to a friend's house is never long.",
    "phrase": "pouches",
    "clothing": "Heart Apron",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Cute",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 281,
    "Average_Popularity_Score": 245,
    "Nookazon_Bells_Price_Ranking": 215,
    "Nookazon_average_price_Bells": 144000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 266,
    "Poll_Ranking_2020_21": 270,
    "Total_Poll_Votes_2020": 284,
    "Total_Poll_Votes_2020_21": 350,
    "Poll_votes_May_2020": 17,
    "Poll_votes_June_2020": 81,
    "Poll_votes_July_2020": 60,
    "Poll_votes_August_2020": 26,
    "Poll_votes_September_2020": 35,
    "Poll_votes_October_2020": 30,
    "Poll_votes_November_2020": 20,
    "Poll_votes_December_2020": 15,
    "Poll_votes_January_2021": 17,
    "Poll_votes_February_2021": 15,
    "Poll_votes_March_2021": 16,
    "Poll_votes_April_2021": 18
  },
  {
    "name": "Hippeux",
    "url": "https://nookipedia.com/wiki/Hippeux",
    "alt_name": "",
    "skin_color": "d8cc39",
    "text_color": "8b5f57",
    "id": "hip09",
    "image_url": "https://dodo.ac/np/images/2/26/Hippeux_NH.png",
    "species": "Hippo",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 15,
    "sign": "Libra",
    "quote": "Mottoes are for the unoriginal.",
    "phrase": "natch",
    "clothing": "Emblem Blazer",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 278,
    "Average_Popularity_Score": 244.25,
    "Nookazon_Bells_Price_Ranking": 53,
    "Nookazon_average_price_Bells": 299375,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 297,
    "Poll_Ranking_2020_21": 300,
    "Total_Poll_Votes_2020": 226,
    "Total_Poll_Votes_2020_21": 291,
    "Poll_votes_May_2020": 10,
    "Poll_votes_June_2020": 37,
    "Poll_votes_July_2020": 28,
    "Poll_votes_August_2020": 36,
    "Poll_votes_September_2020": 47,
    "Poll_votes_October_2020": 34,
    "Poll_votes_November_2020": 18,
    "Poll_votes_December_2020": 16,
    "Poll_votes_January_2021": 20,
    "Poll_votes_February_2021": 12,
    "Poll_votes_March_2021": 10,
    "Poll_votes_April_2021": 23
  },
  {
    "name": "Pierce",
    "url": "https://nookipedia.com/wiki/Pierce",
    "alt_name": "",
    "skin_color": "55cfff",
    "text_color": "fffce9",
    "id": "pbr02",
    "image_url": "https://dodo.ac/np/images/8/80/Pierce_NH.png",
    "species": "Eagle",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "January",
    "birthday_day": 8,
    "sign": "Capricorn",
    "quote": "When someone says fly, you ask how high!",
    "phrase": "hawkeye",
    "clothing": "Tennis Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": "['winger']",
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Gym",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 266,
    "Average_Popularity_Score": 236,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 238,
    "Poll_Ranking_2020_21": 238,
    "Total_Poll_Votes_2020": 352,
    "Total_Poll_Votes_2020_21": 431,
    "Poll_votes_May_2020": 38,
    "Poll_votes_June_2020": 91,
    "Poll_votes_July_2020": 88,
    "Poll_votes_August_2020": 41,
    "Poll_votes_September_2020": 31,
    "Poll_votes_October_2020": 30,
    "Poll_votes_November_2020": 12,
    "Poll_votes_December_2020": 21,
    "Poll_votes_January_2021": 20,
    "Poll_votes_February_2021": 14,
    "Poll_votes_March_2021": 28,
    "Poll_votes_April_2021": 17
  },
  {
    "name": "Rodney",
    "url": "https://nookipedia.com/wiki/Rodney",
    "alt_name": "",
    "skin_color": "459aba",
    "text_color": "fffce9",
    "id": "ham03",
    "image_url": "https://dodo.ac/np/images/3/35/Rodney_NH.png",
    "species": "Hamster",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "November",
    "birthday_day": 10,
    "sign": "Scorpio",
    "quote": "Everything is temporary.",
    "phrase": "le ham",
    "clothing": "Striped Tank",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Cafe",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 256,
    "Average_Popularity_Score": 231.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 153,
    "Poll_Ranking_2020_21": 159,
    "Total_Poll_Votes_2020": 606,
    "Total_Poll_Votes_2020_21": 704,
    "Poll_votes_May_2020": 42,
    "Poll_votes_June_2020": 157,
    "Poll_votes_July_2020": 112,
    "Poll_votes_August_2020": 93,
    "Poll_votes_September_2020": 74,
    "Poll_votes_October_2020": 53,
    "Poll_votes_November_2020": 46,
    "Poll_votes_December_2020": 29,
    "Poll_votes_January_2021": 22,
    "Poll_votes_February_2021": 23,
    "Poll_votes_March_2021": 30,
    "Poll_votes_April_2021": 23
  },
  {
    "name": "Mallary",
    "url": "https://nookipedia.com/wiki/Mallary",
    "alt_name": "",
    "skin_color": "a06fce",
    "text_color": "fffce9",
    "id": "duk06",
    "image_url": "https://dodo.ac/np/images/2/28/Mallary_NH.png",
    "species": "Duck",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "November",
    "birthday_day": 17,
    "sign": "Scorpio",
    "quote": "Purple is the color of royalty.",
    "phrase": "quackpth",
    "clothing": "Striped Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.058823529,
    "Rarity": "0.17%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 276,
    "Average_Popularity_Score": 242.5,
    "Nookazon_Bells_Price_Ranking": 88,
    "Nookazon_average_price_Bells": 225000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 389,
    "Poll_Ranking_2020_21": 389,
    "Total_Poll_Votes_2020": 94,
    "Total_Poll_Votes_2020_21": 139,
    "Poll_votes_May_2020": 5,
    "Poll_votes_June_2020": 19,
    "Poll_votes_July_2020": 20,
    "Poll_votes_August_2020": 16,
    "Poll_votes_September_2020": 9,
    "Poll_votes_October_2020": 12,
    "Poll_votes_November_2020": 8,
    "Poll_votes_December_2020": 5,
    "Poll_votes_January_2021": 14,
    "Poll_votes_February_2021": 12,
    "Poll_votes_March_2021": 8,
    "Poll_votes_April_2021": 11
  },
  {
    "name": "Bree",
    "url": "https://nookipedia.com/wiki/Bree",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "mus03",
    "image_url": "https://dodo.ac/np/images/1/12/Bree_NH.png",
    "species": "Mouse",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "July",
    "birthday_day": 7,
    "sign": "Cancer",
    "quote": "The gift says more about the giver.",
    "phrase": "cheeseball",
    "clothing": "Sweetheart Dress",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 1,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 253,
    "Average_Popularity_Score": 230.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 276,
    "Poll_Ranking_2020_21": 267,
    "Total_Poll_Votes_2020": 254,
    "Total_Poll_Votes_2020_21": 354,
    "Poll_votes_May_2020": 11,
    "Poll_votes_June_2020": 47,
    "Poll_votes_July_2020": 59,
    "Poll_votes_August_2020": 30,
    "Poll_votes_September_2020": 30,
    "Poll_votes_October_2020": 30,
    "Poll_votes_November_2020": 28,
    "Poll_votes_December_2020": 19,
    "Poll_votes_January_2021": 17,
    "Poll_votes_February_2021": 31,
    "Poll_votes_March_2021": 29,
    "Poll_votes_April_2021": 23
  },
  {
    "name": "Marty",
    "url": "https://nookipedia.com/wiki/Marty",
    "alt_name": "",
    "skin_color": "f8e880",
    "text_color": "9a543a",
    "id": "cbr18",
    "image_url": "https://dodo.ac/np/images/a/a9/Marty_PC.png",
    "species": "Bear cub",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "April",
    "birthday_day": 16,
    "sign": "Aries",
    "quote": "Just wait until I get started!",
    "phrase": "pompom",
    "clothing": "Pompompurin Tee",
    "islander": "FALSE",
    "debut": "WA",
    "prev_phrases": [],
    "appearances": "['WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Sanrio",
    "P (individual within species)": 0,
    "Rarity": "0.00%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 292,
    "Average_Popularity_Score": 252,
    "Nookazon_Bells_Price_Ranking": "N/A",
    "Nookazon_average_price_Bells": "N/A",
    "Nookazon_NMT_Price_Ranking": "N/A",
    "Nookazon_average_price_NMT": "N/A",
    "Poll_Ranking_2020": "N/A",
    "Poll_Ranking_2020_21": 252,
    "Total_Poll_Votes_2020": 0,
    "Total_Poll_Votes_2020_21": 389,
    "Poll_votes_May_2020": 0,
    "Poll_votes_June_2020": 0,
    "Poll_votes_July_2020": 0,
    "Poll_votes_August_2020": 0,
    "Poll_votes_September_2020": 0,
    "Poll_votes_October_2020": 0,
    "Poll_votes_November_2020": 0,
    "Poll_votes_December_2020": 0,
    "Poll_votes_January_2021": 0,
    "Poll_votes_February_2021": 0,
    "Poll_votes_March_2021": 181,
    "Poll_votes_April_2021": 208
  },
  {
    "name": "Gigi",
    "url": "https://nookipedia.com/wiki/Gigi",
    "alt_name": "",
    "skin_color": "a06fce",
    "text_color": "fffce9",
    "id": "flg16",
    "image_url": "https://dodo.ac/np/images/8/86/Gigi_NH.png",
    "species": "Frog",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "August",
    "birthday_day": 11,
    "sign": "Leo",
    "quote": "Look at the world through rose-colored glasses.",
    "phrase": "ribbette",
    "clothing": "Full-Length Dress with Pearls",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": [],
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 284,
    "Average_Popularity_Score": 246,
    "Nookazon_Bells_Price_Ranking": 35,
    "Nookazon_average_price_Bells": 335938,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 352,
    "Poll_Ranking_2020_21": 362,
    "Total_Poll_Votes_2020": 143,
    "Total_Poll_Votes_2020_21": 170,
    "Poll_votes_May_2020": 5,
    "Poll_votes_June_2020": 23,
    "Poll_votes_July_2020": 27,
    "Poll_votes_August_2020": 18,
    "Poll_votes_September_2020": 24,
    "Poll_votes_October_2020": 15,
    "Poll_votes_November_2020": 15,
    "Poll_votes_December_2020": 16,
    "Poll_votes_January_2021": 6,
    "Poll_votes_February_2021": 6,
    "Poll_votes_March_2021": 8,
    "Poll_votes_April_2021": 7
  },
  {
    "name": "Tucker",
    "url": "https://nookipedia.com/wiki/Tucker",
    "alt_name": "",
    "skin_color": "e8b010",
    "text_color": "fffce9",
    "id": "elp09",
    "image_url": "https://dodo.ac/np/images/7/7c/Tucker_NH.png",
    "species": "Elephant",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "September",
    "birthday_day": 7,
    "sign": "Virgo",
    "quote": "Time makes fossils of us all.",
    "phrase": "fuzzers",
    "clothing": "Caveman Tank",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 289,
    "Average_Popularity_Score": 250.5,
    "Nookazon_Bells_Price_Ranking": 153,
    "Nookazon_average_price_Bells": 177750,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 275,
    "Poll_Ranking_2020_21": 280,
    "Total_Poll_Votes_2020": 257,
    "Total_Poll_Votes_2020_21": 328,
    "Poll_votes_May_2020": 18,
    "Poll_votes_June_2020": 70,
    "Poll_votes_July_2020": 50,
    "Poll_votes_August_2020": 31,
    "Poll_votes_September_2020": 31,
    "Poll_votes_October_2020": 31,
    "Poll_votes_November_2020": 14,
    "Poll_votes_December_2020": 12,
    "Poll_votes_January_2021": 17,
    "Poll_votes_February_2021": 20,
    "Poll_votes_March_2021": 25,
    "Poll_votes_April_2021": 9
  },
  {
    "name": "Derwin",
    "url": "https://nookipedia.com/wiki/Derwin",
    "alt_name": "",
    "skin_color": "0961f6",
    "text_color": "fffce9",
    "id": "duk08",
    "image_url": "https://dodo.ac/np/images/9/98/Derwin_NH.png",
    "species": "Duck",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "May",
    "birthday_day": 25,
    "sign": "Gemini",
    "quote": "Everything in moderation. Except for snacks.",
    "phrase": "derrrr",
    "clothing": "Striped Tank",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.058823529,
    "Rarity": "0.17%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 287,
    "Average_Popularity_Score": 247.25,
    "Nookazon_Bells_Price_Ranking": 109,
    "Nookazon_average_price_Bells": 200000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 290,
    "Poll_Ranking_2020_21": 278,
    "Total_Poll_Votes_2020": 236,
    "Total_Poll_Votes_2020_21": 333,
    "Poll_votes_May_2020": 13,
    "Poll_votes_June_2020": 49,
    "Poll_votes_July_2020": 52,
    "Poll_votes_August_2020": 35,
    "Poll_votes_September_2020": 35,
    "Poll_votes_October_2020": 24,
    "Poll_votes_November_2020": 17,
    "Poll_votes_December_2020": 11,
    "Poll_votes_January_2021": 23,
    "Poll_votes_February_2021": 18,
    "Poll_votes_March_2021": 32,
    "Poll_votes_April_2021": 24
  },
  {
    "name": "Boris",
    "url": "https://nookipedia.com/wiki/Boris",
    "alt_name": "",
    "skin_color": "194c89",
    "text_color": "fffad4",
    "id": "pig09",
    "image_url": "https://dodo.ac/np/images/e/ef/Boris_NH.png",
    "species": "Pig",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "November",
    "birthday_day": 6,
    "sign": "Scorpio",
    "quote": "Life's short. Eat chocolate.",
    "phrase": "schnort",
    "clothing": "Desert Outfit",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Egyptian",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 275,
    "Average_Popularity_Score": 241.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 301,
    "Poll_Ranking_2020_21": 316,
    "Total_Poll_Votes_2020": 223,
    "Total_Poll_Votes_2020_21": 261,
    "Poll_votes_May_2020": 9,
    "Poll_votes_June_2020": 36,
    "Poll_votes_July_2020": 30,
    "Poll_votes_August_2020": 40,
    "Poll_votes_September_2020": 70,
    "Poll_votes_October_2020": 21,
    "Poll_votes_November_2020": 10,
    "Poll_votes_December_2020": 7,
    "Poll_votes_January_2021": 9,
    "Poll_votes_February_2021": 8,
    "Poll_votes_March_2021": 13,
    "Poll_votes_April_2021": 8
  },
  {
    "name": "Beardo",
    "url": "https://nookipedia.com/wiki/Beardo",
    "alt_name": "",
    "skin_color": "3fd8e0",
    "text_color": "fffce9",
    "id": "bea13",
    "image_url": "https://dodo.ac/np/images/c/c0/Beardo_NH.png",
    "species": "Bear",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "September",
    "birthday_day": 27,
    "sign": "Libra",
    "quote": "Fashion first!",
    "phrase": "whiskers",
    "clothing": "Tweed Jacket",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Office",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 268,
    "Average_Popularity_Score": 236.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 162,
    "Poll_Ranking_2020_21": 169,
    "Total_Poll_Votes_2020": 550,
    "Total_Poll_Votes_2020_21": 639,
    "Poll_votes_May_2020": 24,
    "Poll_votes_June_2020": 142,
    "Poll_votes_July_2020": 129,
    "Poll_votes_August_2020": 75,
    "Poll_votes_September_2020": 78,
    "Poll_votes_October_2020": 56,
    "Poll_votes_November_2020": 24,
    "Poll_votes_December_2020": 22,
    "Poll_votes_January_2021": 22,
    "Poll_votes_February_2021": 20,
    "Poll_votes_March_2021": 34,
    "Poll_votes_April_2021": 13
  },
  {
    "name": "Rex",
    "url": "https://nookipedia.com/wiki/Rex",
    "alt_name": "",
    "skin_color": "ffaa3b",
    "text_color": "874c25",
    "id": "lon02",
    "image_url": "https://dodo.ac/np/images/7/78/Rex_NH.png",
    "species": "Lion",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 24,
    "sign": "Leo",
    "quote": "Three wrongs don't make a right, but three rights make a left.",
    "phrase": "cool cat",
    "clothing": "Striped Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 284,
    "Average_Popularity_Score": 246,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 314,
    "Nookazon_average_price_NMT": 12,
    "Poll_Ranking_2020": 193,
    "Poll_Ranking_2020_21": 193,
    "Total_Poll_Votes_2020": 448,
    "Total_Poll_Votes_2020_21": 558,
    "Poll_votes_May_2020": 30,
    "Poll_votes_June_2020": 117,
    "Poll_votes_July_2020": 118,
    "Poll_votes_August_2020": 51,
    "Poll_votes_September_2020": 43,
    "Poll_votes_October_2020": 44,
    "Poll_votes_November_2020": 29,
    "Poll_votes_December_2020": 16,
    "Poll_votes_January_2021": 25,
    "Poll_votes_February_2021": 28,
    "Poll_votes_March_2021": 33,
    "Poll_votes_April_2021": 24
  },
  {
    "name": "Victoria",
    "url": "https://nookipedia.com/wiki/Victoria",
    "alt_name": "",
    "skin_color": "d8cc39",
    "text_color": "8b5f57",
    "id": "hrs01",
    "image_url": "https://dodo.ac/np/images/d/da/Victoria_NH.png",
    "species": "Horse",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "July",
    "birthday_day": 11,
    "sign": "Cancer",
    "quote": "Don't put the cart before the horse.",
    "phrase": "sugar cube",
    "clothing": "One-Ball Tee",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Gym",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 293,
    "Average_Popularity_Score": 255.25,
    "Nookazon_Bells_Price_Ranking": 130,
    "Nookazon_average_price_Bells": 187500,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 303,
    "Poll_Ranking_2020_21": 301,
    "Total_Poll_Votes_2020": 219,
    "Total_Poll_Votes_2020_21": 290,
    "Poll_votes_May_2020": 16,
    "Poll_votes_June_2020": 46,
    "Poll_votes_July_2020": 50,
    "Poll_votes_August_2020": 20,
    "Poll_votes_September_2020": 23,
    "Poll_votes_October_2020": 29,
    "Poll_votes_November_2020": 19,
    "Poll_votes_December_2020": 16,
    "Poll_votes_January_2021": 15,
    "Poll_votes_February_2021": 24,
    "Poll_votes_March_2021": 18,
    "Poll_votes_April_2021": 14
  },
  {
    "name": "Piper",
    "url": "https://nookipedia.com/wiki/Piper",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "brd05",
    "image_url": "https://dodo.ac/np/images/0/09/Piper_NH.png",
    "species": "Bird",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 18,
    "sign": "Aries",
    "quote": "Where there's life, there's hope.",
    "phrase": "chickadee",
    "clothing": "Lacy Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Modern",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 272,
    "Average_Popularity_Score": 240.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 177,
    "Poll_Ranking_2020_21": 177,
    "Total_Poll_Votes_2020": 493,
    "Total_Poll_Votes_2020_21": 609,
    "Poll_votes_May_2020": 43,
    "Poll_votes_June_2020": 140,
    "Poll_votes_July_2020": 123,
    "Poll_votes_August_2020": 52,
    "Poll_votes_September_2020": 43,
    "Poll_votes_October_2020": 43,
    "Poll_votes_November_2020": 26,
    "Poll_votes_December_2020": 23,
    "Poll_votes_January_2021": 28,
    "Poll_votes_February_2021": 33,
    "Poll_votes_March_2021": 29,
    "Poll_votes_April_2021": 26
  },
  {
    "name": "Groucho",
    "url": "https://nookipedia.com/wiki/Groucho",
    "alt_name": "",
    "skin_color": "194c89",
    "text_color": "fffad4",
    "id": "bea06",
    "image_url": "https://dodo.ac/np/images/1/1d/Groucho_NH.png",
    "species": "Bear",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 23,
    "sign": "Libra",
    "quote": "Rocky road is more than just a flavor of ice cream.",
    "phrase": "grumble",
    "clothing": "Dragon Jacket",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Grunge",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 300,
    "Average_Popularity_Score": 259.5,
    "Nookazon_Bells_Price_Ranking": 276,
    "Nookazon_average_price_Bells": 105000,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 286,
    "Poll_Ranking_2020_21": 289,
    "Total_Poll_Votes_2020": 242,
    "Total_Poll_Votes_2020_21": 307,
    "Poll_votes_May_2020": 18,
    "Poll_votes_June_2020": 52,
    "Poll_votes_July_2020": 59,
    "Poll_votes_August_2020": 25,
    "Poll_votes_September_2020": 19,
    "Poll_votes_October_2020": 31,
    "Poll_votes_November_2020": 27,
    "Poll_votes_December_2020": 11,
    "Poll_votes_January_2021": 18,
    "Poll_votes_February_2021": 19,
    "Poll_votes_March_2021": 15,
    "Poll_votes_April_2021": 13
  },
  {
    "name": "Boots",
    "url": "https://nookipedia.com/wiki/Boots",
    "alt_name": "",
    "skin_color": "0ca54a",
    "text_color": "fffce9",
    "id": "crd02",
    "image_url": "https://dodo.ac/np/images/3/3e/Boots_NH.png",
    "species": "Alligator",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 7,
    "sign": "Leo",
    "quote": "Strength lies in muscles.",
    "phrase": "munchie",
    "clothing": "Jester Costume",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 303,
    "Average_Popularity_Score": 262.25,
    "Nookazon_Bells_Price_Ranking": 255,
    "Nookazon_average_price_Bells": 123959,
    "Nookazon_NMT_Price_Ranking": 314,
    "Nookazon_average_price_NMT": 12,
    "Poll_Ranking_2020": 244,
    "Poll_Ranking_2020_21": 240,
    "Total_Poll_Votes_2020": 332,
    "Total_Poll_Votes_2020_21": 429,
    "Poll_votes_May_2020": 24,
    "Poll_votes_June_2020": 65,
    "Poll_votes_July_2020": 93,
    "Poll_votes_August_2020": 43,
    "Poll_votes_September_2020": 43,
    "Poll_votes_October_2020": 26,
    "Poll_votes_November_2020": 26,
    "Poll_votes_December_2020": 12,
    "Poll_votes_January_2021": 20,
    "Poll_votes_February_2021": 25,
    "Poll_votes_March_2021": 33,
    "Poll_votes_April_2021": 19
  },
  {
    "name": "Buck",
    "url": "https://nookipedia.com/wiki/Buck",
    "alt_name": "",
    "skin_color": 798040,
    "text_color": "fffad4",
    "id": "hrs00",
    "image_url": "https://dodo.ac/np/images/7/7f/Buck_NH.png",
    "species": "Horse",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "April",
    "birthday_day": 4,
    "sign": "Aries",
    "quote": "Keep your eyes on the prize.",
    "phrase": "pardner",
    "clothing": "Sweatshirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Normal",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 293,
    "Average_Popularity_Score": 255.25,
    "Nookazon_Bells_Price_Ranking": 247,
    "Nookazon_average_price_Bells": 131771,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 235,
    "Poll_Ranking_2020_21": 225,
    "Total_Poll_Votes_2020": 363,
    "Total_Poll_Votes_2020_21": 467,
    "Poll_votes_May_2020": 31,
    "Poll_votes_June_2020": 105,
    "Poll_votes_July_2020": 95,
    "Poll_votes_August_2020": 33,
    "Poll_votes_September_2020": 40,
    "Poll_votes_October_2020": 22,
    "Poll_votes_November_2020": 15,
    "Poll_votes_December_2020": 22,
    "Poll_votes_January_2021": 26,
    "Poll_votes_February_2021": 30,
    "Poll_votes_March_2021": 28,
    "Poll_votes_April_2021": 20
  },
  {
    "name": "Jambette",
    "url": "https://nookipedia.com/wiki/Jambette",
    "alt_name": "",
    "skin_color": "0ca54a",
    "text_color": "fffce9",
    "id": "flg13",
    "image_url": "https://dodo.ac/np/images/3/35/Jambette_NH.png",
    "species": "Frog",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "October",
    "birthday_day": 27,
    "sign": "Scorpio",
    "quote": "It takes more muscles to frown than smile.",
    "phrase": "croak-kay",
    "clothing": "Shell Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 303,
    "Average_Popularity_Score": 262.25,
    "Nookazon_Bells_Price_Ranking": 113,
    "Nookazon_average_price_Bells": 196875,
    "Nookazon_NMT_Price_Ranking": 314,
    "Nookazon_average_price_NMT": 12,
    "Poll_Ranking_2020": 311,
    "Poll_Ranking_2020_21": 311,
    "Total_Poll_Votes_2020": 207,
    "Total_Poll_Votes_2020_21": 272,
    "Poll_votes_May_2020": 15,
    "Poll_votes_June_2020": 42,
    "Poll_votes_July_2020": 38,
    "Poll_votes_August_2020": 30,
    "Poll_votes_September_2020": 38,
    "Poll_votes_October_2020": 24,
    "Poll_votes_November_2020": 14,
    "Poll_votes_December_2020": 6,
    "Poll_votes_January_2021": 14,
    "Poll_votes_February_2021": 16,
    "Poll_votes_March_2021": 22,
    "Poll_votes_April_2021": 13
  },
  {
    "name": "Graham",
    "url": "https://nookipedia.com/wiki/Graham",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "ham02",
    "image_url": "https://dodo.ac/np/images/a/a1/Graham_NH.png",
    "species": "Hamster",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 20,
    "sign": "Gemini",
    "quote": "Knowledge is power.",
    "phrase": "indeed",
    "clothing": "Madras Plaid Shirt",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "High-Tech",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 288,
    "Average_Popularity_Score": 250.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 279,
    "Nookazon_average_price_NMT": 14,
    "Poll_Ranking_2020": 208,
    "Poll_Ranking_2020_21": 219,
    "Total_Poll_Votes_2020": 415,
    "Total_Poll_Votes_2020_21": 486,
    "Poll_votes_May_2020": 25,
    "Poll_votes_June_2020": 101,
    "Poll_votes_July_2020": 85,
    "Poll_votes_August_2020": 51,
    "Poll_votes_September_2020": 48,
    "Poll_votes_October_2020": 49,
    "Poll_votes_November_2020": 30,
    "Poll_votes_December_2020": 26,
    "Poll_votes_January_2021": 16,
    "Poll_votes_February_2021": 16,
    "Poll_votes_March_2021": 22,
    "Poll_votes_April_2021": 17
  },
  {
    "name": "Knox",
    "url": "https://nookipedia.com/wiki/Knox",
    "alt_name": "",
    "skin_color": "d8cc39",
    "text_color": "8b5f57",
    "id": "chn11",
    "image_url": "https://dodo.ac/np/images/0/03/Knox_NH.png",
    "species": "Chicken",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "November",
    "birthday_day": 23,
    "sign": "Sagittarius",
    "quote": "A chicken's coop is its castle.",
    "phrase": "cluckling",
    "clothing": "Cavalier Shirt",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": [],
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Opulent",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 297,
    "Average_Popularity_Score": 258,
    "Nookazon_Bells_Price_Ranking": 227,
    "Nookazon_average_price_Bells": 139375,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 274,
    "Poll_Ranking_2020_21": 290,
    "Total_Poll_Votes_2020": 260,
    "Total_Poll_Votes_2020_21": 305,
    "Poll_votes_May_2020": 25,
    "Poll_votes_June_2020": 66,
    "Poll_votes_July_2020": 64,
    "Poll_votes_August_2020": 30,
    "Poll_votes_September_2020": 22,
    "Poll_votes_October_2020": 17,
    "Poll_votes_November_2020": 21,
    "Poll_votes_December_2020": 15,
    "Poll_votes_January_2021": 13,
    "Poll_votes_February_2021": 7,
    "Poll_votes_March_2021": 13,
    "Poll_votes_April_2021": 12
  },
  {
    "name": "Norma",
    "url": "https://nookipedia.com/wiki/Norma",
    "alt_name": "",
    "skin_color": "f2bdc7",
    "text_color": "634b4b",
    "id": "cow06",
    "image_url": "https://dodo.ac/np/images/e/e7/Norma_NH.png",
    "species": "Cow",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "September",
    "birthday_day": 20,
    "sign": "Virgo",
    "quote": "If you want what you have, then you'll have what you want.",
    "phrase": "hoof hoo",
    "clothing": "Plaid-Print Dress",
    "islander": "TRUE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.25,
    "Rarity": "0.71%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 279,
    "Average_Popularity_Score": 244.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 199,
    "Poll_Ranking_2020_21": 185,
    "Total_Poll_Votes_2020": 438,
    "Total_Poll_Votes_2020_21": 580,
    "Poll_votes_May_2020": 20,
    "Poll_votes_June_2020": 121,
    "Poll_votes_July_2020": 110,
    "Poll_votes_August_2020": 52,
    "Poll_votes_September_2020": 43,
    "Poll_votes_October_2020": 39,
    "Poll_votes_November_2020": 24,
    "Poll_votes_December_2020": 29,
    "Poll_votes_January_2021": 40,
    "Poll_votes_February_2021": 38,
    "Poll_votes_March_2021": 38,
    "Poll_votes_April_2021": 26
  },
  {
    "name": "Rizzo",
    "url": "https://nookipedia.com/wiki/Rizzo",
    "alt_name": "",
    "skin_color": "8bcdea",
    "text_color": "fffad4",
    "id": "mus09",
    "image_url": "https://dodo.ac/np/images/6/69/Rizzo_NH.png",
    "species": "Mouse",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "January",
    "birthday_day": 17,
    "sign": "Capricorn",
    "quote": "Evil lurks everywhere.",
    "phrase": "squee",
    "clothing": "Ninja Costume",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Asian",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 309,
    "Average_Popularity_Score": 264.75,
    "Nookazon_Bells_Price_Ranking": 10,
    "Nookazon_average_price_Bells": 500000,
    "Nookazon_NMT_Price_Ranking": 279,
    "Nookazon_average_price_NMT": 14,
    "Poll_Ranking_2020": 373,
    "Poll_Ranking_2020_21": 385,
    "Total_Poll_Votes_2020": 125,
    "Total_Poll_Votes_2020_21": 148,
    "Poll_votes_May_2020": 5,
    "Poll_votes_June_2020": 21,
    "Poll_votes_July_2020": 29,
    "Poll_votes_August_2020": 30,
    "Poll_votes_September_2020": 19,
    "Poll_votes_October_2020": 8,
    "Poll_votes_November_2020": 7,
    "Poll_votes_December_2020": 6,
    "Poll_votes_January_2021": 7,
    "Poll_votes_February_2021": 5,
    "Poll_votes_March_2021": 5,
    "Poll_votes_April_2021": 6
  },
  {
    "name": "Bertha",
    "url": "https://nookipedia.com/wiki/Bertha",
    "alt_name": "",
    "skin_color": "00d1bd",
    "text_color": "fffce9",
    "id": "hip03",
    "image_url": "https://dodo.ac/np/images/a/a7/Bertha_NH.png",
    "species": "Hippo",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 25,
    "sign": "Taurus",
    "quote": "The best part of spring is the picnics!",
    "phrase": "bloop",
    "clothing": "Pintuck-Pleated Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Flowery",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 282,
    "Average_Popularity_Score": 245.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 184,
    "Poll_Ranking_2020_21": 187,
    "Total_Poll_Votes_2020": 471,
    "Total_Poll_Votes_2020_21": 569,
    "Poll_votes_May_2020": 33,
    "Poll_votes_June_2020": 112,
    "Poll_votes_July_2020": 131,
    "Poll_votes_August_2020": 56,
    "Poll_votes_September_2020": 70,
    "Poll_votes_October_2020": 33,
    "Poll_votes_November_2020": 18,
    "Poll_votes_December_2020": 18,
    "Poll_votes_January_2021": 26,
    "Poll_votes_February_2021": 23,
    "Poll_votes_March_2021": 30,
    "Poll_votes_April_2021": 19
  },
  {
    "name": "Rowan",
    "url": "https://nookipedia.com/wiki/Rowan",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "tig01",
    "image_url": "https://dodo.ac/np/images/7/7c/Rowan_NH_Transparent.png",
    "species": "Tiger",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 26,
    "sign": "Virgo",
    "quote": "Refuse to lose.",
    "phrase": "mango",
    "clothing": "Simple-Dots Tee",
    "islander": "TRUE",
    "debut": "AC",
    "prev_phrases": [],
    "appearances": "['AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Asian",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 305,
    "Average_Popularity_Score": 262.75,
    "Nookazon_Bells_Price_Ranking": 251,
    "Nookazon_average_price_Bells": 125000,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 295,
    "Poll_Ranking_2020_21": 308,
    "Total_Poll_Votes_2020": 228,
    "Total_Poll_Votes_2020_21": 274,
    "Poll_votes_May_2020": 13,
    "Poll_votes_June_2020": 68,
    "Poll_votes_July_2020": 49,
    "Poll_votes_August_2020": 43,
    "Poll_votes_September_2020": 21,
    "Poll_votes_October_2020": 14,
    "Poll_votes_November_2020": 14,
    "Poll_votes_December_2020": 6,
    "Poll_votes_January_2021": 14,
    "Poll_votes_February_2021": 9,
    "Poll_votes_March_2021": 11,
    "Poll_votes_April_2021": 12
  },
  {
    "name": "Kitt",
    "url": "https://nookipedia.com/wiki/Kitt",
    "alt_name": "",
    "skin_color": "c0ab72",
    "text_color": "fffce9",
    "id": "kgr00",
    "image_url": "https://dodo.ac/np/images/7/75/Kitt_NH.png",
    "species": "Kangaroo",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "October",
    "birthday_day": 11,
    "sign": "Libra",
    "quote": "Funny parents have funny kids.",
    "phrase": "child",
    "clothing": "Striped Halter Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Colorful",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 299,
    "Average_Popularity_Score": 258.75,
    "Nookazon_Bells_Price_Ranking": 147,
    "Nookazon_average_price_Bells": 184375,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 299,
    "Poll_Ranking_2020_21": 282,
    "Total_Poll_Votes_2020": 225,
    "Total_Poll_Votes_2020_21": 320,
    "Poll_votes_May_2020": 16,
    "Poll_votes_June_2020": 54,
    "Poll_votes_July_2020": 50,
    "Poll_votes_August_2020": 26,
    "Poll_votes_September_2020": 34,
    "Poll_votes_October_2020": 20,
    "Poll_votes_November_2020": 14,
    "Poll_votes_December_2020": 11,
    "Poll_votes_January_2021": 31,
    "Poll_votes_February_2021": 27,
    "Poll_votes_March_2021": 17,
    "Poll_votes_April_2021": 20
  },
  {
    "name": "Diva",
    "url": "https://nookipedia.com/wiki/Diva",
    "alt_name": "",
    "skin_color": "a06fce",
    "text_color": "fffce9",
    "id": "flg18",
    "image_url": "https://dodo.ac/np/images/4/44/Diva_NH.png",
    "species": "Frog",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "October",
    "birthday_day": 2,
    "sign": "Libra",
    "quote": "Eyes are the windows to the soul.",
    "phrase": "ya know",
    "clothing": "Palatial Tank Dress",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Egyptian",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 284,
    "Average_Popularity_Score": 246,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 183,
    "Poll_Ranking_2020_21": 188,
    "Total_Poll_Votes_2020": 474,
    "Total_Poll_Votes_2020_21": 568,
    "Poll_votes_May_2020": 22,
    "Poll_votes_June_2020": 142,
    "Poll_votes_July_2020": 107,
    "Poll_votes_August_2020": 51,
    "Poll_votes_September_2020": 59,
    "Poll_votes_October_2020": 34,
    "Poll_votes_November_2020": 36,
    "Poll_votes_December_2020": 23,
    "Poll_votes_January_2021": 26,
    "Poll_votes_February_2021": 23,
    "Poll_votes_March_2021": 29,
    "Poll_votes_April_2021": 16
  },
  {
    "name": "Winnie",
    "url": "https://nookipedia.com/wiki/Winnie",
    "alt_name": "",
    "skin_color": "c0ab72",
    "text_color": "fffce9",
    "id": "hrs05",
    "image_url": "https://dodo.ac/np/images/b/b8/Winnie_NH.png",
    "species": "Horse",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 31,
    "sign": "Aquarius",
    "quote": "Smile, and the world smiles with you.",
    "phrase": "hay-OK",
    "clothing": "Faux-Hair Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 312,
    "Average_Popularity_Score": 265.5,
    "Nookazon_Bells_Price_Ranking": 259,
    "Nookazon_average_price_Bells": 116667,
    "Nookazon_NMT_Price_Ranking": 209,
    "Nookazon_average_price_NMT": 17,
    "Poll_Ranking_2020": 305,
    "Poll_Ranking_2020_21": 297,
    "Total_Poll_Votes_2020": 217,
    "Total_Poll_Votes_2020_21": 298,
    "Poll_votes_May_2020": 17,
    "Poll_votes_June_2020": 58,
    "Poll_votes_July_2020": 45,
    "Poll_votes_August_2020": 28,
    "Poll_votes_September_2020": 20,
    "Poll_votes_October_2020": 18,
    "Poll_votes_November_2020": 20,
    "Poll_votes_December_2020": 11,
    "Poll_votes_January_2021": 17,
    "Poll_votes_February_2021": 21,
    "Poll_votes_March_2021": 22,
    "Poll_votes_April_2021": 21
  },
  {
    "name": "Chow",
    "url": "https://nookipedia.com/wiki/Chow",
    "alt_name": "",
    "skin_color": "f2bdc7",
    "text_color": "634b4b",
    "id": "bea03",
    "image_url": "https://dodo.ac/np/images/d/d1/Chow_NH.png",
    "species": "Bear",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 22,
    "sign": "Cancer",
    "quote": "All good things must come to an end.",
    "phrase": "aiya",
    "clothing": "Gold-Print Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Bamboo",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 298,
    "Average_Popularity_Score": 258.5,
    "Nookazon_Bells_Price_Ranking": 234,
    "Nookazon_average_price_Bells": 134375,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 345,
    "Poll_Ranking_2020_21": 348,
    "Total_Poll_Votes_2020": 151,
    "Total_Poll_Votes_2020_21": 195,
    "Poll_votes_May_2020": 8,
    "Poll_votes_June_2020": 28,
    "Poll_votes_July_2020": 41,
    "Poll_votes_August_2020": 19,
    "Poll_votes_September_2020": 15,
    "Poll_votes_October_2020": 16,
    "Poll_votes_November_2020": 13,
    "Poll_votes_December_2020": 11,
    "Poll_votes_January_2021": 6,
    "Poll_votes_February_2021": 3,
    "Poll_votes_March_2021": 25,
    "Poll_votes_April_2021": 10
  },
  {
    "name": "Mathilda",
    "url": "https://nookipedia.com/wiki/Mathilda",
    "alt_name": "",
    "skin_color": 515151,
    "text_color": "fffce9",
    "id": "kgr01",
    "image_url": "https://dodo.ac/np/images/5/58/Mathilda_NH.png",
    "species": "Kangaroo",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "November",
    "birthday_day": 12,
    "sign": "Scorpio",
    "quote": "Nail polish is thicker than water.",
    "phrase": "wee baby",
    "clothing": "Sleeveless Sweater Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 282,
    "Average_Popularity_Score": 245.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 302,
    "Poll_Ranking_2020_21": 297,
    "Total_Poll_Votes_2020": 219,
    "Total_Poll_Votes_2020_21": 298,
    "Poll_votes_May_2020": 13,
    "Poll_votes_June_2020": 44,
    "Poll_votes_July_2020": 46,
    "Poll_votes_August_2020": 25,
    "Poll_votes_September_2020": 24,
    "Poll_votes_October_2020": 28,
    "Poll_votes_November_2020": 21,
    "Poll_votes_December_2020": 18,
    "Poll_votes_January_2021": 12,
    "Poll_votes_February_2021": 24,
    "Poll_votes_March_2021": 21,
    "Poll_votes_April_2021": 22
  },
  {
    "name": "Curt",
    "url": "https://nookipedia.com/wiki/Curt",
    "alt_name": "",
    "skin_color": 515151,
    "text_color": "fffce9",
    "id": "bea02",
    "image_url": "https://dodo.ac/np/images/2/27/Curt_NH.png",
    "species": "Bear",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 1,
    "sign": "Cancer",
    "quote": "A Bell saved is a Bell earned.",
    "phrase": "fuzzball",
    "clothing": "MVP Tee",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 301,
    "Average_Popularity_Score": 260,
    "Nookazon_Bells_Price_Ranking": 235,
    "Nookazon_average_price_Bells": 133334,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 280,
    "Poll_Ranking_2020_21": 290,
    "Total_Poll_Votes_2020": 250,
    "Total_Poll_Votes_2020_21": 305,
    "Poll_votes_May_2020": 16,
    "Poll_votes_June_2020": 53,
    "Poll_votes_July_2020": 62,
    "Poll_votes_August_2020": 33,
    "Poll_votes_September_2020": 39,
    "Poll_votes_October_2020": 20,
    "Poll_votes_November_2020": 14,
    "Poll_votes_December_2020": 13,
    "Poll_votes_January_2021": 10,
    "Poll_votes_February_2021": 15,
    "Poll_votes_March_2021": 17,
    "Poll_votes_April_2021": 13
  },
  {
    "name": "Peggy",
    "url": "https://nookipedia.com/wiki/Peggy",
    "alt_name": "",
    "skin_color": "e4b887",
    "text_color": "fffce9",
    "id": "pig11",
    "image_url": "https://dodo.ac/np/images/2/28/Peggy_NH.png",
    "species": "Pig",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "May",
    "birthday_day": 23,
    "sign": "Gemini",
    "quote": "We're all diamonds in the rough.",
    "phrase": "shweetie",
    "clothing": "Aran-Knit Sweater",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Cute",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 311,
    "Average_Popularity_Score": 265.25,
    "Nookazon_Bells_Price_Ranking": 130,
    "Nookazon_average_price_Bells": 187500,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 320,
    "Poll_Ranking_2020_21": 321,
    "Total_Poll_Votes_2020": 189,
    "Total_Poll_Votes_2020_21": 244,
    "Poll_votes_May_2020": 11,
    "Poll_votes_June_2020": 48,
    "Poll_votes_July_2020": 41,
    "Poll_votes_August_2020": 23,
    "Poll_votes_September_2020": 21,
    "Poll_votes_October_2020": 16,
    "Poll_votes_November_2020": 12,
    "Poll_votes_December_2020": 17,
    "Poll_votes_January_2021": 12,
    "Poll_votes_February_2021": 17,
    "Poll_votes_March_2021": 16,
    "Poll_votes_April_2021": 10
  },
  {
    "name": "T-Bone",
    "url": "https://nookipedia.com/wiki/T-Bone",
    "alt_name": "",
    "skin_color": "acc8cf",
    "text_color": 498992,
    "id": "bul05",
    "image_url": "https://dodo.ac/np/images/e/e0/T-Bone_NH.png",
    "species": "Bull",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "May",
    "birthday_day": 20,
    "sign": "Taurus",
    "quote": "Don't have a cow.",
    "phrase": "moocher",
    "clothing": "Hanten Jacket",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.166666667,
    "Rarity": "0.48%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 314,
    "Average_Popularity_Score": 266.5,
    "Nookazon_Bells_Price_Ranking": 33,
    "Nookazon_average_price_Bells": 354167,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 379,
    "Poll_Ranking_2020_21": 372,
    "Total_Poll_Votes_2020": 117,
    "Total_Poll_Votes_2020_21": 158,
    "Poll_votes_May_2020": 2,
    "Poll_votes_June_2020": 22,
    "Poll_votes_July_2020": 22,
    "Poll_votes_August_2020": 16,
    "Poll_votes_September_2020": 20,
    "Poll_votes_October_2020": 13,
    "Poll_votes_November_2020": 13,
    "Poll_votes_December_2020": 9,
    "Poll_votes_January_2021": 12,
    "Poll_votes_February_2021": 5,
    "Poll_votes_March_2021": 12,
    "Poll_votes_April_2021": 12
  },
  {
    "name": "Rocco",
    "url": "https://nookipedia.com/wiki/Rocco",
    "alt_name": "",
    "skin_color": "87e0a9",
    "text_color": 219479,
    "id": "hip00",
    "image_url": "https://dodo.ac/np/images/0/02/Rocco_NH.png",
    "species": "Hippo",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 18,
    "sign": "Leo",
    "quote": "The only thing to fear is fear itself... and wasps!",
    "phrase": "hippie",
    "clothing": "Danger Tank",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Road",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 306,
    "Average_Popularity_Score": 263,
    "Nookazon_Bells_Price_Ranking": 83,
    "Nookazon_average_price_Bells": 233334,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 368,
    "Poll_Ranking_2020_21": 372,
    "Total_Poll_Votes_2020": 127,
    "Total_Poll_Votes_2020_21": 158,
    "Poll_votes_May_2020": 7,
    "Poll_votes_June_2020": 27,
    "Poll_votes_July_2020": 30,
    "Poll_votes_August_2020": 26,
    "Poll_votes_September_2020": 13,
    "Poll_votes_October_2020": 11,
    "Poll_votes_November_2020": 6,
    "Poll_votes_December_2020": 7,
    "Poll_votes_January_2021": 4,
    "Poll_votes_February_2021": 11,
    "Poll_votes_March_2021": 7,
    "Poll_votes_April_2021": 9
  },
  {
    "name": "Elmer",
    "url": "https://nookipedia.com/wiki/Elmer",
    "alt_name": "",
    "skin_color": "d86808",
    "text_color": "fffce9",
    "id": "hrs03",
    "image_url": "https://dodo.ac/np/images/6/60/Elmer_NH.png",
    "species": "Horse",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 5,
    "sign": "Libra",
    "quote": "The horse doesn't pull the cart, the oats do.",
    "phrase": "tenderfoot",
    "clothing": "Boa Fleece",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 307,
    "Average_Popularity_Score": 263.25,
    "Nookazon_Bells_Price_Ranking": 216,
    "Nookazon_average_price_Bells": 143750,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 298,
    "Poll_Ranking_2020_21": 306,
    "Total_Poll_Votes_2020": 225,
    "Total_Poll_Votes_2020_21": 279,
    "Poll_votes_May_2020": 13,
    "Poll_votes_June_2020": 58,
    "Poll_votes_July_2020": 51,
    "Poll_votes_August_2020": 30,
    "Poll_votes_September_2020": 29,
    "Poll_votes_October_2020": 19,
    "Poll_votes_November_2020": 12,
    "Poll_votes_December_2020": 13,
    "Poll_votes_January_2021": 11,
    "Poll_votes_February_2021": 14,
    "Poll_votes_March_2021": 19,
    "Poll_votes_April_2021": 10
  },
  {
    "name": "Axel",
    "url": "https://nookipedia.com/wiki/Axel",
    "alt_name": "",
    "skin_color": "459aba",
    "text_color": "fffce9",
    "id": "elp06",
    "image_url": "https://dodo.ac/np/images/0/09/Axel_NH.png",
    "species": "Elephant",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "March",
    "birthday_day": 23,
    "sign": "Aries",
    "quote": "Do not compare a fly with an elephant.",
    "phrase": "WHONK",
    "clothing": "Kanji Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Toys",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 1,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 289,
    "Average_Popularity_Score": 250.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 187,
    "Poll_Ranking_2020_21": 197,
    "Total_Poll_Votes_2020": 461,
    "Total_Poll_Votes_2020_21": 545,
    "Poll_votes_May_2020": 29,
    "Poll_votes_June_2020": 107,
    "Poll_votes_July_2020": 126,
    "Poll_votes_August_2020": 74,
    "Poll_votes_September_2020": 51,
    "Poll_votes_October_2020": 34,
    "Poll_votes_November_2020": 23,
    "Poll_votes_December_2020": 17,
    "Poll_votes_January_2021": 22,
    "Poll_votes_February_2021": 17,
    "Poll_votes_March_2021": 25,
    "Poll_votes_April_2021": 20
  },
  {
    "name": "Frobert",
    "url": "https://nookipedia.com/wiki/Frobert",
    "alt_name": "",
    "skin_color": "87e0a9",
    "text_color": 219479,
    "id": "flg02",
    "image_url": "https://dodo.ac/np/images/3/3b/Frobert_NH.png",
    "species": "Frog",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "February",
    "birthday_day": 8,
    "sign": "Aquarius",
    "quote": "Always aim high!",
    "phrase": "fribbit",
    "clothing": "Striped Tee",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Toys",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 1,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 289,
    "Average_Popularity_Score": 250.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 296,
    "Poll_Ranking_2020_21": 307,
    "Total_Poll_Votes_2020": 227,
    "Total_Poll_Votes_2020_21": 278,
    "Poll_votes_May_2020": 11,
    "Poll_votes_June_2020": 50,
    "Poll_votes_July_2020": 52,
    "Poll_votes_August_2020": 29,
    "Poll_votes_September_2020": 25,
    "Poll_votes_October_2020": 31,
    "Poll_votes_November_2020": 16,
    "Poll_votes_December_2020": 13,
    "Poll_votes_January_2021": 12,
    "Poll_votes_February_2021": 11,
    "Poll_votes_March_2021": 13,
    "Poll_votes_April_2021": 15
  },
  {
    "name": "Mott",
    "url": "https://nookipedia.com/wiki/Mott",
    "alt_name": "",
    "skin_color": "d8cc39",
    "text_color": "8b5f57",
    "id": "lon06",
    "image_url": "https://dodo.ac/np/images/b/b8/Mott_NH.png",
    "species": "Lion",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 10,
    "sign": "Cancer",
    "quote": "The lion's share goes to the lion.",
    "phrase": "cagey",
    "clothing": "College Cardigan",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": [],
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Normal",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 321,
    "Average_Popularity_Score": 269.75,
    "Nookazon_Bells_Price_Ranking": 46,
    "Nookazon_average_price_Bells": 326875,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 363,
    "Poll_Ranking_2020_21": 372,
    "Total_Poll_Votes_2020": 131,
    "Total_Poll_Votes_2020_21": 158,
    "Poll_votes_May_2020": 10,
    "Poll_votes_June_2020": 35,
    "Poll_votes_July_2020": 28,
    "Poll_votes_August_2020": 23,
    "Poll_votes_September_2020": 11,
    "Poll_votes_October_2020": 11,
    "Poll_votes_November_2020": 7,
    "Poll_votes_December_2020": 6,
    "Poll_votes_January_2021": 3,
    "Poll_votes_February_2021": 10,
    "Poll_votes_March_2021": 9,
    "Poll_votes_April_2021": 5
  },
  {
    "name": "Big Top",
    "url": "https://nookipedia.com/wiki/Big_Top",
    "alt_name": "",
    "skin_color": "78dd62",
    "text_color": "28665a",
    "id": "elp02",
    "image_url": "https://dodo.ac/np/images/8/80/Big_Top_NH.png",
    "species": "Elephant",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 3,
    "sign": "Libra",
    "quote": "A big nose never spoiled a handsome face.",
    "phrase": "villain",
    "clothing": "No. 3 Shirt",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Gym",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 318,
    "Average_Popularity_Score": 267.75,
    "Nookazon_Bells_Price_Ranking": 278,
    "Nookazon_average_price_Bells": 103125,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 293,
    "Poll_Ranking_2020_21": 284,
    "Total_Poll_Votes_2020": 233,
    "Total_Poll_Votes_2020_21": 314,
    "Poll_votes_May_2020": 7,
    "Poll_votes_June_2020": 65,
    "Poll_votes_July_2020": 49,
    "Poll_votes_August_2020": 37,
    "Poll_votes_September_2020": 33,
    "Poll_votes_October_2020": 19,
    "Poll_votes_November_2020": 12,
    "Poll_votes_December_2020": 11,
    "Poll_votes_January_2021": 23,
    "Poll_votes_February_2021": 21,
    "Poll_votes_March_2021": 16,
    "Poll_votes_April_2021": 21
  },
  {
    "name": "Plucky",
    "url": "https://nookipedia.com/wiki/Plucky",
    "alt_name": "",
    "skin_color": "7c6559",
    "text_color": "eac113",
    "id": "chn10",
    "image_url": "https://dodo.ac/np/images/6/63/Plucky_NH.png",
    "species": "Chicken",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "October",
    "birthday_day": 12,
    "sign": "Libra",
    "quote": "Keep your crumbs out of the bed.",
    "phrase": "chicky-poo",
    "clothing": "Bold Muumuu",
    "islander": "TRUE",
    "debut": "AC",
    "prev_phrases": [],
    "appearances": "['AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Beach",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 295,
    "Average_Popularity_Score": 255.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 255,
    "Poll_Ranking_2020_21": 257,
    "Total_Poll_Votes_2020": 312,
    "Total_Poll_Votes_2020_21": 384,
    "Poll_votes_May_2020": 30,
    "Poll_votes_June_2020": 87,
    "Poll_votes_July_2020": 83,
    "Poll_votes_August_2020": 32,
    "Poll_votes_September_2020": 26,
    "Poll_votes_October_2020": 19,
    "Poll_votes_November_2020": 19,
    "Poll_votes_December_2020": 16,
    "Poll_votes_January_2021": 21,
    "Poll_votes_February_2021": 20,
    "Poll_votes_March_2021": 18,
    "Poll_votes_April_2021": 13
  },
  {
    "name": "Broffina",
    "url": "https://nookipedia.com/wiki/Broffina",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "chn12",
    "image_url": "https://dodo.ac/np/images/7/7a/Broffina_NH.png",
    "species": "Chicken",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "October",
    "birthday_day": 24,
    "sign": "Scorpio",
    "quote": "Don't peck the hand that feeds you.",
    "phrase": "cluckadoo",
    "clothing": "Rumba Dress",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 319,
    "Average_Popularity_Score": 269,
    "Nookazon_Bells_Price_Ranking": 68,
    "Nookazon_average_price_Bells": 254688,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 336,
    "Poll_Ranking_2020_21": 342,
    "Total_Poll_Votes_2020": 161,
    "Total_Poll_Votes_2020_21": 201,
    "Poll_votes_May_2020": 1,
    "Poll_votes_June_2020": 27,
    "Poll_votes_July_2020": 27,
    "Poll_votes_August_2020": 13,
    "Poll_votes_September_2020": 17,
    "Poll_votes_October_2020": 7,
    "Poll_votes_November_2020": 39,
    "Poll_votes_December_2020": 30,
    "Poll_votes_January_2021": 11,
    "Poll_votes_February_2021": 7,
    "Poll_votes_March_2021": 15,
    "Poll_votes_April_2021": 7
  },
  {
    "name": "Drift",
    "url": "https://nookipedia.com/wiki/Drift",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "flg04",
    "image_url": "https://dodo.ac/np/images/a/ac/Drift_NH.png",
    "species": "Frog",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 9,
    "sign": "Libra",
    "quote": "Always go for the gold!",
    "phrase": "dribbit",
    "clothing": "Six-Ball Tee",
    "islander": "TRUE",
    "debut": "AC",
    "prev_phrases": "['brah']",
    "appearances": "['AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Metal",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 1,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 296,
    "Average_Popularity_Score": 256.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 277,
    "Poll_Ranking_2020_21": 259,
    "Total_Poll_Votes_2020": 254,
    "Total_Poll_Votes_2020_21": 380,
    "Poll_votes_May_2020": 11,
    "Poll_votes_June_2020": 59,
    "Poll_votes_July_2020": 60,
    "Poll_votes_August_2020": 31,
    "Poll_votes_September_2020": 35,
    "Poll_votes_October_2020": 25,
    "Poll_votes_November_2020": 17,
    "Poll_votes_December_2020": 16,
    "Poll_votes_January_2021": 23,
    "Poll_votes_February_2021": 35,
    "Poll_votes_March_2021": 33,
    "Poll_votes_April_2021": 35
  },
  {
    "name": "Rocket",
    "url": "https://nookipedia.com/wiki/Rocket",
    "alt_name": "",
    "skin_color": "f993ce",
    "text_color": "fffce9",
    "id": "gor09",
    "image_url": "https://dodo.ac/np/images/5/58/Rocket_NH.png",
    "species": "Gorilla",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 14,
    "sign": "Aries",
    "quote": "Art feeds the soul. So does pizza.",
    "phrase": "vroom",
    "clothing": "No. 4 Shirt",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Gym",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 316,
    "Average_Popularity_Score": 267.5,
    "Nookazon_Bells_Price_Ranking": 130,
    "Nookazon_average_price_Bells": 187500,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 307,
    "Poll_Ranking_2020_21": 308,
    "Total_Poll_Votes_2020": 214,
    "Total_Poll_Votes_2020_21": 274,
    "Poll_votes_May_2020": 14,
    "Poll_votes_June_2020": 51,
    "Poll_votes_July_2020": 51,
    "Poll_votes_August_2020": 29,
    "Poll_votes_September_2020": 15,
    "Poll_votes_October_2020": 23,
    "Poll_votes_November_2020": 9,
    "Poll_votes_December_2020": 22,
    "Poll_votes_January_2021": 20,
    "Poll_votes_February_2021": 14,
    "Poll_votes_March_2021": 12,
    "Poll_votes_April_2021": 14
  },
  {
    "name": "Becky",
    "url": "https://nookipedia.com/wiki/Becky",
    "alt_name": "",
    "skin_color": "a06fce",
    "text_color": "fffce9",
    "id": "chn09",
    "image_url": "https://dodo.ac/np/images/7/74/Becky_NH.png",
    "species": "Chicken",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "December",
    "birthday_day": 9,
    "sign": "Sagittarius",
    "quote": "A fool and his Bells are soon parted.",
    "phrase": "chicklet",
    "clothing": "Renaissance Dress",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Music room",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 322,
    "Average_Popularity_Score": 271.5,
    "Nookazon_Bells_Price_Ranking": 95,
    "Nookazon_average_price_Bells": 203125,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 374,
    "Poll_Ranking_2020_21": 383,
    "Total_Poll_Votes_2020": 123,
    "Total_Poll_Votes_2020_21": 149,
    "Poll_votes_May_2020": 5,
    "Poll_votes_June_2020": 18,
    "Poll_votes_July_2020": 44,
    "Poll_votes_August_2020": 17,
    "Poll_votes_September_2020": 12,
    "Poll_votes_October_2020": 14,
    "Poll_votes_November_2020": 6,
    "Poll_votes_December_2020": 7,
    "Poll_votes_January_2021": 6,
    "Poll_votes_February_2021": 5,
    "Poll_votes_March_2021": 9,
    "Poll_votes_April_2021": 6
  },
  {
    "name": "Boyd",
    "url": "https://nookipedia.com/wiki/Boyd",
    "alt_name": "",
    "skin_color": "7a2500",
    "text_color": "fffce9",
    "id": "gor05",
    "image_url": "https://dodo.ac/np/images/2/21/Boyd_NH.png",
    "species": "Gorilla",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 1,
    "sign": "Libra",
    "quote": "There's always time to take a second look.",
    "phrase": "uh-oh",
    "clothing": "Three-Ball Tee",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Road",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 328,
    "Average_Popularity_Score": 276,
    "Nookazon_Bells_Price_Ranking": 29,
    "Nookazon_average_price_Bells": 371094,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 391,
    "Poll_Ranking_2020_21": 393,
    "Total_Poll_Votes_2020": 86,
    "Total_Poll_Votes_2020_21": 125,
    "Poll_votes_May_2020": 1,
    "Poll_votes_June_2020": 25,
    "Poll_votes_July_2020": 17,
    "Poll_votes_August_2020": 16,
    "Poll_votes_September_2020": 3,
    "Poll_votes_October_2020": 12,
    "Poll_votes_November_2020": 9,
    "Poll_votes_December_2020": 3,
    "Poll_votes_January_2021": 4,
    "Poll_votes_February_2021": 8,
    "Poll_votes_March_2021": 17,
    "Poll_votes_April_2021": 10
  },
  {
    "name": "Keaton",
    "url": "https://nookipedia.com/wiki/Keaton",
    "alt_name": "",
    "skin_color": "3fd8e0",
    "text_color": "fffce9",
    "id": "pbr08",
    "image_url": "https://dodo.ac/np/images/3/3b/Keaton_NH.png",
    "species": "Eagle",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 1,
    "sign": "Gemini",
    "quote": "Even in a room full of fools, someone is the smartest.",
    "phrase": "wingo",
    "clothing": "Fuzzy Vest",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Road",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 323,
    "Average_Popularity_Score": 272,
    "Nookazon_Bells_Price_Ranking": 228,
    "Nookazon_average_price_Bells": 138542,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 263,
    "Poll_Ranking_2020_21": 268,
    "Total_Poll_Votes_2020": 291,
    "Total_Poll_Votes_2020_21": 352,
    "Poll_votes_May_2020": 13,
    "Poll_votes_June_2020": 79,
    "Poll_votes_July_2020": 77,
    "Poll_votes_August_2020": 41,
    "Poll_votes_September_2020": 25,
    "Poll_votes_October_2020": 26,
    "Poll_votes_November_2020": 15,
    "Poll_votes_December_2020": 15,
    "Poll_votes_January_2021": 14,
    "Poll_votes_February_2021": 10,
    "Poll_votes_March_2021": 21,
    "Poll_votes_April_2021": 16
  },
  {
    "name": "Maelle",
    "url": "https://nookipedia.com/wiki/Maelle",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "duk03",
    "image_url": "https://dodo.ac/np/images/9/93/Maelle_NH.png",
    "species": "Duck",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 8,
    "sign": "Aries",
    "quote": "A wise duck takes care of its bill.",
    "phrase": "duckling",
    "clothing": "Flower Sweater",
    "islander": "TRUE",
    "debut": "AC",
    "prev_phrases": [],
    "appearances": "['AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Cafe",
    "P (individual within species)": 0.058823529,
    "Rarity": "0.17%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 337,
    "Average_Popularity_Score": 278.5,
    "Nookazon_Bells_Price_Ranking": 34,
    "Nookazon_average_price_Bells": 340625,
    "Nookazon_NMT_Price_Ranking": 314,
    "Nookazon_average_price_NMT": 12,
    "Poll_Ranking_2020": 372,
    "Poll_Ranking_2020_21": 383,
    "Total_Poll_Votes_2020": 126,
    "Total_Poll_Votes_2020_21": 149,
    "Poll_votes_May_2020": 3,
    "Poll_votes_June_2020": 14,
    "Poll_votes_July_2020": 43,
    "Poll_votes_August_2020": 18,
    "Poll_votes_September_2020": 16,
    "Poll_votes_October_2020": 12,
    "Poll_votes_November_2020": 13,
    "Poll_votes_December_2020": 7,
    "Poll_votes_January_2021": 5,
    "Poll_votes_February_2021": 5,
    "Poll_votes_March_2021": 11,
    "Poll_votes_April_2021": 2
  },
  {
    "name": "Del",
    "url": "https://nookipedia.com/wiki/Del",
    "alt_name": "",
    "skin_color": "6b75ce",
    "text_color": "9ae8df",
    "id": "crd04",
    "image_url": "https://dodo.ac/np/images/4/46/Del_NH.png",
    "species": "Alligator",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "May",
    "birthday_day": 27,
    "sign": "Gemini",
    "quote": "The hero is brave in deeds as well as words.",
    "phrase": "gronk",
    "clothing": "Striped Shirt",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Metal",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 302,
    "Average_Popularity_Score": 260.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 262,
    "Poll_Ranking_2020_21": 266,
    "Total_Poll_Votes_2020": 292,
    "Total_Poll_Votes_2020_21": 355,
    "Poll_votes_May_2020": 11,
    "Poll_votes_June_2020": 68,
    "Poll_votes_July_2020": 60,
    "Poll_votes_August_2020": 38,
    "Poll_votes_September_2020": 47,
    "Poll_votes_October_2020": 28,
    "Poll_votes_November_2020": 23,
    "Poll_votes_December_2020": 17,
    "Poll_votes_January_2021": 18,
    "Poll_votes_February_2021": 16,
    "Poll_votes_March_2021": 15,
    "Poll_votes_April_2021": 14
  },
  {
    "name": "Eloise",
    "url": "https://nookipedia.com/wiki/Eloise",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "elp03",
    "image_url": "https://dodo.ac/np/images/b/b1/Eloise_NH.png",
    "species": "Elephant",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "December",
    "birthday_day": 8,
    "sign": "Sagittarius",
    "quote": "An elephant never forgets.",
    "phrase": "tooooot",
    "clothing": "Zigzag-Print Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Colorful",
    "P (individual within species)": 0.090909091,
    "Rarity": "0.26%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 331,
    "Average_Popularity_Score": 277.25,
    "Nookazon_Bells_Price_Ranking": 258,
    "Nookazon_average_price_Bells": 117188,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 278,
    "Poll_Ranking_2020_21": 281,
    "Total_Poll_Votes_2020": 252,
    "Total_Poll_Votes_2020_21": 324,
    "Poll_votes_May_2020": 13,
    "Poll_votes_June_2020": 53,
    "Poll_votes_July_2020": 53,
    "Poll_votes_August_2020": 38,
    "Poll_votes_September_2020": 27,
    "Poll_votes_October_2020": 26,
    "Poll_votes_November_2020": 23,
    "Poll_votes_December_2020": 19,
    "Poll_votes_January_2021": 16,
    "Poll_votes_February_2021": 17,
    "Poll_votes_March_2021": 17,
    "Poll_votes_April_2021": 22
  },
  {
    "name": "Charlise",
    "url": "https://nookipedia.com/wiki/Charlise",
    "alt_name": "",
    "skin_color": "78dd62",
    "text_color": "28665a",
    "id": "bea12",
    "image_url": "https://dodo.ac/np/images/a/ac/Charlise_NH.png",
    "species": "Bear",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 17,
    "sign": "Aries",
    "quote": "Actions speak louder than words.",
    "phrase": "urgh",
    "clothing": "Athletic Jacket",
    "islander": "TRUE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Gym",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 330,
    "Average_Popularity_Score": 276.75,
    "Nookazon_Bells_Price_Ranking": 128,
    "Nookazon_average_price_Bells": 188542,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 340,
    "Poll_Ranking_2020_21": 345,
    "Total_Poll_Votes_2020": 158,
    "Total_Poll_Votes_2020_21": 197,
    "Poll_votes_May_2020": 10,
    "Poll_votes_June_2020": 40,
    "Poll_votes_July_2020": 30,
    "Poll_votes_August_2020": 23,
    "Poll_votes_September_2020": 23,
    "Poll_votes_October_2020": 13,
    "Poll_votes_November_2020": 11,
    "Poll_votes_December_2020": 8,
    "Poll_votes_January_2021": 6,
    "Poll_votes_February_2021": 10,
    "Poll_votes_March_2021": 13,
    "Poll_votes_April_2021": 10
  },
  {
    "name": "Rooney",
    "url": "https://nookipedia.com/wiki/Rooney",
    "alt_name": "",
    "skin_color": "3fd8e0",
    "text_color": "fffce9",
    "id": "kgr09",
    "image_url": "https://dodo.ac/np/images/7/79/Rooney_NH.png",
    "species": "Kangaroo",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 1,
    "sign": "Sagittarius",
    "quote": "Bob and weave! Bob and weave!",
    "phrase": "punches",
    "clothing": "Sleeveless Parka",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Gym",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 323,
    "Average_Popularity_Score": 272,
    "Nookazon_Bells_Price_Ranking": 26,
    "Nookazon_average_price_Bells": 375000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 369,
    "Poll_Ranking_2020_21": 369,
    "Total_Poll_Votes_2020": 127,
    "Total_Poll_Votes_2020_21": 162,
    "Poll_votes_May_2020": 1,
    "Poll_votes_June_2020": 35,
    "Poll_votes_July_2020": 25,
    "Poll_votes_August_2020": 14,
    "Poll_votes_September_2020": 15,
    "Poll_votes_October_2020": 15,
    "Poll_votes_November_2020": 8,
    "Poll_votes_December_2020": 14,
    "Poll_votes_January_2021": 7,
    "Poll_votes_February_2021": 11,
    "Poll_votes_March_2021": 10,
    "Poll_votes_April_2021": 7
  },
  {
    "name": "Peck",
    "url": "https://nookipedia.com/wiki/Peck",
    "alt_name": "",
    "skin_color": "4c3317",
    "text_color": "fffce9",
    "id": "brd17",
    "image_url": "https://dodo.ac/np/images/4/44/Peck_NH.png",
    "species": "Bird",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 25,
    "sign": "Leo",
    "quote": "The best defense is a good offense.",
    "phrase": "crunch",
    "clothing": "Raglan Shirt",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Toys",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 315,
    "Average_Popularity_Score": 267,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 80,
    "Nookazon_average_price_NMT": 25,
    "Poll_Ranking_2020": 341,
    "Poll_Ranking_2020_21": 352,
    "Total_Poll_Votes_2020": 157,
    "Total_Poll_Votes_2020_21": 189,
    "Poll_votes_May_2020": 12,
    "Poll_votes_June_2020": 36,
    "Poll_votes_July_2020": 32,
    "Poll_votes_August_2020": 22,
    "Poll_votes_September_2020": 20,
    "Poll_votes_October_2020": 17,
    "Poll_votes_November_2020": 5,
    "Poll_votes_December_2020": 13,
    "Poll_votes_January_2021": 7,
    "Poll_votes_February_2021": 8,
    "Poll_votes_March_2021": 9,
    "Poll_votes_April_2021": 8
  },
  {
    "name": "Annalise",
    "url": "https://nookipedia.com/wiki/Annalise",
    "alt_name": "",
    "skin_color": "7c6559",
    "text_color": "eac113",
    "id": "hrs09",
    "image_url": "https://dodo.ac/np/images/c/c4/Annalise_NH.png",
    "species": "Horse",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "December",
    "birthday_day": 2,
    "sign": "Sagittarius",
    "quote": "Let gossip go in one ear and out the other.",
    "phrase": "nipper",
    "clothing": "Bold Muumuu",
    "islander": "TRUE",
    "debut": "AC",
    "prev_phrases": [],
    "appearances": "['AC', 'E_PLUS', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Beach",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 333,
    "Average_Popularity_Score": 278,
    "Nookazon_Bells_Price_Ranking": 228,
    "Nookazon_average_price_Bells": 138542,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 343,
    "Poll_Ranking_2020_21": 350,
    "Total_Poll_Votes_2020": 152,
    "Total_Poll_Votes_2020_21": 191,
    "Poll_votes_May_2020": 5,
    "Poll_votes_June_2020": 29,
    "Poll_votes_July_2020": 36,
    "Poll_votes_August_2020": 19,
    "Poll_votes_September_2020": 25,
    "Poll_votes_October_2020": 11,
    "Poll_votes_November_2020": 14,
    "Poll_votes_December_2020": 13,
    "Poll_votes_January_2021": 7,
    "Poll_votes_February_2021": 15,
    "Poll_votes_March_2021": 10,
    "Poll_votes_April_2021": 7
  },
  {
    "name": "Lionel",
    "url": "https://nookipedia.com/wiki/Lionel",
    "alt_name": "",
    "skin_color": "e4b887",
    "text_color": "fffce9",
    "id": "lon08",
    "image_url": "https://dodo.ac/np/images/b/bb/Lionel_NH.png",
    "species": "Lion",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 29,
    "sign": "Leo",
    "quote": "Love is blind.",
    "phrase": "precisely",
    "clothing": "Noble Coat",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Modern",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 326,
    "Average_Popularity_Score": 275.25,
    "Nookazon_Bells_Price_Ranking": 269,
    "Nookazon_average_price_Bells": 112500,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 248,
    "Poll_Ranking_2020_21": 254,
    "Total_Poll_Votes_2020": 325,
    "Total_Poll_Votes_2020_21": 388,
    "Poll_votes_May_2020": 16,
    "Poll_votes_June_2020": 68,
    "Poll_votes_July_2020": 89,
    "Poll_votes_August_2020": 36,
    "Poll_votes_September_2020": 54,
    "Poll_votes_October_2020": 32,
    "Poll_votes_November_2020": 17,
    "Poll_votes_December_2020": 13,
    "Poll_votes_January_2021": 14,
    "Poll_votes_February_2021": 12,
    "Poll_votes_March_2021": 21,
    "Poll_votes_April_2021": 16
  },
  {
    "name": "Rhonda",
    "url": "https://nookipedia.com/wiki/Rhonda",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "rhn01",
    "image_url": "https://dodo.ac/np/images/d/df/Rhonda_NH.png",
    "species": "Rhinoceros",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 24,
    "sign": "Aquarius",
    "quote": "Don't look down your nose at people!",
    "phrase": "bigfoot",
    "clothing": "Ruffled Dress",
    "islander": "FALSE",
    "debut": "WW",
    "prev_phrases": [],
    "appearances": "['WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Cute",
    "P (individual within species)": 0.166666667,
    "Rarity": "0.48%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 333,
    "Average_Popularity_Score": 278,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 375,
    "Poll_Ranking_2020_21": 369,
    "Total_Poll_Votes_2020": 123,
    "Total_Poll_Votes_2020_21": 162,
    "Poll_votes_May_2020": 6,
    "Poll_votes_June_2020": 36,
    "Poll_votes_July_2020": 25,
    "Poll_votes_August_2020": 14,
    "Poll_votes_September_2020": 12,
    "Poll_votes_October_2020": 13,
    "Poll_votes_November_2020": 10,
    "Poll_votes_December_2020": 7,
    "Poll_votes_January_2021": 8,
    "Poll_votes_February_2021": 12,
    "Poll_votes_March_2021": 10,
    "Poll_votes_April_2021": 9
  },
  {
    "name": "Patty",
    "url": "https://nookipedia.com/wiki/Patty",
    "alt_name": "",
    "skin_color": "7a2500",
    "text_color": "fffce9",
    "id": "cow00",
    "image_url": "https://dodo.ac/np/images/f/f1/Patty_NH.png",
    "species": "Cow",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "May",
    "birthday_day": 10,
    "sign": "Taurus",
    "quote": "A friend in need is a friend indeed!",
    "phrase": "how-now",
    "clothing": "Orange Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.25,
    "Rarity": "0.71%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 308,
    "Average_Popularity_Score": 264,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 227,
    "Poll_Ranking_2020_21": 224,
    "Total_Poll_Votes_2020": 373,
    "Total_Poll_Votes_2020_21": 468,
    "Poll_votes_May_2020": 16,
    "Poll_votes_June_2020": 91,
    "Poll_votes_July_2020": 93,
    "Poll_votes_August_2020": 53,
    "Poll_votes_September_2020": 37,
    "Poll_votes_October_2020": 36,
    "Poll_votes_November_2020": 23,
    "Poll_votes_December_2020": 24,
    "Poll_votes_January_2021": 19,
    "Poll_votes_February_2021": 24,
    "Poll_votes_March_2021": 29,
    "Poll_votes_April_2021": 23
  },
  {
    "name": "Chai",
    "url": "https://nookipedia.com/wiki/Chai",
    "alt_name": "",
    "skin_color": "cefdff",
    "text_color": "52b8ec",
    "id": "elp11",
    "image_url": "https://dodo.ac/np/images/a/ab/Chai_PC.png",
    "species": "Elephant",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 6,
    "sign": "Pisces",
    "quote": "He who chases two rabbits catches none.",
    "phrase": "flap flap",
    "clothing": "Cinnamoroll Puffy Blouse",
    "islander": "FALSE",
    "debut": "WA",
    "prev_phrases": [],
    "appearances": "['WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Sanrio",
    "P (individual within species)": 0,
    "Rarity": "0.00%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "Yes",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 3,
    "Apperance_Score": 5,
    "Cute?": "Yes",
    "Average_Popularity_Ranking": 345,
    "Average_Popularity_Score": 284,
    "Nookazon_Bells_Price_Ranking": "N/A",
    "Nookazon_average_price_Bells": "N/A",
    "Nookazon_NMT_Price_Ranking": "N/A",
    "Nookazon_average_price_NMT": "N/A",
    "Poll_Ranking_2020": "N/A",
    "Poll_Ranking_2020_21": 284,
    "Total_Poll_Votes_2020": 0,
    "Total_Poll_Votes_2020_21": 314,
    "Poll_votes_May_2020": 0,
    "Poll_votes_June_2020": 0,
    "Poll_votes_July_2020": 0,
    "Poll_votes_August_2020": 0,
    "Poll_votes_September_2020": 0,
    "Poll_votes_October_2020": 0,
    "Poll_votes_November_2020": 0,
    "Poll_votes_December_2020": 0,
    "Poll_votes_January_2021": 0,
    "Poll_votes_February_2021": 0,
    "Poll_votes_March_2021": 168,
    "Poll_votes_April_2021": 146
  },
  {
    "name": "Hans",
    "url": "https://nookipedia.com/wiki/Hans",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "gor10",
    "image_url": "https://dodo.ac/np/images/1/15/Hans_NH.png",
    "species": "Gorilla",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 5,
    "sign": "Sagittarius",
    "quote": "One good turn deserves another.",
    "phrase": "groovy",
    "clothing": "Down Ski Jacket",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 309,
    "Average_Popularity_Score": 264.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 269,
    "Poll_Ranking_2020_21": 275,
    "Total_Poll_Votes_2020": 274,
    "Total_Poll_Votes_2020_21": 343,
    "Poll_votes_May_2020": 17,
    "Poll_votes_June_2020": 63,
    "Poll_votes_July_2020": 73,
    "Poll_votes_August_2020": 46,
    "Poll_votes_September_2020": 25,
    "Poll_votes_October_2020": 21,
    "Poll_votes_November_2020": 11,
    "Poll_votes_December_2020": 18,
    "Poll_votes_January_2021": 12,
    "Poll_votes_February_2021": 15,
    "Poll_votes_March_2021": 25,
    "Poll_votes_April_2021": 17
  },
  {
    "name": "Annalisa",
    "url": "https://nookipedia.com/wiki/Annalisa",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "ant08",
    "image_url": "https://dodo.ac/np/images/f/f0/Annalisa_NH.png",
    "species": "Anteater",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "February",
    "birthday_day": 6,
    "sign": "Aquarius",
    "quote": "Home is where the heart is.",
    "phrase": "gumdrop",
    "clothing": "Blossoming Kimono",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Asian",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 312,
    "Average_Popularity_Score": 265.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 236,
    "Poll_Ranking_2020_21": 227,
    "Total_Poll_Votes_2020": 361,
    "Total_Poll_Votes_2020_21": 464,
    "Poll_votes_May_2020": 19,
    "Poll_votes_June_2020": 96,
    "Poll_votes_July_2020": 80,
    "Poll_votes_August_2020": 45,
    "Poll_votes_September_2020": 36,
    "Poll_votes_October_2020": 45,
    "Poll_votes_November_2020": 23,
    "Poll_votes_December_2020": 17,
    "Poll_votes_January_2021": 20,
    "Poll_votes_February_2021": 29,
    "Poll_votes_March_2021": 32,
    "Poll_votes_April_2021": 22
  },
  {
    "name": "Bud",
    "url": "https://nookipedia.com/wiki/Bud",
    "alt_name": "",
    "skin_color": "d86808",
    "text_color": "fffce9",
    "id": "lon00",
    "image_url": "https://dodo.ac/np/images/1/1f/Bud_NH.png",
    "species": "Lion",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 8,
    "sign": "Leo",
    "quote": "You're not living unless you're sweating!",
    "phrase": "shredded",
    "clothing": "Pineapple Aloha Shirt",
    "islander": "TRUE",
    "debut": "AC",
    "prev_phrases": "['dood', 'maaan']",
    "appearances": "['AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Beach",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 1,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 339,
    "Average_Popularity_Score": 281,
    "Nookazon_Bells_Price_Ranking": 251,
    "Nookazon_average_price_Bells": 125000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 323,
    "Poll_Ranking_2020_21": 324,
    "Total_Poll_Votes_2020": 186,
    "Total_Poll_Votes_2020_21": 236,
    "Poll_votes_May_2020": 9,
    "Poll_votes_June_2020": 39,
    "Poll_votes_July_2020": 54,
    "Poll_votes_August_2020": 39,
    "Poll_votes_September_2020": 15,
    "Poll_votes_October_2020": 12,
    "Poll_votes_November_2020": 7,
    "Poll_votes_December_2020": 11,
    "Poll_votes_January_2021": 18,
    "Poll_votes_February_2021": 10,
    "Poll_votes_March_2021": 11,
    "Poll_votes_April_2021": 11
  },
  {
    "name": "Goose",
    "url": "https://nookipedia.com/wiki/Goose",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "chn00",
    "image_url": "https://dodo.ac/np/images/9/91/Goose_NH.png",
    "species": "Chicken",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 4,
    "sign": "Libra",
    "quote": "Birds of a feather crow together.",
    "phrase": "buh-kay",
    "clothing": "Bold Aloha Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Normal",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 316,
    "Average_Popularity_Score": 267.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 223,
    "Poll_Ranking_2020_21": 231,
    "Total_Poll_Votes_2020": 379,
    "Total_Poll_Votes_2020_21": 457,
    "Poll_votes_May_2020": 35,
    "Poll_votes_June_2020": 104,
    "Poll_votes_July_2020": 101,
    "Poll_votes_August_2020": 34,
    "Poll_votes_September_2020": 31,
    "Poll_votes_October_2020": 37,
    "Poll_votes_November_2020": 22,
    "Poll_votes_December_2020": 15,
    "Poll_votes_January_2021": 15,
    "Poll_votes_February_2021": 15,
    "Poll_votes_March_2021": 30,
    "Poll_votes_April_2021": 18
  },
  {
    "name": "Vic",
    "url": "https://nookipedia.com/wiki/Vic",
    "alt_name": "",
    "skin_color": "c0ab72",
    "text_color": "fffce9",
    "id": "bul08",
    "image_url": "https://dodo.ac/np/images/1/1d/Vic_NH.png",
    "species": "Bull",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 29,
    "sign": "Capricorn",
    "quote": "You mess with the bull, you get the horns.",
    "phrase": "cud",
    "clothing": "Viking Top",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Beach",
    "P (individual within species)": 0.166666667,
    "Rarity": "0.48%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 340,
    "Average_Popularity_Score": 281.25,
    "Nookazon_Bells_Price_Ranking": 250,
    "Nookazon_average_price_Bells": 125938,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 327,
    "Poll_Ranking_2020_21": 325,
    "Total_Poll_Votes_2020": 183,
    "Total_Poll_Votes_2020_21": 235,
    "Poll_votes_May_2020": 9,
    "Poll_votes_June_2020": 41,
    "Poll_votes_July_2020": 47,
    "Poll_votes_August_2020": 22,
    "Poll_votes_September_2020": 22,
    "Poll_votes_October_2020": 22,
    "Poll_votes_November_2020": 10,
    "Poll_votes_December_2020": 10,
    "Poll_votes_January_2021": 16,
    "Poll_votes_February_2021": 8,
    "Poll_votes_March_2021": 13,
    "Poll_votes_April_2021": 15
  },
  {
    "name": "Cashmere",
    "url": "https://nookipedia.com/wiki/Cashmere",
    "alt_name": "",
    "skin_color": "bff2ff",
    "text_color": "85a2af",
    "id": "shp04",
    "image_url": "https://dodo.ac/np/images/e/eb/Cashmere_NH.png",
    "species": "Sheep",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 2,
    "sign": "Aries",
    "quote": "100% Wool.",
    "phrase": "baaaby",
    "clothing": "Sleeveless Tunic",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Weaver",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 344,
    "Average_Popularity_Score": 282.75,
    "Nookazon_Bells_Price_Ranking": 184,
    "Nookazon_average_price_Bells": 155209,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 348,
    "Poll_Ranking_2020_21": 361,
    "Total_Poll_Votes_2020": 149,
    "Total_Poll_Votes_2020_21": 174,
    "Poll_votes_May_2020": 1,
    "Poll_votes_June_2020": 26,
    "Poll_votes_July_2020": 21,
    "Poll_votes_August_2020": 14,
    "Poll_votes_September_2020": 13,
    "Poll_votes_October_2020": 52,
    "Poll_votes_November_2020": 14,
    "Poll_votes_December_2020": 8,
    "Poll_votes_January_2021": 5,
    "Poll_votes_February_2021": 5,
    "Poll_votes_March_2021": 9,
    "Poll_votes_April_2021": 6
  },
  {
    "name": "Sandy",
    "url": "https://nookipedia.com/wiki/Sandy",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "ost02",
    "image_url": "https://dodo.ac/np/images/a/a9/Sandy_NH.png",
    "species": "Ostrich",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "October",
    "birthday_day": 21,
    "sign": "Libra",
    "quote": "Soaring through the sky takes more than a pair of wings.",
    "phrase": "speedy",
    "clothing": "Striped Tank",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Cafe",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 341,
    "Average_Popularity_Score": 281.5,
    "Nookazon_Bells_Price_Ranking": 78,
    "Nookazon_average_price_Bells": 239375,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 357,
    "Poll_Ranking_2020_21": 362,
    "Total_Poll_Votes_2020": 139,
    "Total_Poll_Votes_2020_21": 170,
    "Poll_votes_May_2020": 2,
    "Poll_votes_June_2020": 34,
    "Poll_votes_July_2020": 28,
    "Poll_votes_August_2020": 11,
    "Poll_votes_September_2020": 18,
    "Poll_votes_October_2020": 11,
    "Poll_votes_November_2020": 22,
    "Poll_votes_December_2020": 13,
    "Poll_votes_January_2021": 7,
    "Poll_votes_February_2021": 8,
    "Poll_votes_March_2021": 10,
    "Poll_votes_April_2021": 6
  },
  {
    "name": "Elise",
    "url": "https://nookipedia.com/wiki/Elise",
    "alt_name": "",
    "skin_color": "d8cc39",
    "text_color": "8b5f57",
    "id": "mnk05",
    "image_url": "https://dodo.ac/np/images/0/0c/Elise_NH.png",
    "species": "Monkey",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 21,
    "sign": "Aries",
    "quote": "Do as I say, not as I do.",
    "phrase": "puh-lease",
    "clothing": "Elegant Dress",
    "islander": "FALSE",
    "debut": "WW",
    "prev_phrases": [],
    "appearances": "['WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 346,
    "Average_Popularity_Score": 284.75,
    "Nookazon_Bells_Price_Ranking": 130,
    "Nookazon_average_price_Bells": 187500,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 351,
    "Poll_Ranking_2020_21": 360,
    "Total_Poll_Votes_2020": 143,
    "Total_Poll_Votes_2020_21": 175,
    "Poll_votes_May_2020": 0,
    "Poll_votes_June_2020": 54,
    "Poll_votes_July_2020": 23,
    "Poll_votes_August_2020": 21,
    "Poll_votes_September_2020": 22,
    "Poll_votes_October_2020": 10,
    "Poll_votes_November_2020": 7,
    "Poll_votes_December_2020": 6,
    "Poll_votes_January_2021": 6,
    "Poll_votes_February_2021": 11,
    "Poll_votes_March_2021": 10,
    "Poll_votes_April_2021": 5
  },
  {
    "name": "Bubbles",
    "url": "https://nookipedia.com/wiki/Bubbles",
    "alt_name": "",
    "skin_color": "e8b010",
    "text_color": "fffce9",
    "id": "hip02",
    "image_url": "https://dodo.ac/np/images/0/0e/Bubbles_NH.png",
    "species": "Hippo",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "September",
    "birthday_day": 18,
    "sign": "Virgo",
    "quote": "It's best to keep your lips and purse sealed.",
    "phrase": "hipster",
    "clothing": "Grape Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Gym",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 329,
    "Average_Popularity_Score": 276.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 389,
    "Nookazon_average_price_NMT": 5,
    "Poll_Ranking_2020": 211,
    "Poll_Ranking_2020_21": 216,
    "Total_Poll_Votes_2020": 408,
    "Total_Poll_Votes_2020_21": 491,
    "Poll_votes_May_2020": 22,
    "Poll_votes_June_2020": 101,
    "Poll_votes_July_2020": 94,
    "Poll_votes_August_2020": 58,
    "Poll_votes_September_2020": 56,
    "Poll_votes_October_2020": 38,
    "Poll_votes_November_2020": 17,
    "Poll_votes_December_2020": 22,
    "Poll_votes_January_2021": 24,
    "Poll_votes_February_2021": 20,
    "Poll_votes_March_2021": 14,
    "Poll_votes_April_2021": 25
  },
  {
    "name": "Al",
    "url": "https://nookipedia.com/wiki/Al",
    "alt_name": "",
    "skin_color": 798040,
    "text_color": "fffad4",
    "id": "gor08",
    "image_url": "https://dodo.ac/np/images/c/c4/Al_NH.png",
    "species": "Gorilla",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 18,
    "sign": "Libra",
    "quote": "Life is a buffet. Always go back for seconds.",
    "phrase": "ayyyeee",
    "clothing": "Athletic Jacket",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": "['hoo hoo ha']",
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Gym",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 332,
    "Average_Popularity_Score": 277.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 384,
    "Nookazon_average_price_NMT": 9,
    "Poll_Ranking_2020": 217,
    "Poll_Ranking_2020_21": 221,
    "Total_Poll_Votes_2020": 396,
    "Total_Poll_Votes_2020_21": 472,
    "Poll_votes_May_2020": 15,
    "Poll_votes_June_2020": 110,
    "Poll_votes_July_2020": 123,
    "Poll_votes_August_2020": 46,
    "Poll_votes_September_2020": 36,
    "Poll_votes_October_2020": 31,
    "Poll_votes_November_2020": 20,
    "Poll_votes_December_2020": 15,
    "Poll_votes_January_2021": 15,
    "Poll_votes_February_2021": 20,
    "Poll_votes_March_2021": 23,
    "Poll_votes_April_2021": 18
  },
  {
    "name": "Spike",
    "url": "https://nookipedia.com/wiki/Spike",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "rhn02",
    "image_url": "https://dodo.ac/np/images/f/f1/Spike_NH.png",
    "species": "Rhinoceros",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "June",
    "birthday_day": 17,
    "sign": "Gemini",
    "quote": "Keep your eye on the ball.",
    "phrase": "punk",
    "clothing": "Gold-Print Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Metal",
    "P (individual within species)": 0.166666667,
    "Rarity": "0.48%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 1,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 327,
    "Average_Popularity_Score": 275.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 260,
    "Poll_Ranking_2020_21": 265,
    "Total_Poll_Votes_2020": 296,
    "Total_Poll_Votes_2020_21": 370,
    "Poll_votes_May_2020": 20,
    "Poll_votes_June_2020": 64,
    "Poll_votes_July_2020": 73,
    "Poll_votes_August_2020": 44,
    "Poll_votes_September_2020": 26,
    "Poll_votes_October_2020": 30,
    "Poll_votes_November_2020": 20,
    "Poll_votes_December_2020": 19,
    "Poll_votes_January_2021": 14,
    "Poll_votes_February_2021": 15,
    "Poll_votes_March_2021": 30,
    "Poll_votes_April_2021": 15
  },
  {
    "name": "Peaches",
    "url": "https://nookipedia.com/wiki/Peaches",
    "alt_name": "",
    "skin_color": "f993ce",
    "text_color": "fffce9",
    "id": "hrs08",
    "image_url": "https://dodo.ac/np/images/0/0d/Peaches_NH.png",
    "species": "Horse",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "November",
    "birthday_day": 28,
    "sign": "Sagittarius",
    "quote": "Every day is a gift.",
    "phrase": "neighbor",
    "clothing": "Long Denim Cardigan",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Cabin",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 320,
    "Average_Popularity_Score": 269.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 334,
    "Poll_Ranking_2020_21": 345,
    "Total_Poll_Votes_2020": 162,
    "Total_Poll_Votes_2020_21": 197,
    "Poll_votes_May_2020": 8,
    "Poll_votes_June_2020": 30,
    "Poll_votes_July_2020": 43,
    "Poll_votes_August_2020": 24,
    "Poll_votes_September_2020": 9,
    "Poll_votes_October_2020": 24,
    "Poll_votes_November_2020": 13,
    "Poll_votes_December_2020": 11,
    "Poll_votes_January_2021": 6,
    "Poll_votes_February_2021": 10,
    "Poll_votes_March_2021": 10,
    "Poll_votes_April_2021": 9
  },
  {
    "name": "Cyrano",
    "url": "https://nookipedia.com/wiki/Cyrano",
    "alt_name": "",
    "skin_color": "194c89",
    "text_color": "fffad4",
    "id": "ant00",
    "image_url": "https://dodo.ac/np/images/4/48/Cyrano_NH.png",
    "species": "Anteater",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "March",
    "birthday_day": 9,
    "sign": "Pisces",
    "quote": "Don't cut off your nose to spite your face.",
    "phrase": "ah-CHOO",
    "clothing": "Judogi",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Asian",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 349,
    "Average_Popularity_Score": 286.75,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 333,
    "Poll_Ranking_2020_21": 334,
    "Total_Poll_Votes_2020": 162,
    "Total_Poll_Votes_2020_21": 219,
    "Poll_votes_May_2020": 8,
    "Poll_votes_June_2020": 39,
    "Poll_votes_July_2020": 32,
    "Poll_votes_August_2020": 24,
    "Poll_votes_September_2020": 18,
    "Poll_votes_October_2020": 22,
    "Poll_votes_November_2020": 13,
    "Poll_votes_December_2020": 6,
    "Poll_votes_January_2021": 15,
    "Poll_votes_February_2021": 14,
    "Poll_votes_March_2021": 16,
    "Poll_votes_April_2021": 12
  },
  {
    "name": "Astrid",
    "url": "https://nookipedia.com/wiki/Astrid",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "kgr05",
    "image_url": "https://dodo.ac/np/images/d/d5/Astrid_NH.png",
    "species": "Kangaroo",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "September",
    "birthday_day": 8,
    "sign": "Virgo",
    "quote": "The apple doesn't fall far from the tree.",
    "phrase": "my pet",
    "clothing": "Tee Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 347,
    "Average_Popularity_Score": 285.25,
    "Nookazon_Bells_Price_Ranking": 129,
    "Nookazon_average_price_Bells": 188412,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 350,
    "Poll_Ranking_2020_21": 344,
    "Total_Poll_Votes_2020": 146,
    "Total_Poll_Votes_2020_21": 198,
    "Poll_votes_May_2020": 10,
    "Poll_votes_June_2020": 37,
    "Poll_votes_July_2020": 32,
    "Poll_votes_August_2020": 20,
    "Poll_votes_September_2020": 21,
    "Poll_votes_October_2020": 10,
    "Poll_votes_November_2020": 12,
    "Poll_votes_December_2020": 4,
    "Poll_votes_January_2021": 16,
    "Poll_votes_February_2021": 13,
    "Poll_votes_March_2021": 9,
    "Poll_votes_April_2021": 14
  },
  {
    "name": "Penelope",
    "url": "https://nookipedia.com/wiki/Penelope",
    "alt_name": "",
    "skin_color": "c0ab72",
    "text_color": "fffce9",
    "id": "mus17",
    "image_url": "https://dodo.ac/np/images/1/15/Penelope_NH.png",
    "species": "Mouse",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "February",
    "birthday_day": 5,
    "sign": "Aquarius",
    "quote": "One mile or a thousand makes no difference to love.",
    "phrase": "oh bow",
    "clothing": "Oversized Print Dress",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Cute",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 333,
    "Average_Popularity_Score": 278,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 335,
    "Poll_Ranking_2020_21": 322,
    "Total_Poll_Votes_2020": 162,
    "Total_Poll_Votes_2020_21": 238,
    "Poll_votes_May_2020": 9,
    "Poll_votes_June_2020": 29,
    "Poll_votes_July_2020": 24,
    "Poll_votes_August_2020": 43,
    "Poll_votes_September_2020": 24,
    "Poll_votes_October_2020": 14,
    "Poll_votes_November_2020": 13,
    "Poll_votes_December_2020": 6,
    "Poll_votes_January_2021": 11,
    "Poll_votes_February_2021": 23,
    "Poll_votes_March_2021": 20,
    "Poll_votes_April_2021": 22
  },
  {
    "name": "Olaf",
    "url": "https://nookipedia.com/wiki/Olaf",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "ant09",
    "image_url": "https://dodo.ac/np/images/1/11/Olaf_NH.png",
    "species": "Anteater",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "May",
    "birthday_day": 19,
    "sign": "Taurus",
    "quote": "Keep your nose clean.",
    "phrase": "whiffa",
    "clothing": "Suit of Lights",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 360,
    "Average_Popularity_Score": 294.5,
    "Nookazon_Bells_Price_Ranking": 249,
    "Nookazon_average_price_Bells": 127500,
    "Nookazon_NMT_Price_Ranking": 387,
    "Nookazon_average_price_NMT": 8,
    "Poll_Ranking_2020": 258,
    "Poll_Ranking_2020_21": 271,
    "Total_Poll_Votes_2020": 297,
    "Total_Poll_Votes_2020_21": 347,
    "Poll_votes_May_2020": 21,
    "Poll_votes_June_2020": 80,
    "Poll_votes_July_2020": 68,
    "Poll_votes_August_2020": 39,
    "Poll_votes_September_2020": 27,
    "Poll_votes_October_2020": 32,
    "Poll_votes_November_2020": 19,
    "Poll_votes_December_2020": 11,
    "Poll_votes_January_2021": 16,
    "Poll_votes_February_2021": 15,
    "Poll_votes_March_2021": 14,
    "Poll_votes_April_2021": 5
  },
  {
    "name": "Gwen",
    "url": "https://nookipedia.com/wiki/Gwen",
    "alt_name": "",
    "skin_color": 735000000000,
    "text_color": "fffce9",
    "id": "pgn05",
    "image_url": "https://dodo.ac/np/images/b/be/Gwen_NH.png",
    "species": "Penguin",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 23,
    "sign": "Aquarius",
    "quote": "Mind your manners, or someone else will.",
    "phrase": "h-h-h-hon",
    "clothing": "Retro Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Ice",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "Yes",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 358,
    "Average_Popularity_Score": 292.25,
    "Nookazon_Bells_Price_Ranking": 216,
    "Nookazon_average_price_Bells": 143750,
    "Nookazon_NMT_Price_Ranking": 209,
    "Nookazon_average_price_NMT": 17,
    "Poll_Ranking_2020": 377,
    "Poll_Ranking_2020_21": 372,
    "Total_Poll_Votes_2020": 120,
    "Total_Poll_Votes_2020_21": 158,
    "Poll_votes_May_2020": 4,
    "Poll_votes_June_2020": 22,
    "Poll_votes_July_2020": 32,
    "Poll_votes_August_2020": 21,
    "Poll_votes_September_2020": 8,
    "Poll_votes_October_2020": 16,
    "Poll_votes_November_2020": 9,
    "Poll_votes_December_2020": 8,
    "Poll_votes_January_2021": 8,
    "Poll_votes_February_2021": 10,
    "Poll_votes_March_2021": 8,
    "Poll_votes_April_2021": 12
  },
  {
    "name": "Doc",
    "url": "https://nookipedia.com/wiki/Doc",
    "alt_name": "",
    "skin_color": "0961f6",
    "text_color": "fffce9",
    "id": "rbt10",
    "image_url": "https://dodo.ac/np/images/c/cd/Doc_NH.png",
    "species": "Rabbit",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "March",
    "birthday_day": 16,
    "sign": "Pisces",
    "quote": "One cannot live on carrots alone.",
    "phrase": "old bunny",
    "clothing": "Flannel Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Library",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 338,
    "Average_Popularity_Score": 279.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 268,
    "Poll_Ranking_2020_21": 273,
    "Total_Poll_Votes_2020": 275,
    "Total_Poll_Votes_2020_21": 346,
    "Poll_votes_May_2020": 10,
    "Poll_votes_June_2020": 61,
    "Poll_votes_July_2020": 70,
    "Poll_votes_August_2020": 31,
    "Poll_votes_September_2020": 41,
    "Poll_votes_October_2020": 26,
    "Poll_votes_November_2020": 19,
    "Poll_votes_December_2020": 17,
    "Poll_votes_January_2021": 14,
    "Poll_votes_February_2021": 18,
    "Poll_votes_March_2021": 23,
    "Poll_votes_April_2021": 16
  },
  {
    "name": "Ike",
    "url": "https://nookipedia.com/wiki/Ike",
    "alt_name": "",
    "skin_color": "4c3317",
    "text_color": "fffce9",
    "id": "bea11",
    "image_url": "https://dodo.ac/np/images/3/34/Ike_NH.png",
    "species": "Bear",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "May",
    "birthday_day": 16,
    "sign": "Taurus",
    "quote": "The higher you climb, the smaller things look.",
    "phrase": "roadie",
    "clothing": "Camo Bomber-Style Jacket",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WA', 'NH']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Metal",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 325,
    "Average_Popularity_Score": 274.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 354,
    "Poll_Ranking_2020_21": 355,
    "Total_Poll_Votes_2020": 142,
    "Total_Poll_Votes_2020_21": 180,
    "Poll_votes_May_2020": 7,
    "Poll_votes_June_2020": 34,
    "Poll_votes_July_2020": 33,
    "Poll_votes_August_2020": 21,
    "Poll_votes_September_2020": 16,
    "Poll_votes_October_2020": 12,
    "Poll_votes_November_2020": 6,
    "Poll_votes_December_2020": 13,
    "Poll_votes_January_2021": 7,
    "Poll_votes_February_2021": 11,
    "Poll_votes_March_2021": 10,
    "Poll_votes_April_2021": 10
  },
  {
    "name": "Dora",
    "url": "https://nookipedia.com/wiki/Dora",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "mus00",
    "image_url": "https://dodo.ac/np/images/d/de/Dora_NH.png",
    "species": "Mouse",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "February",
    "birthday_day": 18,
    "sign": "Aquarius",
    "quote": "The squeaky wheel gets the cheese.",
    "phrase": "squeaky",
    "clothing": "Sea Hanten Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Asian",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 336,
    "Average_Popularity_Score": 278.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 304,
    "Poll_Ranking_2020_21": 302,
    "Total_Poll_Votes_2020": 218,
    "Total_Poll_Votes_2020_21": 289,
    "Poll_votes_May_2020": 8,
    "Poll_votes_June_2020": 71,
    "Poll_votes_July_2020": 53,
    "Poll_votes_August_2020": 25,
    "Poll_votes_September_2020": 21,
    "Poll_votes_October_2020": 18,
    "Poll_votes_November_2020": 8,
    "Poll_votes_December_2020": 14,
    "Poll_votes_January_2021": 13,
    "Poll_votes_February_2021": 27,
    "Poll_votes_March_2021": 12,
    "Poll_votes_April_2021": 19
  },
  {
    "name": "Huck",
    "url": "https://nookipedia.com/wiki/Huck",
    "alt_name": "",
    "skin_color": 515151,
    "text_color": "fffce9",
    "id": "flg11",
    "image_url": "https://dodo.ac/np/images/1/17/Huck_NH.png",
    "species": "Frog",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 9,
    "sign": "Cancer",
    "quote": "Cold coffee makes for a cold demeanor.",
    "phrase": "hopper",
    "clothing": "Striped Tank",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.055555556,
    "Rarity": "0.16%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 356,
    "Average_Popularity_Score": 291.25,
    "Nookazon_Bells_Price_Ranking": 211,
    "Nookazon_average_price_Bells": 145313,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 308,
    "Poll_Ranking_2020_21": 315,
    "Total_Poll_Votes_2020": 213,
    "Total_Poll_Votes_2020_21": 262,
    "Poll_votes_May_2020": 14,
    "Poll_votes_June_2020": 50,
    "Poll_votes_July_2020": 49,
    "Poll_votes_August_2020": 25,
    "Poll_votes_September_2020": 20,
    "Poll_votes_October_2020": 22,
    "Poll_votes_November_2020": 21,
    "Poll_votes_December_2020": 12,
    "Poll_votes_January_2021": 11,
    "Poll_votes_February_2021": 12,
    "Poll_votes_March_2021": 16,
    "Poll_votes_April_2021": 10
  },
  {
    "name": "Bitty",
    "url": "https://nookipedia.com/wiki/Bitty",
    "alt_name": "",
    "skin_color": "f993ce",
    "text_color": "fffce9",
    "id": "hip05",
    "image_url": "https://dodo.ac/np/images/7/74/Bitty_NH.png",
    "species": "Hippo",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "October",
    "birthday_day": 6,
    "sign": "Libra",
    "quote": "Necessity is the mother of all invention.",
    "phrase": "my dear",
    "clothing": "Frilly Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Fashion studio",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 357,
    "Average_Popularity_Score": 291.75,
    "Nookazon_Bells_Price_Ranking": 55,
    "Nookazon_average_price_Bells": 287500,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 390,
    "Poll_Ranking_2020_21": 394,
    "Total_Poll_Votes_2020": 89,
    "Total_Poll_Votes_2020_21": 121,
    "Poll_votes_May_2020": 2,
    "Poll_votes_June_2020": 14,
    "Poll_votes_July_2020": 21,
    "Poll_votes_August_2020": 18,
    "Poll_votes_September_2020": 13,
    "Poll_votes_October_2020": 12,
    "Poll_votes_November_2020": 6,
    "Poll_votes_December_2020": 3,
    "Poll_votes_January_2021": 14,
    "Poll_votes_February_2021": 3,
    "Poll_votes_March_2021": 12,
    "Poll_votes_April_2021": 3
  },
  {
    "name": "Lucy",
    "url": "https://nookipedia.com/wiki/Lucy",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "pig04",
    "image_url": "https://dodo.ac/np/images/e/e5/Lucy_NH.png",
    "species": "Pig",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "June",
    "birthday_day": 2,
    "sign": "Gemini",
    "quote": "The best is yet to come.",
    "phrase": "snoooink",
    "clothing": "Frilly Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Music room",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 350,
    "Average_Popularity_Score": 287.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 279,
    "Nookazon_average_price_NMT": 14,
    "Poll_Ranking_2020": 284,
    "Poll_Ranking_2020_21": 293,
    "Total_Poll_Votes_2020": 246,
    "Total_Poll_Votes_2020_21": 303,
    "Poll_votes_May_2020": 7,
    "Poll_votes_June_2020": 55,
    "Poll_votes_July_2020": 58,
    "Poll_votes_August_2020": 33,
    "Poll_votes_September_2020": 20,
    "Poll_votes_October_2020": 36,
    "Poll_votes_November_2020": 18,
    "Poll_votes_December_2020": 19,
    "Poll_votes_January_2021": 14,
    "Poll_votes_February_2021": 13,
    "Poll_votes_March_2021": 16,
    "Poll_votes_April_2021": 14
  },
  {
    "name": "Spork",
    "url": "https://nookipedia.com/wiki/Spork",
    "alt_name": "",
    "skin_color": "e4b887",
    "text_color": "fffce9",
    "id": "pig05",
    "image_url": "https://dodo.ac/np/images/c/c2/Spork_NH.png",
    "species": "Pig",
    "personality": "Lazy",
    "gender": "Male",
    "birthday_month": "September",
    "birthday_day": 3,
    "sign": "Virgo",
    "quote": "It's never too late for a snack.",
    "phrase": "snork",
    "clothing": "Layered Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 350,
    "Average_Popularity_Score": 287.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 209,
    "Nookazon_average_price_NMT": 17,
    "Poll_Ranking_2020": 328,
    "Poll_Ranking_2020_21": 328,
    "Total_Poll_Votes_2020": 182,
    "Total_Poll_Votes_2020_21": 232,
    "Poll_votes_May_2020": 10,
    "Poll_votes_June_2020": 43,
    "Poll_votes_July_2020": 39,
    "Poll_votes_August_2020": 28,
    "Poll_votes_September_2020": 23,
    "Poll_votes_October_2020": 18,
    "Poll_votes_November_2020": 8,
    "Poll_votes_December_2020": 13,
    "Poll_votes_January_2021": 6,
    "Poll_votes_February_2021": 15,
    "Poll_votes_March_2021": 15,
    "Poll_votes_April_2021": 14
  },
  {
    "name": "Leopold",
    "url": "https://nookipedia.com/wiki/Leopold",
    "alt_name": "",
    "skin_color": "e4b887",
    "text_color": "fffce9",
    "id": "lon04",
    "image_url": "https://dodo.ac/np/images/3/3a/Leopold_NH.png",
    "species": "Lion",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 14,
    "sign": "Leo",
    "quote": "The bigger the fish, the bigger your dinner.",
    "phrase": "lion cub",
    "clothing": "Tennis Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "School",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 348,
    "Average_Popularity_Score": 286.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 282,
    "Poll_Ranking_2020_21": 286,
    "Total_Poll_Votes_2020": 248,
    "Total_Poll_Votes_2020_21": 312,
    "Poll_votes_May_2020": 15,
    "Poll_votes_June_2020": 62,
    "Poll_votes_July_2020": 60,
    "Poll_votes_August_2020": 29,
    "Poll_votes_September_2020": 24,
    "Poll_votes_October_2020": 24,
    "Poll_votes_November_2020": 21,
    "Poll_votes_December_2020": 13,
    "Poll_votes_January_2021": 13,
    "Poll_votes_February_2021": 17,
    "Poll_votes_March_2021": 19,
    "Poll_votes_April_2021": 15
  },
  {
    "name": "Yuka",
    "url": "https://nookipedia.com/wiki/Yuka",
    "alt_name": "",
    "skin_color": "194c89",
    "text_color": "fffad4",
    "id": "kal00",
    "image_url": "https://dodo.ac/np/images/c/ca/Yuka_NH.png",
    "species": "Koala",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "July",
    "birthday_day": 20,
    "sign": "Cancer",
    "quote": "Beauty is in the eye of the beholder.",
    "phrase": "tsk tsk",
    "clothing": "Aran-Knit Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 341,
    "Average_Popularity_Score": 281.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 265,
    "Poll_Ranking_2020_21": 259,
    "Total_Poll_Votes_2020": 285,
    "Total_Poll_Votes_2020_21": 380,
    "Poll_votes_May_2020": 30,
    "Poll_votes_June_2020": 63,
    "Poll_votes_July_2020": 57,
    "Poll_votes_August_2020": 37,
    "Poll_votes_September_2020": 29,
    "Poll_votes_October_2020": 27,
    "Poll_votes_November_2020": 21,
    "Poll_votes_December_2020": 21,
    "Poll_votes_January_2021": 20,
    "Poll_votes_February_2021": 29,
    "Poll_votes_March_2021": 25,
    "Poll_votes_April_2021": 21
  },
  {
    "name": "Greta",
    "url": "https://nookipedia.com/wiki/Greta",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "mus16",
    "image_url": "https://dodo.ac/np/images/b/bd/Greta_NH.png",
    "species": "Mouse",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "September",
    "birthday_day": 5,
    "sign": "Virgo",
    "quote": "The world is a stage.",
    "phrase": "yelp",
    "clothing": "Pinafore",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Asian",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 354,
    "Average_Popularity_Score": 289.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 91,
    "Nookazon_average_price_NMT": 23,
    "Poll_Ranking_2020": 385,
    "Poll_Ranking_2020_21": 391,
    "Total_Poll_Votes_2020": 105,
    "Total_Poll_Votes_2020_21": 129,
    "Poll_votes_May_2020": 1,
    "Poll_votes_June_2020": 25,
    "Poll_votes_July_2020": 21,
    "Poll_votes_August_2020": 11,
    "Poll_votes_September_2020": 16,
    "Poll_votes_October_2020": 12,
    "Poll_votes_November_2020": 5,
    "Poll_votes_December_2020": 14,
    "Poll_votes_January_2021": 7,
    "Poll_votes_February_2021": 4,
    "Poll_votes_March_2021": 11,
    "Poll_votes_April_2021": 2
  },
  {
    "name": "Curly",
    "url": "https://nookipedia.com/wiki/Curly",
    "alt_name": "",
    "skin_color": "f993ce",
    "text_color": "fffce9",
    "id": "pig00",
    "image_url": "https://dodo.ac/np/images/3/3d/Curly_NH.png",
    "species": "Pig",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 26,
    "sign": "Leo",
    "quote": "Get fired up!",
    "phrase": "nyoink",
    "clothing": "Energetic Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Normal",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 365,
    "Average_Popularity_Score": 297.25,
    "Nookazon_Bells_Price_Ranking": 210,
    "Nookazon_average_price_Bells": 149000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 370,
    "Poll_Ranking_2020_21": 377,
    "Total_Poll_Votes_2020": 126,
    "Total_Poll_Votes_2020_21": 156,
    "Poll_votes_May_2020": 5,
    "Poll_votes_June_2020": 28,
    "Poll_votes_July_2020": 23,
    "Poll_votes_August_2020": 29,
    "Poll_votes_September_2020": 11,
    "Poll_votes_October_2020": 11,
    "Poll_votes_November_2020": 11,
    "Poll_votes_December_2020": 8,
    "Poll_votes_January_2021": 7,
    "Poll_votes_February_2021": 8,
    "Poll_votes_March_2021": 8,
    "Poll_votes_April_2021": 7
  },
  {
    "name": "Gloria",
    "url": "https://nookipedia.com/wiki/Gloria",
    "alt_name": "",
    "skin_color": "ffffff",
    "text_color": 848484,
    "id": "duk15",
    "image_url": "https://dodo.ac/np/images/1/14/Gloria_NH.png",
    "species": "Duck",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "August",
    "birthday_day": 12,
    "sign": "Leo",
    "quote": "Time is money.",
    "phrase": "quacker",
    "clothing": "Floral Lace Dress",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": [],
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Road",
    "P (individual within species)": 0.058823529,
    "Rarity": "0.17%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 343,
    "Average_Popularity_Score": 282.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 104,
    "Nookazon_average_price_NMT": 20,
    "Poll_Ranking_2020": 371,
    "Poll_Ranking_2020_21": 371,
    "Total_Poll_Votes_2020": 126,
    "Total_Poll_Votes_2020_21": 161,
    "Poll_votes_May_2020": 3,
    "Poll_votes_June_2020": 26,
    "Poll_votes_July_2020": 28,
    "Poll_votes_August_2020": 17,
    "Poll_votes_September_2020": 18,
    "Poll_votes_October_2020": 10,
    "Poll_votes_November_2020": 11,
    "Poll_votes_December_2020": 13,
    "Poll_votes_January_2021": 6,
    "Poll_votes_February_2021": 12,
    "Poll_votes_March_2021": 11,
    "Poll_votes_April_2021": 6
  },
  {
    "name": "Rory",
    "url": "https://nookipedia.com/wiki/Rory",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "lon07",
    "image_url": "https://dodo.ac/np/images/d/db/Rory_NH.png",
    "species": "Lion",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 7,
    "sign": "Leo",
    "quote": "Set 'em up and knock 'em down.",
    "phrase": "capital",
    "clothing": "Sea Hanten Shirt",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Beach",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 364,
    "Average_Popularity_Score": 297,
    "Nookazon_Bells_Price_Ranking": 190,
    "Nookazon_average_price_Bells": 150000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 331,
    "Poll_Ranking_2020_21": 337,
    "Total_Poll_Votes_2020": 168,
    "Total_Poll_Votes_2020_21": 207,
    "Poll_votes_May_2020": 11,
    "Poll_votes_June_2020": 38,
    "Poll_votes_July_2020": 51,
    "Poll_votes_August_2020": 21,
    "Poll_votes_September_2020": 14,
    "Poll_votes_October_2020": 15,
    "Poll_votes_November_2020": 3,
    "Poll_votes_December_2020": 15,
    "Poll_votes_January_2021": 7,
    "Poll_votes_February_2021": 9,
    "Poll_votes_March_2021": 10,
    "Poll_votes_April_2021": 13
  },
  {
    "name": "Violet",
    "url": "https://nookipedia.com/wiki/Violet",
    "alt_name": "",
    "skin_color": "ec7efc",
    "text_color": "fffce9",
    "id": "gor07",
    "image_url": "https://dodo.ac/np/images/6/6b/Violet_NH.png",
    "species": "Gorilla",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "September",
    "birthday_day": 1,
    "sign": "Virgo",
    "quote": "Pearls are a pink gorilla's best friend.",
    "phrase": "sweetie",
    "clothing": "Poncho-Style Sweater",
    "islander": "TRUE",
    "debut": "E_PLUS",
    "prev_phrases": "['faboom']",
    "appearances": "['E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 373,
    "Average_Popularity_Score": 307.75,
    "Nookazon_Bells_Price_Ranking": 390,
    "Nookazon_average_price_Bells": 75000,
    "Nookazon_NMT_Price_Ranking": 51,
    "Nookazon_average_price_NMT": 30,
    "Poll_Ranking_2020": 388,
    "Poll_Ranking_2020_21": 395,
    "Total_Poll_Votes_2020": 98,
    "Total_Poll_Votes_2020_21": 120,
    "Poll_votes_May_2020": 2,
    "Poll_votes_June_2020": 24,
    "Poll_votes_July_2020": 27,
    "Poll_votes_August_2020": 12,
    "Poll_votes_September_2020": 8,
    "Poll_votes_October_2020": 10,
    "Poll_votes_November_2020": 11,
    "Poll_votes_December_2020": 4,
    "Poll_votes_January_2021": 4,
    "Poll_votes_February_2021": 4,
    "Poll_votes_March_2021": 12,
    "Poll_votes_April_2021": 2
  },
  {
    "name": "Pango",
    "url": "https://nookipedia.com/wiki/Pango",
    "alt_name": "",
    "skin_color": "00d1bd",
    "text_color": "fffce9",
    "id": "ant02",
    "image_url": "https://dodo.ac/np/images/d/d5/Pango_NH.png",
    "species": "Anteater",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "November",
    "birthday_day": 9,
    "sign": "Scorpio",
    "quote": "A thing of beauty is a joy forever.",
    "phrase": "snooooof",
    "clothing": "Oversized Print Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Asian",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 360,
    "Average_Popularity_Score": 294.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 384,
    "Nookazon_average_price_NMT": 9,
    "Poll_Ranking_2020": 242,
    "Poll_Ranking_2020_21": 255,
    "Total_Poll_Votes_2020": 335,
    "Total_Poll_Votes_2020_21": 386,
    "Poll_votes_May_2020": 26,
    "Poll_votes_June_2020": 75,
    "Poll_votes_July_2020": 69,
    "Poll_votes_August_2020": 50,
    "Poll_votes_September_2020": 43,
    "Poll_votes_October_2020": 26,
    "Poll_votes_November_2020": 30,
    "Poll_votes_December_2020": 16,
    "Poll_votes_January_2021": 10,
    "Poll_votes_February_2021": 19,
    "Poll_votes_March_2021": 14,
    "Poll_votes_April_2021": 8
  },
  {
    "name": "Maggie",
    "url": "https://nookipedia.com/wiki/Maggie",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "pig10",
    "image_url": "https://dodo.ac/np/images/b/b8/Maggie_NH.png",
    "species": "Pig",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "September",
    "birthday_day": 3,
    "sign": "Virgo",
    "quote": "All a plant needs is love...and sun and water and soil.",
    "phrase": "schep",
    "clothing": "Pintuck-Pleated Dress",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Backyard",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 353,
    "Average_Popularity_Score": 288.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 321,
    "Poll_Ranking_2020_21": 322,
    "Total_Poll_Votes_2020": 188,
    "Total_Poll_Votes_2020_21": 238,
    "Poll_votes_May_2020": 7,
    "Poll_votes_June_2020": 40,
    "Poll_votes_July_2020": 52,
    "Poll_votes_August_2020": 36,
    "Poll_votes_September_2020": 18,
    "Poll_votes_October_2020": 15,
    "Poll_votes_November_2020": 14,
    "Poll_votes_December_2020": 6,
    "Poll_votes_January_2021": 12,
    "Poll_votes_February_2021": 10,
    "Poll_votes_March_2021": 20,
    "Poll_votes_April_2021": 8
  },
  {
    "name": "Pippy",
    "url": "https://nookipedia.com/wiki/Pippy",
    "alt_name": "",
    "skin_color": "fff98f",
    "text_color": "879b96",
    "id": "rbt06",
    "image_url": "https://dodo.ac/np/images/a/a1/Pippy_NH.png",
    "species": "Rabbit",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "June",
    "birthday_day": 14,
    "sign": "Gemini",
    "quote": "Fake it till you make it.",
    "phrase": "li'l hare",
    "clothing": "Overall Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Colorful",
    "P (individual within species)": 0.05,
    "Rarity": "0.14%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 352,
    "Average_Popularity_Score": 287.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 289,
    "Poll_Ranking_2020_21": 271,
    "Total_Poll_Votes_2020": 241,
    "Total_Poll_Votes_2020_21": 347,
    "Poll_votes_May_2020": 11,
    "Poll_votes_June_2020": 50,
    "Poll_votes_July_2020": 59,
    "Poll_votes_August_2020": 30,
    "Poll_votes_September_2020": 26,
    "Poll_votes_October_2020": 25,
    "Poll_votes_November_2020": 22,
    "Poll_votes_December_2020": 18,
    "Poll_votes_January_2021": 17,
    "Poll_votes_February_2021": 30,
    "Poll_votes_March_2021": 35,
    "Poll_votes_April_2021": 24
  },
  {
    "name": "Anicotti",
    "url": "https://nookipedia.com/wiki/Anicotti",
    "alt_name": "",
    "skin_color": "78dd62",
    "text_color": "28665a",
    "id": "mus10",
    "image_url": "https://dodo.ac/np/images/8/80/Anicotti_NH.png",
    "species": "Mouse",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "February",
    "birthday_day": 24,
    "sign": "Pisces",
    "quote": "The walls have ears.",
    "phrase": "cannoli",
    "clothing": "Colorful Striped Sweater",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Colorful",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 360,
    "Average_Popularity_Score": 294.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 314,
    "Nookazon_average_price_NMT": 12,
    "Poll_Ranking_2020": 281,
    "Poll_Ranking_2020_21": 290,
    "Total_Poll_Votes_2020": 249,
    "Total_Poll_Votes_2020_21": 305,
    "Poll_votes_May_2020": 6,
    "Poll_votes_June_2020": 52,
    "Poll_votes_July_2020": 76,
    "Poll_votes_August_2020": 44,
    "Poll_votes_September_2020": 29,
    "Poll_votes_October_2020": 18,
    "Poll_votes_November_2020": 14,
    "Poll_votes_December_2020": 10,
    "Poll_votes_January_2021": 11,
    "Poll_votes_February_2021": 17,
    "Poll_votes_March_2021": 16,
    "Poll_votes_April_2021": 12
  },
  {
    "name": "Moose",
    "url": "https://nookipedia.com/wiki/Moose",
    "alt_name": "",
    "skin_color": "7fa9ff",
    "text_color": "fffce9",
    "id": "mus14",
    "image_url": "https://dodo.ac/np/images/e/ee/Moose_NH.png",
    "species": "Mouse",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "September",
    "birthday_day": 13,
    "sign": "Virgo",
    "quote": "A cornered rat will summon the courage to bite a cat.",
    "phrase": "shorty",
    "clothing": "Big-Star Tee",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": [],
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Bachelor pad",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 369,
    "Average_Popularity_Score": 302.25,
    "Nookazon_Bells_Price_Ranking": 111,
    "Nookazon_average_price_Bells": 197917,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 384,
    "Poll_Ranking_2020_21": 387,
    "Total_Poll_Votes_2020": 106,
    "Total_Poll_Votes_2020_21": 145,
    "Poll_votes_May_2020": 9,
    "Poll_votes_June_2020": 21,
    "Poll_votes_July_2020": 27,
    "Poll_votes_August_2020": 11,
    "Poll_votes_September_2020": 15,
    "Poll_votes_October_2020": 11,
    "Poll_votes_November_2020": 4,
    "Poll_votes_December_2020": 8,
    "Poll_votes_January_2021": 16,
    "Poll_votes_February_2021": 9,
    "Poll_votes_March_2021": 12,
    "Poll_votes_April_2021": 2
  },
  {
    "name": "Limberg",
    "url": "https://nookipedia.com/wiki/Limberg",
    "alt_name": "",
    "skin_color": "ffaa3b",
    "text_color": "874c25",
    "id": "mus01",
    "image_url": "https://dodo.ac/np/images/b/b0/Limberg_NH.png",
    "species": "Mouse",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 17,
    "sign": "Libra",
    "quote": "Don't build a better mousetrap.",
    "phrase": "squinky",
    "clothing": "Hanten Jacket",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 376,
    "Average_Popularity_Score": 310.25,
    "Nookazon_Bells_Price_Ranking": 75,
    "Nookazon_average_price_Bells": 245313,
    "Nookazon_NMT_Price_Ranking": 388,
    "Nookazon_average_price_NMT": 7,
    "Poll_Ranking_2020": 382,
    "Poll_Ranking_2020_21": 389,
    "Total_Poll_Votes_2020": 112,
    "Total_Poll_Votes_2020_21": 139,
    "Poll_votes_May_2020": 9,
    "Poll_votes_June_2020": 25,
    "Poll_votes_July_2020": 25,
    "Poll_votes_August_2020": 13,
    "Poll_votes_September_2020": 18,
    "Poll_votes_October_2020": 7,
    "Poll_votes_November_2020": 12,
    "Poll_votes_December_2020": 3,
    "Poll_votes_January_2021": 6,
    "Poll_votes_February_2021": 5,
    "Poll_votes_March_2021": 3,
    "Poll_votes_April_2021": 13
  },
  {
    "name": "Baabara",
    "url": "https://nookipedia.com/wiki/Baabara",
    "alt_name": "",
    "skin_color": "8bcdea",
    "text_color": "fffad4",
    "id": "shp01",
    "image_url": "https://dodo.ac/np/images/8/81/Baabara_NH_Transparent.png",
    "species": "Sheep",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 28,
    "sign": "Aries",
    "quote": "Don't just follow the flock.",
    "phrase": "daahling",
    "clothing": "Zigzag-Print Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 355,
    "Average_Popularity_Score": 290.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 326,
    "Poll_Ranking_2020_21": 327,
    "Total_Poll_Votes_2020": 185,
    "Total_Poll_Votes_2020_21": 234,
    "Poll_votes_May_2020": 7,
    "Poll_votes_June_2020": 53,
    "Poll_votes_July_2020": 48,
    "Poll_votes_August_2020": 28,
    "Poll_votes_September_2020": 19,
    "Poll_votes_October_2020": 7,
    "Poll_votes_November_2020": 15,
    "Poll_votes_December_2020": 8,
    "Poll_votes_January_2021": 10,
    "Poll_votes_February_2021": 17,
    "Poll_votes_March_2021": 15,
    "Poll_votes_April_2021": 7
  },
  {
    "name": "Buzz",
    "url": "https://nookipedia.com/wiki/Buzz",
    "alt_name": "",
    "skin_color": "d86808",
    "text_color": "fffce9",
    "id": "pbr03",
    "image_url": "https://dodo.ac/np/images/0/05/Buzz_NH.png",
    "species": "Eagle",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 7,
    "sign": "Sagittarius",
    "quote": "Pride'll put you in a pickle.",
    "phrase": "captain",
    "clothing": "Nine-Ball Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Road",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 360,
    "Average_Popularity_Score": 294.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 184,
    "Nookazon_average_price_NMT": 18,
    "Poll_Ranking_2020": 358,
    "Poll_Ranking_2020_21": 355,
    "Total_Poll_Votes_2020": 135,
    "Total_Poll_Votes_2020_21": 180,
    "Poll_votes_May_2020": 9,
    "Poll_votes_June_2020": 39,
    "Poll_votes_July_2020": 24,
    "Poll_votes_August_2020": 18,
    "Poll_votes_September_2020": 11,
    "Poll_votes_October_2020": 15,
    "Poll_votes_November_2020": 9,
    "Poll_votes_December_2020": 10,
    "Poll_votes_January_2021": 5,
    "Poll_votes_February_2021": 17,
    "Poll_votes_March_2021": 14,
    "Poll_votes_April_2021": 9
  },
  {
    "name": "Claudia",
    "url": "https://nookipedia.com/wiki/Claudia",
    "alt_name": "",
    "skin_color": "ec7efc",
    "text_color": "fffce9",
    "id": "tig05",
    "image_url": "https://dodo.ac/np/images/d/d6/Claudia_NH.png",
    "species": "Tiger",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "November",
    "birthday_day": 22,
    "sign": "Scorpio",
    "quote": "A tiger can't change its stripes.",
    "phrase": "ooh la la",
    "clothing": "Lacy Dress",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Modern",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 359,
    "Average_Popularity_Score": 292.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 317,
    "Poll_Ranking_2020_21": 331,
    "Total_Poll_Votes_2020": 192,
    "Total_Poll_Votes_2020_21": 227,
    "Poll_votes_May_2020": 5,
    "Poll_votes_June_2020": 40,
    "Poll_votes_July_2020": 40,
    "Poll_votes_August_2020": 41,
    "Poll_votes_September_2020": 27,
    "Poll_votes_October_2020": 18,
    "Poll_votes_November_2020": 9,
    "Poll_votes_December_2020": 12,
    "Poll_votes_January_2021": 6,
    "Poll_votes_February_2021": 10,
    "Poll_votes_March_2021": 6,
    "Poll_votes_April_2021": 13
  },
  {
    "name": "Ed",
    "url": "https://nookipedia.com/wiki/Ed",
    "alt_name": "",
    "skin_color": "55cfff",
    "text_color": "fffce9",
    "id": "hrs06",
    "image_url": "https://dodo.ac/np/images/c/c9/Ed_NH.png",
    "species": "Horse",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "September",
    "birthday_day": 16,
    "sign": "Virgo",
    "quote": "Beauty is pretty!",
    "phrase": "greenhorn",
    "clothing": "Collarless Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 366,
    "Average_Popularity_Score": 299.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 279,
    "Nookazon_average_price_NMT": 14,
    "Poll_Ranking_2020": 309,
    "Poll_Ranking_2020_21": 317,
    "Total_Poll_Votes_2020": 210,
    "Total_Poll_Votes_2020_21": 260,
    "Poll_votes_May_2020": 16,
    "Poll_votes_June_2020": 49,
    "Poll_votes_July_2020": 53,
    "Poll_votes_August_2020": 25,
    "Poll_votes_September_2020": 19,
    "Poll_votes_October_2020": 17,
    "Poll_votes_November_2020": 17,
    "Poll_votes_December_2020": 14,
    "Poll_votes_January_2021": 10,
    "Poll_votes_February_2021": 11,
    "Poll_votes_March_2021": 17,
    "Poll_votes_April_2021": 12
  },
  {
    "name": "Paula",
    "url": "https://nookipedia.com/wiki/Paula",
    "alt_name": "",
    "skin_color": "e8b010",
    "text_color": "fffce9",
    "id": "bea10",
    "image_url": "https://dodo.ac/np/images/0/0f/Paula_NH.png",
    "species": "Bear",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "March",
    "birthday_day": 22,
    "sign": "Aries",
    "quote": "Trends always make a comeback.",
    "phrase": "yodelay",
    "clothing": "Zigzag-Print Dress",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Cute",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 375,
    "Average_Popularity_Score": 310,
    "Nookazon_Bells_Price_Ranking": 180,
    "Nookazon_average_price_Bells": 156250,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 364,
    "Poll_Ranking_2020_21": 368,
    "Total_Poll_Votes_2020": 131,
    "Total_Poll_Votes_2020_21": 164,
    "Poll_votes_May_2020": 4,
    "Poll_votes_June_2020": 23,
    "Poll_votes_July_2020": 29,
    "Poll_votes_August_2020": 26,
    "Poll_votes_September_2020": 15,
    "Poll_votes_October_2020": 9,
    "Poll_votes_November_2020": 15,
    "Poll_votes_December_2020": 10,
    "Poll_votes_January_2021": 7,
    "Poll_votes_February_2021": 6,
    "Poll_votes_March_2021": 12,
    "Poll_votes_April_2021": 8
  },
  {
    "name": "Coach",
    "url": "https://nookipedia.com/wiki/Coach",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "bul07",
    "image_url": "https://dodo.ac/np/images/c/c1/Coach_NH.png",
    "species": "Bull",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "April",
    "birthday_day": 29,
    "sign": "Taurus",
    "quote": "Fool me once, shame on you. Fool me twice, shame on me.",
    "phrase": "stubble",
    "clothing": "Relay Tank",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Gym",
    "P (individual within species)": 0.166666667,
    "Rarity": "0.48%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 377,
    "Average_Popularity_Score": 310.75,
    "Nookazon_Bells_Price_Ranking": 391,
    "Nookazon_average_price_Bells": 60000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 261,
    "Poll_Ranking_2020_21": 264,
    "Total_Poll_Votes_2020": 294,
    "Total_Poll_Votes_2020_21": 371,
    "Poll_votes_May_2020": 22,
    "Poll_votes_June_2020": 90,
    "Poll_votes_July_2020": 77,
    "Poll_votes_August_2020": 33,
    "Poll_votes_September_2020": 23,
    "Poll_votes_October_2020": 19,
    "Poll_votes_November_2020": 15,
    "Poll_votes_December_2020": 15,
    "Poll_votes_January_2021": 22,
    "Poll_votes_February_2021": 14,
    "Poll_votes_March_2021": 26,
    "Poll_votes_April_2021": 15
  },
  {
    "name": "Leonardo",
    "url": "https://nookipedia.com/wiki/Leonardo",
    "alt_name": "",
    "skin_color": "ffd00d",
    "text_color": "9b553a",
    "id": "tig04",
    "image_url": "https://dodo.ac/np/images/0/0a/Leonardo_NH.png",
    "species": "Tiger",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "May",
    "birthday_day": 15,
    "sign": "Taurus",
    "quote": "That's the way the energy bar crumbles.",
    "phrase": "flexin'",
    "clothing": "Hawk Jacket",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Metal",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 371,
    "Average_Popularity_Score": 305.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 314,
    "Nookazon_average_price_NMT": 12,
    "Poll_Ranking_2020": 313,
    "Poll_Ranking_2020_21": 312,
    "Total_Poll_Votes_2020": 203,
    "Total_Poll_Votes_2020_21": 270,
    "Poll_votes_May_2020": 14,
    "Poll_votes_June_2020": 43,
    "Poll_votes_July_2020": 39,
    "Poll_votes_August_2020": 26,
    "Poll_votes_September_2020": 31,
    "Poll_votes_October_2020": 21,
    "Poll_votes_November_2020": 20,
    "Poll_votes_December_2020": 9,
    "Poll_votes_January_2021": 18,
    "Poll_votes_February_2021": 16,
    "Poll_votes_March_2021": 17,
    "Poll_votes_April_2021": 16
  },
  {
    "name": "Candi",
    "url": "https://nookipedia.com/wiki/Candi",
    "alt_name": "",
    "skin_color": "ff6183",
    "text_color": "fffce9",
    "id": "mus08",
    "image_url": "https://dodo.ac/np/images/5/57/Candi_NH.png",
    "species": "Mouse",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "April",
    "birthday_day": 13,
    "sign": "Aries",
    "quote": "The players may change, but the music stays the same.",
    "phrase": "sweetie",
    "clothing": "Bohemian Tunic Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Colorful",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 378,
    "Average_Popularity_Score": 313.25,
    "Nookazon_Bells_Price_Ranking": 266,
    "Nookazon_average_price_Bells": 114584,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 380,
    "Poll_Ranking_2020_21": 381,
    "Total_Poll_Votes_2020": 116,
    "Total_Poll_Votes_2020_21": 151,
    "Poll_votes_May_2020": 4,
    "Poll_votes_June_2020": 31,
    "Poll_votes_July_2020": 22,
    "Poll_votes_August_2020": 14,
    "Poll_votes_September_2020": 14,
    "Poll_votes_October_2020": 11,
    "Poll_votes_November_2020": 11,
    "Poll_votes_December_2020": 9,
    "Poll_votes_January_2021": 7,
    "Poll_votes_February_2021": 7,
    "Poll_votes_March_2021": 15,
    "Poll_votes_April_2021": 6
  },
  {
    "name": "Louie",
    "url": "https://nookipedia.com/wiki/Louie",
    "alt_name": "",
    "skin_color": "d86808",
    "text_color": "fffce9",
    "id": "gor04",
    "image_url": "https://dodo.ac/np/images/5/5a/Louie_NH.png",
    "species": "Gorilla",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "March",
    "birthday_day": 26,
    "sign": "Aries",
    "quote": "It's all about the muscle.",
    "phrase": "hoo hoo ha",
    "clothing": "Muscle Tank",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": "['toots', 'odelay']",
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Gym",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 367,
    "Average_Popularity_Score": 300.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 338,
    "Poll_Ranking_2020_21": 347,
    "Total_Poll_Votes_2020": 161,
    "Total_Poll_Votes_2020_21": 196,
    "Poll_votes_May_2020": 9,
    "Poll_votes_June_2020": 49,
    "Poll_votes_July_2020": 34,
    "Poll_votes_August_2020": 18,
    "Poll_votes_September_2020": 12,
    "Poll_votes_October_2020": 17,
    "Poll_votes_November_2020": 15,
    "Poll_votes_December_2020": 7,
    "Poll_votes_January_2021": 8,
    "Poll_votes_February_2021": 5,
    "Poll_votes_March_2021": 10,
    "Poll_votes_April_2021": 12
  },
  {
    "name": "Carrie",
    "url": "https://nookipedia.com/wiki/Carrie",
    "alt_name": "",
    "skin_color": "e8b010",
    "text_color": "fffce9",
    "id": "kgr02",
    "image_url": "https://dodo.ac/np/images/6/6a/Carrie_NH.png",
    "species": "Kangaroo",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "December",
    "birthday_day": 5,
    "sign": "Sagittarius",
    "quote": "A mother's work is never done.",
    "phrase": "little one",
    "clothing": "Simple-Dots Dress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Normal",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 378,
    "Average_Popularity_Score": 313.25,
    "Nookazon_Bells_Price_Ranking": 251,
    "Nookazon_average_price_Bells": 125000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 347,
    "Poll_Ranking_2020_21": 339,
    "Total_Poll_Votes_2020": 149,
    "Total_Poll_Votes_2020_21": 203,
    "Poll_votes_May_2020": 5,
    "Poll_votes_June_2020": 41,
    "Poll_votes_July_2020": 30,
    "Poll_votes_August_2020": 17,
    "Poll_votes_September_2020": 16,
    "Poll_votes_October_2020": 8,
    "Poll_votes_November_2020": 20,
    "Poll_votes_December_2020": 12,
    "Poll_votes_January_2021": 16,
    "Poll_votes_February_2021": 16,
    "Poll_votes_March_2021": 12,
    "Poll_votes_April_2021": 10
  },
  {
    "name": "Sylvia",
    "url": "https://nookipedia.com/wiki/Sylvia",
    "alt_name": "",
    "skin_color": "a06fce",
    "text_color": "fffce9",
    "id": "kgr06",
    "image_url": "https://dodo.ac/np/images/9/93/Sylvia_NH.png",
    "species": "Kangaroo",
    "personality": "Sisterly",
    "gender": "Female",
    "birthday_month": "May",
    "birthday_day": 3,
    "sign": "Taurus",
    "quote": "Hop first; ask questions later.",
    "phrase": "boing",
    "clothing": "Tropical Muumuu",
    "islander": "FALSE",
    "debut": "E_PLUS",
    "prev_phrases": "['joey']",
    "appearances": "['E_PLUS', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Metal",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 368,
    "Average_Popularity_Score": 301.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 294,
    "Poll_Ranking_2020_21": 299,
    "Total_Poll_Votes_2020": 231,
    "Total_Poll_Votes_2020_21": 297,
    "Poll_votes_May_2020": 18,
    "Poll_votes_June_2020": 57,
    "Poll_votes_July_2020": 47,
    "Poll_votes_August_2020": 37,
    "Poll_votes_September_2020": 25,
    "Poll_votes_October_2020": 18,
    "Poll_votes_November_2020": 13,
    "Poll_votes_December_2020": 16,
    "Poll_votes_January_2021": 24,
    "Poll_votes_February_2021": 17,
    "Poll_votes_March_2021": 10,
    "Poll_votes_April_2021": 15
  },
  {
    "name": "Pancetti",
    "url": "https://nookipedia.com/wiki/Pancetti",
    "alt_name": "",
    "skin_color": "e2856b",
    "text_color": "fffce9",
    "id": "pig16",
    "image_url": "https://dodo.ac/np/images/e/ec/Pancetti_NH.png",
    "species": "Pig",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "November",
    "birthday_day": 14,
    "sign": "Scorpio",
    "quote": "Always get it in writing.",
    "phrase": "sooey",
    "clothing": "Dollhouse Dress",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 1,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 380,
    "Average_Popularity_Score": 316,
    "Nookazon_Bells_Price_Ranking": 281,
    "Nookazon_average_price_Bells": 101875,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 367,
    "Poll_Ranking_2020_21": 379,
    "Total_Poll_Votes_2020": 129,
    "Total_Poll_Votes_2020_21": 155,
    "Poll_votes_May_2020": 8,
    "Poll_votes_June_2020": 25,
    "Poll_votes_July_2020": 19,
    "Poll_votes_August_2020": 22,
    "Poll_votes_September_2020": 32,
    "Poll_votes_October_2020": 10,
    "Poll_votes_November_2020": 4,
    "Poll_votes_December_2020": 9,
    "Poll_votes_January_2021": 3,
    "Poll_votes_February_2021": 6,
    "Poll_votes_March_2021": 8,
    "Poll_votes_April_2021": 9
  },
  {
    "name": "Rasher",
    "url": "https://nookipedia.com/wiki/Rasher",
    "alt_name": "",
    "skin_color": "951d43",
    "text_color": "fffad4",
    "id": "pig02",
    "image_url": "https://dodo.ac/np/images/e/e1/Rasher_NH.png",
    "species": "Pig",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "April",
    "birthday_day": 7,
    "sign": "Aries",
    "quote": "Don't judge a book by its cover.",
    "phrase": "swine",
    "clothing": "Pineapple Aloha Shirt",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Road",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 372,
    "Average_Popularity_Score": 307.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 289,
    "Nookazon_average_price_NMT": 13,
    "Poll_Ranking_2020": 318,
    "Poll_Ranking_2020_21": 328,
    "Total_Poll_Votes_2020": 192,
    "Total_Poll_Votes_2020_21": 232,
    "Poll_votes_May_2020": 16,
    "Poll_votes_June_2020": 39,
    "Poll_votes_July_2020": 43,
    "Poll_votes_August_2020": 27,
    "Poll_votes_September_2020": 27,
    "Poll_votes_October_2020": 18,
    "Poll_votes_November_2020": 13,
    "Poll_votes_December_2020": 9,
    "Poll_votes_January_2021": 8,
    "Poll_votes_February_2021": 3,
    "Poll_votes_March_2021": 19,
    "Poll_votes_April_2021": 10
  },
  {
    "name": "Kevin",
    "url": "https://nookipedia.com/wiki/Kevin",
    "alt_name": "",
    "skin_color": "ffaa3b",
    "text_color": "874c25",
    "id": "pig15",
    "image_url": "https://dodo.ac/np/images/7/71/Kevin_NH.png",
    "species": "Pig",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "April",
    "birthday_day": 26,
    "sign": "Taurus",
    "quote": "Sometimes it's OK to get dirty.",
    "phrase": "weeweewee",
    "clothing": "After-School Jacket",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Gym",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 370,
    "Average_Popularity_Score": 304,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 292,
    "Poll_Ranking_2020_21": 304,
    "Total_Poll_Votes_2020": 234,
    "Total_Poll_Votes_2020_21": 283,
    "Poll_votes_May_2020": 19,
    "Poll_votes_June_2020": 54,
    "Poll_votes_July_2020": 61,
    "Poll_votes_August_2020": 32,
    "Poll_votes_September_2020": 31,
    "Poll_votes_October_2020": 18,
    "Poll_votes_November_2020": 10,
    "Poll_votes_December_2020": 9,
    "Poll_votes_January_2021": 9,
    "Poll_votes_February_2021": 18,
    "Poll_votes_March_2021": 15,
    "Poll_votes_April_2021": 7
  },
  {
    "name": "Monty",
    "url": "https://nookipedia.com/wiki/Monty",
    "alt_name": "",
    "skin_color": "acc8cf",
    "text_color": 498992,
    "id": "mnk04",
    "image_url": "https://dodo.ac/np/images/d/d7/Monty_NH.png",
    "species": "Monkey",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 7,
    "sign": "Sagittarius",
    "quote": "No news is good news.",
    "phrase": "g'tang",
    "clothing": "Guayabera Shirt",
    "islander": "FALSE",
    "debut": "WW",
    "prev_phrases": [],
    "appearances": "['WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Outdoor",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 374,
    "Average_Popularity_Score": 309.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 225,
    "Nookazon_average_price_NMT": 15,
    "Poll_Ranking_2020": 365,
    "Poll_Ranking_2020_21": 364,
    "Total_Poll_Votes_2020": 130,
    "Total_Poll_Votes_2020_21": 169,
    "Poll_votes_May_2020": 5,
    "Poll_votes_June_2020": 26,
    "Poll_votes_July_2020": 35,
    "Poll_votes_August_2020": 14,
    "Poll_votes_September_2020": 15,
    "Poll_votes_October_2020": 16,
    "Poll_votes_November_2020": 10,
    "Poll_votes_December_2020": 9,
    "Poll_votes_January_2021": 9,
    "Poll_votes_February_2021": 12,
    "Poll_votes_March_2021": 11,
    "Poll_votes_April_2021": 7
  },
  {
    "name": "Velma",
    "url": "https://nookipedia.com/wiki/Velma",
    "alt_name": "",
    "skin_color": "ff6183",
    "text_color": "fffce9",
    "id": "goa06",
    "image_url": "https://dodo.ac/np/images/5/59/Velma_NH.png",
    "species": "Goat",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 14,
    "sign": "Capricorn",
    "quote": "Work smarter, not harder.",
    "phrase": "blih",
    "clothing": "Prim Outfit",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Music room",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 384,
    "Average_Popularity_Score": 324.25,
    "Nookazon_Bells_Price_Ranking": 265,
    "Nookazon_average_price_Bells": 114900,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 349,
    "Poll_Ranking_2020_21": 354,
    "Total_Poll_Votes_2020": 147,
    "Total_Poll_Votes_2020_21": 181,
    "Poll_votes_May_2020": 6,
    "Poll_votes_June_2020": 26,
    "Poll_votes_July_2020": 23,
    "Poll_votes_August_2020": 22,
    "Poll_votes_September_2020": 33,
    "Poll_votes_October_2020": 19,
    "Poll_votes_November_2020": 9,
    "Poll_votes_December_2020": 9,
    "Poll_votes_January_2021": 7,
    "Poll_votes_February_2021": 7,
    "Poll_votes_March_2021": 5,
    "Poll_votes_April_2021": 15
  },
  {
    "name": "Gruff",
    "url": "https://nookipedia.com/wiki/Gruff",
    "alt_name": "",
    "skin_color": "78dd62",
    "text_color": "28665a",
    "id": "goa04",
    "image_url": "https://dodo.ac/np/images/2/25/Gruff_NH.png",
    "species": "Goat",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "August",
    "birthday_day": 29,
    "sign": "Virgo",
    "quote": "Don't burn bridges.",
    "phrase": "bleh eh eh",
    "clothing": "Old-School Jacket",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Bachelor pad",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 391,
    "Average_Popularity_Score": 332.5,
    "Nookazon_Bells_Price_Ranking": 278,
    "Nookazon_average_price_Bells": 103125,
    "Nookazon_NMT_Price_Ranking": 384,
    "Nookazon_average_price_NMT": 9,
    "Poll_Ranking_2020": 330,
    "Poll_Ranking_2020_21": 334,
    "Total_Poll_Votes_2020": 178,
    "Total_Poll_Votes_2020_21": 219,
    "Poll_votes_May_2020": 13,
    "Poll_votes_June_2020": 32,
    "Poll_votes_July_2020": 39,
    "Poll_votes_August_2020": 22,
    "Poll_votes_September_2020": 27,
    "Poll_votes_October_2020": 22,
    "Poll_votes_November_2020": 15,
    "Poll_votes_December_2020": 8,
    "Poll_votes_January_2021": 10,
    "Poll_votes_February_2021": 7,
    "Poll_votes_March_2021": 14,
    "Poll_votes_April_2021": 10
  },
  {
    "name": "Frank",
    "url": "https://nookipedia.com/wiki/Frank",
    "alt_name": "",
    "skin_color": "78dd62",
    "text_color": "28665a",
    "id": "pbr06",
    "image_url": "https://dodo.ac/np/images/7/75/Frank_NH.png",
    "species": "Eagle",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 30,
    "sign": "Leo",
    "quote": "Today is the last day of the rest of your life.",
    "phrase": "crushy",
    "clothing": "Letter Jacket",
    "islander": "TRUE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Gym",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 386,
    "Average_Popularity_Score": 326.25,
    "Nookazon_Bells_Price_Ranking": 281,
    "Nookazon_average_price_Bells": 101875,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 353,
    "Poll_Ranking_2020_21": 350,
    "Total_Poll_Votes_2020": 142,
    "Total_Poll_Votes_2020_21": 191,
    "Poll_votes_May_2020": 10,
    "Poll_votes_June_2020": 25,
    "Poll_votes_July_2020": 32,
    "Poll_votes_August_2020": 21,
    "Poll_votes_September_2020": 20,
    "Poll_votes_October_2020": 17,
    "Poll_votes_November_2020": 5,
    "Poll_votes_December_2020": 12,
    "Poll_votes_January_2021": 5,
    "Poll_votes_February_2021": 15,
    "Poll_votes_March_2021": 23,
    "Poll_votes_April_2021": 6
  },
  {
    "name": "Soleil",
    "url": "https://nookipedia.com/wiki/Soleil",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "ham04",
    "image_url": "https://dodo.ac/np/images/d/de/Soleil_NH.png",
    "species": "Hamster",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "August",
    "birthday_day": 9,
    "sign": "Leo",
    "quote": "Sometimes dreams are merely dreams.",
    "phrase": "tarnation",
    "clothing": "Sari",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Asian",
    "P (individual within species)": 0.125,
    "Rarity": "0.36%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 3,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 380,
    "Average_Popularity_Score": 316,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 325,
    "Poll_Ranking_2020_21": 328,
    "Total_Poll_Votes_2020": 186,
    "Total_Poll_Votes_2020_21": 232,
    "Poll_votes_May_2020": 5,
    "Poll_votes_June_2020": 39,
    "Poll_votes_July_2020": 31,
    "Poll_votes_August_2020": 19,
    "Poll_votes_September_2020": 47,
    "Poll_votes_October_2020": 25,
    "Poll_votes_November_2020": 13,
    "Poll_votes_December_2020": 7,
    "Poll_votes_January_2021": 10,
    "Poll_votes_February_2021": 8,
    "Poll_votes_March_2021": 10,
    "Poll_votes_April_2021": 18
  },
  {
    "name": "Harry",
    "url": "https://nookipedia.com/wiki/Harry",
    "alt_name": "",
    "skin_color": "e8b010",
    "text_color": "fffce9",
    "id": "hip08",
    "image_url": "https://dodo.ac/np/images/1/1a/Harry_NH.png",
    "species": "Hippo",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "January",
    "birthday_day": 7,
    "sign": "Capricorn",
    "quote": "Patience is a virtue for folks with time.",
    "phrase": "beach bum",
    "clothing": "Camo Tee",
    "islander": "TRUE",
    "debut": "E_PLUS",
    "prev_phrases": [],
    "appearances": "['E_PLUS', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Bathroom",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 388,
    "Average_Popularity_Score": 329,
    "Nookazon_Bells_Price_Ranking": 216,
    "Nookazon_average_price_Bells": 143750,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 383,
    "Poll_Ranking_2020_21": 388,
    "Total_Poll_Votes_2020": 111,
    "Total_Poll_Votes_2020_21": 144,
    "Poll_votes_May_2020": 2,
    "Poll_votes_June_2020": 15,
    "Poll_votes_July_2020": 21,
    "Poll_votes_August_2020": 21,
    "Poll_votes_September_2020": 22,
    "Poll_votes_October_2020": 13,
    "Poll_votes_November_2020": 10,
    "Poll_votes_December_2020": 7,
    "Poll_votes_January_2021": 6,
    "Poll_votes_February_2021": 7,
    "Poll_votes_March_2021": 14,
    "Poll_votes_April_2021": 6
  },
  {
    "name": "Bettina",
    "url": "https://nookipedia.com/wiki/Bettina",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "mus15",
    "image_url": "https://dodo.ac/np/images/9/9c/Bettina_NH_Transparent.png",
    "species": "Mouse",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "June",
    "birthday_day": 12,
    "sign": "Gemini",
    "quote": "No time like the present!",
    "phrase": "eekers",
    "clothing": "Chef's Outfit",
    "islander": "FALSE",
    "debut": "CF",
    "prev_phrases": [],
    "appearances": "['CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Cafe",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 382,
    "Average_Popularity_Score": 318,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 329,
    "Poll_Ranking_2020_21": 332,
    "Total_Poll_Votes_2020": 178,
    "Total_Poll_Votes_2020_21": 223,
    "Poll_votes_May_2020": 10,
    "Poll_votes_June_2020": 41,
    "Poll_votes_July_2020": 47,
    "Poll_votes_August_2020": 18,
    "Poll_votes_September_2020": 22,
    "Poll_votes_October_2020": 15,
    "Poll_votes_November_2020": 11,
    "Poll_votes_December_2020": 14,
    "Poll_votes_January_2021": 12,
    "Poll_votes_February_2021": 18,
    "Poll_votes_March_2021": 10,
    "Poll_votes_April_2021": 5
  },
  {
    "name": "Chops",
    "url": "https://nookipedia.com/wiki/Chops",
    "alt_name": "",
    "skin_color": "d8cc39",
    "text_color": "8b5f57",
    "id": "pig14",
    "image_url": "https://dodo.ac/np/images/a/ad/Chops_NH_Transparent.png",
    "species": "Pig",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "October",
    "birthday_day": 13,
    "sign": "Libra",
    "quote": "You can't have your cake and eat it too.",
    "phrase": "zoink",
    "clothing": "Military Uniform",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Education",
    "interior_decor": "Bachelor pad",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 390,
    "Average_Popularity_Score": 331,
    "Nookazon_Bells_Price_Ranking": 256,
    "Nookazon_average_price_Bells": 122657,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 378,
    "Poll_Ranking_2020_21": 372,
    "Total_Poll_Votes_2020": 118,
    "Total_Poll_Votes_2020_21": 158,
    "Poll_votes_May_2020": 8,
    "Poll_votes_June_2020": 33,
    "Poll_votes_July_2020": 26,
    "Poll_votes_August_2020": 18,
    "Poll_votes_September_2020": 10,
    "Poll_votes_October_2020": 9,
    "Poll_votes_November_2020": 8,
    "Poll_votes_December_2020": 6,
    "Poll_votes_January_2021": 10,
    "Poll_votes_February_2021": 5,
    "Poll_votes_March_2021": 11,
    "Poll_votes_April_2021": 14
  },
  {
    "name": "Lucha",
    "url": "https://nookipedia.com/wiki/Lucha",
    "alt_name": "",
    "skin_color": "ff4040",
    "text_color": "fffad4",
    "id": "brd15",
    "image_url": "https://dodo.ac/np/images/4/4a/Lucha_NH.png",
    "species": "Bird",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "December",
    "birthday_day": 12,
    "sign": "Sagittarius",
    "quote": "Birds of a feather, et cetera, et cetera...",
    "phrase": "cacaw",
    "clothing": "Athletic Jacket",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Gym",
    "P (individual within species)": 0.076923077,
    "Rarity": "0.22%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 387,
    "Average_Popularity_Score": 327.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 389,
    "Nookazon_average_price_NMT": 5,
    "Poll_Ranking_2020": 315,
    "Poll_Ranking_2020_21": 318,
    "Total_Poll_Votes_2020": 195,
    "Total_Poll_Votes_2020_21": 254,
    "Poll_votes_May_2020": 15,
    "Poll_votes_June_2020": 53,
    "Poll_votes_July_2020": 56,
    "Poll_votes_August_2020": 19,
    "Poll_votes_September_2020": 19,
    "Poll_votes_October_2020": 11,
    "Poll_votes_November_2020": 13,
    "Poll_votes_December_2020": 9,
    "Poll_votes_January_2021": 9,
    "Poll_votes_February_2021": 18,
    "Poll_votes_March_2021": 18,
    "Poll_votes_April_2021": 14
  },
  {
    "name": "Truffles",
    "url": "https://nookipedia.com/wiki/Truffles",
    "alt_name": "",
    "skin_color": "f993ce",
    "text_color": "fffce9",
    "id": "pig01",
    "image_url": "https://dodo.ac/np/images/e/eb/Truffles_NH.png",
    "species": "Pig",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "July",
    "birthday_day": 28,
    "sign": "Leo",
    "quote": "The best things in life are free.",
    "phrase": "snoutie",
    "clothing": "Tee-Parka Combo",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Colorful",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 2,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 389,
    "Average_Popularity_Score": 329.75,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 321,
    "Nookazon_average_price_NMT": 11,
    "Poll_Ranking_2020": 356,
    "Poll_Ranking_2020_21": 357,
    "Total_Poll_Votes_2020": 140,
    "Total_Poll_Votes_2020_21": 179,
    "Poll_votes_May_2020": 6,
    "Poll_votes_June_2020": 30,
    "Poll_votes_July_2020": 28,
    "Poll_votes_August_2020": 19,
    "Poll_votes_September_2020": 21,
    "Poll_votes_October_2020": 16,
    "Poll_votes_November_2020": 9,
    "Poll_votes_December_2020": 11,
    "Poll_votes_January_2021": 13,
    "Poll_votes_February_2021": 7,
    "Poll_votes_March_2021": 7,
    "Poll_votes_April_2021": 12
  },
  {
    "name": "Alli",
    "url": "https://nookipedia.com/wiki/Alli",
    "alt_name": "",
    "skin_color": "3fd8e0",
    "text_color": "fffce9",
    "id": "crd01",
    "image_url": "https://dodo.ac/np/images/8/8e/Alli_NH.png",
    "species": "Alligator",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "November",
    "birthday_day": 8,
    "sign": "Scorpio",
    "quote": "Think before you act.",
    "phrase": "graaagh",
    "clothing": "Leopard Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.142857143,
    "Rarity": "0.41%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 383,
    "Average_Popularity_Score": 322.5,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 332,
    "Poll_Ranking_2020_21": 341,
    "Total_Poll_Votes_2020": 164,
    "Total_Poll_Votes_2020_21": 202,
    "Poll_votes_May_2020": 5,
    "Poll_votes_June_2020": 47,
    "Poll_votes_July_2020": 41,
    "Poll_votes_August_2020": 24,
    "Poll_votes_September_2020": 21,
    "Poll_votes_October_2020": 9,
    "Poll_votes_November_2020": 10,
    "Poll_votes_December_2020": 7,
    "Poll_votes_January_2021": 6,
    "Poll_votes_February_2021": 13,
    "Poll_votes_March_2021": 13,
    "Poll_votes_April_2021": 6
  },
  {
    "name": "Samson",
    "url": "https://nookipedia.com/wiki/Samson",
    "alt_name": "",
    "skin_color": "acc8cf",
    "text_color": 498992,
    "id": "mus04",
    "image_url": "https://dodo.ac/np/images/9/9b/Samson_NH.png",
    "species": "Mouse",
    "personality": "Jock",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 5,
    "sign": "Cancer",
    "quote": "Squeak softly and carry a big stick.",
    "phrase": "pipsqueak",
    "clothing": "Kanji Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Fruit",
    "P (individual within species)": 0.066666667,
    "Rarity": "0.19%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 385,
    "Average_Popularity_Score": 326,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 342,
    "Poll_Ranking_2020_21": 348,
    "Total_Poll_Votes_2020": 157,
    "Total_Poll_Votes_2020_21": 195,
    "Poll_votes_May_2020": 12,
    "Poll_votes_June_2020": 35,
    "Poll_votes_July_2020": 31,
    "Poll_votes_August_2020": 24,
    "Poll_votes_September_2020": 18,
    "Poll_votes_October_2020": 18,
    "Poll_votes_November_2020": 14,
    "Poll_votes_December_2020": 5,
    "Poll_votes_January_2021": 9,
    "Poll_votes_February_2021": 10,
    "Poll_votes_March_2021": 6,
    "Poll_votes_April_2021": 13
  },
  {
    "name": "Naomi",
    "url": "https://nookipedia.com/wiki/Naomi",
    "alt_name": "",
    "skin_color": "3fd8e0",
    "text_color": "fffce9",
    "id": "cow07",
    "image_url": "https://dodo.ac/np/images/f/f6/Naomi_NH.png",
    "species": "Cow",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "February",
    "birthday_day": 28,
    "sign": "Pisces",
    "quote": "Moo like there's no tomorrow.",
    "phrase": "moolah",
    "clothing": "Marble-Print Dress",
    "islander": "FALSE",
    "debut": "NL",
    "prev_phrases": [],
    "appearances": "['NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.25,
    "Rarity": "0.71%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 394,
    "Average_Popularity_Score": 347.25,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 389,
    "Nookazon_average_price_NMT": 5,
    "Poll_Ranking_2020": 355,
    "Poll_Ranking_2020_21": 358,
    "Total_Poll_Votes_2020": 141,
    "Total_Poll_Votes_2020_21": 178,
    "Poll_votes_May_2020": 8,
    "Poll_votes_June_2020": 24,
    "Poll_votes_July_2020": 30,
    "Poll_votes_August_2020": 18,
    "Poll_votes_September_2020": 36,
    "Poll_votes_October_2020": 7,
    "Poll_votes_November_2020": 10,
    "Poll_votes_December_2020": 8,
    "Poll_votes_January_2021": 9,
    "Poll_votes_February_2021": 8,
    "Poll_votes_March_2021": 10,
    "Poll_votes_April_2021": 10
  },
  {
    "name": "Cesar",
    "url": "https://nookipedia.com/wiki/Cesar",
    "alt_name": "",
    "skin_color": "ff791f",
    "text_color": "fff2bb",
    "id": "gor00",
    "image_url": "https://dodo.ac/np/images/2/23/Cesar_NH.png",
    "species": "Gorilla",
    "personality": "Cranky",
    "gender": "Male",
    "birthday_month": "September",
    "birthday_day": 6,
    "sign": "Virgo",
    "quote": "As soon as you can grow a mustache, do it.",
    "phrase": "highness",
    "clothing": "A Tee",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD']",
    "Amiibo": "YES",
    "hobby": "Fitness",
    "interior_decor": "Modern",
    "P (individual within species)": 0.111111111,
    "Rarity": "0.32%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 1,
    "Appearance points - Ling": 1,
    "Apperance_Score": 1,
    "Cute?": "",
    "Average_Popularity_Ranking": 392,
    "Average_Popularity_Score": 343,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 386,
    "Poll_Ranking_2020_21": 382,
    "Total_Poll_Votes_2020": 102,
    "Total_Poll_Votes_2020_21": 150,
    "Poll_votes_May_2020": 2,
    "Poll_votes_June_2020": 24,
    "Poll_votes_July_2020": 24,
    "Poll_votes_August_2020": 15,
    "Poll_votes_September_2020": 12,
    "Poll_votes_October_2020": 11,
    "Poll_votes_November_2020": 6,
    "Poll_votes_December_2020": 8,
    "Poll_votes_January_2021": 17,
    "Poll_votes_February_2021": 18,
    "Poll_votes_March_2021": 8,
    "Poll_votes_April_2021": 5
  },
  {
    "name": "Queenie",
    "url": "https://nookipedia.com/wiki/Queenie",
    "alt_name": "",
    "skin_color": "a06fce",
    "text_color": "fffce9",
    "id": "ost00",
    "image_url": "https://dodo.ac/np/images/f/f1/Queenie_NH.png",
    "species": "Ostrich",
    "personality": "Snooty",
    "gender": "Female",
    "birthday_month": "November",
    "birthday_day": 13,
    "sign": "Scorpio",
    "quote": "You never get a second chance to make a first impression.",
    "phrase": "chicken",
    "clothing": "Shirtdress",
    "islander": "FALSE",
    "debut": "DNM",
    "prev_phrases": [],
    "appearances": "['DNM', 'AC', 'E_PLUS', 'WW', 'CF', 'NL', 'WA', 'NH', 'HHD', 'PC']",
    "Amiibo": "YES",
    "hobby": "Fashion",
    "interior_decor": "Elegant",
    "P (individual within species)": 0.1,
    "Rarity": "0.29%",
    "Special House Style": "",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "normal",
    "Special Appearance - Jenny": "",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "normal",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 393,
    "Average_Popularity_Score": 345,
    "Nookazon_Bells_Price_Ranking": 284,
    "Nookazon_average_price_Bells": 100000,
    "Nookazon_NMT_Price_Ranking": 324,
    "Nookazon_average_price_NMT": 10,
    "Poll_Ranking_2020": 381,
    "Poll_Ranking_2020_21": 386,
    "Total_Poll_Votes_2020": 116,
    "Total_Poll_Votes_2020_21": 146,
    "Poll_votes_May_2020": 6,
    "Poll_votes_June_2020": 19,
    "Poll_votes_July_2020": 32,
    "Poll_votes_August_2020": 21,
    "Poll_votes_September_2020": 8,
    "Poll_votes_October_2020": 14,
    "Poll_votes_November_2020": 7,
    "Poll_votes_December_2020": 9,
    "Poll_votes_January_2021": 8,
    "Poll_votes_February_2021": 5,
    "Poll_votes_March_2021": 8,
    "Poll_votes_April_2021": 9
  },
  {
    "name": "Chelsea",
    "url": "https://nookipedia.com/wiki/Chelsea",
    "alt_name": "",
    "skin_color": "feaaaa",
    "text_color": "fff9f9",
    "id": "der10",
    "image_url": "https://dodo.ac/np/images/9/97/Chelsea_PC.png",
    "species": "Deer",
    "personality": "Normal",
    "gender": "Female",
    "birthday_month": "January",
    "birthday_day": 18,
    "sign": "Capricorn",
    "quote": "Always look a gift horse in the mouth.",
    "phrase": "pound cake",
    "clothing": "My Melody Shirt",
    "islander": "FALSE",
    "debut": "WA",
    "prev_phrases": [],
    "appearances": "['WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Play",
    "interior_decor": "Sanrio",
    "P (individual within species)": 0,
    "Rarity": "0.00%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 3,
    "Appearance points - Ling": 2,
    "Apperance_Score": 4,
    "Cute?": "",
    "Average_Popularity_Ranking": 395,
    "Average_Popularity_Score": 377,
    "Nookazon_Bells_Price_Ranking": "N/A",
    "Nookazon_average_price_Bells": "N/A",
    "Nookazon_NMT_Price_Ranking": "N/A",
    "Nookazon_average_price_NMT": "N/A",
    "Poll_Ranking_2020": "N/A",
    "Poll_Ranking_2020_21": 377,
    "Total_Poll_Votes_2020": 0,
    "Total_Poll_Votes_2020_21": 156,
    "Poll_votes_May_2020": 0,
    "Poll_votes_June_2020": 0,
    "Poll_votes_July_2020": 0,
    "Poll_votes_August_2020": 0,
    "Poll_votes_September_2020": 0,
    "Poll_votes_October_2020": 0,
    "Poll_votes_November_2020": 0,
    "Poll_votes_December_2020": 0,
    "Poll_votes_January_2021": 0,
    "Poll_votes_February_2021": 0,
    "Poll_votes_March_2021": 76,
    "Poll_votes_April_2021": 80
  },
  {
    "name": "Toby",
    "url": "https://nookipedia.com/wiki/Toby",
    "alt_name": "",
    "skin_color": "fce229",
    "text_color": "479b78",
    "id": "rbt20",
    "image_url": "https://dodo.ac/np/images/6/67/Toby_PC.png",
    "species": "Rabbit",
    "personality": "Smug",
    "gender": "Male",
    "birthday_month": "July",
    "birthday_day": 10,
    "sign": "Cancer",
    "quote": "Toby or not Toby? I don't know, I'm asking you.",
    "phrase": "ribbit",
    "clothing": "Kerokerokeroppi Tank Top",
    "islander": "FALSE",
    "debut": "WA",
    "prev_phrases": [],
    "appearances": "['WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Music",
    "interior_decor": "Sanrio",
    "P (individual within species)": 0,
    "Rarity": "0.00%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 2,
    "Apperance_Score": 3,
    "Cute?": "",
    "Average_Popularity_Ranking": 396,
    "Average_Popularity_Score": 396,
    "Nookazon_Bells_Price_Ranking": "N/A",
    "Nookazon_average_price_Bells": "N/A",
    "Nookazon_NMT_Price_Ranking": "N/A",
    "Nookazon_average_price_NMT": "N/A",
    "Poll_Ranking_2020": "N/A",
    "Poll_Ranking_2020_21": 396,
    "Total_Poll_Votes_2020": 0,
    "Total_Poll_Votes_2020_21": 91,
    "Poll_votes_May_2020": 0,
    "Poll_votes_June_2020": 0,
    "Poll_votes_July_2020": 0,
    "Poll_votes_August_2020": 0,
    "Poll_votes_September_2020": 0,
    "Poll_votes_October_2020": 0,
    "Poll_votes_November_2020": 0,
    "Poll_votes_December_2020": 0,
    "Poll_votes_January_2021": 0,
    "Poll_votes_February_2021": 0,
    "Poll_votes_March_2021": 51,
    "Poll_votes_April_2021": 40
  },
  {
    "name": "Rilla",
    "url": "https://nookipedia.com/wiki/Rilla",
    "alt_name": "",
    "skin_color": "ff3339",
    "text_color": "fff6f6",
    "id": "gor11",
    "image_url": "https://dodo.ac/np/images/3/31/Rilla_PC.png",
    "species": "Gorilla",
    "personality": "Peppy",
    "gender": "Female",
    "birthday_month": "November",
    "birthday_day": 1,
    "sign": "Scorpio",
    "quote": "When there's a will, there's a way.",
    "phrase": "hello",
    "clothing": "Hello Kitty Tee",
    "islander": "FALSE",
    "debut": "WA",
    "prev_phrases": [],
    "appearances": "['WA', 'NH', 'PC']",
    "Amiibo": "YES",
    "hobby": "Nature",
    "interior_decor": "Sanrio",
    "P (individual within species)": 0,
    "Rarity": "0.00%",
    "Special House Style": "Yes",
    "Special House Style - Ling": "",
    "Combined_Special_House_Style": "special",
    "Special Appearance - Jenny": "Yes",
    "Special Appearance - Ling": "",
    "Combined_special_appearance": "special",
    "Appearance points - Jenny": 2,
    "Appearance points - Ling": 1,
    "Apperance_Score": 2,
    "Cute?": "",
    "Average_Popularity_Ranking": 397,
    "Average_Popularity_Score": 397,
    "Nookazon_Bells_Price_Ranking": "N/A",
    "Nookazon_average_price_Bells": "N/A",
    "Nookazon_NMT_Price_Ranking": "N/A",
    "Nookazon_average_price_NMT": "N/A",
    "Poll_Ranking_2020": "N/A",
    "Poll_Ranking_2020_21": 397,
    "Total_Poll_Votes_2020": 0,
    "Total_Poll_Votes_2020_21": 43,
    "Poll_votes_May_2020": 0,
    "Poll_votes_June_2020": 0,
    "Poll_votes_July_2020": 0,
    "Poll_votes_August_2020": 0,
    "Poll_votes_September_2020": 0,
    "Poll_votes_October_2020": 0,
    "Poll_votes_November_2020": 0,
    "Poll_votes_December_2020": 0,
    "Poll_votes_January_2021": 0,
    "Poll_votes_February_2021": 0,
    "Poll_votes_March_2021": 19,
    "Poll_votes_April_2021": 24
  }
]
}
